webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/JrEPOj/%3F1709062252278&title=Don%27t%20Do%20It%2C%20She%20Likes%20It&summary=If%20you%20read%20this%2C%20this%20is%20a%20story%20about%20you%2C%20written%20by%20you%2C%20from%20you%20and%20for%20you.%20As%20we%20know%20social%20media%20has%20changed%20the%20world%2C%20it%20is%20not%20just%20part%20of%20your%20life%20but%20it%20is%20your%20life.%20Social%20media%20motto%3A%20do%20not%20judge%2C%20lest%20be%20judged%20with%20photoshopped%20and%20&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/JrEPOj/%3F1709062252278",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=If%20you%20read%20this%2C%20this%20is%20a%20story%20about%20you%2C%20written%20by%20you%2C%20from%20you%20and%20for%20you.%20As%20we%20know%20social%20media%20has%20changed%20the%20world%2C%20it%20is%20not%20just%0Dhttps://textcafe.co/books/JrEPOj/%3F1709062252278&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/JrEPOj/%3F1709062252278&posttype=link&caption=If%20you%20read%20this%2C%20this%20is%20a%20story%20about%20you%2C%20written%20by%20you%2C%20from%20you%20and%20for%20you.%20As%20we%20know%20social%20media%20has%20changed%20the%20world%2C%20it%20is%20not%20just%20part%20of%20your%20life%20but%20it%20is%20your%20life.%20Social%20media%20motto%3A%20do%20not%20judge%2C%20lest%20be%20judged%20with%20photoshopped%20and%20",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/JrEPOj/%3F1709062252278&description=If%20you%20read%20this%2C%20this%20is%20a%20story%20about%20you%2C%20written%20by%20you%2C%20from%20you%20and%20for%20you.%20As%20we%20know%20social%20media%20has%20changed%20the%20world%2C%20it%20is%20not%20just%20part%20of%20your%20life%20but%20it%20is%20your%20life.%20Social%20media%20motto%3A%20do%20not%20judge%2C%20lest%20be%20judged%20with%20photoshopped%20and%20&media=https://textcafe.co/books/JrEPOj/tc-custom/FC-9781528985536.jpg?1684870885593",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon UK',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.co.uk/s?k=9781528985536&i=stripbooks&linkCode=qs',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781528985536').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/JrEPOj/tc-custom/FC-9781528985536.jpg?1684870885593?1709062252278',
        alt: 'Don&#x27;t Do It, She Likes It'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "nav", "text/ch001", "text/ch002", "text/ch003", "text/ch004", "text/ch005", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/JrEPOj/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_text_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_text_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_text_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_text_title_page__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_text_title_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_text_title_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_nav__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_text_ch001__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_text_ch001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_text_ch001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_text_ch002__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_text_ch002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_text_ch002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_text_ch003__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_text_ch003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_text_ch003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_text_ch004__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_text_ch004___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_text_ch004__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_text_ch005__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_text_ch005___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_text_ch005__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_text_ch006__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_text_ch006___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_text_ch006__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_text_ch007__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_text_ch007___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_text_ch007__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_text_ch008__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_text_ch008___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_text_ch008__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_text_ch009__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_text_ch009___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_text_ch009__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_text_ch010__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_text_ch010___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_text_ch010__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_text_ch011__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_text_ch011___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_text_ch011__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_text_ch012__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_text_ch012___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_text_ch012__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_last__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_last__);
/*jshint esversion: 6 */






















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/nav",
    "name": "nav",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_nav___default.a
  }, {
    "path": "/text/ch001",
    "name": "text/ch001",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_text_ch001___default.a
  }, {
    "path": "/text/ch002",
    "name": "text/ch002",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_text_ch002___default.a
  }, {
    "path": "/text/ch003",
    "name": "text/ch003",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_text_ch003___default.a
  }, {
    "path": "/text/ch004",
    "name": "text/ch004",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_text_ch004___default.a
  }, {
    "path": "/text/ch005",
    "name": "text/ch005",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_text_ch005___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_19__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JrEPOj/tc-custom/FC-9781528985536.jpg?1684870885593?1709062252278",
      "alt": "This image is the cover for the book Don't Do It, She Likes It"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Don't Do It, She Likes It\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("If you read this, this is a story about you, written by you, from you and for you. As we know social media has changed the world, it is not just part of your life but it is your life. Social media motto: do not judge, lest be judged with photoshopped and filtered photos. Social media is so powerful, it can turn nice guys into thugs, strangers into lovers, and your milkman into lover (and vice versa). What you post there is limitless – duck face selfies, possum face selfies, egg holder mouth selfies (all photoshopped). The limits are your internet connection and if your partner finds out your passwords (are you in cold sweat now?) Come and discover the good, the bad and the funny side of social media – where you can see what everyone’s bathroom looks like…")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Susu Smitzh\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Susu Smitzh was born and grew up in South Asia, now living in Sydney, Australia. She is married and a mother of a daughter. She likes drawing, sudoku, watching documentaries, cooking and 50% discounts. This is her very first book.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Don’t Do It, She Likes It")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#introduction"
    }
  }, [_vm._v("Introduction")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#social-media-is-your-parallel-universe-wannabe"
    }
  }, [_vm._v("Social Media Is Your Parallel Universe Wannabe")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#politics-and-biases"
    }
  }, [_vm._v("Politics and Biases")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#biases-in-social-media-in-group-bias-and-confirmation-bias"
    }
  }, [_vm._v("Biases in Social Media: In-Group Bias and Confirmation Bias")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#dunning-kruger-effect"
    }
  }, [_vm._v("Dunning-Kruger Effect")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#lies-about-photoshop-gates"
    }
  }, [_vm._v("Lies About Photoshop Gates")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#that-candid-look"
    }
  }, [_vm._v("That Candid Look")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-singing-video"
    }
  }, [_vm._v("The Singing Video")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#i-just-woke-up-i-cant-sleep-i-have-no-sleep"
    }
  }, [_vm._v("I Just Woke Up, I Can’t Sleep, I Have No Sleep")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#judge-not-lest-you-be-judged-the-look"
    }
  }, [_vm._v("Judge Not, Lest You Be Judged, The Look")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#an-einstein-look"
    }
  }, [_vm._v("An Einstein Look")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#beautiful-face-lifestyle-the-photographer-and-the-phantom-job"
    }
  }, [_vm._v("Beautiful Face, Lifestyle, the Photographer and the Phantom Job")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-phantom-lover"
    }
  }, [_vm._v("The Phantom Lover")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#money-talks"
    }
  }, [_vm._v("Money Talks")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#drama-queen"
    }
  }, [_vm._v("Drama Queen")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#pregnant-selfie-and-post-baby-selfie-syndrome"
    }
  }, [_vm._v("Pregnant Selfie and Post Baby Selfie Syndrome")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-recovery-photo"
    }
  }, [_vm._v("The Recovery Photo")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#unfriend-and-friend"
    }
  }, [_vm._v("Unfriend and Friend")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-make-ups-and-the-breaks-ups-on-social-media"
    }
  }, [_vm._v("The Make Ups and the Breaks Ups on Social Media")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#introverts-and-extroverts-on-social-media"
    }
  }, [_vm._v("Introverts and Extroverts on Social Media")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-fake-love"
    }
  }, [_vm._v("The Fake Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#bragging-about-relationships"
    }
  }, [_vm._v("Bragging About Relationships")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#stealing-identity-and-no-identity"
    }
  }, [_vm._v("Stealing Identity and No Identity")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#celebrities-minions"
    }
  }, [_vm._v("Celebrities’ Minions")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#news-anchor-social-media-hero-and-the-news-breaker"
    }
  }, [_vm._v("News Anchor, Social Media Hero and the News Breaker")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#food-eyes-and-our-mind"
    }
  }, [_vm._v("Food, Eyes and Our Mind")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-mosquitoeses-aka-big-girls-blouse"
    }
  }, [_vm._v("The Mosquitoeses AKA Big Girl’s Blouse")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-controversial-sexy-photo"
    }
  }, [_vm._v("The Controversial Sexy Photo")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#confused-identity-the-pretenders-this-section-is-dedicated-to-many-celebrities-in-some-asian-countries"
    }
  }, [_vm._v("Confused Identity, the Pretenders (this section is dedicated to many celebrities in some Asian countries)")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#variety-of-social-media-parents"
    }
  }, [_vm._v("Variety of Social Media Parents")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#special-dedication-for-selfies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Special Dedication for Selfies")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#the-attempts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The Attempts")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#the-position-and-the-location",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Position and the Location")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#types-of-selfie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Types of Selfie")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#sexy-selfie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sexy Selfie")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#dangerous-selfie-or-drop-dead-stupid-selfie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dangerous Selfie or Drop-Dead Stupid Selfie")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#hollywood-social-media",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hollywood Social Media")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#how-to-spot-someone-jealous-of-you-on-social-media",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Spot Someone Jealous of You on Social Media")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#they-imitate-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They imitate you")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#he-tries-to-compete-with-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("He tries to compete with you")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#backhanded-compliments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Backhanded compliments")])]), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#downgrading-your-success-and-achievement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Downgrading your success and achievement")])]), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#they-will-hate-things-you-love-and-they-love-things-you-hate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They will hate things you love, and they love things you hate")])]), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#they-watch-and-spy-on-your-social-media",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They watch and spy on your social media")])]), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#they-see-you-as-their-rival",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They see you as their rival")])]), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#they-love-talking-about-your-mistakes-and-enjoy-it",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They love talking about your mistakes and enjoy it")])]), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#they-dont-want-people-to-admire-you-and-compliment-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They don’t want people to admire you and compliment you")])]), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#they-tell-you-how-successful-happy-smart-and-wealthy-they-are",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They tell you how successful, happy, smart and wealthy they are")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#the-coded-language-on-social-media",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Coded Language on Social Media")])]), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#most-failed-mistypes-on-social-media",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Most Failed Mistypes on Social Media")])]), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#most-miscellaneous-items-on-social-media",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Most Miscellaneous Items on Social Media")])]), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#the-aftermath-social-media-and-internet-for-us",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Aftermath Social Media and Internet for Us")])]), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#suggestion-to-all-social-media-users-and-countries-to-restore-law-and-order",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suggestion to All Social Media Users and Countries to Restore Law and Order")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#according-to-social-media-companies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("According to social media companies:")])]), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#according-to-society",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("According to society:")])]), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#just-my-humble-suggestions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just my humble suggestions:")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#the-generalisation-of-the-world-on-social-media",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Generalisation of the World on Social Media")])]), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#final-conclusion-and-questions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Conclusion and Questions")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#final-thoughts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Thoughts")])]), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#grand-question-for-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grand Question for You")])]), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#a-note-to-all-dear-world-leaders",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Note to All Dear World Leaders")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#the-countries-that-are-almost-perfect-and-stereotypes-on-social-media",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Countries That Are Almost Perfect and Stereotypes on Social Media")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#special-thanks-to",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Special Thanks To")])]), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#a-mega-special-thank-you-to",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Mega Special Thank You To")])])])])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-top": "150px"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Susu Smitzh was born and grew up in South Asia, now living in Sydney, Australia. She is married and a mother of a daughter. She likes drawing, sudoku, watching documentaries, cooking and 50% discounts. This is her very first book.")])])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "copyright-information"
    }
  }, [_c('h1', [_vm._v("Copyright Information ©")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Susu Smitzh (2020)")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("The right of Susu Smitzh to be identified as author of this work has been asserted by her in accordance with section 77 and 78 of the Copyright, Designs and Patents Act 1988.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Austin Macauley is committed to publishing works of quality and integrity. In this spirit, we are proud to offer this book to our readers; however, the story, the experiences, and the words are the author’s alone.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("ISBN 9781528985529 (Paperback)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("ISBN 9781528985536 (ePub e-book)")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("www.austinmacauley.com")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("First Published (2020)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Austin Macauley Publishers Ltd")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("25 Canada Square")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Canary Wharf")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("London")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("E14 5LQ")])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgements"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-top": "150px"
    }
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', [_vm._v("Firstly, I would like to thank the entire team of Austin Macauley for their help and encouragement to publish this book. I also thank my husband and daughter for their love, support and understanding.")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "introduction"
    }
  }, [_c('h1', [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_vm._v("Hello, my name is Social Media, I am your story, I am your diary, your best friend, online society, civilisation, life and soul. I am for all genders, all ages, all races, cultures, nationalities, ethnicities and religions. I am still young, I am not even twenty-year-old yet I am the most powerful tool in the world for communication and sharing. I know more secrets than the FBI, CIA and your spouse.")]), _vm._v(" "), _c('p', [_vm._v("I make two strangers become lovers, lovers become strangers, your neighbour becomes your mama, the milkman becomes your papa, and papa becomes the milkman, sex magnets become a fridge magnet and fridge magnets become sex magnet. Even I can make vampires stop sucking blood and become blood donors. That shows how powerful I am.")]), _vm._v(" "), _c('p', [_vm._v("My users come from all over the world, seven continents, 195 countries (193 countries are member states of the United Nations). The number of worldwide social media users has reached 3.196 billion in 2018. The population of the world reached 7.7 billion in 2018. It means almost half of the world’s population is social media users. 71% of internet users were social media users, and these figures are expected to increase.")]), _vm._v(" "), _c('p', [_vm._v("They use me for different purposes. Just to stay in touch with what my friends are doing, to stay in touch with current events, to fill up spare time, to spread the word of God, to meet new people, to share my opinion and photos, to expand my business. Oh, cut to the chase, skip the boring part and let’s talk about why you all are here. You all use social media to check up what your exes are up to and if you are much hotter than her boyfriend, to show off your handbags and first-class travel, to see someone else’s bathroom as so many sexy selfies taken in the bathtub, to see the underwear she’s wearing, to see people become sentimental and romantic over politics.")]), _vm._v(" "), _c('p', [_vm._v("Social media is your TV station and you are the news anchor. You choose your news that you are going to broadcast live from your computer, then it is up to the audience. Some news makes you smile or half-smile. Some news makes you poke your eyes with sandals. Some news is just news that makes your heart beat faster, run out of breath, perspiring, you are screaming… then you look for a cigarette with that smile. “That was really good,” you say to yourself, then pass out on the lounge.")]), _vm._v(" "), _c('p', [_vm._v("Warning: this book is not suitable for children under 18. For external use only, not to be eaten or drunk. This book is for fun, there are dramatisations, locations and names are fictional to protect the innocent. This book may contain traces of nuts and choking hazards. Shake well side to side before use, if pain persists, please see your doctor. This book is the story about you, social media addicts, inspired by you, and for you. Pride and fries of social media. Don’t stress too much about social media and this book, if you keep cursing social media and this book, you will be lactating (men can lactate too, you know). By the way, would you like fries with that?")]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "social-media-is-your-parallel-universe-wannabe"
    }
  }, [_c('h3', [_vm._v("Social Media Is Your Parallel Universe Wannabe")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("This is how most of us see our social media: check the homepage, check the notifications, who likes my post, how many likes I get, what did they comment about my post, check the inbox, check who sends me a friend request, then check your friend’s wall, from wall to wall. Then back to the homepage again, then repeat the whole cycle again and again. You know you have read those, you know you have seen those, but you go back there again and again. If this is a house, you check your bathroom, then you go to see your parents’ bedroom, “Hi, Mum and Dad,” your sibling’s room, “Hi, brother,” then you go to the kitchen, walk to the living room, after you see it all, you repeat again. You go to the bathroom again, then to your parents’ room again, “Hi, Mum and Dad,” go round and round until your father says, “What the hell are you doing, you dickhead!” You just look for excitement and something new. You’re expecting to see a new room or a box of treasure in your house that you haven’t discovered (which is impossible).")]), _vm._v(" "), _c('p', [_vm._v("Social media can turn a thug into a nice guy and a nice guy into a thug. Mama says, you must go to bed at 9:00 pm but you go to bed at 9:05, a thug life. Mama says, you must wear your pyjamas, but you go to bed wearing pyjamas and socks, a thug life. You say you’re the toughest man in the world, you will fight anyone who’s standing in your way, but you still sleep with your Hello Kitty soft toy. You say you are the scariest thug, but you have a peanut allergy and flowers allergy. You say you’re the scariest gangster, you have a scary skull tattoo on your arm with writing, “Mama loves me no more,” but you still cry watching the Pretty Boy movie and whenever you open your wallet.")]), _vm._v(" "), _c('p', [_vm._v("Never judge a book by its cover. Most of social media users are here to judge your posts, that’s why there are emojis, likes, dislikes, and comments. Not all thugs are bad. There are some thug-looking men that look like a Hell Boyoyo but have a heart like a Hello Kitty, soft and cuddly. Never judge a camel by its humps, unless you’re a tax office and the banks. They’ll judge you monthly. They can find you wherever you are in the world and never give up chasing you. Even if you go missing in the North Pole, they will find you! Not to help you but ask you to pay your tax.")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, Lord, thank you very much. When I lost hope that no one could ever find me as I’ve been lost for 8 days without food, water and shelter, there you are. Thank you.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s all right, big fellow, but the purpose for which I am here is not because I want to rescue you, I am here because you haven’t paid your tax yet.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh God, this is so cruel. I am really, really dying here. Get me home first then I pay tax.”")]), _vm._v(" "), _c('p', [_vm._v("“Sir, there are two certain things in life: death and taxes,” says the tax man, he looks at you then he adds, “Oh, sorry I forgot, actually there are three. Death, taxes and exes.”")]), _vm._v(" "), _c('p', [_vm._v("“Nooo…! For God’s sake, nooo…! I think I’d better die here when you mentioned the last one. At least I’ll die with dignity.”")]), _vm._v(" "), _c('p', [_vm._v("I turn a grown-up man into a child and a child into a grown-up, a baker into a lover and a lover into a baker, a milkman into a lover and a lover into a milk allergy.")]), _vm._v(" "), _c('p', [_vm._v("“Honey, what’s this? You’ve been exchanging thousands of messages with the milkman?”")]), _vm._v(" "), _c('p', [_vm._v("“Darling, I just want to make sure we got the right milk. I am so careful about milk, I like to know the cow, the process and all.”")]), _vm._v(" "), _c('p', [_vm._v("“But thousands of messages to a… milkman? Come on! From now on, I change milk to soya milk! Is it about the real cow or the milkman? Or you do both of them! Tomorrow, no moo-moo in this house!”")]), _vm._v(" "), _c('p', [_vm._v("“I think you develop a milk allergy and a milk rash. See, when you have a milk rash, you get angry easily. A wise man says, a happy cow is a happy wife.”")]), _vm._v(" "), _c('p', [_vm._v("“I am not afraid of moo-moo, it’s the moan moan that I hate. Have you ever seen a man being jailed because he got a milk rash? Maybe because he’s been milking the wrong women. I am not afraid of Santa either. I just hate it when Santa gives you presents quietly when your husband and children are asleep! Or maybe I am the stupid one.”")]), _vm._v(" "), _c('p', [_vm._v("In this case, I, social media, would like to say yes, you are stupid if you believe you have a milk allergy or a milk rash. You didn’t know your lady has a thing for a milkman. Have you ever heard a saying, “Do not cry over spilled milk?” This is only one true story from millions of true stories on social media. Bias to a stupid thing can make a smart man into a stupid man. Bias to Santa turns you into a generous man. Just like politics, when we have favourites and hate, it makes us biased as it will impact our decision and the way we perceive the world.")]), _vm._v(" "), _c('p', [_vm._v("Basically, you can turn into anything in your social media, it’s limitless. Two things that limit you are your internet connection or when your lover finds out your password. Check your social media inbox again, I think your partner just hacked your account. Is your heart beating faster? Are you in a cold sweat? Is your blood pressure much higher than Mount Everest? Is your mouth wide open and quickly you check your smartphone now, in case your lover hacked your account? Did I just scare you?")]), _vm._v(" "), _c('p', [_vm._v("Social media is used for business, political engagements, news, students, marketing, statistics, relationships, employees, advertising, love, and the lists go on.")]), _vm._v(" "), _c('p', [_vm._v("“I use social media to keep in touch with family and friends.”")]), _vm._v(" "), _c('p', [_vm._v("“No, I don’t have social media. I don’t need them.”")]), _vm._v(" "), _c('p', [_vm._v("That’s what you tell your wife, family and friends. When they are not around, you secretly check your social media inbox, your eyes light up, a big smile on your face and say, “Ayaya…carumba! You are hotter than chicken enchiladas. Aww yes, hit me like a piñata. The more you hit, the more I ejaculate sweets. Yes, yes, yes!” And that picture you are lusting at is not your wife. Meanwhile, on your social media wall, you write how lucky and blessed you are to have the best wife and family, but inside your secret chat room, you write how much you want to be blessed and baptised by hot chicks. I know what you did last night.")]), _vm._v(" "), _c('p', [_vm._v("You are at your best behaviour when you’re using social media. It does not necessarily need to be wise, honest, smart and have emotional maturities. You choose and select the content that you’re going to post. Hence, all of your pictures are flawless on social media. All of your posts you share are the information that you agree with and the proof that you are right.")]), _vm._v(" "), _c('p', [_vm._v("Have you ever seen a post which is proof that you are a liar and cannot be trusted? Nope. The point is, you are fully aware and conscious of when and what you post on your social media. You don’t write on your wall when you’re asleep, do you? Sleep walking? Sleep networking? I don’t think so. If your post is so cringeworthy and causes so much controversy, just post it again and tell them your account has been hacked. It is not you, blame the hacker. If anything goes wrong, blame the hacker. Is your girlfriend pregnant? Well, it is not her account that has been hacked, it is the milkman who secretly spilled the milk, not the hacker.")]), _vm._v(" "), _c('p', [_vm._v("In my ancestry, a cell phone was born. It was bulky, heavy and huge like a new-born baby. You could tell the difference between a cell phone user and a non-cell phone user. How? The guys with the muscly Rambo arms were the cell phone users. Keep picking an old cell phone is like weightlifting.")]), _vm._v(" "), _c('p', [_vm._v("Then SMS and email were born. Actually, they are my siblings, we have the same mama and papa, an internet family. See, I have a family too just like you. If my Dad is angry, there will be no internet connection for us. This will impact you, too. Make you sure you be nice to Dad, so you can chat, share, flirt, twerk, share joy and happiness, share your crying and tears online. I am the youngest one, I was born in 2000s, I am the youngest one but I am the most popular one.")]), _vm._v(" "), _c('p', [_vm._v("I hold all of your secrets, all your juicy, dry and dirty secrets are with me. Some of you are hypocrites. What you write on your wall is totally different from your inbox. All I can say is when you drop all those bombshells in your inbox, wow, I almost fall off my chair. You act like a Wi-Fi angel or wingel (you only open your wings when Wi-Fi is available) on your wall but you are a hasshole, AKA hairy asshole, when it comes to your inbox.")]), _vm._v(" "), _c('p', [_vm._v("In social media, forget the wall. The wall is full of adverts and how good of a person you are, full of self-promotion. The inbox is where all the dark affairs begin and wars begin. These are my facial expressions when you write in your secret inbox:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("I roll my eyes")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("I shake my head")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("My mouth is wide open")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Nausea")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Sneezing")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Laughing")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Wrinkle in my forehead")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Combination of all the above")])])]), _vm._v(" "), _c('p', [_vm._v("You write on your wall about that guy, “He’s a pimp! He has no soul!” But later you inbox him, “Psst… do you have new stock? Any new girl?” Or you tell your wife and family you don’t have social media. Of course you don’t, I mean you don’t use your real name and real photo for your social media account. You look completely unrecognisable on your social media, I see you use a photo of a very good-looking man with a six pack for your social media image, despite in real life your real look is a far cry from six-pack abs like your social media photo, but your real abs say you’re a burger lover.")]), _vm._v(" "), _c('p', [_vm._v("The majority is not a hasshole, thank God for that. There are so many beautiful secrets I hold. I know who you are, you are truly a hero. You never post how you save some nuns and children from a zombie, or post your photo feeding starving people, hugging a sick child, no, you don’t do that. You don’t write how great you are or some wisdom crap either on your wall. But secretly inside the inbox you have helped and touched so many people by either your support or love. You don’t need validation and accolades from others, because you have a heart of gold. Many times I clap my hands because of the good things you’ve done.")]), _vm._v(" "), _c('p', [_vm._v("There are many good Samaritans on social media. They rally and stand up together for a good cause. With social media, we can become united for love and humanity. There is a big difference between sharing positivities and love together, and competing in the name of a good cause just to reach that title: to be the best person, the hero who helps the most, where ego and narcissism talks.")]), _vm._v(" "), _c('p', [_vm._v("The fake philanthropists do good things to compete with other good Samaritans. They help people to get recognition, attention, compliments and accolades. They love to be showered with compliments. They more they have likes, the happier they are. They use poverty and tragedies to boost their bloated ego and are superficial. Narcissists want to be called a hero when they post their charity work. And they hate it when they see the other good Samaritans do the same to help people, because in their mind, they want to be recognised as the only hero to save the world. This is what narcissists think – if the other can feed one village, I can feed two villages. They build one school, I have to build two schools.")]), _vm._v(" "), _c('p', [_vm._v("Most of us are a philanthropist, we don’t write how many people we have helped or how many good things we’ve done. We write it in our heart, not on social media. To be a good Samaritan is not social status to upgrade your self-image. When you do something from the heart, there’s no strings attached. But when you do something from ego, you want something in return. Just like business, there’s a demand and supply, no free ride.")]), _vm._v(" "), _c('p', [_vm._v("Social media doesn’t applaud you because you are a nice person, an angel, the richest, the smartest one, a bad person, a narcissist, Machiavellian, two-faced, three-faced, a pervert, upvert, downvert, photoshop maniac, psycho backside, cupcake killer, duck face selfies, nutters and all that creepy stuff online, or whatever you are. Social media doesn’t care, it just cares about mighty dollars. Why are many violent videos and graphic photos still around social media? Read again, because they don’t care. They deal with Satan and vampires too if they have to, as long as they make big money.")]), _vm._v(" "), _c('p', [_vm._v("Did social media ask your permission to use your information and sell it to other companies? Did social media force you to sign terms and agreements as if you have clicked ‘agree’ whether you like it or not? Did social media ask your permission to expose what information that you just gave a like, when you wrote the last comment, when the last time was that you were active? No. Because it (social media) thinks it is too big to stop and listen to us, listen to what users need and want. They think we need them more, the fact is they need us more than we need them.")]), _vm._v(" "), _c('p', [_vm._v("Social media doesn’t care if you are angels from heaven or devils from hell, as long as social media makes big money. Well, social media has policies too, to report bullying, harassment, self-harm, crimes and all the bad stuff. But come on, it’s only for display and advertising for: “I, social media, am a good person, I am here to help.” The fact is, there is still much dodgy and terrible stuff which is still around in social media.")]), _vm._v(" "), _c('p', [_vm._v("This is why I am here, I am your book, your secrets, your messenger, your mirror, your journal, your wonder wall, your diary, your life and your soul. According to a Pew survey which was conducted in 2014 – 2015, 94% of teenagers go online every day on their smartphone daily. 71% of them have more than one social media site.")]), _vm._v(" "), _c('p', [_vm._v("Signs you are addicted to social media:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Before you go to bed, you check your social media, you wake up in the middle of the night, you still manage to check your social media, even just scrolling on the home page or timeline.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Every morning once you’re awake, the first thing you do is check your social media, in case you have missed some news or new things.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You just waste your time looking at procrastination and nonsense. They can be entertaining but most news of social media doesn’t do any good for your health. You are glued to social media, scrolling for hours to read most of the news. Looking at social media is your activities.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You check in everywhere you go.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Checking your notifications all the time. Some social media addicts have a delusion that their phone vibrates or receives notification.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You focus on likes, comments and shares you receive. Especially for likes, that matters the most. For social media addicts, receiving likes is like receiving a blood transfusion to make you alive again.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Taking photos of everything, even a tasteless and senseless one like an accident. First thing you do when you see an accident, you don’t help the victim but you grab your smartphone and share it on your social media, which is morally wrong. Social media addiction is a moral issue, sharing everything without thinking, "), _c('em', [_vm._v("Is my post morally right or wrong?")]), _vm._v(". From all the food you eat, the video of your wife giving birth, having a shower, constantly taking selfies from anywhere, when you just hit the pillow, all your movements, anything.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Social media is not just a part of your life but has become your life. Without it, you lose interests in doing anything. You feel something is missing in your life if you don’t have an internet connection, you just don’t feel right if you can’t see your social media.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Loss of interest to communicate with real people in real life and do activities.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Your children are there playing with their toys next to you, but your mind and hands are on social media, you are communicating and looking at your social media more than spending time to have communication with your children. You get together with your friends, you all sit at one table with your friends, you all are busy communicating but not to each other, to your smartphone and interact less with each other. No social media is no life, for social media addicts. You are sick, can’t sleep and eat well, but you’re lying in bed staying online non-stop looking at your smartphone. Well, this doesn’t help your health at all. You are a selfie addict. If you have an addiction to alcohol, sex and gambling, you go to meetings and rehab. But if you have a selfie addiction, the only thing that stops you taking selfies is when you hear this, “Don’t move! Hands up! You are under arrest!”")])])]), _vm._v(" "), _c('p', [_vm._v("This is a common view about a new mother, you are pushing a stroller with your baby in that pram. Something unusual about this is you don’t push the stroller with your hands but with both of your elbows while your hands are checking your social media. So your eyes and your mind are juggling between watching the road and social media.")]), _vm._v(" "), _c('p', [_vm._v("Social media makes you disconnect from reality but stay closer to the cyber world. You feel you more belong in the cyber world, not in real life. Social media is your sunshine and universe. People who get addicted to alcohol are called alcoholics, addicted to work is a workaholic, addicted to chocolate is called a chocoholic, social cyber addiction is called a soberdict. You use social media like you use a padded bra, to boost and inflate your ego, without it you feel smaller and can’t stand firm.")]), _vm._v(" "), _c('p', [_vm._v("Social media has changed the way we communicate, share and get connected to the world. These days, you don’t have to be nice to have a friend, as long as you have Wi-Fi, you’ll get friends from around the globe. Life through the ages has been between tribes, families, children and relationships, not with current technology.")]), _vm._v(" "), _c('p', [_vm._v("God didn’t give Moses the Ten Commandments through social media. The earliest true writing systems are the Sumerian archaic and the Egyptian hieroglyphs, both emerged from their ancestral photo-literate symbol systems from 3400 – 3100 BC, with earliest coherent texts from about 2600 BC. Should the smartphone and social media have existed in those days, it could’ve been less effort for them to write it on their social media wall than chipping it into the rock as they could’ve zoomed in and zoomed out, added emojis and likes. Then around 100 BC, paper was invented in China. In 105 AD, during the dynasty of Han emperor Ho-Ti, a government official in China named Ts’ai Lun was the first to start the paper making industry. The first recorded zero appeared in Mesopotamia around 3 BC. The first selfie appeared in 1839 by Robert Cornelius.")]), _vm._v(" "), _c('p', [_vm._v("The new generation has been influenced by social media. It has changed the way we live. Your mood is dependent on what happens on your social media, basically social media dictates your happiness. There is a song from Crowded House, "), _c('em', [_vm._v("Take the Weather with You")]), _vm._v(". Your social media has become the weather for its users. It brings sunshine, rainbows, and also bad weather such as hurricanes and storms, even a tsunami. Happiness comes from what we see, hear, listen to, touch and feel. Happiness make us more positive and motivated, mostly coming from kindness and love. But for soberdicts (social cyber addicts), the happiness comes from the speed of the internet connection, if the battery is full, likes, emojis, and all attention in social media.")]), _vm._v(" "), _c('p', [_vm._v("It is very rare to see someone who doesn’t use social media to communicate. Some who refuse to use social media because they believe the valid communication is to interact face-to-face, not from staring at a smartphone. What is communication? According to a dictionary, communication is the imparting or exchanging of information by speaking, writing or using some other medium. To communicate is to share or exchange information, news or ideas.")]), _vm._v(" "), _c('p', [_vm._v("The most common communication since the stone age is face-to-face interaction. This boosts collaboration and creativity through the ability to share ideas more freely. The advantages of real communication are, we can see the body language, facial expressions, intonation of voice, feelings and reactions, directly. Social media has expressions too, which are called emojis.")]), _vm._v(" "), _c('p', [_vm._v("If we used these emojis to express our feelings in ancient times, it would’ve been very strange, it was not really what warriors would do. Now, what emoji would the Vikings use? I think it wouldn’t be a big heart or a big kiss emoji. If the Samurai or Bushido, the highest-ranking social class of the Edo period in Japan (1603 – 1867) used social media – Shimaju Yoshihisa, one of the famous samurai heroes, just posted a photo of his samurai. We were assumed he would’ve attracted millions of fans from around the world, his photos would’ve broken the internet. Big possibilities of the comments on his photos would’ve been like these:")]), _vm._v(" "), _c('p', [_vm._v("“Shimazu Yoshihisa, you are my hero,” said the girls with a big kiss and love emoji.")]), _vm._v(" "), _c('p', [_vm._v("“Oh, my gosh. You look hot, hot, hot, marry me.”")]), _vm._v(" "), _c('p', [_vm._v("“I’ll die to have a samurai like yours, Yoshihisa. Mine is only an ordinary samurai. My wife was chopping onions and garlics for fried rice using my samurai.”")]), _vm._v(" "), _c('p', [_vm._v("“So your enemies will smell like onions and garlic then.”")]), _vm._v(" "), _c('p', [_vm._v("“My enemies were screaming so loud begging for mercy when I used my favourite samurai.”")]), _vm._v(" "), _c('p', [_vm._v("“Actually, your girlfriend was louder than your enemies last night.”")]), _vm._v(" "), _c('p', [_vm._v("“Master Shimaju Yoshihisa said, he had a vision about the future last night. He looked so upset, he said in his vision, he sees men won’t use samurai anymore. But they use a selfie stick.”")]), _vm._v(" "), _c('p', [_vm._v("“A selfie stick? So in the future, all of them are fighting with the selfie sticks to kill the enemies?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, they use selfie sticks to take a picture of themselves, then they fight over that selfie.”")]), _vm._v(" "), _c('p', [_vm._v("“Are they warriors or a bunch of Tupperware Ladies?”")]), _vm._v(" "), _c('p', [_vm._v("“No more samurai, it will be a selfie-stick battle.”")]), _vm._v(" "), _c('p', [_vm._v("Imagine if a mammoth had social media. She just posted her selfie, then came a carnosaurus to reply on her post. A carnosaurus was a dinosaur with a massive body, beefy shoulder blades, but the hands were very small, little more than nubs that would have barely stuck out from the body.")]), _vm._v(" "), _c('p', [_vm._v("He leaves a comment on the mammoth’s selfie, “Gorgeous! Wow, what a fabulous body you have. Nice photoshop!”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you so much, handsome. I love your small and upturned nose, your full sexy lips, six-pack abs and those muscly long hands. Wow, who looks so alluring here. You’ve photoshopped so well, too!”")]), _vm._v(" "), _c('p', [_vm._v("“I am so totally blushing with your compliments, girlfriend,” said the carnosaurus, he’s very shy indeed.")]), _vm._v(" "), _c('p', [_vm._v("“Awww… me too. Oh, I have butterflies in my stomach,” said the mammoth, “Yes, I ate butterflies for lunch.”")]), _vm._v(" "), _c('p', [_vm._v("“I have worms in my stomach,” said the carnosaurus.")]), _vm._v(" "), _c('p', [_vm._v("Then the carnosaurus sent a big hug emoji to the mammoth which replied with a big kiss emoji.")]), _vm._v(" "), _c('p', [_vm._v("A cave lion who just happened to read those, couldn’t resist to leave a comment, “Omg! This is so, so super awesome. How romantic, I am so totally happy for you both, a super cool couple. Oh… I think I’m starting to cry now… Come on, I’ll give you both big hugs.”")]), _vm._v(" "), _c('p', [_vm._v("The carnosaurus, mammoth and cave lion clicked group hugs emoji (not group sex, but maybe later on, who knows) many times. Group hugs for anyone who reads this, too.")]), _vm._v(" "), _c('p', [_vm._v("There is a video call application which allows you to communicate face to face but not real face-to-face communication with which we can see the whole shebang unfettered by the size of a smartphone screen. This app is like you’re enjoying a view from a small window. Meanwhile, real face-to-face communication is like seeing the view at a location, an uninterrupted view.")]), _vm._v(" "), _c('p', [_vm._v("This app is fun and so futuristic, you can talk to someone and see him from the other side of the world, live from your smartphone. To put it simply, talking to someone by using this app is like you’re talking to an inmate in a maximum-security prison. You can touch him, you can see him but through a glass window, you and he still have to use a phone to communicate.")]), _vm._v(" "), _c('p', [_vm._v("Thanks to Shigetaka Kurita, who invented emojis in 1999. Thanks a lot too to emoticons which were invented by Dr Scott Fahlman, that humble smiley face in 1982. Talking about expressions, it’s been well known for centuries that the obesity and the anorexia of our wallet also has a strong power to control our mood and expression. By looking at your wallet days before your payday, your mood changes drastically. After a pay cheque, your mood improves significantly, you see smiley faces, flirting eyes and big kiss emojis on your wallet and also on your bank account balance statement from the ATM. When you only have $5 left in your bank account, you can see a crying face and a poke-me-in-the-eye emoji on your bank statement.")]), _vm._v(" "), _c('p', [_vm._v("One common thing they all have, regardless of what you feel these days, you all share one position: staring at your social media, scrolling down all the posts. How you feel today or yesterday or in the stone age (should you still be alive then), it will be revealed on your social media. You gain weight or lose weight, you’re on a diet or cakes diet or diamonds diet, happy, sad, angry, joyful, in love, rich, poor, tragedy, triumph, holiday, good luck, bad luck, the good, the bad and the ugly, it’s all there.")]), _vm._v(" "), _c('p', [_vm._v("You may say you could be a psychopath, sociopath, a porn star, a corn star, a devil, an angel, a hero, a liar, a communist, a conservative, a leftie, a righty, all good and evil in the world but one thing you all have in common: you filtered your photo… To look smooth, younger, flawless, with no wrinkles and no acne. Have we come across a selfie that has not been filtered and blurred? We all know the differences between the latest TV with ultra 8K, and black and white TVs. The more advanced the TV is, the more it has clarity and definition. If you go to see the latest TV, you can see how magnificent the clarity is and how sharp the pictures are, as if the water you see on TV is in front of you.")]), _vm._v(" "), _c('p', [_vm._v("Have you seen selfies with ultra 8K definition on social media? You can see the skin pores of hers, eyebrows, the wrinkles very clearly, just like you see on the latest TV. No, they have filtered and photoshopped their photos. Sometimes way too much, we can see the eyes and the mouth but we can’t see the nose and the eyebrows, they disappeared due to too much filter. The only selfies that never use filter is the selfies from Discovery Channel and all science programs.")]), _vm._v(" "), _c('p', [_vm._v("Anywhere you go, it is a common view to see people just staring at their smartphones as if we were born with smartphones stuck in our hand. If aliens have been watching us from the space, they would’ve thought, “This is strange, people on Planet Earth are committed to this thing called a smartphone. They are inseparable, we see them flirt with their smartphone, laugh, cry, sing, dance, talk and even they masturbate with this! They act like a husband and wife. Look at that man down there! He just grabbed his hand lotion and is doing it again! How could they become intelligent and conquer the universe if all they do is a duck selfie or that egg holder mouth selfie! We change the shape of the future with our brains and meanwhile these people keep filtering their selfie! This is why we don’t live on Planet Earth, the trailer trash, selfies, duck face selfies, egg holder mouth selfies, photoshopped maniac, Botox, pillows and panties fights on social media over politics. Come on, let’s get out of here!”")]), _vm._v(" "), _c('p', [_vm._v("Maybe if our smartphone could talk, it would’ve said this to us, “Geez… do I have to look at your face every day? Before you doze off, you look at me. You get up in the middle of your sleep, you look at me again. When you just wake up, you look at me, again. You brush your teeth, you look at me. You’re sitting on your toilet, you look at me. You’re in good health and bad health, you still look at me. What did I do to deserve this? I have to look at your face again and again. Wow, what a joy… Not! If I could punch you, I would.”")]), _vm._v(" "), _c('p', [_vm._v("If a smartphone were your lady, that smartphone would give you the silent treatment because it would be angry at you, too much time on your social media. Or it would turn itself off or be on mute all day. You asked what’s wrong, it says, “Nothing!” When it is really angry at you, you can’t turn the volume up or down. All volume is at the same level, mute. Then you can’t turn the volume down at all as if it were always at the maximum volume of sound as if it was screaming all the time in your ears.")]), _vm._v(" "), _c('p', [_vm._v("A smartphone doesn’t talk back. It is only a gadget. But you will suffer a minor heart attack it you forgot your smartphone, meanwhile you forget you have left your wife several times at the supermarket but you were not really panicking as if you lost your smart phone.")]), _vm._v(" "), _c('p', [_vm._v("If a smartphone were alive, if it had two nostrils, one mouth and two hands, these would be what your smartphone would do for you:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("You would’ve been slapped by your smartphone because you wrote some bad words on your social media after your smartphone said, “You bastard!”")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You would’ve been told off by your smartphone because you lied on social media or used it for revenge and anger, it would scream at you, “Asshole!”")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Your smartphone would’ve been sneezing at you because you posted bullshit stuff, smartphones have a bullshit allergy, you know.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You would’ve been electrocuted by your own smartphone because you’d been spreading propaganda and being manipulative to play off against each other.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("How many times had your smartphone been vomiting because you were a narcissist, desperate for attention and compliments?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("How many times had you been tasered by your own smartphone because you were being a bully and coward?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Your battery was always full and recharged no matter the duration for which you used it because you were a good person who shared your kindness, joy and love for others.")])])]), _vm._v(" "), _c('p', [_vm._v("As mentioned above, a smartphone doesn’t talk back. In saying that, the latest smartphones come with this technology which allows you to say anything you want and it will answer all the questions. Due to legal reasons and copyright, I can’t use their real names, let’s say the voices were those of Mao Ug Lee or Xi Lai Lai. These voices of Mao Ug Lee and Xi Lai Lai are included in your smartphone. They speak with Chinese accents.")]), _vm._v(" "), _c('p', [_vm._v("“Good morning, Mao Ug Lee, what is the weather today?”")]), _vm._v(" "), _c('p', [_vm._v("“Today is 22 degrees Celsius, as warm as dim sim,” replies Mao Ug Lee.")]), _vm._v(" "), _c('p', [_vm._v("“Good afternoon, Xi Lai Lai, where is the closest restaurant?”")]), _vm._v(" "), _c('p', [_vm._v("“Good afternoon, Yum Cha Cha, the closest one is exactly behind you,” says Xi Lai Lai, “Behind your behind.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you.”")]), _vm._v(" "), _c('p', [_vm._v("“By the way, your zipper is undone. Please, the flies are sneezing a lot here.”")]), _vm._v(" "), _c('p', [_vm._v("“Sorry,” you apologise.")]), _vm._v(" "), _c('p', [_vm._v("“Hi there, Mao Ug Lee, where is the closest hot chick with big tits here?”")]), _vm._v(" "), _c('p', [_vm._v("“Confucius says, you go to hell, you asshole! You’re a married man!”")]), _vm._v(" "), _c('p', [_vm._v("Why do they always know everything? Secretly they are not robots, they could be a spy who is employed by your mother who knows everything about you. Test the water, ask Mao Ug Lee or Xi Lai Lai this question:")]), _vm._v(" "), _c('p', [_vm._v("“Good day, Mao Ug Lee and Xi Lai Lai, what do you think of my exes?”")]), _vm._v(" "), _c('p', [_vm._v("“A colonoscopy, if pain persists please see your doctor.”")]), _vm._v(" "), _c('p', [_vm._v("Ha! That is your mother, not a robot. Because mother think she knows what’s best for us or not. Test them again by asking these questions:")]), _vm._v(" "), _c('p', [_vm._v("“How do I look today?”")]), _vm._v(" "), _c('p', [_vm._v("“You look super fabulous, if I see you from space.”")]), _vm._v(" "), _c('p', [_vm._v("“Aww… so feisty! Now tell me, how do I look today?”")]), _vm._v(" "), _c('p', [_vm._v("“Your car is a chick magnet, but your body is a fridge magnet.”")]), _vm._v(" "), _c('p', [_vm._v("“Excuse me?”")]), _vm._v(" "), _c('p', [_vm._v("“You look as gorgeous as a doll. A voodoo doll! If you keep asking me how you look today blah blah blah… I suggest you go and do yourself!”")]), _vm._v(" "), _c('p', [_vm._v("Now you know they are your exes as the voices of Mao Ug Lee and Xi Lai Lai.")]), _vm._v(" "), _c('p', [_vm._v("Ask this question:")]), _vm._v(" "), _c('p', [_vm._v("“Mao Ug Lee and Xi Lai Lai, have you seen my wallet?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, but you have to pay me $10 and I’ll tell you where it is.”")]), _vm._v(" "), _c('p', [_vm._v("“Excuse me?”")]), _vm._v(" "), _c('p', [_vm._v("“Just give me your money, or else, I’ll give you my money.”")]), _vm._v(" "), _c('p', [_vm._v("In that case, it is not your exes nor your mother as the voice of your Mao Ug Lee and Xi Lai Lai, but it is when your smartphone become a smart ass.")]), _vm._v(" "), _c('p', [_vm._v("One day without social media for you, how will you cope? Will you be panicking and feeling empty? Or does it not really matter to you? If you don’t feel your day is a normal day without checking your social media, it means you are addicted to social media. You also missed the much bigger picture, to treasure your real life, you missed how it feels to enjoy the blessings, joys and happiness in real life. Social media addicts are detached from the facts and real life, physically you’re here in the real world but spiritually you’re in the Wi-Fi world. Yes, actually being on social media is like being an exorcist. It is not Satan who possesses you but the ghost of a chicken from the past, because you are clucking all the time as your eyes are hypnotised by social media. Then you produce an egg, well, it ain’t an Easter egg.")]), _vm._v(" "), _c('p', [_vm._v("Do you still remember the last time you felt so grateful for your real life? You don’t have to say it and prove it on your social media that you feel blessed and grateful, being grateful and so blessed is the appreciation proven by the way you see the world and the way you conduct yourself, it comes from your heart, not from likes and shares on your social media. Social media addicts will tell you when they feel so grateful and so blessed on their social media, they are more attached to their cyber world but far, far away from real life.")]), _vm._v(" "), _c('p', [_vm._v("Obviously, there is a rhino sitting on your lap, yet you don’t feel it and see it, but when you see one disagree with your social media, just one disagreement, it is a red flag to you! This is a nuclear war to you. You pay more attention to online news also, you believe that online news is more reliable than real news in real life. Why? Because to you, that news that happened in real life isn’t as attractive as social media news, where we can share what we think and engage with others at the same time about the same topic. The more enthusiastic you are to give responses in the cyber world, the slower you are to respond to your real life.")]), _vm._v(" "), _c('p', [_vm._v("One of the reasons, again, why you are more alive and responsive in the cyber world is because you don’t have to show your real face, real name and real address. Thus, this means you can say anything without being afraid of the consequences. Contrary to real life where you have to be polite and careful when saying things, or else you’re going to be slapped by a girl every two seconds.")]), _vm._v(" "), _c('p', [_vm._v("The words “Hello, how are you?” are now replaced by ‘follow’, ‘subscribe’, ‘friend request’. You go to a fish and chips shop, then you spot this beautiful girl, you pay the bill and say to that girl, “Don’t forget to subscribe me, give a thumbs up, follow and share.” Then you walk off. You go to a massage parlour, and before you finish the massage, the girls say to you, “Don’t forget to subscribe, like and leave a comment down below,” Well, we know for sure you have been subscribed to her massage parlour and leave a comment bellow for an extra you know what.")]), _vm._v(" "), _c('p', [_vm._v("If social media already existed during WW2, should Stalin have had social media, Stalin would have just posted on his social media, “You have to approve my friend request or I’ll shoot you!”")]), _vm._v(" "), _c('p', [_vm._v("One of his soldiers posted, “I am so, so totally craving chocolate right now.”")]), _vm._v(" "), _c('p', [_vm._v("Stalin posted in between the battles, “Mussolini, you look so super cool in those pants.”")]), _vm._v(" "), _c('p', [_vm._v("Hitler left a comment on Mussolini’s post. Mussolini replied, “Thank you, by the way, does this gun make my hips look fat?”")]), _vm._v(" "), _c('p', [_vm._v("Do you want to see a soap opera live from your computer? Pick a photo of four or five girls, and leave a comment, “The good, the bad and the ugly,” without telling them which one is which. Grab some soda and a bowl of popcorn, you’ll watch the drama unfold live from your computer.")]), _vm._v(" "), _c('p', [_vm._v("Remember those days when you got addicted to a TV soapie? You’d been waiting all day just to watch your fave soapie, here comes the scene where all the family and close friends got together. Then came the pregnant girl, they all were staring at her waiting for her answer. She was looking down, feeling guilty and said, “Actually… the father of my child is…” She paused, the whole room went quiet and anxious, especially all men who were looking at each other with suspicion. The grandma stood up angrily, “Tell me! Tell me! Who is the father?” The pregnant girl was crying then looking at her grandma, and said, “The real father is… the real father is…” Then to be continued, finish. You all were screaming too, “No…!” That is exactly like social media dramas, streaming live daily on your computer screen. You love watching live sports, don’t you? It’s better than a repeat of sports.")])])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "politics-and-biases"
    }
  }, [_c('h1', [_vm._v("Politics and Biases")]), _vm._v(" "), _c('p', [_vm._v("Because of me, too, so many politicians have won the election and many politicians were defeated. I have played a vital role in politics, and your life. Yes, I have caused chaos and controversy in politics, but people turn to me when they want to have their say about politics or non-politics. Without me, politics is not alive. I allow you to communicate and question the candidates without the middleman. I am used as a political campaign, even worse I am used to spread propaganda, false news and hoaxes to eliminate the rivals.")]), _vm._v(" "), _c('p', [_vm._v("How do social media users see the news and justice? They go to social media. How do they solve the problem? They go to social media. Why social media? Because it is how they want to convince people who’s right and wrong. This is why social media plays a major role in a cyber trial. Is it fair? If they are patient, honest, without bias, no pros, no cons, it will be fair dinkum.")]), _vm._v(" "), _c('p', [_vm._v("Having bias, pros, cons, hate, favouritism, there won’t be justice. It is called a tele nova, when everything is scripted and staged. There is much news in which some parts have been added or subtracted from the truth. Even some news has been added to with many ingredients to spice it up so it makes the reader easier to love or to hate. Have you ever seen a biased person feel embarrassed? Biased people can’t feel embarrassed and shy. Imagine if Idi Amin and Hitler got embarrassed,")]), _vm._v(" "), _c('p', [_vm._v("“Ohhh… I am so shy and embarrassed. There’s a hole in my pants, I am so super embarrassed. Did you see my curvy ass?” says Idi Amin.")]), _vm._v(" "), _c('p', [_vm._v("“Omg, omg, me too. My shirt has a hole in the armpit. This is so totally embarrassing, I can see my armpit hair sticking out,” says Hitler.")]), _vm._v(" "), _c('p', [_vm._v("“Oh… Hitler, look! You have one eyelash that fell on your cheek, did you know it means someone has a huge crush on you?”")]), _vm._v(" "), _c('p', [_vm._v("“Really? Oh gosh, I am so flattered and so shy right now.”")]), _vm._v(" "), _c('p', [_vm._v("“We are so super blushing right now. Oh, gosh, our cheeks turn pink because we are shy guys,” Idi Amin and Hitler are blushing, putting their hands in their cheeks.")]), _vm._v(" "), _c('p', [_vm._v("Biased people can’t accept the facts, they deny the truth because the expectation does not match their real life. A biased person goes to an ATM, asking for a billion dollars. The ATM denies it due to his account balance being less than $100. He screams at the ATM that he is the richest person in the world and no one ever tells him that he’s wrong, not even an ATM. He throws some punches at the ATM, yelling, “You want a piece of me? You are a liar, bigot, racist, and stupid!” He keeps headbutting the ATM till the ATM reduces his account balance to zero dollars.")]), _vm._v(" "), _c('p', [_vm._v("Biased people, narcissists, Machiavellians and psychopaths develop seven phobias: remorse phobia, empathy phobia, down to earth phobia, shy phobia, embarrassed phobia, the truth phobia, and apology phobia. Why? Because they are afraid of being themselves and too afraid to accept the facts. If this is a car, it is a lemon car. There are no brakes, the battery has been in a coma for a long time, never regaining consciousness. How do you stop your lemon car when the car has no brakes? The only one way to stop this car is to keep dabbing the machine with a wet towel or you have to open the door and slide your shoes on the street to slow the car down. If this car is a Japanese warrior, it would kill itself in honour to the Emperor as it has no dignity to be a car anymore. It is better to die with dignity and pride than to live as an ignorant.")]), _vm._v(" "), _c('p', [_vm._v("Politics and social media are like a marriage, inseparable. No social media means no politics, and vice versa. Have you seen a politician without social media? Maybe in North Korea. In most countries, all politicians and people use me as their platform. If you believe social media does not have a maximum impact on politics, this is like you believe that lightning strikes are actually a flash from God’s camera when He took a photo of us.")]), _vm._v(" "), _c('p', [_vm._v("Any politics is here, doesn’t have to be a politician to be involved in politics. The way you suck up to your boss, that’s your politics at work. The way you talk about your big investment and money to your friends even though you don’t have that much money like you keep telling people, that’s your politics to make you look good. The way you make friends and unfriend friends, join the group or out of the group, that’s your politics in social media.")]), _vm._v(" "), _c('p', [_vm._v("Well, all of us were born here in this world because our mum and dad had sex or a diplomatic exchange, but now I am not talking about that politics,, I am talking about politics, that can cause a war not a wiggle, wait a minute, politics, can make a wiggle too, you know. Talking about politics is like squeezing a man’s balls because by squeezing that ‘magic’ word, it can make everybody scream in pain. Politics can divide people or unite the world. Hey, don’t blame me, I am just the middleman. You may accuse me that I am involved in politics, but actually my motivation isn’t about politics. It is money. I just use you for money. Do you think I am here to make cupcakes with you? Do you think I am your fairy Godmother? No, I am not your fairy Godmother, I am just your mirror. You are what you say, do and think. I am your reflection.")]), _vm._v(" "), _c('p', [_vm._v("You see me, I see you, I am your mirror. This is how others see you in the online world and offline world. You complain you don’t like your own reflection? You complain people don’t like you online? To put it simply, if you always post anger, hate, lies, too much drama, always drop some names, slander your opponents, that’s what you are. You = anger + hate + too much drama + manipulative x 30 (there are 30 days in a month). That’s what you are in a month. Or maybe in a month you show your emotional maturities for two days, but the rest are spent being childish. It means the chance for you to be an adult is every 1 in 15 days.")]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "biases-in-social-media-in-group-bias-and-confirmation-bias"
    }
  }, [_c('h3', [_vm._v("Biases in Social Media: In-Group Bias and Confirmation Bias")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("There are 178 biases listed. In social media, some of the most common biases are confirmation bias and in-group bias. Also, the Dunning-Kruger Effect happens a million times in social media daily. I’ll explain that later. What did you say? You ask me if you have a bias to be sleazy, perverted and creepy? I don’t know what that bias is, but I know what it is called, a moron. That’s your name.")]), _vm._v(" "), _c('p', [_vm._v("How the others see you varies, depends on how they feel about you, both good and bad. Even if you didn’t do anything wrong, you still can’t please everyone. If they have a clear vision without any cognitive bias, they will get a clear picture, they will call a flower a flower, butterflies as butterflies, butter is butter and sex is sex. Biased people are different, they don’t want to admit that they have sex they just said, “No, I didn’t have sex with that girl, it was a cultural exchange or student exchange, some overtime or teamwork. This is how we work, with good teamwork.” In politics, a blowjob is not considered as sex. In politics, a scandal is not considered a mistake, it is called a team effort, or overtime.")]), _vm._v(" "), _c('p', [_vm._v("If you add some bias you will make an error in judgement, even if it is only a tiny bit of bias, it is like adding a drop of ink into a cup of milk, it is not a pure white anymore because you have a bias. As I said, I am just your mirror. Friends who have the same interests as you will see your reflection is better looking than those who don’t have the same interests.")]), _vm._v(" "), _c('p', [_vm._v("People who always agree with you tend to like you more and see your reflection as more attractive than seeing people who disagree with them, and vice versa. Same as people who share the same political point of view as you, they will find you more personable and attractive than those who don’t.")]), _vm._v(" "), _c('p', [_vm._v("“Hi, gorgeous, are you going to vote for Humpty Dumpty tonight?”")]), _vm._v(" "), _c('p', [_vm._v("“No, I am voting for Ginger Bread Man.”")]), _vm._v(" "), _c('p', [_vm._v("“Ugh, you’re ugly, you vote for Ginger Bread Man. Hope you have bad karma.”")]), _vm._v(" "), _c('p', [_vm._v("“Hi, blop fish. Are you going to vote for Humpty Dumpty tonight?”")]), _vm._v(" "), _c('p', [_vm._v("“As a blop fish, yes, I am voting for Humpty Dumpty.”")]), _vm._v(" "), _c('p', [_vm._v("“Awww, you are so wonderful. I love you blop fish. You are the most beautiful creature in this world.”")]), _vm._v(" "), _c('p', [_vm._v("As for confirmation bias, we are more drawn to information that confirms our belief and opinion as right. We think we know what most people think but actually we don’t. A confirmation bias is a tendency to accept the evidence that confirms our beliefs and reject evidence that contradicts them. We have a tendency to search for, interpret, favour and recall information that confirms one’s pre-existing belief or hypothesis.")]), _vm._v(" "), _c('p', [_vm._v("If that happens in the fairy tale world, the news and social media fairy tales would be like this:")]), _vm._v(" "), _c('p', [_vm._v("“No, Snow White didn’t eat a poisonous apple. She was stoned and intoxicated, too much magic mushroom. Please read this newspaper by yourself. The journalists had some evidence and witnesses against Snow White,” say the Snow-White haters and the newspaper that is contrary to Snow White. All Snow-White haters only read news that prove Snow White is a bad person and ignore all the news that proves Snow White is a good person.")]), _vm._v(" "), _c('p', [_vm._v("“That was fabricated news. Not according to this newspaper, she is as pure as driven snow. Snow White never touched magic mushroom, not even a constipation pill in her life. We know she had touched a lot of men’s hearts but not things that make her stoned and passed out. She collapsed after she ate that poisonous apple. One of the seven dwarves and witnesses told the media she was with Prince Jim before she collapsed,” say Snow White supporters and newspapers which are pro-Snow White. They only read information that prove Snow White is a good person.")]), _vm._v(" "), _c('p', [_vm._v("“Definitely she has touched many men’s hearts and their horns, too! Sure, she was with Jim that night, we mean Jim Bean, not with prince Jim. D’oh,” Snow White haters are mocking Snow White supporters.")]), _vm._v(" "), _c('p', [_vm._v("“Hey, read this newspaper, not that newspaper. Here, read up. There is no evidence that showed Snow White was intoxicated as heck that night. She is a saint and you are vain.”")]), _vm._v(" "), _c('p', [_vm._v("Here comes Snow White, regaining her consciousness. Her version is, “I was so tired last night. Prince Jim came over and we did all the housework together, I didn’t eat much, then I just dozed off the moment I hit the pillow. It was not the apple nor the magic mushroom. I was just so dead tired.”")]), _vm._v(" "), _c('p', [_vm._v("The truth is, yes, that is the truth: Snow White didn’t touch any drug that night but she had visitors: Prince Jim, Prince Jom and Prince Jum. Ten minutes after Prince Jim went home, there was Prince Jom who came to see Snow White for an obvious reason. A half an hour later after Prince Jom went home, Prince Jum knocked at the door. To cut to the chase, “Roses are red, violets are blue. Come and sit on my face and wiggle a bit,” that’s what those Princes said to Snow White, which she did. Snow White had some Jim Jom Jum last night after the mingle and the giggle. No wonder she slept like a baby, didn’t wake up like Jeff from the Wiggles last night, she had no energy left. The seven dwarves knew that, they planted an apple in her hand to make her look innocent. One of the dwarves testifies, “I did not have sex… with that apple.” The apple was innocent, they used it as a scapegoat. That is the truth.")]), _vm._v(" "), _c('p', [_vm._v("You see, there are four versions: Snow White supporters, Snow White haters, Snow White herself and the truth. With the help of social media, the news is shared rapidly and attracts more viewers. To put it simply, the truth about you. What your family thinks about you, what you think about yourself, your current girlfriend, your ex-girlfriends, your friends, they tell different stories about you. And the only one who thinks you are unbiased and have the best point of view in politics, is you, but not according to your exes though.")]), _vm._v(" "), _c('p', [_vm._v("As we know it, everyone believes in biased news because it makes them happy and more peaceful knowing their expectations match the news not the truth. Snow White supporters only read information that prove Snow White is as pure as a driven snow, Snow White haters only read information that proves Snow White is bad, Snow White herself has an alibi why she collapsed. The truth is, she didn’t touch the magic mushroom, but she sleeps around.")]), _vm._v(" "), _c('p', [_vm._v("Just like fairy tale stories, newspapers these days are divided into two versions, the newspaper who are pro-cupcake and the other one is pro-muffin. Cupcakes and muffins hate each other. They both use baking powder to raise the dough and finish it with icing sugar to make their news taste so good. Just like in real life and online news, all media adds some ingredients to make their news look inviting and convincing. Both camps don’t make an apology to attack each other, like oil and water, can’t blend together. Oil is with oil; water is with water.")]), _vm._v(" "), _c('p', [_vm._v("Like a cat and a mouse, the efforts to have sex with each other is far greater than to make peace. Why is there a lot of sex in social media? I mean it’s sex galore here every minute. Because this group says to the opponents ‘f’ you, and the opponents say ‘f’ you, too. Then they try to ‘f’ each other up. See, they’re having sex. So much sex going on here, sex between countries, political parties, social media users, families, friends and so on.")]), _vm._v(" "), _c('p', [_vm._v("The war in the cyber world is full of sex, all love orgy but no one can reach the climax, I mean, peace. This is why social media wars don’t end in peace because no one has experienced the beauty of a climax. The only one that ends the war is no Wi-Fi, or your wife having just hacked your password. Before you have sex, oh I mean war, on social media, make sure you have an orgasm. Trust me, it feels good and it makes you happier, relaxed, you sleep better and feel satisfied. To put it this way, it pisses you off when you watch a movie with a cliff-hanger ending, doesn’t it? Make up your mind, you want to come or you want to go? End it like in the movie, come with a happy ending.")]), _vm._v(" "), _c('p', [_vm._v("The truth never changes, it always stays the same. If you distance the truth, it will come closer. You bury it, it will surface. You hide it, it will find you. You drown the truth, it will float to the surface. You change the colour of the truth, it will go back to its original colour eventually. It is only a matter of time when the whole truth and nothing but the truth will reveal itself. If you want to believe that is the truth even after the facts say otherwise, it is not the truth but it will be called ‘your favourite song’ because you only listen to songs that you like, you don’t want to listen to the songs that you dislike, do you? The truth is not what you want, it is not a buffet where you only pick food that interests you, but you have to take it all, whether you like it or not.")]), _vm._v(" "), _c('p', [_vm._v("Thinking highly of yourselves is a form of narcissistic. If you think too highly that you are so smart in detecting the lies and truth on social media, then you will end up getting confused between lies and truth. If you think you are too smart for your opinion, it means you can’t listen to anything because you are blinded by your high opinions. All the facts that prove you wrong are interpreted by you as an attack towards you.")]), _vm._v(" "), _c('p', [_vm._v("Because in your mind, nothing and no one is more right than your opinion. See, when you think too highly of yourself, when you are too high, you can’t see any details and small things on the ground, which is vital. Just like when you go the highest mountain, you can’t see how many ants are walking near the river. The higher you think of yourself, the smaller they see you as from the ground. The higher you think of yourself, the more you can’t see things happening on the ground from the highest mountain, you can’t see your own backyard where your wife is cosying up with the milkman because you’re way up there, so high. Sometimes people see you as smaller than a speck because you are so high up there in space. Logically, the higher you think, the more ‘splat’ when you fall to the ground.")]), _vm._v(" "), _c('p', [_vm._v("You may preach and discipline people online on how to have a moral standard and know everything about politics in your social media, but you don’t know the truth about yourself.")]), _vm._v(" "), _c('p', [_vm._v("“Bad news, he won. I don’t like him. You don’t know the election was rigged, do you?”")]), _vm._v(" "), _c('p', [_vm._v("“No.”")]), _vm._v(" "), _c('p', [_vm._v("“You don’t know much about politics, do you? You should learn about politics more.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you know about Tiffany-Anne, ma’am?”")]), _vm._v(" "), _c('p', [_vm._v("“No, who’s that? A politician?”")]), _vm._v(" "), _c('p', [_vm._v("“You don’t know much about your husband, do you? You should learn about your husband more.”")]), _vm._v(" "), _c('p', [_vm._v("By the way, those male names on your husband’s smartphone aren’t actually real men. He just tricked you so you don’t have any suspicions of what he’s up to. He changed all the chicks’ names into a blokes’ names. Miranda becomes Michael, Brenda becomes Bruce, Valerie becomes Vladimir, Wendy becomes Wayne, Penelope becomes Peter and so on.")]), _vm._v(" "), _c('p', [_vm._v("“Babe, your phone was ringing. Who’s that?”")]), _vm._v(" "), _c('p', [_vm._v("“Darling wife, could you please read the name who’s ringing?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, it’s Jeff. I can see the name on the display. Who is Jeff?”")]), _vm._v(" "), _c('p', [_vm._v("“A plumber.”")]), _vm._v(" "), _c('p', [_vm._v("Actually, that Jeff is not a plumber, that Jeff wants your husband to fix her sink, that Jeff is wearing high-heeled shoes, a red dress, pink lipstick and waiting in the secret cafe for a secret rendezvous. Jeff is actually Jane, a real woman.")]), _vm._v(" "), _c('p', [_vm._v("Hence, you got mixed up a lot. You believe propaganda is the truth and the truth is propaganda. In mistakes we trust, becomes you. You trust in your mistakes and you hate the truth, that’s your problem in social media and your offline life. You cherish and nurture your errors while you destroy and twist the truth, you reject being honest. It applies to anything, not just social media, but social media is highlighting your true colours because you don’t have to be polite and nice when you write something on your social media. Well, when you see your boss face to face, you are always polite because you don’t want to lose your job, “You make that umbrella look good, boss,” but on your social media you say, “My boss with an umbrella looks like Charlie Chaplin.”")]), _vm._v(" "), _c('p', [_vm._v("Believing in propaganda will impact your diet, too. You believe you still keep up with your diet just because you drink a diet drink after you consumed two burgers, one large French fries, two croissants and one big bowl of ice cream. At least I have a diet drink, that’s in your mind. Another effect after you believe in propaganda and reject the truth is you can’t tell your woman has a fake orgasm or a real orgasm. For ladies, you don’t know and you can’t tell the difference between whether your husband has a headache or ‘plays dead’ when you ask him to make love to you. You didn’t know your husband had a meeting in the afternoon with his clothes on or off with you know who. For men, you didn’t know your wife and that tradesman fixed the sink together. Why are women’s feet smaller than men’s? To get closer to the sink.")]), _vm._v(" "), _c('p', [_vm._v("Back to the topic about the truth, the thing is with some of you, you create what you believe into truth, you shape the truth that matches your expectations, colours and desire, not matching it with reality and rejecting unwanted facts as fake news. The point is, you corrupt the truth. Social media news and most of the media now doesn’t tell you the real news. Media steers you to hear what the media wants you to hear, not what the truth wants you to hear. In the end, you can’t really tell the truth and the lies apart. If you drink bad coffee all your life, you’ll never know the taste of good coffee. If you have shonky and quick sex all the time, you’ll never know how good it is to enjoy long and delicious sex.")]), _vm._v(" "), _c('p', [_vm._v("No, you can’t do anything about the truth except you have to be honest and you must accept the truth without adding or subtracting the truth. The truth is the truth, like math. Three times three is nine. If you are adding, subtracting and modifying the facts, it is called a recipe, not the truth. If you are ugly, then you really are ugly, that’s the truth. I am drunk, sober, lacking sleep, I am relaxed, I am stressed, I still call you ugly. You water boarded me, you grill me for hours, you drugged me, you spiked my drink, you stuck a chop stick in my behind, I got the flu, I got diarrhoea, I got constipation, good health, bad health, I’m in a good mood, a bad mood, I still call you ugly, that’s the truth.")]), _vm._v(" "), _c('p', [_vm._v("People intend to believe something that suits their expectation. They embrace anything that confirms their views while ignoring or rejecting information that casts doubts on it. When they like some concepts or ideas to be true, they end up believing it is true. This explains why you believe your point of view is always right and unbiased. The fact is, you are a prisoner of your assumptions. You believe you know all the solutions for every problem in the world but you don’t know the differences between Facebookers and face fuckers, big difference, because you become numb for a long time. You say you know how to get rid of all evil in the world while you don’t know how to get rid of cellulite in your thighs. You’ve been preaching the truth, but your social media photos are heavily filtered and photoshopped.")]), _vm._v(" "), _c('p', [_vm._v("Confirmation bias and in-group bias in social media are very obvious when it comes to politics. Especially when the election is getting close. There’s an upcoming election between a chicken and a giraffe. The chicken voters always post how bad the giraffe is and how good the chicken is. Meanwhile, giraffe voters always post how good the giraffe is and how bad the chicken is.")]), _vm._v(" "), _c('p', [_vm._v("Chicken voters believe Giraffe is cunning, manipulative and dangerous while the oppositions launch the same attack against the chicken. Chicken voters believe Giraffe is the wrong person to be elected as their leader. On their social media they constantly post any information to prove Giraffe is a bad creature, but never post the good side of Giraffe, but Chicken voters constantly post information how good and great Chicken is, the best leader. The same strategies and attacks are launched by Giraffe voters.")]), _vm._v(" "), _c('p', [_vm._v("These are the instances from both parties who are busy attacking each other’s ideology. This is from Chicken supporters:")]), _vm._v(" "), _c('p', [_vm._v("“Is this our future leader? Look, this is the proof that the Giraffe stole Elephant’s shoes.”")]), _vm._v(" "), _c('p', [_vm._v("“Watch this video, this is the video showing you when Giraffe put fake eye lashes on. His eye lashes are fake, not real. God forbid the giraffe becomes a president.”")]), _vm._v(" "), _c('p', [_vm._v("Meanwhile from chicken’s side:")]), _vm._v(" "), _c('p', [_vm._v("“See what a good man Chicken is. This photo shows Chicken is cutting Tiger’s hair into a mullet haircut and cleaning up Elephant’s ivory. The real leader, I’m proud to vote this guy.”")]), _vm._v(" "), _c('p', [_vm._v("From the giraffe’s side:")]), _vm._v(" "), _c('p', [_vm._v("“Watch this video. This is the proof Chicken was the master mind behind crocodile genocide for an underwear company.”")]), _vm._v(" "), _c('p', [_vm._v("Attacks from the chicken to Giraffe:")]), _vm._v(" "), _c('p', [_vm._v("“Busted! Giraffe had a fling with a prawn star. Do you really want to vote for an adulterer to lead your country?”")]), _vm._v(" "), _c('p', [_vm._v("“Look, this is the photo where Giraffe was helping an old rhino cross the road and feeding blind King Kong some banana, what a great guy. Giraffe for president.”")]), _vm._v(" "), _c('p', [_vm._v("In-group bias, out-group bias and moral exclusion do happen a lot in social media. In-group bias is a pattern of favouring one’s in-group over out-group members. A tendency that people have is to favour their own group above that of others. This bias has a major influence on both group and individual’s behaviour. If you pick a favourite, you already have a bias. You hate someone, you already have a bias and hate definitely influences your point of view.")]), _vm._v(" "), _c('p', [_vm._v("The belief that your group is the best one or your group is the victim of other groups is one of the major reasons to instigate the fight in politics. Meanwhile in social groups, your group must be seen as the coolest one, the funniest one or the most elite one. I see two groups of ladies fighting like hell just because they hate each other’s eyebrows. The first group thinks the best eyebrow shape is the eyebrows in a sperm shape. The second group disagrees, they think ladies should have their eyebrows in a water slide shape. Meanwhile in different locations, many groups are fighting over hairy legs or fairy legs and hairy ass or fairy ass.")]), _vm._v(" "), _c('p', [_vm._v("You’ll be cheering on your favourite soccer team, your friends’ group, and your favourite stripper louder and prouder than the other group while expressing your dislike and disdain for the opposing group. Contrary to what you post on your social media to what you keep preaching, “Judge not, you shall be judged.” But you have bias towards your own group or race or ethnicity or beliefs, thus making you keep attacking others who don’t have the same point of view as you or are of a different race or ethnicity or beliefs.")]), _vm._v(" "), _c('p', [_vm._v("You only communicate, make friends, engage, date, marry, interact more with and act supportive towards people who have the same race or ethnicity or religion as you, but you scream you want to be treated equally and fairly. You see there’s a contradiction here, the one who favours his own group above others is screaming that he wants to be treated fairly.")]), _vm._v(" "), _c('p', [_vm._v("On a much larger scale, in-group bias happens in nationality, ethnicity, race, and religion. This bias results in ‘us versus them’. You are nicer, more respectful, empathetic and supportive to your own group than out-group members, but you are more likely to attack, harass and even bully the out-group members. When one of your group members is attacked by the other group you have an urge to defend them, not because you’re protecting the truth but because you’re protecting your own bias. You treat your bias above the truth.")]), _vm._v(" "), _c('p', [_vm._v("This happens in social media often:")]), _vm._v(" "), _c('p', [_vm._v("Cucumbers and zucchinis have been fighting each other since ages ago. Cucumbers believe they taste better, stand taller and stronger than zucchinis, and on top of that they have more vitamins, but zucchinis disagree, zucchinis think they taste better and have more nutrients than cucumbers. Cucumbers believe zucchinis have been violating their territory and rights, but zucchinis disagree with that, zucchinis believe it is the cucumbers who are the real aggressors.")]), _vm._v(" "), _c('p', [_vm._v("They accuse each other, they want to destroy each other. They play games like a little girl, “I attacked you because you did it first.” This ‘but you did it first’ mentality is very typical of in-group bias. Then a tragedy struck in the zucchini field, all zucchinis rallied up together online to help their fellow countrymen.")]), _vm._v(" "), _c('p', [_vm._v("The response from the cucumbers’ community? They don’t blink, they don’t want to know. Even if they get jealous because all the fruit rally up together to help zucchinis. All cucumbers online don’t post any sympathy or support towards the zucchini community, because it is a sin to show any sympathy and empathy to enemies. It is even a sin to show empathy for a baby, because that baby is the son of the enemies. Instead of showing empathy, the cucumbers gloat, “That was karma.”")]), _vm._v(" "), _c('p', [_vm._v("Due to too much hatred towards zucchinis, refusing to acknowledge that zucchinis deserve help, instead cucumbers compare the tragedy with a tragedy that happened in their community by saying, “When we had a tragedy, no one helped and supported us. They all turned a blind eye. We had tragedy and unfortunate moments, where was everyone? Why is everyone busy helping zucchinis but not us? We, the cucumbers, are the ones who deserve more attention,” scream the majority of cucumbers on their social media.")]), _vm._v(" "), _c('p', [_vm._v("If you think cucumbers are the bad ones, zucchinis are not far off. They show the same attitude if cucumbers have a tragedy. So they are both bad pickles. Logically, if two people are fighting to be the chosen one from God, don’t believe them. This is like two cheerleader girls are fighting over the pom pom. If you believe in God, you pray and send each other love and best wishes, not exchange ammunition and bras.")]), _vm._v(" "), _c('p', [_vm._v("Those things happen on social media so often. When one country, let’s say that country’s name is Chacha, just had a big tragedy, where so many people died because of an attack, all social media users from around the world would be in shock and send their prayers to Chacha, except social media users in several countries because they think Chacha didn’t deserve any attention and sympathy at all.")]), _vm._v(" "), _c('p', [_vm._v("Why do they think it is a sin to have sympathy? Because of these reasons:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("The majority of the people who live in Chacha don’t share the same race or belief as they do.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("The attacker (who just murdered many people in Chacha) had the same beliefs as those countries who hate Chacha (the majority of Chacha doesn’t have the same belief as the attacker). For fanatics, it is a sin to mention a religion but it is okay to attack.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("They hate their enemies more than they love their children (the origin of these wise words are still in debate).")])])]), _vm._v(" "), _c('p', [_vm._v("This could happen to some of you, too, “When I was in hospital, no one visited me, but when she is in the hospital, everyone is visiting her and even brought flowers to the hospital. Not fair.” You are unhappy, not because she is not well, but because you didn’t get as much attention as she did. See, too much hate makes you compare the bad luck.")]), _vm._v(" "), _c('p', [_vm._v("Unless, when that bad luck happens to you, you want the whole universe to pay attention to you and tuck you into bed. According to biased people, the only ones who deserve the most attention and help are the people who have the same point of view as you in politics. Including the same race, ethnicity, gender, nationality, and religion as you.")]), _vm._v(" "), _c('p', [_vm._v("To compare the tragedy with a tragedy, playing the card that your group is the one ‘who deserve the most’ and your group is the ‘victim’ is a manipulative act. You are so obsessed by your in-group bias. Even worse, in some cases you want the whole world to applaud the criminals who did such a terrible crime just because the criminals have the same belief or race as you, but you will punish the victims because the victims don’t share the same belief as you or have the same race as you. In your eyes, your favourite group can’t be blamed for anything even if they murder someone. In your eyes, the murder victims don’t deserve anything just because they didn’t share the same belief or race as you.")]), _vm._v(" "), _c('p', [_vm._v("In-group bias and you with your bias will be justifying your jealousy (because your group is not the centre of attention) by using starving children, “When a high profile dies the whole world cries, when a child dies because of starvation, no one cries.”")]), _vm._v(" "), _c('p', [_vm._v("Yes, you were right, many children die because of starvation. According to Hunger Statistics: one in seven people in the world is starving, poor nutrition causes 45% of death in children under five – 3.1 million children in year 2011.")]), _vm._v(" "), _c('p', [_vm._v("So, if you are consistent with what you say and so disgusted (like you say) that no one shows empathy and pays tribute on social media to those poor children, it means you have to post your tribute every day on your social media because every day a child under five dies in relation to poor nutrition. According to UNICEF, about 353,000 babies are born every day. 151,600 people die every day. If you are consistent with what you say, you will post your tribute every single day to those 151,600 people who just lost their life.")]), _vm._v(" "), _c('p', [_vm._v("Why do fans pay tribute to their idols? Because they gave joy, happiness and memories that will be cherished and live in our hearts forever. Their songs can make our bad mood into a good mood, their movie makes us laugh. It is the feeling that we get and stays in our mind whenever we hear his song or watch her movie. That’s why we pay tribute to them. Or because they were great inventors and scientists, without which we would’ve never experienced a smart phone like this or knowledge about the universe.")]), _vm._v(" "), _c('p', [_vm._v("Still talking about bias, but this is not about tragedy, it is about triumph and achievement. You will compare one victory to another because you are jealous you want all the accolades to go to your group.")]), _vm._v(" "), _c('p', [_vm._v("“Just because he is from planet Pluto the whole universe gave him an award, while we who live on Jupiter who have done the same thing didn’t get any recognition at all.”")]), _vm._v(" "), _c('p', [_vm._v("“All the hype about the man on the moon mission is more important than people who live in extreme poverty.”")]), _vm._v(" "), _c('p', [_vm._v("See, bias makes you unhappy when all the attention and accolades didn’t go to your favourite group. If someone from an out-group just received a victory or good news, your reaction on social media is you will compare the victory they got with the tragedy that happened in a third world country to make those people who are so happy and enjoying their achievement feel so small and bad. It is like, “Oh, I have just won a prestigious tennis tournament, but apparently I should be feeling so sad now because they say some people can’t afford to buy food for their family.”")]), _vm._v(" "), _c('p', [_vm._v("If you feel you are left behind because someone has just won an award in math or science or technology, it is not because of their race or belief but because of their dedications, achievements and contributions to the world which will help so many people including you, your family and your favourite group in the future.")]), _vm._v(" "), _c('p', [_vm._v("Why are you jealous and always rejecting good news from the out-group? Because you can’t compete. When you can’t compete with them but you really want to rule the world, you will be against them. The questions are:")]), _vm._v(" "), _c('p', [_vm._v("1. Do you only read the news you want to believe, or do you read the news from all sides: left, right, up and down? If you believe Planet Earth is not round but curly like a noodle, you just read all the information that proves Planet Earth is curly like a noodle without challenging yourself to read all information that supports that Planet Earth is not flat.")]), _vm._v(" "), _c('p', [_vm._v("2. Have you ever challenged yourself and asked this question: What if I am wrong? This is a question that most mathematicians face every day. They keep challenging themselves by using their linear thinking and logic to get the right answer. Or are you too afraid to challenge yourself because you will find out that you’ve been wrong all this time, are you too afraid to know the answer that went wrong in your belief?")]), _vm._v(" "), _c('p', [_vm._v("3. What do you do every day to get more knowledge for yourself? Just scroll down your social media news feed or just stare at the computer?")]), _vm._v(" "), _c('p', [_vm._v("The conclusion is, biased people are too afraid to challenge themselves. Without bias we will know what mistakes we’ve made and all that is lacking to shape ourselves to be a better person. We will show more empathy, be more grateful, be morally conscious and show humanity regardless of who they are. To have a moral value and value of life, to help those and support each other, it does come from the heart and is not based on race, religion, gender, ethnicity, age, disability, job occupation and nationality. Without bias, we would be happy to hear good news from the other side. Without bias, we will show empathy and moral support to the other side when they have unfortunate events. Bias limits our moral value, even the way we grieve.")]), _vm._v(" "), _c('p', [_vm._v("If you are kind and honest, you give us inspiration, joy and happiness, we will support and respect you too for all the right reasons no matter what race, religion, nationality, gender, occupation and how much money you have. We will not use ‘starving children’ when you just receive good news.")]), _vm._v(" "), _c('p', [_vm._v("Now to put it all together, bias dictates you and limits your humanity. Let’s say you’re a doctor working in an emergency:")]), _vm._v(" "), _c('p', [_vm._v("“Doctor, it’s urgent. A man just had a heart attack.”")]), _vm._v(" "), _c('p', [_vm._v("Without any hesitation, in a nanosecond you will help that poor man right away as your first priority. Now using your bias as a doctor, this is how you respond:")]), _vm._v(" "), _c('p', [_vm._v("“Doctor, it’s urgent. A man just had a heart attack.”")]), _vm._v(" "), _c('p', [_vm._v("“What religion and what race is he?”")]), _vm._v(" "), _c('p', [_vm._v("If you’re a smartphone company, you only sell your products to the customers who share the same view as you or same belief as you. And if you stretch it further because you really hate some people due to their belief or race or nationality, you’d be like this:")]), _vm._v(" "), _c('p', [_vm._v("“What race was the inventor of smartphones and what was his religion? What race was the inventor of paper? Did the inventor of paper believe in God or was he an atheist? Because I am reluctant to buy something when it was invented by a person who didn’t have the same belief or same race as me.”")]), _vm._v(" "), _c('p', [_vm._v("“What is the religion and the race of the social media inventor? If he has the same race as me and the same religion, yes, I will join social media.” As I say, no matter how biased, or how much of a racist, bigot, misogynist, creep or pervert you are, you are a hypocrite when it comes to money, technology and social media. You still want to join social media and use the technology regardless of the inventor’s religion, which is worshipping a seaweed.")]), _vm._v(" "), _c('p', [_vm._v("In many cases they will eliminate their bias because they know if they stick to it and are consistent with their bias, they can’t do much, especially when it comes to money. Let’s say you’re a musical artist, on your social media you always attack people because they have a different point of view from you, especially in politics. You will chase them to the end of the world and punish those who disagree with you on social media, replying to all those comments who expressed their disagreement with you, but you let anyone buy your songs regardless of whether the purchasers have a different ideology or view or race than you.")]), _vm._v(" "), _c('p', [_vm._v("Why? Because money is money, money bias is above all biases. When it comes to money, forget all ideologies, politics, races, beliefs; put aside all the differences. No matter what you are, if you are a communist, socialist, right wing, left wing, ear wing, armpit wing, if your hips dip, if you have a beer gut, six pack, eight pack, if you’re a sociopath, psychopath, are from any countries, are dictators, perverts, virgins, extremists, atheists, maniac photoshopper, have a duck face, cow face, are liars, prudish, and have big tits, or small tits, anyone is welcome. I take money from anyone including from people I hate and enemies too, regardless of my dignity and pride. If I don’t do that, I’ll have less money, opportunities and freedom.")]), _vm._v(" "), _c('p', [_vm._v("Mount Edna erupted, it was your enemy’s fault. The sun doesn’t rise in the North, yes, it’s your enemy’s fault. What about the pimples on your face? Yes, it’s my enemy’s fault too. Why you didn’t get 100% for your math exam? That would be my enemy’s fault too, it’s a conspiracy theory. Actually, I am really good at math but all those numbers are conspiring against me.")]), _vm._v(" "), _c('p', [_vm._v("What about when you are very ‘premature’ in bed with your wife? Is that your enemy’s fault too? Yes, definitely they provoke my sperm to come too early just to make my wife sad. What about those wrinkles on your face? Is that your fault or your enemy’s? My enemy’s fault. When I was asleep, they came to my bedroom and folded my face like origami, so when I woke up, I had all these wrinkles. And that cellulite? It’s my enemy’s fault, actually they are not mine, they planted this cellulite in my thighs when I was asleep to make it as if it is mine but is actually theirs. Just like when they planted those porn DVDs in my backpack, actually they are not mine. I just watched them but I don’t own them.")]), _vm._v(" "), _c('p', [_vm._v("Biases make you too stupid to know what mistakes you made. Typical of biased people is if you admit you are wrong, it means you are defeated and it would be a win for the enemies because you just confessed you are wrong. Like biases in social media, you photoshop and edit the real photos to spread the propaganda. There are many reasons why you edited the photos, from the extreme to the harmless. From propaganda to just having some fun.")]), _vm._v(" "), _c('p', [_vm._v("Weed is edited to seaweed, “The police got it wrong. They arrested the wrong person. I never smoked weed. I just smoked seaweed.”")]), _vm._v(" "), _c('p', [_vm._v("A Wombat Woman’s face becomes your face and your friend’s face becomes a Wanker Woman, and so on and so on.")]), _vm._v(" "), _c('p', [_vm._v("Basically, you edited everything. But the fact is you can’t edit the truth, you can’t edit your dignity and pride. You can edit and photoshop the lie, but you can’t edit and photoshop the honesty.")]), _vm._v(" "), _c('p', [_vm._v("In social media life, worshiping a bias and ego is the same as worshipping a God. If anyone expresses their point of view which is different from yours, you will say God will punish you. You quickly use the word ‘God’ to anything and anyone that you disagree with. You say, “God will send you to hell.” Firstly, God doesn’t have social media and doesn’t reply to the comment, like or post or tag people on social media. Secondly, you are not a God but you change the word ‘I’ to ‘God’ to make it more effective, controversial, hurtful and more impactful on the other believers in order to make them join you to condemn and curse your enemies.")]), _vm._v(" "), _c('p', [_vm._v("If you use the word ‘my grandma’ such as in “My grandma will condemn you,” it is not as mighty and powerful as mentioning God. People are not afraid of the word ‘grandma’. Grandma isn’t associated with hell and heaven but associated with good food, knitting and recipes. But be afraid when you hear the word ‘God’ because God has the power to send you to hell or heaven. The conclusion is there is no other word that is more effective and powerful than the word God when it comes to believers. To win your argument, you are manipulating your own God for your selfish comment, hence why many of you use the word God a lot to punish your opponent. Trust me, God knows you are manipulating your own God, and God is way smarter than you think.")]), _vm._v(" "), _c('p', [_vm._v("Apart from using the word God, some of you also act as a representative of your own race, nationality or your gender when the real truth has nothing to do with that. How to get more support for you and help from others? Mention your race or nationality. How to damage the opponents? Mention your race or nationality even when it has nothing to do with that or no one says that to you, you just lie. You lie that you’ve been bullied because of your race, you accuse them of being racist,")]), _vm._v(" "), _c('p', [_vm._v("“They did this because of my race or nationality.” The truth is, you are being manipulative by using your own gender or race or nationality or religion to provoke them and play them off against each other for your own agenda which has nothing to do with religion, race, nationality and gender.")]), _vm._v(" "), _c('p', [_vm._v("So if you get hurt by someone, by using these words, ‘God’, ‘race’, ‘religion’, ‘nationality’, ‘ethnicity’, ‘gender’, people who have the same race or nationality or gender or race or whatever as you will stand up together and punish that person you attack. Another reason again, if you stir the pot and spice it up by involving your own race or gender or nationality or your religion, it will cause more controversy, get more attention and do more damage to your opponent.")]), _vm._v(" "), _c('p', [_vm._v("Actually, what your mind saying is, “You hurt me so bad. I don’t like it when you found out my dark secrets and you will pay for this, I am going to use my religion and all believers to punish you as if you have hurt my religion, God and all believers.”")]), _vm._v(" "), _c('p', [_vm._v("“Starfish didn’t allow me to eat seaweed just because I am a shark. Starfish are racist.”")]), _vm._v(" "), _c('p', [_vm._v("“I didn’t get the parking spot because I am a bisexual. This is an insult to all bisexuals in the world.”")]), _vm._v(" "), _c('p', [_vm._v("“Cucumber said I wasn’t good enough to be a pickle because of my religion as a carrot. All carrots in the world should stand together and defend our religion.”")]), _vm._v(" "), _c('p', [_vm._v("What you are trying to say is, “You hurt me. I am so upset you knew I was wrong. I hate it when I get caught. I hate it when you found out my web of lies and my flaws. You will pay big-time for this. I am going to use whatever it takes to bring you down. I will do my best to hurt you the most because you know I lie. I will involve the whole world to punish you. By mentioning my faith, the response will be greater as if you have hurt all fellow believers in the world too, not just me.”")]), _vm._v(" "), _c('p', [_vm._v("You see, the guilty ones are the ones who always mentioned their God or race or gender or nationality to punish anyone when they got caught and people just found out the ugly truth about them.")]), _vm._v(" "), _c('p', [_vm._v("“Oh, you ate my burger, this is an insult to my religion. That’s it, you will be baptised. I’ll baptise anyone who hurts me.”")]), _vm._v(" "), _c('p', [_vm._v("“Baby, I’d like to say something to you. This is a very delicate matter. Could you please seek a doctor’s advice because you always come too early when we’re having sex? I love you, as your woman I am a bit concerned that you’re a bit premature.”")]), _vm._v(" "), _c('p', [_vm._v("“What did you say? I came too early? My God, you are a very racist woman.”")]), _vm._v(" "), _c('p', [_vm._v("“The truth is, two-minute instant noodles are longer than you.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God, did you compare my God with two-minute instant noodles? You just insulted my religion. Shame on you.”")]), _vm._v(" "), _c('p', [_vm._v("“Did I hear you just got beaten by a dog? Oh, so sorry to hear that.”")]), _vm._v(" "), _c('p', [_vm._v("“Stupid dog, that dog bit me because I am a woman. Misogynist dog!”")]), _vm._v(" "), _c('p', [_vm._v("“Were you born by Caesarean?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, because the doctor was an atheist, doesn’t believe in resurrection.”")]), _vm._v(" "), _c('p', [_vm._v("“I thought because your doctor loved using Windows.”")]), _vm._v(" "), _c('p', [_vm._v("“I wanted to be born naturally, not by C-section. My dad said I was born by C-section because the doorknob was broken, a deadbolt. That’s why I was born by C-section. Nope, I didn’t buy that. The truth is the doctor was an atheist. I do believe in God, and I do believe in resurrection.”")]), _vm._v(" "), _c('p', [_vm._v("We all are entitled to believe in our religion and choose our religion. We should respect each other’s beliefs and never force one’s religion upon another. According to Google, there are about 4200 religions in the world. The remains of one of the earliest anatomically modern humans ever to be cremated was buried near Lake Mungo, 40,000 BCE. From 9120 BCE – 7370 BCE, Göbekli Tepe, one of the oldest human sites of worship, was discovered, with evidence of similar human sites of worship also found in Nevali Çori. The Aurignacian Löwensmech figure, in 38,000 BCE, the oldest known zoomorphic and the oldest sculpture in general, was made. This sculpture may represent a God.")]), _vm._v(" "), _c('p', [_vm._v("For the believers, religion is the compass and guidance to a better place in life and the afterlife. With religion, you believe in God. With God, you believe in love, joy and peace in the world. With love comes joy and happiness, if you believe this, you believe you can live in harmony. All religions are supposed to guide us to be a better person and have a better life, not to hurt anyone, never tell a lie, respect each other and help those in need.")]), _vm._v(" "), _c('p', [_vm._v("You believe in what you believe and we believe in what we believe, we respect each other. There is no need to force your religion on us as we don’t force ours on you. We live on Planet Earth, we have six continents on this planet, 195 countries (if we count Taiwan), over 6000 languages, and more than 7 billion people in the world (according to data from the year 2018). We’ve been to the moon, the New Horizon reached Pluto in July 2015, Voyager 1 already entered interstellar space in August 2012. However, there are still 15 uncontacted tribes in Peru and some in Amazonian countries, and New Guinea has two tribes on Andaman Island, off the coast of India.")]), _vm._v(" "), _c('p', [_vm._v("On social media, this is what is going to happen when a tragedy happens relating to beliefs. The majority will write on their social media, “It has nothing to do with their religion, it was the person himself who had some mental issues.” There are lots of denials and condemnations, but they forget the most important thing that they should care about: the victims.")]), _vm._v(" "), _c('p', [_vm._v("Fact: as freely as they can criticise and point out the country and government they live in now. In many countries, they will face severe punishment if they say anything against the royal family and government. Fact: the number of countries designated by Freedom in the world as Free in 2013 stood at 88. According to Freedom House, only 13% of world’s population enjoys free press where you can talk against your government. According to the International Federation of Journalists, in the year 2017, at least 81 journalists were killed, as harassment and attacks on journalists are on the rise. There were more than 270 journalists in prison in the year 2017, because they were just simply doing their job. Colombia, Mexico, Afghanistan, Iraq and Russia are the top five most dangerous countries for journalists.")]), _vm._v(" "), _c('p', [_vm._v("Fact: some high-profile celebrities are banned in one Asian country due to their criticisms towards that country. One celeb was about to enter that Asian country but couldn’t get a visa because her actions and words on social media were not approved by that country. The punishments in some countries for talking against their government vary. Some punishments are very severe, such as flogging, one country will punish you up to 20 years for insulting the royal family, and one country will exile you permanently as a punishment for talking against the government and their royal family. Some people faced jail terms because they were verbally abusing the airport staff, you can be jailed too if you post a traffic accident on your social media in one country.")]), _vm._v(" "), _c('p', [_vm._v("Do you want to make a parody about some countries on YouTube? If you do this in some countries, you’ll be jailed for three years. The conclusion is, you are more likely to do something when you know there are no consequences. But when the consequences are severe, you will think twice because you don’t want to take the consequences. If all social media offences in all countries in the world would result in jailing anyone who speak against each other including their government, there would have been zero attacks on social media.")]), _vm._v(" "), _c('p', [_vm._v("Do you want to be respected? Be respectful, if you respect yourself you will do so to others, you will respect the law in your country you live in and the law in all countries. Are you sick and tired of drama and fights on social media because you love peace? First of all, if you want peace, you have to be a peaceful person. If you don’t want to make peace with your enemy, but you want your enemies to be destroyed, forget it. It means your biggest enemy is yourself, you have a problem with yourself which is you can’t even make peace with your emotions and anger. You will not change the world if you just sit in front of your laptop or smartphone without making any peace and respect with anyone.")]), _vm._v(" "), _c('p', [_vm._v("The security systems in the world have changed due to attacks that are targeting public places and transportations, including tourist attractions. Some people would see it as an insult to their faith, as if their faith is the cause of the problems. While others would blame that faith, because it is not safe anymore to go anywhere due to these random attacks. The war starts again on social media, the blame game. Who got the biggest underwear, who wears the brightest red lipstick, who wears the pinkest lipstick and so on. These fights over politics and religions on social media can make grown-up men lactate like a new mother.")]), _vm._v(" "), _c('p', [_vm._v("Sure, it has changed the way we travel, especially by plane. We almost clock 8 billion people in the world, and only very, very few of us are bad people. But because of these criminals, it has changed the way we live and travel to protect ourselves. Not all people in the world are thieves or armed robbers, but we have to lock our house every time we go away or whenever we are at home to protect the family we love inside. Not all people in the world are car hijackers, but we have to lock our car to protect our car from the criminals.")]), _vm._v(" "), _c('p', [_vm._v("A few bad men can change the system in which the majority live. Now this is universal, I ask you this simple question: How many of you write your social media password on your social media? “Hey, this is my password in case you want to log in to my social media.” Anyone like that? I bet not. Why do you have a password? Is it because of your religion? No, it is to protect you. Not all social media users are hackers, but you protect your social media because of a few hackers, especially if you want to protect your social media from your spouse. You know what I mean, nudge nudge, wink wink.")]), _vm._v(" "), _c('p', [_vm._v("In the simplest example, in some cases (not all), why do you buy condoms? To protect yourself from unwanted results. If you forget to use condom for that 30 minutes ‘karaoke’, your whole life and maybe some other people’s lives too would be affected, upset and stuffed up. Especially after you have waited for nine months in agony and feeling guilty for your wife because you have betrayed your beloved wife and family, then you realised that baby looks more and more like a milkman as he grows up, but you have to pay child support for at least 18 years. It is not yours, it is the milkman’s! See, that 30 minutes can cost you your life! Now you know why a little thing can change the system to protect yourself.")]), _vm._v(" "), _c('p', [_vm._v("I mentioned those above to explain to those who accuse the authority for being discriminative towards some beliefs, “Oh, just because the criminal had the same religion as me, now we all change the way we travel. This is discriminating towards my religion.” The fact is, no. You know the reason why, same reason why you have to use password to lock your social media and online banking, all of us in the world have to protect ourselves from a few bad hackers who are going to steal your lifetime’s savings in your bank account or steal your identity for bad reasons.")]), _vm._v(" "), _c('p', [_vm._v("Hence, the conspiracy theory is born to justify their propaganda, which is that no matter what happens in the world, you can’t blame one’s group for the cause of the tragedy, but it is an act of defamation towards one’s group. On social media, when a crime is committed, it is not about the justice for the victims, but it is more important to defend the faith, nationality, gender, ethnicity or race of the attacker.")]), _vm._v(" "), _c('p', [_vm._v("In social media, it is the social media users who decide if you go to hell or Heaven, not God. It is social media users who decide who are the victims and who is the criminal based on their race, nationality, ethnicity, and faith. The measure of the crime is not based on the severity and the brutality that the victim had endured, but it is measured by the race, ethnicity, faith and nationality of the attacker. The conspiracy theory is used to protect the guilty and treat the victim as the criminal.")]), _vm._v(" "), _c('p', [_vm._v("However, the majority of the world doesn’t buy that conspiracy theory. Murder is a murder, evil is an evil, no matter what they believe, justice has to be done. I know my position here is just as social media, but believe me, the majority of the world population respects each other, the majority of the people who believe in religion are taught to forgive and give love, the majority of us just want to live on this Planet Earth without any conflicts and crimes.")]), _vm._v(" "), _c('p', [_vm._v("These are the facts, on social media I have seen many believers who have asked forgiveness from the non-believers because the criminals killed people due to different religions. Many of the social media users apologise to the victims of discrimination against race or nationality, too. The power of kindness is much greater than the small negativity in this world (but this negative community makes the most noise on social media). Now, if we all humans in the world stand up together, you know who will be outnumbered and are going to lose.")]), _vm._v(" "), _c('p', [_vm._v("As I mentioned above, there are about 4200 religions in the world. A religion can turn your demon into a kindness, but if you have a religion it does not guarantee you are a good person. While in many countries, many different religions can live side by side in harmony, but religions and politics are still the cause of the internet speed going much faster than the speed of light, not because the real internet connection is speeding up but it is speeding up the anger, blood pressure, heart rate, emotion, lipstick fights, panty fights and pillow fights. You know why? Because social media has become their religion.")]), _vm._v(" "), _c('p', [_vm._v("The blame game is on, “You’re wrong, I’m right.” It is about equal treatment and respect to us, not to all, us first and forget the rest. They all call themselves the victims of religion haters or racism or they claim some people use the religion and racism card to cover up the guilty. But one question must be asked: if you’re just sitting there in front of the computer and doing nothing, without a job or you don’t want to get a job but are asking the world to respect you because you’re being mistreated, blaming ancestors and history: what do you do for living?")]), _vm._v(" "), _c('p', [_vm._v("Here are the questions:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Did you have a chance to go to school? Did you reject it or take it?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Do you have freedom of speech to express your view? Can you protest against your government on the street or social media without being prosecuted?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Did you burn flags? Did you blame the ancestors of the country you live in now?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Do you ask for more rights and entitlements from the government?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You ask the government and everyone to respect you and to apologise to you, do you pay tax and go to work? Do you help people who live under extreme poverty? Do you help people who live in a corrupt country to get their freedom of speech?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Can you forgive and ask forgiveness from others? Do you spend more time on negativities or positivities? If your group doesn’t like the out-group, you keep pointing the finger at them, angry at them because of the problems they made. The question is, have you ever made some effort, or even just one attempt at effort to work hand-in-hand with them? Or do you just want to have war with them? What is the percentage of positives and negatives on your social media? Is it more positivities, or is it condemning others, or just full of posts about how great and good looking you are?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Do you feel grateful and blessed for your life or do you start counting things that make you angry and disappointed?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Do you always have a happy relationship with your family and friends? Have you ever taken a depression pill or illegal drug?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Do you have more intention to have a peaceful solution (without money involved) with everyone or do you want everyone to follow your instructions or else you’ll give them hell?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Are you an explosive person? Do you have more anger, or inner peace and love?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Do you treat everyone equally regardless of race, gender, wealth, occupation, nationality, disability, ethnicity and religion? Do you have some maids at home that you pay very poorly and are treated less than human? Did you give your maids a nice and clean room to sleep in, or does she sleep in the ugliest room in the house?")])])]), _vm._v(" "), _c('p', [_vm._v("Let’s say you are in the same situation now, but you live in some Asian country. Can you campaign and do the same thing like those questions from numbers 1 – 5? If you can protest in some countries, why can’t you do the same in all countries? So you don’t seem flip-flop with your argument and what you’re fighting for. I think the answer, is you just ask for more rights in the countries where they give you more freedom of speech, freedom and welfare.")]), _vm._v(" "), _c('p', [_vm._v("As for the questions from numbers 6 – 11, never ask anyone to treat you right and respect you if:")]), _vm._v(" "), _c('p', [_vm._v("You are still not capable of controlling your anger and emotion, you look down on some people due to their social economy, you still have maids in your house, you always scream at your employees and pay them with low wages, you can’t forgive and ask for forgiveness, you cheated on tax, you can’t be honest and be down to earth, you can’t feel grateful and blessed for your life, you are more focused on punishing your opponents rather than making peace and living in harmony with them. If you still can’t do those but you are asking for more rights and entitlements, you are a hypocrite.")]), _vm._v(" "), _c('p', [_vm._v("The guilty ones (who have freedom of speech and are free to express post of view without being prosecuted, except in some countries where they don’t have a freedom to speak) will bring up the past century and history to support their argument that your ancestors had killed and tortured their ancestors. The guilty ones scream that they are the real victim of the past centuries.")]), _vm._v(" "), _c('p', [_vm._v("According to history, between 1211 – 1337, the Mongols may have killed as many 18.4 million in East Asia alone. Genghis Khan killed more than anyone in the world. If you steal my money, it is not about your ancestor having killed my ancestor or about what race or religion you have, but it is my money. I am talking about now, without the past and your ancestors, you would’ve never enjoyed freedom and welfare, would you? If your ancestors didn’t work hard for you, more likely you would’ve been working as a labourer in a farm right for living. The facts are, no, you don’t go to work but start complaining. History brought us here, what you are now is not related to history where your ancestor had been killed by Genghis Khan or Alexander the Great.")]), _vm._v(" "), _c('p', [_vm._v("The question is, do we treat anyone the same? If you say yes, we should treat everyone the same thus we can’t ban one country because of religion or race. Some countries ask for equal fair treatment, yet there are 24 countries who are (or have been) forbidden to enter some countries or almost anywhere in the world. There are 14 countries that have banned Israeli passports. If you hold a Somaliland passport, it is more likely you will be banned from entering any country in the world (except 14 countries).")]), _vm._v(" "), _c('p', [_vm._v("This is quite common in social media, when some social media users manipulate some other users by using the word God. They won’t admit that they have interfered with someone else’s private life but they will say this,")]), _vm._v(" "), _c('p', [_vm._v("“It is not that I have to interfere or dictate your life. But because we all believe in the same God, you should dress down.”")]), _vm._v(" "), _c('p', [_vm._v("“It is compulsory to spread one sentence from the Holy Book.”")]), _vm._v(" "), _c('p', [_vm._v("In some cases, some believers threaten another believer by using the sentence “This is what God wants.”")]), _vm._v(" "), _c('p', [_vm._v("They only use the word God or religion to discipline and give warning to the small kittens, because the small kittens don’t fight back. But they are too afraid to say anything to the real bad man that deserves to be lectured about God, such as drug cartels or their own government or the royal family who are above the law.")]), _vm._v(" "), _c('p', [_vm._v("Meanwhile, the rest who don’t give a damn about the religion and politics war on social media are happier and enjoying their life. They are so grateful they choose not to focus on social media or look at their computer or smartphone just to join the armpit hair fights and diaper fights about politics and religion, because it is better to do something useful such as spending time with family and loved ones, be creative or do something good quietly and feel good inside. Why? Because real life is more important than cyber life. Logically, why do you escape yourself by staring at social media if you say your life is on the right path?")]), _vm._v(" "), _c('p', [_vm._v("Do you want to change the world? Go home and love your family.")]), _vm._v(" "), _c('p', [_vm._v("I will never attend an anti-war rally, but if you have a peace rally, please invite me.")]), _vm._v(" "), _c('p', [_vm._v("There are very wise quotes from Mother Theresa. Mahatma Gandhi’s quote: the weak can never forgive. Forgiveness is the attribute of the strong.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "dunning-kruger-effect"
    }
  }, [_c('h3', [_vm._v("Dunning-Kruger Effect")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("In the field of psychology, the Dunning-Kruger Effect is a cognitive bias wherein people of low ability have illusory superiority, mistakenly assessing their cognitive ability as greater than it is. People who are ignorant or unskilled in a given domain tend to believe they are much more competent than they are. Two psychologists from Cornell University, David Dunning and Justin Kruger, identified this cognitive bias in a 1999 study, Unskilled and Unaware of It: How Difficulties in Recognising One’s Own Incompetence Lead to Inflated Self-Assessment. The McArthur Wheeler case got attention from Professor David Dunning and Justin Kruger, a graduate. In 2000, Professor David Dunning and Justin Kruger were awarded an Ig Nobel Prize.")]), _vm._v(" "), _c('p', [_vm._v("On April 19, 1995, McArthur Wheeler robbed two banks in Pittsburg in broad daylight. He didn’t use a mask, the security camera picked up his image holding a gun at the teller. The police broadcasted the footage on the eleven o’clock news. Within minutes, the police got the information, and that man was identified as McArthur Wheeler. He was incredulous, “But I wore the juice.” Wheeler told the police he rubbed lemon juice on his face to make it invisible to the security camera, because lemon juice is used as an invisible ink. Before he robbed the bank, he tested this before, rubbed his face with lemon juice and took a selfie from a Polaroid camera. There was no face in the photo. But one problem again, Wheeler is not a brilliant photographer. He couldn’t really see properly because lemon juice stung his eyes badly.")]), _vm._v(" "), _c('p', [_vm._v("Now let me ask you this question: you are not biased, your opinion is based on your knowledge and not on your emotions, you are funny, you are always right, you know everything as it is impossible for you to say, “I don’t know,” or, “I think I am wrong.” Everyone else is biased except you. Empty vessels make the most noise. The clown looks at his reflection as a professor. A kitten looks at his reflection as a grizzly bear. Small dicks look in the mirror as a big dickzilla, that’s why the ‘small’ one makes the most noise.")]), _vm._v(" "), _c('p', [_vm._v("Have you been arguing on your social media because you believe your point of view is better and smarter than others’? How many of you feel that you can’t be wrong? If someone points out your mistakes, you’ll be angry and attack them, right? Now I ask you this, you believe you are smarter, have a great sense of humour, your point of view is spot on and unbiased, you know all the solutions and answers in the world, God and the universe are always on your side, and of course you are a very likeable person. When you see someone disagrees with you, will you label him as a racist, bully or bigot just because they tell you that your posts contain wrong information?")]), _vm._v(" "), _c('p', [_vm._v("Of course, you will deny that you make a comment or post on social media based on your bias. Biases, ego and emotion are not based on your common sense, but based on your hate and your favouritism. You want to make an impression that you are Mr Einstein or Mr Wise to all, but you don’t have any knowledge, skill, experience or study of the topic but you claim you do know the answer. You lie, you do that because you don’t want to look stupid, but actually by opening your mouth and writing your comment, it makes you look stupid. Better to be silent to show wisdom than open your mouth to reveal stupidity. They say the speed of light is faster than the speed of sound, some people seem bright till they open their mouth.")]), _vm._v(" "), _c('p', [_vm._v("Every day on social media, I always see so many comments attacking each other, one social media user feels his comment is right but the other is wrong and vice versa. It’s a mutual feeling between them. Or more precisely, it is mutual online sex. Yes, it is online sex, you say f you and they say f you too. It is sex, the length of the arguing between you and them, the more you guys curse each other, call each other names, the more you and they get tired and run out of breath. Just like sex, tired, now it is time for you to have a cigarette.")]), _vm._v(" "), _c('p', [_vm._v("Now let me ask you a second question, how many of you only got the knowledge and information from your social media home page or from a $2 newspaper, but your comment says you’re the chosen one from God or you are better than Google? This is like you’re telling me you know all the history of ancient China just because you just ate one yum cha with soy sauce. Wow, one yum cha with soy sauce dip makes you an expert of Chinese history, what a miracle! No need to study about history and learn, no books to read, no knowledge at all but based on this one piece of information which is as small as a dim sim, suddenly you know the whole universe! Hallelujah! You just ate a slice of Margarita Pizza and tiramisu, suddenly bingo, you’re the expert in ancient Roman history and also the politics in Italy.")]), _vm._v(" "), _c('p', [_vm._v("Now test this, mention one political problem in the world on social media, relax, get your drink and popcorn. And watch this soap opera live from your computer! Suddenly there are many people jumping in to comment and make a conclusion, competing with each other to get the trophy of: “I am the one with the right answer.” You want everyone to worship your comment like they worship God, this is why you get mad when someone finds an error in judgement in your comment, because only God can criticise you, no others. If you could, you would provide dildos to all of them, so they all can fuck each other.")]), _vm._v(" "), _c('p', [_vm._v("You don’t need necessarily to think before you answer but you come to write on social media with this attitude, “I am so right whether you like it or not, you have to agree with my comment or you’ll die!” The more you don’t know, the more you talk and think you are smarter (the facts are that you are incompetent), and the more aggressive you are. Lacking in knowledge, emotional maturity and because you are guilty makes you so aggressive and become a bully on social media.")]), _vm._v(" "), _c('p', [_vm._v("Hey, if you think you are smart and know everything, don’t budget your fantasy. Take it up much higher, you are the most intelligent person in the world, reach for the sky, baby. Why do you talk as if you know everything? It is because you don’t know everything but you pretend you know everything to impress anyone or to make yourself look good and intelligent. There is a very big difference between ‘pretending’ and ‘knowledge’. But did you know, the more you talk, the more you spill the beans which gradually reveals your true colour. The more you talk, the more you make an idiot of yourself. Just be quiet and remain positive, rather than opening your mouth and revealing your stupidity.")]), _vm._v(" "), _c('p', [_vm._v("Lies are a bloated emptiness. You blow some air into an empty brown paper bag, you keep blowing it to make it look bigger and better, in the end it explodes. Why? Because if you keep feeding an empty head with nonsense and blow the wind of lies into an empty head, in the end your brain can’t take all the bullshit and lies anymore. It explodes! Boom! All the fibs, deceit and dishonesty will splatter everywhere from that explosion. Your ego says you are the greatest but your brain cells say, “I can’t take this shit anymore.”")]), _vm._v(" "), _c('p', [_vm._v("That’s why you got aggressive. One thing you didn’t know, telling lies is like you’re ditching your spouse. One day she’ll come back at you with revenge and bite you harder, even terrorising you, stalking you and sending you many spiteful messages, haunting you till you take your last breath. You can extend your horizon by learning, but you can’t extend the horizon with lies because lies are not a straight line and cannot be straightened. Extending a lie is like extending a curly rope which is round and round, and in the end you’ll get knotted and tied up by your own rope that you have extended. I know honesty is permanent, the truth is forever, drunkenness is temporary, a bloated stomach is temporary, hiccups are temporary, but a moron is forever.")]), _vm._v(" "), _c('p', [_vm._v("Mention anything in the world to you, if you suffer Dunning Kruger syndrome, you’ll know the answer even though you don’t know anything about it at all. Never say, “I don’t know,” or, “I don’t know the answer,” or, “I am stupid.” Competent and skilled people will answer when they know the answer, incompetent and unskilled people will answer regardless of whether they know it or not, to them it is not about the knowledge, it is about ego. A Dunning Kruger sufferer will lie and say anything not because they know the answer, but they want to look good and give an impression to everyone, “I know about everything and I am right.”")]), _vm._v(" "), _c('p', [_vm._v("Now, I ask you about politics. What is the relation between doughnuts and politics? Just one question and your answer will be longer than the Gone With The Wind movie. Listen to what some real people with real knowledge reply to your ‘highly intelligent’ explanations, did they say these words? “I see, all right, okay, I see your point, spot on, brilliant, excellent, wonderful, great, and awesome.” Do you think they say those words because they agree with you? Or because they look up to you as a wise man, an intelligent person and a politics guru or master of financial advisers? Well, they look up to you because you are stuck in the palm tree. Secondly, they say those words such as, “All right, okay, brilliant, wonderful, excellent, you are so smart, you are so spot on,” and so on not because they agree with you, but because it’s a shortcut to cut the stupid conversation. You don’t know you’ve been fooled by them, do you?")]), _vm._v(" "), _c('p', [_vm._v("The reason why they show their agreement with you: they are being polite as they didn’t want to tell you that you are so stupid, because it will hurt you to know that you are so stupid. Not to that level, but to put it this way: what if your wife asks you, “Honey, do I look fat now?”")]), _vm._v(" "), _c('p', [_vm._v("Now what would your answer be for that, of course you’d say, “Of course not, you have the most beautiful body in the world.” To put it this way again, what if you’re being honest by saying this to your lady, “Actually the new neighbour is hotter and slimmer than you.”")]), _vm._v(" "), _c('p', [_vm._v("Wow, this is a dangerous level, this is the same as if you go to a police station and ask the officer, “Officer, could you please taser me?”")]), _vm._v(" "), _c('p', [_vm._v("The cops look puzzled and ask you, “Why?”")]), _vm._v(" "), _c('p', [_vm._v("You say, “Because I’ve got nothing to do.” If you’re smart you won’t say that. Same as the Dunning Kruger effect, if you say, “No, actually I am smarter and have more knowledge than you,” you know you will be dragged down to their stupidity level as they will challenge you to have a handbag and pillow fight for their ego and the title ‘I know better than you’.")]), _vm._v(" "), _c('p', [_vm._v("As with Hores Hump’s quote, “Jennay… I am not smart, but I know you are stupid.” Wow, you’d go ballistic as if you took a doughnut away from a fat bastard, or you say to a random girl that her eyebrows are back to front. Just say yes, yes, yes, to make a shortcut and cut the bullshit, rather than taking the stupidity seriously by saying, “No, you’re wrong, I disagree with you.” Oh, it is going to be a long and tiring argument, more tiring than sweeping the floor of The Great Wall of China. Maybe longer than waiting for your woman to draw and shape her eyebrows with an eyebrows pencil. Oh, I am so sorry, I could be wrong here. I think shaping and drawing eyebrows takes longer than that.")]), _vm._v(" "), _c('p', [_vm._v("Now let me test you, what do you think about Kim Bang Yu? You with Dunning Kruger syndrome will answer,")]), _vm._v(" "), _c('p', [_vm._v("“Kim Bang Yu, Dim Wit Yu, Zack Ash and Ben Dover are brothers. Same mama but different papa. Kim Bang Yu used to work as a kindergarten teacher, once he turned down an offer to be a major star in this big budget movie, Cing Cong, because the gorilla had a crush on him and you know Kim is a lesbian…” and so on and so on and so on. For you with Dunning Kruger effect, this sounds so reasonable and is common sense. But for some people who have knowledge and experience that explanation sounds like:")]), _vm._v(" "), _c('p', [_vm._v("“My cat ate my homework.”")]), _vm._v(" "), _c('p', [_vm._v("“Sir, I am very sorry that I was late to class because I had to go home again to turn the tap water off, I forgot to turn it off.”")]), _vm._v(" "), _c('p', [_vm._v("“Sorry I was late to school because I was waiting for my brother in the bathroom. He wanted to go to school together with me,” says someone who lives next door to school.")]), _vm._v(" "), _c('p', [_vm._v("“Sorry I didn’t do my homework. I may be lazy, silly and stupid, but I did not have sex with that homework!”")]), _vm._v(" "), _c('p', [_vm._v("“No, H2O is not water. It is a bus route to Zimbabwe. So, when they say take a lot of H2O, it means you have to go to Zimbabwe a lot.”")]), _vm._v(" "), _c('p', [_vm._v("Or it sounds like this,")]), _vm._v(" "), _c('p', [_vm._v("“Baby, I am pregnant with your baby.”")]), _vm._v(" "), _c('p', [_vm._v("“How come? We didn’t have sex this year.”")]), _vm._v(" "), _c('p', [_vm._v("“You told me Santa could make my wish come true, so I told Santa that I wanted to have a baby, which I did.”")]), _vm._v(" "), _c('p', [_vm._v("“What did Santa say to you?”")]), _vm._v(" "), _c('p', [_vm._v("“You’re old but you’re good.”")]), _vm._v(" "), _c('p', [_vm._v("You see how ridiculous it is when you don’t know the answer, but you forced yourself to answer in order to make yourself look good, but actually it makes you look silly? You can’t force a Cinderella shoe onto a gorilla foot.")]), _vm._v(" "), _c('p', [_vm._v("Did you get bored with TV these days? Bored and so over telenova or soapies? Just get a bowl of popcorn, or if you get bored with popcorn just get some spaghetti or pizza, then turn your computer on. Watch the Dunning Kruger sufferers on social media. You see the war amongst them. They all want to be called the smartest one with the most brilliant point of view. Watch them mock each other. Even the tough big guys with many tattoos suddenly become the bitchiest Tupperware ladies. If you could wish to be there in a visual world, you would give those Tupperware ladies a chocolate bar and an energy drink to make their fight even bigger, tastier, more enjoyable and more memorable.")]), _vm._v(" "), _c('p', [_vm._v("Just to have fun when you watch these Dunning Kruger sufferers fight amongst them, you join in and leave some comments,")]), _vm._v(" "), _c('p', [_vm._v("“Throw him some flowers and the pot too.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t punch him, just pinch him with the pliers!”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t yell at her please, just wake her up and stroke her hair with boxing gloves.”")]), _vm._v(" "), _c('p', [_vm._v("“Tell her that her sister is hotter and better in bed!”")]), _vm._v(" "), _c('p', [_vm._v("Asking any question of you who suffer Dunning Kruger Effect Personality, you’ll have an answer. Ask to rate yourself from 1 – 10, you’ll say you’re off the chart. I ask you where the milk come from, you say from the best virgin cows which live in the castle while your child says milk comes from the fridge. Asking you about anything, you’ll have an answer. Never give up on giving an answer even though you are empty, no clue at all. This is like a gun, you still keep shooting even though you know the gun is empty, no bullets but you blast it anyway just to let them know that you are the real deal. The results? Only one loud noise but didn’t hit the target because it has no ammunition. Only a shock of strong wind, no bullet, the enemies won’t get hit but it may make your enemy’s hair look good though, like a hair dryer.")]), _vm._v(" "), _c('p', [_vm._v("Asking you about sex, how do you rate yourself in bed? You say 10 out of 10 while your wife says quicker than 2-minute instant noodles. Asking you about money, you say you are smarter than Warren Buffet, you know all the blue chips in the stock exchange. You say you invest here and there because you know and are very smart to invest your money, but the reality is you are not a money guru and wealthy like you say. People who are smart with money and the ones with money don’t talk about money and their investment unless to accountants, lawyers and their spouse. The ones who don’t have it are the ones who talk the most. If it’s true they are so smart with money, can make easy money like they say, why aren’t they in the rich list? The less you feel, the more you lie.")]), _vm._v(" "), _c('p', [_vm._v("Dunning Kruger sufferers think they are smarter than you, better in politics than you, wiser than you and unbiased. Not just that, a Dunning Kruger sufferer also thinks he is a smart investor, smart businessman, the best in stock market business and very rich (in fact, he only has $10 in his wallet). He teaches you how to invest and make millions of dollars. He is a money guru, knows everything and anything about investment and money. Why? Because he doesn’t have money and never makes good money in investment but he wants to make an impression that he is a very successful businessman. He will tell you how much money he has here and there without you asking them, he just volunteers that information. Remember, narcissists suffer Dunning Kruger Effects too, they also want to compete with you, to outdo you because they are jealous of you.")]), _vm._v(" "), _c('p', [_vm._v("He will tell you how successful and expert he is in business. Of course, he always mentions a big number, how easy it is for him to make money and so on. He will tell you about his multi-million-dollar business and knows how to predict the stock market, which is all a super lie. As a wise man says, never talk about money, politics, religion and bullshit. That’s the golden rule.")]), _vm._v(" "), _c('p', [_vm._v("Dunning Kruger sufferers suffer narcissism, too,")]), _vm._v(" "), _c('p', [_vm._v("“I have invested one million dollars in South Bank.”")]), _vm._v(" "), _c('p', [_vm._v("“I have invested two million dollars in South Bank.”")]), _vm._v(" "), _c('p', [_vm._v("See, they all are competing over who is the biggest, actually they try to compete to be the biggest liar. If you say, “My land size is about 300 m2,” the other Dunning Kruger sufferer will reply, “Mine is 500 m2.”")]), _vm._v(" "), _c('p', [_vm._v("“I fly business class.”")]), _vm._v(" "), _c('p', [_vm._v("“I fly first class.”")]), _vm._v(" "), _c('p', [_vm._v("“I fly on my private jet,”")]), _vm._v(" "), _c('p', [_vm._v("“I fly on a flying rug like Ali Baba.”")]), _vm._v(" "), _c('p', [_vm._v("It’s all about competition over who is smarter, richer, luckier and the more successful one. The bigger they lie, the better they feel. When they say, “I want,” mostly linked to a big amount of money they want to spend, you know they don’t have that much money,")]), _vm._v(" "), _c('p', [_vm._v("“I want to buy that waterfront house. I don’t have to sell my house to buy that waterfront mansion.”")]), _vm._v(" "), _c('p', [_vm._v("“I want to buy that factory, so all up I have 11 factories.”")]), _vm._v(" "), _c('p', [_vm._v("“I want to invest one or two million dollars more, I just received three million dollars dividends as a shareholder.”")]), _vm._v(" "), _c('p', [_vm._v("The more jealous they are of you, the more spectacularly they lie to you,")]), _vm._v(" "), _c('p', [_vm._v("“I can make my woman climax like a piñata.”")]), _vm._v(" "), _c('p', [_vm._v("“They have to put conception behind my wife’s throat because my honk is too big and too long.”")]), _vm._v(" "), _c('p', [_vm._v("They won’t compliment you such as, “How magnificent your house is, you are so lucky and so smart.” But they will outdo you and outsmart you by saying, “My house is bigger than yours, I am smarter, luckier and wealthier than you.” As I say, they will not give you a compliment about how lucky you are or happy for you but they will compete with you. Whatever you have, they have better and bigger than you. If you say you have a moon, they say they have this Planet Earth. You say you have planet Mars, they say they have the whole solar system.")]), _vm._v(" "), _c('p', [_vm._v("If you say your penis is so long so it can knock at your girlfriend’s house door, they will reply, “Oh, mine can go to the moon, rotating the moon and back to Earth.” In fact, the tinier his tool is, the bigger and longer he lies. They live in their dream world but they don’t have it. For them it is a big taboo to say, “I can’t afford that.” This is why they always say, “I can afford that, I can buy that, I know.” Sure, they can talk anything they want but the proof and the truth don’t say so. Honest people don’t do that, honest people don’t eat bullshit, we call it hallucination.")]), _vm._v(" "), _c('p', [_vm._v("With this syndrome, comes jealousy and rivalry. You are also a jealous person apart from your delusion as the smartest and the most unbiased person in the world. Why are you deceiving them? Because they are your rival, they are the person you envy because they have everything you dream of but you can’t have it. To reach their level or to make you look ‘bigger and more successful’ than them, you will study first about who they are and predict how much their net worth is. If they are penniless you won’t give a damn. You will give bad treatment to people who don’t have money as if they are a part of the furniture. Yes, Dunning Kruger sufferers have a narcissistic personality, are shallow and so deceitful.")]), _vm._v(" "), _c('p', [_vm._v("Did you see Bill Gates showing off his bank account or his wealth to everyone on his social media? Did you see Warren Buffet boasting what a successful investor he is? Did you see Einstein keep telling everyone how smart he was? True story, one of the symptoms of severe Dunning Kruger and narcissism is, he pretends that he makes a fake phone call with that stereo sound surround system voice in order to make you listen to him, “How much is all up? One billion dollars? Did I just get fifty million dollars dividends? Thank you very much.” You know it was a fake call, he didn’t call anyone on the cell phone, he’s pretending he’s on the phone with some imaginary important businessman. It is so obvious he talks louder on purpose than his normal voice when he talks about millions of dollars, so we all can hear and think, “Ohh… he must be a multi-millionaire,” but he is kind of whispering on the phone when he is talking to his mistress.")]), _vm._v(" "), _c('p', [_vm._v("One of the other symptoms is, he acts and talks differently whenever he is with his close friends, his family or his wife. On social media, if his family are in his social media friend list, he can’t say much about his imaginary multi-million business on his wall but he will tell you in his chat room or inbox. Or in many cases he has two social media accounts, one for his family and close friends who know shit about him and the other one account is an account to boast his ‘successful life’ full of young girls in his friend list.")]), _vm._v(" "), _c('p', [_vm._v("Why does he act differently when he’s with his close pals or family who knows him? Because his family, his wife and his friends know the truth that he is not as successful and so smart as he tells you. When his wife is beside him, suddenly he is quieter, he doesn’t talk about millions of dollars or this mansion or that business because his wife knows the truth (there are cases where husband and wife suffer Dunning Kruger and narcissism, so they support each other’s lies and ego). When his close friends are with him, he doesn’t talk big money, his excuse is, “I don’t talk money with them because they are struggling financially. I am more comfortable talking money with you because we are on the same page.” No, we are not on the same page. I am honest and you are not. Also, it is very strange he doesn’t talk about his investment to his close friends whom he’s known since primary school but he talks money to a stranger like you, and you just knew him since only a few months ago.")]), _vm._v(" "), _c('p', [_vm._v("Meanwhile the person with the real knowledge who is very intelligent will not say anything and will not get involved in the comment arguments on social media with this mindset, “I am the one with the right answer and you are wrong.” Why? Because they don’t want to waste their time, they don’t want to drag themselves down to that level and mostly, they have dignity and pride. They don’t want to lose their pride and dignity by getting involved in those brief or thong fights.")]), _vm._v(" "), _c('p', [_vm._v("If only we could slip some ads in between Dunning Kruger pillow fights just for fun like this,")]), _vm._v(" "), _c('p', [_vm._v("“Feeling thirsty? Run out of breath? Refresh and energise yourself with this energy drink.”")]), _vm._v(" "), _c('p', [_vm._v("“Bad breath? Take this minty candy. Freshen up your breath so when you’re arguing, it will be a minty argument. Hmm… so fresh and minty.”")]), _vm._v(" "), _c('p', [_vm._v("“Split ends, dull and frizzy hair? Change your shampoo to this shampoo to make your hair shine, stronger and manageable. It is a nice feeling to argue with bouncy and healthy hair.”")]), _vm._v(" "), _c('p', [_vm._v("“Have you ever wondered why baby shampoo doesn’t sting baby eyes but adult shampoo and capsicum spray stings your eyes? Because you deserve it. Adults need to be hurt, try this shampoo, it won’t sting your eyes.”")]), _vm._v(" "), _c('p', [_vm._v("“This peanut butter tastes so good. I can’t believe it’s not a nutter!”")]), _vm._v(" "), _c('p', [_vm._v("“Sick and tired of your hairy legs and hairy ass? Why don’t you try this cream, hair removal, no more hairy legs, no more hairy ass.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you feeling tired? Drowsy? Short tempered? Constipated? Angry? You have moronic symptoms. Take this pill. One tablet of Morondol will cure your moron. Gentle on the stomach, also suitable for breast feeding mothers. If pain persists, please see punch yourself in the face.”")]), _vm._v(" "), _c('p', [_vm._v("“Give something so precious and memorable to your lover today. Chocolate will melt, flowers will die, but a dildo is forever. Dildo, the perfect jewellery for your woman.”")]), _vm._v(" "), _c('p', [_vm._v("How wonderful and fun would that be if we could do that.")]), _vm._v(" "), _c('p', [_vm._v("It is very unlikely but possible if there is a skilled and competent person involved and tries to explain to those Dunning Kruger effect sufferers the right answer, you the Dunning Kruger sufferers will see it as a red flag. You do not listen to the smart one because you would rather stay stupid than admit someone is smarter than you.")]), _vm._v(" "), _c('p', [_vm._v("When your ego is bigger than knowledge, you will follow the bigger one which is your ego and emotion, not your brain and common sense. You know what will happen if you don’t want to learn and be honest, this is like you are sailing around the world without any navigation. You’ll get lost.")]), _vm._v(" "), _c('p', [_vm._v("“Hey, I think you took the wrong turn. We’re supposed to go to tropical and exotic Africa, not Antarctica. I can see the penguins over there. This is not Africa.”")]), _vm._v(" "), _c('p', [_vm._v("“No, we’re heading in the right direction. There are penguins too in Africa you know, they love playing bungee jumping with African lion.”")]), _vm._v(" "), _c('p', [_vm._v("“Why does aurora occur the most in the North Pole?”")]), _vm._v(" "), _c('p', [_vm._v("“D’oh, because aurora can’t do pole dancing in South Pole.”")]), _vm._v(" "), _c('p', [_vm._v("You lie about your intelligence, you are not looking forward to learning or trying to be honest at least. You are only looking forward to getting complimented and getting accolades because you are so smart and highly intelligent. Some of the words or jokes you have on social media don’t necessarily come from your brain, you stole it from others just to take accolades and compliments for you. You love it when someone strokes your ego. Secondly, you think you can outsmart anyone. Thirdly, because if you admit that you are not capable and lacking information, you will see it as a defeat, you will think you lost your reputation.")]), _vm._v(" "), _c('p', [_vm._v("See, stupidity is entrapment, you can’t get out of it unless you are honest that you don’t know the answer and you are willing to learn. Stupidity will trap you and lock you in your stupid world, this is why you’d better learn and ask someone who is smarter than you how to open the door to your stupidity entrapment. No one deserves to be stupid, but some people have their brain not inside their head, but inside their knees and armpits. Next time you wear a helmet, please protect your knees and don’t wax your armpit hair as your brain will get waxed too.")]), _vm._v(" "), _c('p', [_vm._v("The fact is, the more we learn, the more we realise there are so many things in this universe that we haven’t known yet. This doesn’t apply to the Dunning Kruger effect personality disorder because the more you don’t know, the more you feel superior and smarter. Unless the evidence and results are present, look your bank account shows $10 but you kept telling everyone that you are a successful multi-millionaire investor. The truth is the truth, you can’t upgrade the truth. If a man says you have bad breath, he is just being mean. If a woman says you have bad breath, she is just being jealous. But if a kid says you have bad breath, it means you really, really have bad breath and that is the truth.")]), _vm._v(" "), _c('p', [_vm._v("Just like McArthur Wheeler who was in disbelief and said to the police, “But I wore the juice.” Exactly like you with Dunning Kruger effect. That’s what you say to yourself and everyone, “But I was right.” Of course you are always right, and that’s what the opponents think. The opponents think they are always right but you are wrong.")]), _vm._v(" "), _c('p', [_vm._v("It is not a crime to believe in anything you want. It is not a crime either to believe that the facts are very reliable, accurate and undeniable instead of being pretend. But it is going to trap you and imprison you if keep telling lies. Because eventually your lies will turn around and embarrass you. The difference between the pretenders and the real truth-tellers is, they always measure their dick by the expensive car they drive. Honest men don’t need an expensive sports car to advertise that he has a ‘Dickzilla’.")]), _vm._v(" "), _c('p', [_vm._v("We don’t predict the weather based on your fantasy, but we predict the weather through knowledge, experiences, complex math calculation, science and brain cells. How could that be if we use fantasy to predict the weather today?")]), _vm._v(" "), _c('p', [_vm._v("“What’s the weather tomorrow?”")]), _vm._v(" "), _c('p', [_vm._v("“Wetter than your wife and morning dew.”")]), _vm._v(" "), _c('p', [_vm._v("“This afternoon will be very cold, colder than your mother in law with some hail.”")]), _vm._v(" "), _c('p', [_vm._v("Just like sex, fantasy makes you high but the climax makes you grounded. The Dunning Kruger effect can be cured, if you live in real life not a fantasy land. Imagine this, we have an ATM with a Dunning Kruger version, wow, isn’t it so interesting to watch. You ask for the balance, and the balance says.")]), _vm._v(" "), _c('p', [_vm._v("“You are the richest person in the world.”")]), _vm._v(" "), _c('p', [_vm._v("Then you withdraw money for one billion dollars, the ATM says, “Don’t worry about the $2 billion you just took, you still have plenty here and it’s endless.”")]), _vm._v(" "), _c('p', [_vm._v("You ask for the receipt, the ATM says, “You have all the money in the world, no one is richer than you, you gorgeous hot stuff.”")]), _vm._v(" "), _c('p', [_vm._v("You ask again for the receipt, the ATM replies, “Would you like to masturbate now? Please press yes or no.”")]), _vm._v(" "), _c('p', [_vm._v("If there is a mirror for the Dunning Kruger effect personality disorder and also for narcissists, whenever you look at yourself in the mirror, the mirror will say, “You are the most beautiful girl in the world.”")]), _vm._v(" "), _c('p', [_vm._v("You ask again, “Mirror on the wall, who’s the brightest of them all?”")]), _vm._v(" "), _c('p', [_vm._v("The mirror says, “You, my lord.”")]), _vm._v(" "), _c('p', [_vm._v("“Mirror on the wall, who’s the most talented girl of them all?”")]), _vm._v(" "), _c('p', [_vm._v("“Your neighbour, she was with your boyfriend last night.”")]), _vm._v(" "), _c('p', [_vm._v("Well, there goes that mirror, smashed by your fist. Even a mirror in the end can’t take bullshit.")]), _vm._v(" "), _c('p', [_vm._v("“Mirror on the wall, who’s the richest of them all?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s you, your Highness.”")]), _vm._v(" "), _c('p', [_vm._v("“Mirror mirror on the wall, who’s the most heroic person of them all?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s you, your Majesty.”")]), _vm._v(" "), _c('p', [_vm._v("“Mirror mirror on the wall, who’s the most gorgeous and smartest person of them all?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s you, my Lord.”")]), _vm._v(" "), _c('p', [_vm._v("“Mirror mirror on the wall, who’s the most philanthropic of them all?”")]), _vm._v(" "), _c('p', [_vm._v("“It’s not you, you moron! You want to know the most philanthropist of them all? Why don’t you bend over and I’ll give you the answer! And I’ll tell you when I’m finished. It’s disgusting using humanity to boost your reputation. Even a mirror like me is sick and tired of being forced by you to give all compliments and accolades to a jerk like you, all the time, non-stop. Oh mirror mirror… oh moron moron… bla bla bla bla…You ask me one more question, Mirror mirror on the wall, I’ll make sure this mirror will be stuck up yours! Now you can see what you are! Moron moron on the wall, who’s the most narcissistic and hypocritical person in the world? It’s you, and now, get lost!”")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "lies-about-photoshop-gates"
    }
  }, [_c('h3', [_vm._v("Lies About Photoshop Gates")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("If you think you are better, nicer and bigger than you think, this is why you can’t park your car properly and are hopeless in math because you think your manhood is 10 inches, but actually it’s not. And for some grandmas and grandpas, they don’t really know whether their smart phone battery is full or not because they always believe they are full of energy and life. Some ladies can’t really tell the fake leather from the genuine leather handbag because they always lie about their real age. Some of you never know why toilet tissue is still stuck to your behind because you always lie about how delicate and sensitive you are. You can’t tell your partner has a backache or not because you always lie about your weight. This is one of the reasons why you have a bad taste in fashion, your mind says Victoria Secret model but your backside says Vladimir Secret.")]), _vm._v(" "), _c('p', [_vm._v("I think it’s quite universal and is considered as one of the top secrets, you lie about your age and body weight, and money, too. In social media, five of the most common lies are age, your real looks (filtered and photoshopped), money, body weight and… relationships, ha! Does it sound familiar to you? I’ll talk about that later. But the number one lie on social media goes to… your real looks. Thank God for the Photoshop app, no need for Botox, no laser treatment to get rid of those age spots or plastic surgery. Hey, it is fun to use photoshop, as long as it is not too much. Even bananas are photoshopped to look more tasty, longer and more yellow so we all can go bananas. The conclusion is your social media photo is so beautiful that men would die for you but when men see your real face in person they pretend they die because you don’t look like your social photo at all. Your online face is candy, your offline face is a cactus. If you don’t like the truth, I’ll buy you a dildo. So you can go and do yourself if you don’t like it.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4.79931in",
      "height": "6.57222in"
    },
    attrs: {
      "alt": "",
      "src": "media/imgg.png"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("For girls, it is not a crime to use make-up for self-confidence. We all want to look good, especially for social media photos and videos. Because everyone from around the world will be watching us. It is not a crime either to use a filter, a bit of blur here blur there to get rid of the age spots and wrinkles. There you go.")]), _vm._v(" "), _c('p', [_vm._v("“Oh Photoshop Fairy, I worry about my muffin tops that look like a swim ring stuck in my hips.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t worry my child, I will make your dream come true. That swim ring in your hips will be gone.”")]), _vm._v(" "), _c('p', [_vm._v("“But I want big boobs, my breasts are flat like two pan cakes.”")]), _vm._v(" "), _c('p', [_vm._v("“Abracadabra, there you go. Now you have two Mount Everests on your chest.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, I love them, I do, I do. Thank you very much, Photoshop Fairy. Ain’t no mountain higher than Mount Everest.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s the max that I can do for breast enlargement. I can make them bigger. But they will look silly. My child, please be careful when you climb Mount Everest. Climbers only have a 31% chance of making it to the summit and a 1.5% chance of dying.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you for your advice, Photoshop Fairy. Now I want my short dumpy legs look longer, slimmer and toned.”")]), _vm._v(" "), _c('p', [_vm._v("“Would you like fairy legs or hairy legs?”")]), _vm._v(" "), _c('p', [_vm._v("“Fairy legs please, with two knees, not four.”")]), _vm._v(" "), _c('p', [_vm._v("“Your wish has come true. Abracadabra! Now you have two super model legs. Slender, long and toned. No more chicken drumstick legs. Before with those chicken drumstick legs you couldn’t do doggy style with your man, now you can bend over high, proud and loud.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, thank you, thank you very much, Photoshop Fairy. You are the magic in my life.”")]), _vm._v(" "), _c('p', [_vm._v("“But remember, the magic will be gone the moment you turn the computer or your smart phone off.”")]), _vm._v(" "), _c('p', [_vm._v("“Noted, Photoshop Fairy.”")]), _vm._v(" "), _c('p', [_vm._v("There’s a man who is unhappy with his physical appearance, pleading for help from the Photoshop Fairy,")]), _vm._v(" "), _c('p', [_vm._v("“Oh, Photoshop Fairy, I desperately need your help. As a man, I have low esteem because my stomach is so big. I can’t see my groin and my feet when I am standing up, help, please.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t worry my son. Would you like to have six pack abs?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, please.”")]), _vm._v(" "), _c('p', [_vm._v("“Abracadabra, now you have six-pack abs.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God, this is awesome! I look hot. Women will be chasing me like crazy.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s right,” Photoshop Fairy smiles.")]), _vm._v(" "), _c('p', [_vm._v("“Oh my, Photoshop Fairy, you forgot something.”")]), _vm._v(" "), _c('p', [_vm._v("“What is that?”")]), _vm._v(" "), _c('p', [_vm._v("“You didn’t give me a navel. I already have my desired abs but no navel. Please, I want one.”")]), _vm._v(" "), _c('p', [_vm._v("“Well, you didn’t request it before.”")]), _vm._v(" "), _c('p', [_vm._v("“My apologies, I forgot, due to being too focused on six packs.”")]), _vm._v(" "), _c('p', [_vm._v("“Let me put it wherever you want. Do you want me to put it on your forehead? In between those two eyes? Or back to your abs?”")]), _vm._v(" "), _c('p', [_vm._v("“Let me think. I’d love to put in on my armpit but no one would see it unless I put my hand up in the air. So I think my navel should go to its old place which is on my stomach, thank you.”")]), _vm._v(" "), _c('p', [_vm._v("“Any more requests, my son? What about your hair?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, it has me worried. I have no hair on the top of my head. Sometimes I covered it with grass then a daisy grew on it, I don’t like it. I’d love to have hair like a Persian carpet on the top of my head, no more baldness.”")]), _vm._v(" "), _c('p', [_vm._v("“What kind of hair do you want? Would you like it curly, straight or wavy?”")]), _vm._v(" "), _c('p', [_vm._v("“Kind of round, wavy and stylish.”")]), _vm._v(" "), _c('p', [_vm._v("“You mean it is as if I put a soft Nacho on top of your hair?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, that’s the one.”")]), _vm._v(" "), _c('p', [_vm._v("“So you want your hair with no part or middle part?”")]), _vm._v(" "), _c('p', [_vm._v("“I would love a middle part but it will look like my backside, you know all backsides are middle parted.”")]), _vm._v(" "), _c('p', [_vm._v("“I see.”")]), _vm._v(" "), _c('p', [_vm._v("“Last but not least, can I please have a handsome face like that movie star from the Chor movie?”")]), _vm._v(" "), _c('p', [_vm._v("“Done!”")]), _vm._v(" "), _c('p', [_vm._v("“I know I am a bit demanding here, but can I have one more request? This is also important.”")]), _vm._v(" "), _c('p', [_vm._v("“Go on.”")]), _vm._v(" "), _c('p', [_vm._v("“Can you make my body slim with my wallet fat? Please don’t get mixed up. Don’t do it the other way around. I want a slim body and fat wallet, not a slim wallet and fat body, got it?”")]), _vm._v(" "), _c('p', [_vm._v("“Of course, abracadabra! Now you have an expensive huge mansion, sports cars and all the wealth. Plus, your slim hot body!”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God, you are a genius! This is the life and the body I always desire that I don’t have offline. My body is fat and my wallet is thin. Only the online world can make my dreams come true! Thank you, thank you.”")]), _vm._v(" "), _c('p', [_vm._v("There’s one lady who cries over her cellulite and stretch mark on her legs seeking help from the Photoshop Fairy. Photoshop Fairy smiles and comforts her, “There’s nothing impossible in photoshop world. In the online world and this photoshop app, you can have anything you want.”")]), _vm._v(" "), _c('p', [_vm._v("She looks up at the Photoshop Fairy and asks, “Anything I want?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, my dear.”")]), _vm._v(" "), _c('p', [_vm._v("Her eyes are lit up, she enthusiastically starts making some lists for herself,")]), _vm._v(" "), _c('p', [_vm._v("“If I could please have my stretch marks and cellulite removed, my lips look thick like a truck tyre, my eyes look big, my nose become upturned and thin, not downturned and curly, my hair become green and wavy, and my breasts become DD cups. I want my skin as clear as a mirror so a mosquitoes or fly can slide on my face, I want an hourglass body, not an hour mug body, I want all women to be jealous of me and men dying for me. Just like that song, ‘When I get that feeling… I want sexual drilling… oh baby…’… Sexual drilling song, that would be me.”")]), _vm._v(" "), _c('p', [_vm._v("“Drill baby drill, abracadabra! There you go, from a sensual dribbling to sexual drilling.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank youuu, oh I am so chuffed. Thank you very, very much Photoshop Fairy, you made my dream come true. I think I am going to cry now. I look so goooood!”")]), _vm._v(" "), _c('p', [_vm._v("“I am glad you like it. But remember my child, all the magic will be gone when you turn off your smartphone and computer. Your Cinderella feet would go back to your ginger feet again. You may look like a Princess in the online world but the moment you turn that damn computer off, you’re going to look like a Piñata again, your real look.”")]), _vm._v(" "), _c('p', [_vm._v("All photos on social media look so very good. In the good old days, you needed to spend some money to go to a professional studio and a professional make-up artist to get your photo to look like a super model in the magazine. Not now, you can do anything and be anything in the online world.")]), _vm._v(" "), _c('p', [_vm._v("What you see is not always the real picture, what you read is not necessarily the truth, what you say doesn’t necessarily come from the heart or what you really think, and what you hear doesn’t really necessarily come from facts. Not all Princesses on social media are princesses, not all barking dog sounds are coming from a dog, it could be your neighbour doing the doggy. Here are some of my suggestions when you want to see a person in real life after you’re attracted to her beautiful face on her social media:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Take a really deep breath, hold it for four seconds and breathe out through your mouth. Do this to gain your patience and to avoid a big disappointment.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Don’t have high expectations, keep your expectations low. If you really think she looks exactly like her social media, slap your face with a frying pan because that’s not going to happen.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Take a pain killer pill, just in case you can’t handle the truth.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Keep practising saying this, “You look better in person,” rather than saying, “Geez, bad luck girl, do you get up with that face every day?”")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("If she really looks much uglier than her social media photo, tell her, “Excuse me honey, I really have to go to the rest room.” I mean you really have to go to the rest room but not in that restaurant or nearby, go to the restroom in a different state such as Las Vegas or Alaska. At least you’re being honest that you’re going to the rest room.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("If you’re reluctant to do number 5, you don’t want to hurt her feelings and you’re being polite, say this, “My princess, I am so sorry I have to go home because I totally forgot that I have to put my mattress back inside, I hung it on my balcony in the morning and now the weather is not kind, I was really, really silly.”")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Or pretend you work in the hospital, “Sorry babe, just got a call. Duty calls, I have to go to work, very urgent. This man got a remote control stuck in his behind, this is about life and death. I love seeing you in person but I really have to go because this man is dying, the remote control is out of his control.”")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Last one, if you are really brave and want to be honest, tell her this, “Thank you for making an effort to see me. Look, I understand you put your best photo up for the marketing department. But this is a false advertisement for the consumers. I see a Rolls Royce in your social media photo, that’s why I’m here. But when I see in real life it’s not a Rolls Royce at all, not even a Swiss roll cake. I am expecting a Rolls Royce, not a tricycle! Now I want my money back! Cut to the chase, I’d rather die as a virgin than sleep with you!”")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Or say this, “Oh my God, I can’t believe my luck. You look like that movie star. I saw you on TV. Your look exactly like her.” I’m sure she will be blushing and all gaga goo goo. “Yes, I saw you in the Wombat Woman movie. I see you run so fast. You’re on fire. You rock! You didn’t even use make-up to be that horse that Wombat Woman was riding. You were that horse.” Then run as fast as you can before she slaps you with her handbag. If you want to stay alive, leave town and change your name.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Send a decoy with a secret camera, put a tuxedo on your pet such as your goat with sunglasses and tell her actually that goat was you. If she cons you big time with her looks, on social media she looks like a princess but in real life she looks like a pickle. Now she knows how we all feel. Disappointed, girl? Same as us.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "that-candid-look"
    }
  }, [_c('h3', [_vm._v("That Candid Look")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("One of the trending photos on social media is ‘That Candid Look’. What I mean is that look where you’ve been trying too hard but you pretend you didn’t try that hard in your selfie. For example, you post your candid photo or a short video showing you opening a present, then you get surprised that you just received your dream book, you are so ecstatic, “Oh my God, my bae just surprised me with this book!” You look happy and surprised holding that book. Your eyes light up, your mouth wide open, you just look super excited, can’t stop smiling, bursting with happiness because you have a pleasant surprise today.")]), _vm._v(" "), _c('p', [_vm._v("Social media users who happened to see your post would feel so happy too as you share your happiness. Oh, we are so happy for you. Unplanned, totally out of the blue, that moment was captured in your photo or video. Think again, not being negative or putting you down. Who took the photo and video? Did you do it by yourself or did you ask someone to do that? You don’t hang your smartphone on the tree and suddenly your smartphone turns around to capture that surprise moment. You don’t ask a passing bird to hold your camera and take a photo of you. So it must be a real human who took your photo.")]), _vm._v(" "), _c('p', [_vm._v("“John, could you please do me a favour? Could you please take a photo of me when I open this package?”")]), _vm._v(" "), _c('p', [_vm._v("“But it’s already open and you know what’s inside that box.”")]), _vm._v(" "), _c('p', [_vm._v("“No no, I’d like to post this on my social media. Could you please snap it when I look that excited?”")]), _vm._v(" "), _c('p', [_vm._v("“All right, ready? One, two, three!”")]), _vm._v(" "), _c('p', [_vm._v("“Let me see again. No no no, this is not the right one. I didn’t look so surprised and happy here. Do it again!”")]), _vm._v(" "), _c('p', [_vm._v("“Maybe if you do it with your hands wide open also your mouth open as if you’re really surprised?”")]), _vm._v(" "), _c('p', [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', [_vm._v("“Not like that, I say your mouth wide open not your nostrils wide open!”")]), _vm._v(" "), _c('p', [_vm._v("After 100 takes and two hours later you only take one video or photo to post on your social media.")]), _vm._v(" "), _c('p', [_vm._v("There’s another one, the proposal photo. Oh, how romantic it is. We all feel joy and have tears in our eyes when we see those photos. Your man kneels down, holding your hands, looking up at you and asking you those four words, “Would you marry me?” Don’t we all get softie and romantic now, love is in the air. This is what we see on social media. But who took the photo? Both of your boyfriend’s hands are holding a ring to you as he proposed to you. Who took that photo? A tourist who happened to see that? Or is it God? The answer is, it’s been staged and you hired someone to take that photo (after 100 takes).")]), _vm._v(" "), _c('p', [_vm._v("What really happens is all these candid photos, not all but most of them, have the same process as if you make yourself an ad or commercial on TV. We see this kid running around, falling over, bleeding on his knees, he doesn’t cry but smiles and so happy after all the injuries and pain after taking a fall! His mother smiles too and looks so happy to put a band-aid on his injury. Then they all are happy happy, kissy kissy, lovey lovey. The kid is playing again, running around in happiness and the mother just never stops smiling. Isn’t life so wonderful even after he took a fall. That is a commercial for a band-aid.")]), _vm._v(" "), _c('p', [_vm._v("A commercial can turn a pain into a pleasure. A commercial is meant to look good and inevitably to attract buyers because it is a marketing strategy to sell the product. To put it this way, you don’t want to buy a product that makes you miserable, do you? No matter how bad or stuffed up your life is, when it comes to a commercial, it has to look good, at least twice as good as the real event.")]), _vm._v(" "), _c('p', [_vm._v("Some monkey throws a big coconut on your head resulting in a huge lump on your forehead. Are you mad at the monkey? Not at all, you just smile and give them a thumbs up. Then a llama slaps you in your face before humping your legs, in the end it’s always a happy ending as you find this magic drink that cures your thirst and mood swing. You look at the llama and dare him, “Come on, do it again! I dare you, I want moreee!” In the end, the llama is happy and you are smiling together and laughing away sitting together while you and the llama point fingers here and there, enjoying the view. See, this is a commercial. Just like what you see on those candid pictures and most posts on social media.")]), _vm._v(" "), _c('p', [_vm._v("Let me take you for one moment, does that happen in your life? In a commercial if you take a fall, you can get all the happiness in the world. In real life this is what happens when you take a fall.")]), _vm._v(" "), _c('p', [_vm._v("“Darling wife… I took a fall. It hurts so bad…”")]), _vm._v(" "), _c('p', [_vm._v("“I told you not to do the river dance with my high heels again, you dickhead!” Then she slaps the back of your head, “Now, give me back my shoes!”")]), _vm._v(" "), _c('p', [_vm._v("“Darling wife… ohh…. I took a fall into our swimming pool… I am wet and my back hurts!”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, you’ve been a pervert again? Climbing that wall to sneak on that hot chick sunbathing in her back yard and you fell into our swimming pool? That’s a shame you didn’t drown!” Then your wife didn’t throw you a big towel to dry yourself but throws chocolate cake at your face, “Here, take this! You pervert!”")]), _vm._v(" "), _c('p', [_vm._v("That is the real life, the facts. Social media life for attention seekers is not based on real life, it’s based on delusional, unrealistic dreams, sweet fantasy, high expectations and 1% honesty. Meanwhile for some men, social media life is based on money 1%, testosterone 1%, moronic instinct 1%, marketing strategy 1% and nice tits 96%.")]), _vm._v(" "), _c('p', [_vm._v("Back to those proposal photos or videos, surely some of them are genuine and want to share it with the world. This is what happens behind the camera before you make a decision to post it on your social media:")]), _vm._v(" "), _c('p', [_vm._v("“Babe, now, you get down on your knees. Not on two knees, just one. Yes, like that.”")]), _vm._v(" "), _c('p', [_vm._v("“Like this? Then what? Do I have to look at your groin?”")]), _vm._v(" "), _c('p', [_vm._v("“Look me in the eyes! Not in the groin, you idiot! Oh for goodness sake, please take your helmet off!”")]), _vm._v(" "), _c('p', [_vm._v("“Do I have to say this, do you feel lucky? Do yaaa? Punk?? Marry me now or else I’ll marry you! Now!”")]), _vm._v(" "), _c('p', [_vm._v("“No, say something romantic. Something like, would you marry me.”")]), _vm._v(" "), _c('p', [_vm._v("“Okay, I get it. Is this going to be like this? Hey, give me your money or else I’ll marry you! Now!”")]), _vm._v(" "), _c('p', [_vm._v("“Not that! Please say, my gorgeous princess, would you marry me? You have to look at me like you’re looking at the most precious thing and the most beautiful girl with all the love in the world.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, I know what you want. You want me to have that loving and seductive look with my mouth wide open like your look when you gave me blow job.”")]), _vm._v(" "), _c('p', [_vm._v("Just like making a commercial, it takes one day or even one week, many locations, hundreds of takes, just for a two-minute commercial for your social media.")]), _vm._v(" "), _c('p', [_vm._v("Also, we love your photos when you’re doing exercise, yoga and boxing in the gym. You look after yourself very well, good on you. You are a spiritual person, too. Love those meditation photos. As gorgeous as you are when you are doing upside down yoga, the question is, who took your photo? Just like when you are doing meditation. Who took that meditation photo? Was it an Angel who took a break from Heaven to Planet Earth just to take your photo?")]), _vm._v(" "), _c('p', [_vm._v("Before social media, a man proposed to his girlfriend because he loved her so much. The motive was love. People went to the gym because their motivation was to be healthy. People did meditation because they wanted to be connected with themselves, to be healthier or seek alignment with God. After social media, becoming spiritual, a romantic couple, doing Yoga or being at the gym, or becoming a vegan, are not because of your own decision, but because you follow the trend, just like fashion and it looks good on your social media. It is a fashion to be a spiritual person, doing meditation. Also, it is a fashion too to become a philanthropist. It makes you look good.")]), _vm._v(" "), _c('p', [_vm._v("“Didn’t you read the description on my social media?”")]), _vm._v(" "), _c('p', [_vm._v("“No.”")]), _vm._v(" "), _c('p', [_vm._v("“I am a philanthropist.”")]), _vm._v(" "), _c('p', [_vm._v("“Good on you, you love helping people without seeking recognition.”")]), _vm._v(" "), _c('p', [_vm._v("“That’s right, and thank you.”")]), _vm._v(" "), _c('p', [_vm._v("“I can see you are a generous person, you keep helping some husbands, making them happy and quietly without seeking recognition. I hope their wife didn’t find out.”")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-singing-video"
    }
  }, [_c('h3', [_vm._v("The Singing Video")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("We all love singing a good song, it is a good vibration. We all love looking at that teaser video with a few seconds duration, you are singing a song with your pet or your loved ones. It is a nice video but it will disappear 24 hours later. I see you singing a song with that pose and your sexy pout trout. Looks like you have two ponytails, one on your hair and one on your mouth. You keep singing a song while your son takes a fall in the backyard, but you still don’t care. This is about you, not about your child, you’re loving your own image on your smartphone.")]), _vm._v(" "), _c('p', [_vm._v("The truth is, how many times have you been practising to sing that song for your 5 second video? Did you take it spontaneously then post it on your social media? Maybe yes, maybe no. Before you post it, you rehearse it. You put your make-up on and rehearse your pose, make your lips more sensual when you sing a song as if you are a men magnet. You make sure you are in the position where you can be seen as a sensual and attractive person, this is why you raise your hand higher when you hold your cell phone to make your face look small with bigger eyes. If you put your camera in a lower position, lower than your face, let’s say the camera is in front of your chin, it will make your face longer like a horse with bigger nostrils. You want to look like a seductive Goddess, not a seductive llama.")]), _vm._v(" "), _c('p', [_vm._v("That is cyber life, that is singing in cyber life. In real life this is what happens, you just sing the first notes, suddenly you kiss your pillow, your cat hits you with a pillow because your voice is so lame. You try again to continue your song, suddenly your TV keeps changing itself frantically, the TV gets freaked out after listening to your voice. What’s going on? You try to change the TV channel with your remote but suddenly you get electrocuted by the TV. I think you got the message from the TV. But you never give up, this time you are determined to sing a song. You did, wonderfully.")]), _vm._v(" "), _c('p', [_vm._v("The neighbour’s baby didn’t cry when he heard you singing, but after you sang that song that baby’s hair became curly and red, some patients who are in a coma in the hospital came back to life after they heard your voice singing a song. The first words came out of their mouth, “Was it a trumpet from hell or heaven?”")]), _vm._v(" "), _c('p', [_vm._v("The doctor answered, “Sorry, but I think it’s from hell, your son just sang a song,” Then another patient just woke up from a long coma, the first word that came from the patient’s mouth was ‘fuck’. For people out there, I mean really, really out there, they thought it was aliens trying to give Planet Earth a frequency signal that they were coming to this earth, but actually it’s you who sang the song so terribly.")]), _vm._v(" "), _c('p', [_vm._v("However, there are many genuine videos showing many people singing a song just for fun, not for a gimmick. Some of them really floored you because they are just so talented. Some of them bring tears to your eyes because they’re so terrible that you can’t stop laughing. Look, no matter what the purpose is that you post your video on social media, many videos are entertaining and fun to watch. The person who tries to look so sweet and seductive is trying to get attention, meanwhile the person who is not afraid to look ugly and silly is the fun one to watch. Who knows, you might get discovered by some famous person who wants to sponsor you as a rockstar or get an offer to be a voice over for a horse.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "i-just-woke-up-i-cant-sleep-i-have-no-sleep"
    }
  }, [_c('h3', [_vm._v("I Just Woke Up, I Can’t Sleep, I Have No Sleep")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("Just woke up, first thing to do, take a selfie then post it on social media. That’s the impression you’re trying to tell us. We all wish we could look as good as you when we just open our eyes. You are awake with your face looking so fresh and your skin looks so flawless. You look beautiful effortlessly. You manage to smile even though you just opened your eyes. Then you post it on your social media, “Good morning, just woke up.”")]), _vm._v(" "), _c('p', [_vm._v("Remember when we were at school? We were taught to thank God for His blessing and for what He’s given to us, being grateful and staying positive. Now after the social media era, the first thing to do in the morning, you turn your cell phone on. Check your inbox, who’s sent you a message or who likes your post or tagged you. Check your home page and friend requests. Then back to sleep. After you get up, you clean your face, brush your hair with a little make-up to cover your dark circled eyes and age spots on your face, you look flawless, then you decide to post your selfie on your social media. Don’t forget to blur your face with filter, so we can’t see you’re still dribbling. That’s social media life, this is how you wake up. First thing to do when you open your eyes in the morning: selfie (after doing some make-up a bit and a hundred takes).")]), _vm._v(" "), _c('p', [_vm._v("This is in real life. First thing when you just get up, you sleep again, you just don’t want to get up. Then you do some sit ups, which is you hitting the snooze button several times, in between you were dreaming you’re standing with your crush in front of this beautiful water fall, you’re blushing as she approaches you, she touches your face and getting close to kiss your lips behind that magical water fall. Then you got up after you realised your mother just splashed your face with water after a hundred times trying to wake you up, she says, “Wake up, you lazy bastard! Today is your first day at work!”")]), _vm._v(" "), _c('p', [_vm._v("You don’t have time to cook breakfast, you don’t even know whether you’re wearing your mother’s pants or your pants but you still manage to check your social media. Who’s knocking at your inbox? What’s going on with the others? What’s gossip today? How many likes did you have on your photo today? Before you brush your teeth and in between brushing your teeth, you check your crush’s social media. Believe me, no matter how busy you are, how pressed you are, you still managed to check your social media.")]), _vm._v(" "), _c('p', [_vm._v("The truth is, most of you got up feeling so grumpy and still dribbling (opposite from your selfie, you got up feeling happy and gorgeous). You have to drag your body out of bed, one eye still closed but the other eye already managed to open up. You have to use your fingers to open up your both eyes wide open till your forehead hits the wall. Then you really, really woke up. You look in the mirror, you have these eye bags, also you have more wrinkles on one side of your face because your hand was pushing your face to the other side when you’re asleep (in social media your eyes so bright and your skin so radiant seconds after you’re awake). That is the reality.")]), _vm._v(" "), _c('p', [_vm._v("What about those photos on your social media when you are asleep? Oh, how sweet to see you’re asleep. Even when you’re asleep you look so alluring as if you were saying, “How good is this, sleeping is so, so amazing! Wow, mind blowing.” The caption is, “My bae took this photo when I was asleep.” How romantic, you look like an angel. Of course you got so many likes and compliments on your ‘sleeping beauty’ selfie on your social media. Breaking news! You were caught sleeping.")]), _vm._v(" "), _c('p', [_vm._v("This is the fact, after fifty times you took a photo pretending you are asleep like a baby, finally you took the best one out of fifty photos to post on your social media. The question is, who took your sleeping beauty selfie? Your boyfriend? No. Your mama? No. Your brother? Impossible! If that was your brother, he would’ve put some make-up on you, a doll’s make-up, I mean a voodoo doll to make you look horrible, then he posted it on his social media to make people laugh at you. You don’t want that, you want people to compliment you.")]), _vm._v(" "), _c('p', [_vm._v("So back to the question, who took your photo? The answer is no one. It’s you who took your sleeping beauty selfie. But how? We see both your hands were holding the pillow. The fact is, while you’re acting that you are really asleep, put yourself in the best position, making sure you close your mouth and your eyes too (normally your eyes were closed but your mouth is wide open like an egg holder), you raise your legs in the air, both your feet are holding your selfie stick to take a photo of you. Aren’t you smart! Now it looks like your boyfriend took a candid photo of you when you were napping. Actually, it’s your legs. You have trained your legs in such position like a gymnast, perfect! Until one of your friends notices something and comments, “Nice try, I see your legs in the reflection of the mirror behind you!” D’oh!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4.73422in",
      "height": "6.83502in"
    },
    attrs: {
      "alt": "",
      "src": "media/file1.jpg"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("99.99% of the world population looks like a donkey when we can’t sleep, you still manage to look like a supermodel. You look that good when you can’t sleep? Imagine how good you look when you have enough sleep, wow, must be more beautiful than a super model. Your ‘can’t sleep’ selfie attracts more than 1000 likes, imagine the likes you will get with your ‘enough sleep’ selfie.")]), _vm._v(" "), _c('p', [_vm._v("First thing you do when you can’t sleep is take a selfie. It is the new medicine, after you took that selfie and post it on your social media, guarantee you will fall asleep like a baby. We don’t need doctors to cure insomnia. Just take one selfie, all insomnia will be gone. In social media, even though you can’t sleep or can’t do anything or you haven’t been to the bathroom for a week, you still look so goddamn good. This is cyber life, not real life.")]), _vm._v(" "), _c('p', [_vm._v("The real life when you don’t sleep is, do you look that good like your selfie when you don’t sleep at all? Scientifically proven, everyone knows when you don’t sleep at all, it will increase your bad health, you will be grumpy, in a bad mood, eyes are half closed and half open. All of your workmates distance themselves from you because you are a grumpy young man, even a vampire gets a heart attack because it is you who bites him, you are like a mad alpaca. Due to lacking sleep, the way you smile is not a full smile, it is only a half-smile. One half smiles and the other half is angry. Because you don’t sleep much.")]), _vm._v(" "), _c('p', [_vm._v("It is annoying when you can’t sleep. You turn the light off, pitch dark, you still can’t sleep. Turn to the right side, it reminds you of your vicious mother in law. Turn to the left side, it reminds of your ex. You are laying on your back but it reminds you of a hot dog, now you feel hungry. All efforts have been tried, such as drinking herbal tea, you still can’t sleep.")]), _vm._v(" "), _c('p', [_vm._v("You try to blindfold your eyes but it sends you the wrong message, suddenly you’re thinking of extreme sex, you want sex not sleep. No, no luck, you still can’t sleep. You do a little meditation, you follow your heart and clear your head, take a deep breath in, breathe out through your mouth. Oh, feels so good and relaxing. Now you feel so much lighter and happier, you follow your heart, your heart says, “Go to the fridge.” Take one slice of cheesecake and the leftover fried rice. Turn the TV on, get bored. Change TV to a porn movie, turn the volume down because you don’t want that movie to leave an echo in the house, “Oooh… faster… faster… ter… rrrr…” No, you don’t want that. Just mute it, you don’t need sound, do you? You feel happy and excited till you fall asleep as a happy man on the couch with rice still all over your mouth. This is real life.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "judge-not-lest-you-be-judged-the-look"
    }
  }, [_c('h3', [_vm._v("Judge Not, Lest You Be Judged, The Look")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("Men always scream they like girls with a natural look instead of girls with make-up. Sure, girls believe that. If that’s the truth, no man would’ve ever watched porn movies. Have you ever seen a porn star with no make-up at all? Nope. I know the reason men watch porn, definitely not for make-up tutorial, but for the other tutorial.")]), _vm._v(" "), _c('p', [_vm._v("Grandma never wears make-up, she is just a natural beauty, but why men don’t worship her when she posts her photo on her social media? Meanwhile many girls with heavy make-up post their photos in a very suggestive way which attracted a lot of creepy guys out from the woods to leave their comment such as, “Hot, hot, hot!”")]), _vm._v(" "), _c('p', [_vm._v("Being beautiful with make-up and no make-up can attract many likes and compliments. Being beautiful is a dream come true, but you can’t please everyone because of your beauty, many girls will hate you because you are so beautiful. I guarantee you no one will get jealous of you if you look that ugly, “I am so totally jealous of your ugliness, I wish I was as ugly as you.” It is very impossible a person will be so jealous for something that is beyond repair, “I think your ugliness is too sexy for me.” Well, simply put, you don’t eat food that you don’t like, do you? You eat food that you desire. You don’t date someone because you hate that person.")]), _vm._v(" "), _c('p', [_vm._v("Because you are being polite, you still compliment someone that doesn’t look that good with kind words such as,")]), _vm._v(" "), _c('p', [_vm._v("“Aren’t you adorable and beautiful.”")]), _vm._v(" "), _c('p', [_vm._v("“You look amazing.”")]), _vm._v(" "), _c('p', [_vm._v("“You are sooo pretty.”")]), _vm._v(" "), _c('p', [_vm._v("Especially to a child, “Oh, such a beautiful baby,” meanwhile the back of your head says, “Wow, that baby is the spitting image of his dad, that ugly bastard.”")]), _vm._v(" "), _c('p', [_vm._v("You are flattered and love getting those compliments and accolades, especially about your appearance. You love it, you are even blushing because someone compliments you too much, “Aww, you are just too too hot!” This is a delicate matter, trust me, you won’t like it when someone insults your looks, “Fuck! Do you look like that?” It is very likely you will give a colonoscopy to whoever insults your appearance. They say love is blind, they say inner beauty is the most important thing in life. If that’s the truth, why are 99% of selfies on social media photoshopped?")]), _vm._v(" "), _c('p', [_vm._v("Some comments on social media are because they are so jealous of your good looks,")]), _vm._v(" "), _c('p', [_vm._v("“You look beautiful because of your make-up.”")]), _vm._v(" "), _c('p', [_vm._v("“It’s been photoshopped.”")]), _vm._v(" "), _c('p', [_vm._v("“We don’t need make-up and fashion to look beautiful, all women were born beautiful.” This is another way of saying, “Don’t try to look beautiful please, because beautiful women are a threat to me. This is why I don’t want to make friends or to be photographed with a better-looking woman than me.”")]), _vm._v(" "), _c('p', [_vm._v("“Your make-up and that dress make you look way older than your real age.”")]), _vm._v(" "), _c('p', [_vm._v("“You look like a transvestite with make-up on.”")]), _vm._v(" "), _c('p', [_vm._v("“You look beautiful and young because you photoshopped your photo too much.”")]), _vm._v(" "), _c('p', [_vm._v("Envious girls will put you down because you are just so beautiful, they think you are a threat, you have more attention from boys than them. A girl like this only wants to be photographed with girls that look less beautiful than she is, because she wants to stand out and get the most attention. She will compliment you when you look so ordinary, “You go girl, you look gorgeous with the helmet on.” Or when they say, “You look better without make-up.” It is another way to say, “I am glad you can look plain Jane, what a relief.” Those beauties will compliment the girls who are less attractive than them, “Don’t you look so gorgeous,” they say. But the moment they see a girl who is more beautiful than them, they say, “Must be photoshopped.”")]), _vm._v(" "), _c('p', [_vm._v("On social media, we give compliments for two reasons: she deserves a compliment and because we are being polite, we just want to make you happy. Many girls say you are a Goddess, not because you are really a goddess or you look amazing but because those words make you happy. Especially when friends post their photo on social media, we are obligated to say kind words, not because we are being fake but because we choose to be polite and choose friendship. We can’t say to our friends, “Wow, your mouth is open like an egg holder.”")]), _vm._v(" "), _c('p', [_vm._v("In saying that, it is a different story for men, most of them, not all. They choose to slag off each other but they don’t mean it. While the girls compliment each other but don’t mean it, this is what men would say about another men’s appearance:")]), _vm._v(" "), _c('p', [_vm._v("“Brother, you look like a German… German Shepherd!”")]), _vm._v(" "), _c('p', [_vm._v("“Your Chinese name would be Wai Yu Doh Jee.”")]), _vm._v(" "), _c('p', [_vm._v("“You are still alive.”")]), _vm._v(" "), _c('p', [_vm._v("“Your fingers are huge like five banana fingers.”")]), _vm._v(" "), _c('p', [_vm._v("“Look at this photo, you and I were wearing the same jacket. Looks like we came from the same orphanage.”")]), _vm._v(" "), _c('p', [_vm._v("They slag off each other but they still remain friends, even stronger.")]), _vm._v(" "), _c('p', [_vm._v("Use your animal instinct. If you believe all the compliments you got because you are really beautiful or you are really amazing, you are a naive person. This is like you just received your credit card bill then you say, “Wow, this is amazing. I love paying bills, woohoo.” Or when the police stopped your car because you parked in the bus zone, “Amazing! I can’t believe a cop stopped me because I parked my car illegally. Do it again please, this is an amazing feeling! I think I am wet!” There are some genuine compliments because they are polite, and the compliments are followed by these words, “You are so beautiful but I am in trouble right now, could you please lend me some money?”")]), _vm._v(" "), _c('p', [_vm._v("Who wants to look ugly? The minute you’re born the head nurse takes a look at you and says, “Leave this one alone, he’s ugly to the bone.”")]), _vm._v(" "), _c('p', [_vm._v("While the doctor says, “This baby looks so old. Looks like he doesn’t need a child support, he’s ready to join the workforce.” People ask you, “Did you really marry that? Bad luck, mate.” We all want to look beautiful and young. Just like we are adoring a beautiful painting. I know beauty is in the eye of the beholder. But you know the way we look is because our mother and father produced us like this, “Look, this is the result. You can’t return the faulty product to the retailer.” You say, “I know, I was manufactured like this from mum and dad, came from the factory like this.”")]), _vm._v(" "), _c('p', [_vm._v("Well, actually what attracts you as a man is not really about make-up or no make-up looks, but it’s the look. If a hot chick posts a photo of her with her duck, there will be a 1000 likes from men.")]), _vm._v(" "), _c('p', [_vm._v("“So gorgeous, I wish I was that duck.”")]), _vm._v(" "), _c('p', [_vm._v("“What a beautiful girl, lucky duck.”")]), _vm._v(" "), _c('p', [_vm._v("“If I was that duck I couldn’t stop quacking like crazy because you are so beautiful.”")]), _vm._v(" "), _c('p', [_vm._v("Imagine if it were an average Joe posing with his duck, what would happen?")]), _vm._v(" "), _c('p', [_vm._v("“Geez, what has that duck done to deserve posing with you?”")]), _vm._v(" "), _c('p', [_vm._v("“Did you bribe that duck $20 to pose together with you?”")]), _vm._v(" "), _c('p', [_vm._v("“Nice duck, what a shame about the bloke sitting next to that duck.”")]), _vm._v(" "), _c('p', [_vm._v("“I think the duck smoked the ganja, a sober duck would’ve never posed with him.”")]), _vm._v(" "), _c('p', [_vm._v("“That duck should be awarded a Bravery Award for its bravery to pose with that man.”")]), _vm._v(" "), _c('p', [_vm._v("See, you see the different treatment between a beautiful girl and an average Joe. Men would be dying to be that duck just be close to a beautiful girl while men would feel so sorry for the duck who happened to sit next to an average looking bloke.")]), _vm._v(" "), _c('p', [_vm._v("The theory about make-up vs natural make-up is a thin line between love and hate. Men just say that to make it not really obvious that they actually fancy looks over personality. Logically, if you put make-up on a duck, it still looks like a duck, quacks like a duck and walks like a duck, no different. You put make-up on or put no make-up on a beautiful girl, she still looks awesome, even when you put her upside down, she still looks beautiful. In saying that, some bitter men would say, “We all know all girls look the same when you turn them upside down.”")]), _vm._v(" "), _c('p', [_vm._v("However, I have to admit a skilled make-up artist can turn a Minion into a Marilyn Monroe, a prawn star into a porn star. In social media, the most powerful thing to improve your looks is not make-up, it is called photoshop and filters. Back to what I mentioned before about the duck, no matter what you do with the duck, it still looks like a duck, quacks like a duck, walks like a duck. You turn it upside down, shake it side to side, it is still a duck. But with this application, you can turn a duck into a beautiful swan, a frog into a prince, a prince into a frog, a vespa into a UFO, even a cat has a six pack and sideburns like Elvis Presley, a caravan into a castle, and so on.")]), _vm._v(" "), _c('p', [_vm._v("Every second many selfies are born. Just like you, you know you are beautiful, that’s why you post your photo on social media. If you have only one eye in the middle of your face and three nostrils you wouldn’t ever have posted your selfie on social media, would you? One of the trends on social media is that look, the natural look, no make-up, no filter, no editing. Talking about these photos that are supposed to be ‘natural’. It is not really natural, actually, it depends on your skills in photoshopping and editing your photo.")]), _vm._v(" "), _c('p', [_vm._v("How many times do we see ‘no make-up, no filter’ selfies but we still can see the blurred edges? It is like when you’re driving, you can’t see the road clearly because the windshield is fogged up. This is like a half-truth, half-lie. Ain’t no such thing as a half-truth, half-lie, honesty can’t be halved like a cupcake so it must be a lie. Yes, it is true that you don’t wear make-up. No filter? I am afraid to say you still use filters to create your beauty without make-up, too much filter until I can’t see your nose. The point is, you are still dying to prove to everyone that you are still smoking hot even without make-up.")]), _vm._v(" "), _c('p', [_vm._v("Those photos with the caption ‘no make-up no filter’ photo, is same as this, “No, I don’t watch sex scenes on TV, I just block my eyes with my sunglasses.” It means, you’re still able to see that sex scene with your sunglasses, you just can’t see the sex scene clearly, it’s just a darker sex scene. Look, it is not a sin to use filters, but it is a sin when you lie about a ‘no make-up, no filter’. It doesn’t stand in the courtroom. How does it sound when we hear someone say, “No no, I didn’t have sex with that man. I just gave him a blow job, it is not sex.” If you say that, you must have worked in the White House.")]), _vm._v(" "), _c('p', [_vm._v("More interestingly, when you add the captions on your selfie, “No make-up. I am getting old, did you see a fine line under my eyes?” You try to point out your imperfections that have been hidden, which are edited and filtered. This is your effort to make an impression to the world that you are not trying to look perfect, but on the other hand you filtered your selfie before you posted it. We can’t see your fine lines. How are we able to see your fine lines and age spots on your face after you erased and filtered them? This is like you are asking us, “When my flight took off, did you see me waving at you from inside that aeroplane?” Well, we can’t see your wrinkles and all the details on your face because you have erased them. “Oh, I didn’t use filters. I just blurred them.” I see, this is like you’re telling us, “No, I didn’t call it sex because he used a condom when we were having intercourse. If he didn’t use a condom, yes I call it sex.”")]), _vm._v(" "), _c('p', [_vm._v("You try to tell every social media user who happens to see your social media that you are still drop-dead gorgeous and younger than your real age with no make-up on, when you’re asleep, when you just got up, when you’re tired and had no sleep, when you have jet lag, when you’re reading, when you do charity, when you’re eating, when you cry, when you laugh, when you dance, when you’re in the gym, when you’re with Jim Bean and so on. Oh, my apologies, those candid photos of you getting caught with Jim Bean wearing your father’s trousers on your arms, not your legs (you thought your father’s pants was your jacket due to too many tequilas) were not rehearsed, that was an accident, just caught you off guard. Back to the candid photo you post on social media, you don’t want to use a high definition ultra HD 4K video or camera because it will reveal your wrinkles and flaws on your face.")]), _vm._v(" "), _c('p', [_vm._v("Some of ‘no make-up selfie’ trends or make-up photos or bare nude photos showing flaws in women’s bodies (contrary to those nude photos which show a perfect body) or your bare face without a filter is neither about ‘embracing your body’ or your uniqueness, it is asking for attention. However, many of those photos are for a good cause and self-confidence. Good on you for showing the world you have the guts to show the world that you have a 3D tattoo on your thighs AKA cellulite on your thighs. It could be about a competition too, between a good shaped body versus a not really in good shape body, an hourglass body versus an hour mug body for retaliation.")]), _vm._v(" "), _c('p', [_vm._v("You must have read this on social media, “She looks beautiful because of her make-up.” This is a sign that you are so gorgeous and she sees you as her rival. Competition is getting more fierce? Is that why you say so? In saying that, ladies are born naturally beautiful with or without make-up. There are also ladies who don’t like make-up, there are some who like make-up as they see it as an art. People are allowed to make their choice in life. If they feel comfortable without make-up, it is who they are. Big tick for them, even though they don’t wear too much make-up or not at all, they won’t judge other women. Respect each other’s choices as a woman.")]), _vm._v(" "), _c('p', [_vm._v("But when the ladies who refuse to wear make-up insult those who wear make-up, that’s when the personal choice becomes a competition and jealousy is rising, “I never wear make-up and I don’t know how to use make-up. I feel weird to use make-up, I think girls wear make-up because they have low self-esteem.” Did you just say you never wear make-up and criticised girls with make-up, but you heavily use filter and photoshop? I see, I think there is a contradiction here. No make-up, but your social media photo is so blurred that we can’t see your freckles and dark spots on your face. This is like you say you don’t like watching cowboy movies but when you’re having sex with your man, you like it on top with the cowboy hat and controlling the bull, rodeo style and yodelling non-stop. Contradiction?")]), _vm._v(" "), _c('p', [_vm._v("How many times have you heard this? “We all are beautiful. Beauty is in the eye of the beholder. All women are beautiful. We embrace life and celebrate life. This is who we are, we have grey hair, cellulite, muffin tops and wrinkles on our face but we love it. When we feel confidence, we will feel beautiful.” Good on you for being happy as a woman. You write those with pride, meanwhile your photos on social media were filtered and handpicked. Contradiction? Honestly, who wants to look ugly and old? Everybody wants to look young and beautiful. It is not a crime to look after yourself and it is not a crime either to eat healthily and look beautiful. This is why women in the USA spend $8 billion on cosmetics.")]), _vm._v(" "), _c('p', [_vm._v("Why do some women compliment the other woman who is so proud to show off their cellulite, muffin tops and stretch marks? Firstly, because it represents the reality, the majority. Secondly, because you have strong self-confidence, and are not pretentious or trying hard to look good to get likes on your photo. This is me, no less, no more. But there’s a few ladies who post their muffin tops and stretch mark body because of this factor: if you can’t join them, you will be against them. If you can’t compete, if you can’t have it, you will be against them, mocking them and showing them to their face what makes them afraid, which is a muffin top body, hip dips, cellulite and so on.")]), _vm._v(" "), _c('p', [_vm._v("Some girls who are too proud of their beautiful face and nude body then write on their social media, “Do not judge, lest you be judged.” This is like you posting photos of yourself in underwear all the time, but the setting of your social media is private. You put nude photos online, call yourself an introvert, but your backside says you are an extrovert, everyone is welcome to see you naked or half-naked. As a retaliation to them, you will put it in their face that you are not afraid of having cellulite or wrinkles on your face because you know those girls would’ve never displayed their skin and face too much on social media if they had wrinkles, cellulite, big legs, big stomach and pancake boobs. “Here, I’ll show you and confront you with what you are afraid of.” This is like you giving a snake toy to one of your girlfriends who is afraid of a snake even though she is a snake eater, oh sorry, I mean, a man eater.")]), _vm._v(" "), _c('p', [_vm._v("This is why you praise those women who are not afraid to show off their imperfect body.")]), _vm._v(" "), _c('p', [_vm._v("“You go, girl.”")]), _vm._v(" "), _c('p', [_vm._v("“You rock.”")]), _vm._v(" "), _c('p', [_vm._v("“This is who we are, women. This shows what we’ve been through after having a baby.”")]), _vm._v(" "), _c('p', [_vm._v("“You are just gorgeous.”")]), _vm._v(" "), _c('p', [_vm._v("“This body represents all mothers around the world.”")]), _vm._v(" "), _c('p', [_vm._v("“I am a proud woman and so are you.”")]), _vm._v(" "), _c('p', [_vm._v("If you depend heavily on your good looks and body to get the most likes and attention on social media, remember all the compliments you got on your social media regarding your sexy hot photos? Do you think you are the only girl on social media who gets complimented by guys? The truth is, these men shopped around, whenever they see some beauty, they stop by and have a taste. Or maybe you prefer lies to the truth. Bodies can change shape but personality is very hard to change. If you were narcissistic before social media, then I met you again on your social media and you are still in a narcissistic shape, it means you still keep your figure, a narcissistic figure.")]), _vm._v(" "), _c('p', [_vm._v("Yes, I see your photos at the gym, doing the exercises to keep your body goals. Good on you. Sometimes you post your happy photos with your children, you’re in your gym gear which is showing your toned body and six pack abs. You say your photos might inspire some other mothers to work out to have a body like you. You want to be an inspiration. Look, who doesn’t want to have a drop-dead gorgeous body after giving birth. Yes, I applaud you for being positive and motivating others to do exercise. The question is, there is a big difference between being a motivator and being a narcissist to fish for many compliments and likes. On social media, you are more concerned about how you want to be seen and how they see you because you don’t see the big picture, reality.")]), _vm._v(" "), _c('p', [_vm._v("There are tons of videos on YouTube on how to keep your body in shape. Any shape you want, you can get it on YouTube. Those tutorial videos are to motivate us to do exercise and to lead a healthy lifestyle. You can learn step by step by watching this video. First step, put your feet up in the air, then put your right hand on your left ear and your left hand on your right ear. From Tai chi, yoga, pilates, hula hoops, aerobics, bungee jumping, humping humping and the list goes on and on.")]), _vm._v(" "), _c('p', [_vm._v("On social media I see many photos of doing sit ups, stand ups, push ups, or up yours things. You post photos of you doing some push ups, but actually the intention is you are pushing for some compliments. It is totally a different look between ‘push ups look’ and ‘pushing for compliments look’. In push up exercises you push your body against the floor, pushing for compliments you push men’s testosterone to look you up. The camera captured you perfectly to show that you are focusing on the treadmill, in the gym, doing yoga, hula hoops. There are some photos too, of you posing in the gym looking at the camera, “Am I too good to be true?”")]), _vm._v(" "), _c('p', [_vm._v("I really envy your hourglass body even after seven children and you just got a visit from the Menopause Fairy. You still have the courage to post your photos in bikinis, half-naked and even nude on your social media. You receive many likes and compliments. Obviously, your age does not stop you from posting a suggestive photo on social media, you challenge men’s testosterone with your photos as if you are saying, “I am old but I am damn good. I may be wrinkled but I can wiggle. I may be your mama but I can be your piñata. Come on guys, come and lust over me. I am not a young coconut anymore but I still have enough coconut juice to make some curry. This is your opportunity to adore me and worship me because you will never see a hot mama like me again. Come on, give this elder a chance. I suffer here without compliments from men.”")]), _vm._v(" "), _c('p', [_vm._v("Some of us give a compliment to you as a hot mama not because we feel, “Wow, you’re hot stuff,” but we feel like we do it for charity, we respect the elderly you know, we respect your generation. Because your generation was the one responsible for why we’re here. As we were taught at school to respect the elderly, so do we do charity by giving you a compliment on your sexy photos. I know Buffalo Bill will not have interest in you. “The skin is too mature and too tough like a tyre,” he said about your skin. Believe me, Buffalo is the skin expert, he knows the expiry date.")]), _vm._v(" "), _c('p', [_vm._v("Even when you’re pregnant you still post your half-nude photo just to show the world that you still look desirable and your body is still in good shape during pregnancy. People with common sense would think: It is not about how good your selfie is, but it is about the health of your baby that comes first, your baby should be the first priority, not your selfie. Are you still craving to be a man magnet and compliments even when you’re having a baby? “Oh, I just want to show the world how proud I am to be pregnant.” Do you need to take your clothes off to be a proud mother?")]), _vm._v(" "), _c('p', [_vm._v("As I say, there is a big difference between celebrating a pregnancy and using the pregnancy to get compliments. “Because I am a woman, I am proud to be pregnant.” If all women were like that, 90% of pregnant women in the world would be walking half-naked because they are so proud to be pregnant. To be proud as a woman is to be honest, never lie, be wise, have emotional maturity, have moral values, and give love, compassion, help and support to those who need it. How to see the character of a mother: look at the way she guides her children, that shows her personality.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "an-einstein-look"
    }
  }, [_c('h3', [_vm._v("An Einstein Look")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("I love seeing people reading. Never give up on searching for the answer in the name of knowledge. People who are just willing to learn and study to get more knowledge and dedicate themselves to continuing, are the ones who shape the future of the world. Hats off to them. Because knowledge is the key to open the universe and all solutions in the world. Knowledge opens our mind and keeps us grounded. Knowledge is limitless. However, stupidity is limitless too.")]), _vm._v(" "), _c('p', [_vm._v("What is knowledge? Knowledge is familiarity, awareness or understanding about someone or something, such as facts, descriptions, information, or skills. To get knowledge, you require experience or education by learning, perceiving and discovering. What is stupidity? Stupidity is when what you do and what you say is not based on the brain, because your brain is not in your head. So where is it? It is either inside your knees or in your armpit hair or your backside.")]), _vm._v(" "), _c('p', [_vm._v("Did you see me reading a book? Or did you see my social media post of how I successfully solved an extreme sudoku (but you never film yourself solving an extreme sudoku, so basically you cheated by looking at the answers)? Did you see how many books I have? Did you see me sleeping with a book? I love books. Books are important in my life. When you see so many books I have and how much I love books, you know the message that I give you: I am smart, I am so intelligent.")]), _vm._v(" "), _c('p', [_vm._v("Whenever you read a book, you make sure you post it on social media to let everyone know, “I love reading.” You just bought a book, you’ll post it on your social media, “Found this book in the city, I couldn’t resist buying it.” You are about to read, you’ll post it on social media, “Can’t wait to read this book.” You are in between reading, you’ll post it on social media, “Just finished reading chapter 12.” When you finished reading a book, you’ll post it on social media, “Finished reading for today.” Whatever you think about that book, you’ll give a review on social media, “I think this is a very good read. I strongly recommend you read this book.” How much you love books instead of make-up and fashion, you’ll post it on your social media, “Books are forever, make-up and fashion are temporary.”")]), _vm._v(" "), _c('p', [_vm._v("Books are important for you, but what is more important for you? Books or an image to be seen as a book lover? “I am a book lover because I am an intelligent person.” The answer is the image, you let everybody know that you love books, that is more important than absorbing the knowledge of the book. You use books to make yourself look good, this is why you are bragging how much you are into books. To boost your image on social media, you love to give an impression to others that you love books. “Books is a part of who I am,” you keep pushing this image on social media.")]), _vm._v(" "), _c('p', [_vm._v("You wear a see-through shirt for this photo shoot, we can see a glimpse of your two chocolate macaroons there. You want to give a seductive look yet look like a genius for your social media, the mission for this photo is to get likes and also a compliment from your followers. You ask one of your friends to take a photo of you,")]), _vm._v(" "), _c('p', [_vm._v("“John, can you take a photo of me reading this book now?”")]), _vm._v(" "), _c('p', [_vm._v("“Now? Okay. How you come you’re reading that book, you can’t even spell.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh come on, this is just for a gimmick. This will make me look good on my social media.”")]), _vm._v(" "), _c('p', [_vm._v("“Babe, you’re holding your book upside down.”")]), _vm._v(" "), _c('p', [_vm._v("“I just fixed it, ready?”")]), _vm._v(" "), _c('p', [_vm._v("“Babe, your book doesn’t represent your image. Do you really want to post your photo of you reading that book?”")]), _vm._v(" "), _c('p', [_vm._v("“What book is this?”")]), _vm._v(" "), _c('p', [_vm._v("“That book title is The Horse Walks Into The Bar, Hey What’s With The Long Ass.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God, I don’t want to be seen with this book.”")]), _vm._v(" "), _c('p', [_vm._v("“Looks like it’s been a long ass day for you, babe. What about this book, The Law Of Attraction by Kim Jong Un? That’s a good book.”")]), _vm._v(" "), _c('p', [_vm._v("“No, it sounds bizarre. What about this book, "), _c('em', [_vm._v("The Theory of Relativity")]), _vm._v(" by Albert Einstein. I want to be photographed with this book and post it on my social media.”")]), _vm._v(" "), _c('p', [_vm._v("Nobel Prize winners for science and many geniuses don’t brag how much they love books and how intelligent they are, but they always share their knowledge to the world on their social media by explaining how this star or that comet happens. There is a big difference between fishing for compliments from the followers about how smart you are and sharing knowledge with the world. “Oh baby, you are not just a pretty face but also a genius.” This is the kind of comment that you want to hear from your followers. Meanwhile the comments on a scholar’s social media post is, “Thank you for the information. Now I know antimatter was first predicted by physicist Paul Dirac in 1928, antimatter is the opposite of normal matter.”")]), _vm._v(" "), _c('p', [_vm._v("To anyone who is hungry for knowledge and willing to learn, we applaud you for that. Good on you, the whole world should be like you, reading and learning rather than preaching and judging others. We need more brains than complainers.")]), _vm._v(" "), _c('p', [_vm._v("In social media, knowledge is not really the main priority. The first priority is the likes and attention from the followers. It is a competition. There are very good-looking girls who try to show the world that they have a brain apart from their looks. There are girls who hate beautiful girls and are compensating for it by doing extreme sports or what boys do or books. There are many ladies who have the beauty, brains and good mannerisms, but they don’t use social media a lot or even don’t have it at all because they are busy contributing to the world.")]), _vm._v(" "), _c('p', [_vm._v("This is how girls compete on social media. Whatever the intention is, fishing for compliments, asking for validation. The less they feel, the more they want to show the world about who they are. Bragging about how much they love books, extreme sports, and so on. It comes down to one word: narcissism. Craving attention just like girls who uploaded their naked photo from their bedroom or bathroom but ask for respect. Thank God for social media, now we know most of your bedrooms and bathrooms look alike.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "beautiful-face-lifestyle-the-photographer-and-the-phantom-job"
    }
  }, [_c('h3', [_vm._v("Beautiful Face, Lifestyle, the Photographer and the Phantom Job")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("Men love looking at hot bodies, especially if the owner of that sexy body is a very beautiful girl. You know men love it, you know you will get so many likes and compliments from the boys, that’s why you keep posting your beautiful photos and showing off your flesh.")]), _vm._v(" "), _c('p', [_vm._v("You have everything that all women dream about. The look, the body and the lifestyle. Many photos of you in a bikini, showing off your two big ‘papayas’ and your ‘middle part’ AKA your backside a lot on social media. Sometimes you wear nothing at all, laying on this king size bed in this luxurious presidential suite. Well, doesn’t that photo invite all the creepy guys out from the woods, meanwhile girls didn’t want to comment unless they feel they have to comment, “Trailer trash of the day.” While men comment, “Hotter than chicken tikka masala curry.”")]), _vm._v(" "), _c('p', [_vm._v("Next photo, you are somewhere in this luxurious resort with a shopping bag in your hand. It is not an ordinary shopping bag, you spent at least $5000 to get that shopping bag. The caption of your photo: ‘Shopping’. The next day you are photographed by the pool side of this six-star hotel, of course with your bikini that is smaller than your sunglasses. On the weekend you are photographed in this luxury private jet, sitting next to you is your very expensive designer handbag that cost you your virginity to get.")]), _vm._v(" "), _c('p', [_vm._v("You enjoy all the attention, likes and compliments from men on your social media photos. You deleted all the bad comments that criticised you for being too narcissistic. The more likes you get, the more excitement you get, and the more you are motivated to do sexier selfies. Life is too good without selfies and showing off. You have done all the sexy selfies in every luxury hotel in the world.")]), _vm._v(" "), _c('p', [_vm._v("If you don’t have those three: good looks, good body and likes on your social media, you’ll be falling apart. I know you will deny this,")]), _vm._v(" "), _c('p', [_vm._v("“No, I didn’t post my half-nude picture to get adored by my fans. I did it because it made me happy and boosted my self-confidence.”")]), _vm._v(" "), _c('p', [_vm._v("“No, I did it because I am a woman, I am proud of my body.” Yes, I agree with you. You are proud of your body and good looks, if what you say is true, it means what makes you proud as a woman is posing half-naked. Meanwhile, for many women and men out there, what makes them proud is when they quietly give love, help and support for those who need. That makes them proud and prideful.")]), _vm._v(" "), _c('p', [_vm._v("Be honest, you post a half-naked or even nude photo because you’re craving compliments, the more they compliment, you the happier you are. If your backside moves to your front, a muffin top, no compliments from the guys makes you miserable. You have prepared yourself to post alluring seductive photos on your social media. You did your waxing, Brazilian, spray tanned skin, make-up and hair do. Unbutton your blouse, remove your jeans, now you’re only in your underwear. Next step, you choose one of your best bras and knickers.")]), _vm._v(" "), _c('p', [_vm._v("Of course, you don’t want to mix and match, the mission is to seduce men till they say, “Woww!” Then they start fantasising about you in the wildest way. You do not want men to say, “Wheww!” Then they pass out after seeing your photo. No, you don’t want that. There’s a difference between ‘wow’ and ‘whew’. Wow makes their adrenalin and testosterone running high, whew makes their vision become blurry and causes nausea. This is why you don’t want to wear your old briefs, the colour is fading away, worn out, there are some holes in there not because of the aftermath after being hit by a man’s torpedo, but because it is simply worn out.")]), _vm._v(" "), _c('p', [_vm._v("Now you try your terminator bra and big grandma flower knickers. You asked yourself, why flowers knickers? These flower knickers remind you of a memorial service for those diggers who got buried in there, you know what I mean. So you change your big flower knickers to lacy seductive knickers to make you look more alluring.")]), _vm._v(" "), _c('p', [_vm._v("See-through lacy knickers that make all men drool over you. Now you are really ready to post it on your social media. No no no, there’s something wrong here. You realise your lacy knickers don’t cover up your thick stubborn ‘tassels’. Oh you know what I mean about tassels. It is time to grab a shaving kit, shave it like a gardener. In a fairytale story, Prince Charming has to chop the wood to see the castle. You never see a lingerie model with a thick and big ‘bristle’ underneath her knickers that could remove mould from bathroom tiles.")]), _vm._v(" "), _c('p', [_vm._v("“Darling wife, have you seen the mould remover that we bought from supermarket?”")]), _vm._v(" "), _c('p', [_vm._v("“No.”")]), _vm._v(" "), _c('p', [_vm._v("“Have you shaved your pubes?”")]), _vm._v(" "), _c('p', [_vm._v("“No.”")]), _vm._v(" "), _c('p', [_vm._v("“Good, I need that to clean the mould off my bathroom tiles.”")]), _vm._v(" "), _c('p', [_vm._v("“No worries husband, I’ll make sure your bathroom tiles are shiny and squeaky clean.”")]), _vm._v(" "), _c('p', [_vm._v("“I love you.”")]), _vm._v(" "), _c('p', [_vm._v("“I love you too.”")]), _vm._v(" "), _c('p', [_vm._v("After so much time and all the work, no man left behind and no body hair, you put on your see-through lingerie. You are 100% ready to go take a photo to post on your social media. The question is, what if no one likes your photo after all the labour-intensive jobs you’ve done? To guarantee you get more likes, you are thinking to drop your bra to the floor, cover your breasts strategically then we’ll see what happens.")]), _vm._v(" "), _c('p', [_vm._v("If this photo doesn’t get any likes at all, you have to do more extreme selfies which is going commando, bending over and cough cough, Thunderbirds are go! If this does not work either, it means it is time for you to quit social media and start doing bungee jumping. Within seconds, you have 10 likes. In one hour, you have 200 likes. In a day you have more than 1000 likes. On social media, the less you dress, the more you get likes. The more likes, the happier you are. The more controversial your selfie is, the more popular and more viral you are on the internet. In two days, you get more than 5000 likes, you are so happy.")]), _vm._v(" "), _c('p', [_vm._v("We love your social media, it is entertaining. So many photos of you looking absolutely gorgeous, sexy, and also we see you enjoy your lifestyle. We see you travel in first class, from one six-star hotel to another, you ain’t suffering. We see your designer handbags, we’ve seen your lifestyle, we’ve seen you were photographed in all bathtubs in all luxury hotels in the world. First thing beautiful girls do when they are in a six-star hotel, go to the bathtub then mirror selfie or take a nude photo in the bathtub to post it on their social media.")]), _vm._v(" "), _c('p', [_vm._v("Having seen 1000 photos of your photos that only the majority dream about, we’re envious of your looks, body and wealth. We know you are a jet setter with all the high-end goods you display on your social media that the majority of us can’t afford it. It is very obvious you don’t work from 9 to 5 like the rest of us, we only see 2 photos of you at work, doing some photo shoots for some commercial that we still don’t know what it is for. It is not clear what you do in life.")]), _vm._v(" "), _c('p', [_vm._v("Also, your sexy photos in your bedroom and bathroom, some of those photos are not suitable for children. Yes, you have a gorgeous face and body. Yes, you love life. First question is: who took your photo? Did you take that photo by yourself? Perhaps you could stretch your toes out up to 2 meters so you can take a photo of yourself from that distance. Do you use your knees to press the camera button on your smartphone? No, impossible unless you have four knees. The two reasons above are very impossible.")]), _vm._v(" "), _c('p', [_vm._v("Even if it was taken by a drone, how did the drone know your best angle? This is the way you do it, you take your clothes off then pose in a very suggestive way in your bedroom and bathroom, the photographer must be someone that is very, very close to you. Unless you let anyone see you in your bathroom and bedroom, like selling a house, ‘open home day’ or you put a sign out in front of your hotel suite, “Come in please, yes, I am open.”")]), _vm._v(" "), _c('p', [_vm._v("Or is it your sex toy that took all of your photos? But a dildo doesn’t have two hands. Oh, I know now who took your photos in the bathroom and bedroom, it is a person who shares a pillow with you that took those photos. It can’t be Santa, unless Santa wants to slip some present for you in between your two ‘pillows’ AKA your behind. It can’t be the milkman unless he wants some fresh milk. It can’t be a parking ranger unless you let him park his ‘vehicle’ in your ‘garage’. So only two suspects left: either it is your boyfriend or your sugar daddy. Third suspect: your boss. Yes, let’s call it overtime. If it is your boss who took those pictures, your age is 23 years but your work experience is 50 years. Why? You have done overtime too many times.")]), _vm._v(" "), _c('p', [_vm._v("Second question: What is your job description? You must make very good money to afford your lifestyle as you are a high maintenance girl. Never see you travel in economy class or carry a cheap handbag. All fancy restaurants, this private jet, crocodile skin handbag, chicken skin wallet, duck skin boots, travel around the world, but no job? Well, maybe you don’t have to travel in first class or on a private jet, maybe you don’t have a designer handbag that cost you your virginity. But what do you do for a living?")]), _vm._v(" "), _c('p', [_vm._v("You have more selfies in the bathroom than selfies at work. You don’t have a specific skill such as an engineer, a doctor, a nurse, or some real job. We do know you are a vegetarian and support rainforests, but you don’t make money by being a vegetarian, maybe by eating bananas. Here’s what we know for sure: you are not the highest paid actor or model, we do know you are in one or two random movies or one or two unknown commercials, but the source of your income is still a mystery.")]), _vm._v(" "), _c('p', [_vm._v("You say you have saved some orang-utans and some other animals but who the hell gave you money for living? Orang-utans? So an orang-utan goes to the bar, sees you there and say,")]), _vm._v(" "), _c('p', [_vm._v("“Hi babe, this is $100 for you for saving my grandpa. In the name of orang-utans, we are so grateful to have you here in our community. By the way, if you need me, call me. If you are single and want some candlelight dinner with me, call me. I’ll let you have the best banana in town like you never tasted a banana before. Believe me, you’ll go bananas.”")]), _vm._v(" "), _c('p', [_vm._v("I don’t see that you have a husband or boyfriend, either. If you do have a rich boyfriend or super rich husband, you’ve been hiding them very well. It is still not clear what you do for a living. Sure, you have one or two jobs every three months, but your lifestyle doesn’t match your income as a random model who just got a job once every two months, unless you are paid more expensively than an A-lister Hollywood movie star. There is only one suspect, your life has been ‘upgraded’ by some sugar daddy or nutmeg daddy to maintain your lifestyle.")]), _vm._v(" "), _c('p', [_vm._v("I see, as Pores Hump says, “Jennayy…. I am not smart. But I know what you do for a living.” Most of us work from 9 to 5. We work, pay our rent and mortgage, we spend more hours at work than home. We are still keeping our head above water, but still can’t afford to have holiday all the time like you. At least we have a real job and pay our taxes.")]), _vm._v(" "), _c('p', [_vm._v("Some children get a scholarship because they are high achievers, so bright. You too, you got a scholarship too, from Sugar Daddy or Nutmeg Daddy or Paprika Daddy University, not because you were selected by Education Department but you are ‘carefully’ handpicked by Daddy because of your ‘specific’ talent.")]), _vm._v(" "), _c('p', [_vm._v("A real scholarship is being awarded to students who have the greatest skill in specific knowledge and talents. A Sugar Daddy or Nutmeg Daddy Scholarship is awarded to those girls who have the best talent in culinary. This daddy knows how to choose the tart, insert the cream into the tart, put icing on the dick, oh I mean cake, and so on. While these girls supply the oven and fluffy buns, not a vending machine, oh wait a minute, these girls can be a vending machine, too. Should I call sugar daddy and find out these girls are actually philanthropists? They keep contributing and donating quietly.")]), _vm._v(" "), _c('p', [_vm._v("The question is, don’t you think it is time to take a photo of you and your ‘sponsor’ together and post it on your social media? You’re not shy to take your clothes off to post it on social media, why should you be shy to be photographed together with your anchovy daddy? He sponsors you a lot, you know. Without him, you would’ve never been able to post your sexy photos in every five-star hotel’s bathroom, travel around the world, fancy restaurants, and so on. Well, there are one or two photos of you with some younger looking man that you call ‘my best friend’ which gives the impression to your followers that you’ve been dating that good-looking guy.")]), _vm._v(" "), _c('p', [_vm._v("Still, it is not clear what you do for a living. Obviously that young guy, your so-called ‘best friend’, has an unstable job, he doesn’t have a real job like you. He can’t afford to support your lifestyle. Or maybe you secretly supported that young man, be careful if your sponsor AKA your sugar daddy knows, he won’t provide you any money anymore. If sugar daddy finds someone else hotter than you, that’s it, you have to find another turmeric daddy. Certainly your young man, your so-called ‘best friend’ will not be able to support you or give you money to support your lifestyle, he is even reluctant to pay for dinner with you. You’re the one who pays for everything when you’re with that young man.")]), _vm._v(" "), _c('p', [_vm._v("And to all sugar, nutmeg, paprika, cinnamon and candle nuts daddies in the world. You should be awarded as the best philanthropist, without you many girls out there would be homeless, no education, no food on the table and no clothes to wear. We can see ‘how deep is your love’. Your love is 5 inches according to them. These 5-6 inches (you lie about 8 inches anyway) is the bridge for your donations, you keep making this contribution because it makes you feel comfortable and warm apart from being happy inside. For those who rock, we salute you. For those sugar daddies, this contribution to these chicks is not to evade tax.")]), _vm._v(" "), _c('p', [_vm._v("And to these girls, the recipients from Candle Nuts Nutmeg Sugar Dad University, you may say you are a vegetarian, you don’t eat meat but you taste someone else’s husband’s sausage. You may say we should protect the sharks but you sleep with the shark. You may preach a healthy lifestyle by doing yoga, eating right and exercising, but you should make a healthy mind and clear heart your first priority rather than food. You may say you have saved orang-utans you but don’t save someone’s marriage, you don’t respect his wife. How would you feel if your boyfriend or husband secretly betrayed you because he feels happier with another woman? What goes around comes around, one day you get old and are not getting prettier, there will be no sugar daddy wanting to sponsor you anymore, not even a sour daddy will want to support you.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-phantom-lover"
    }
  }, [_c('h3', [_vm._v("The Phantom Lover")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("Social media is here to help communicate and share information. We all love to share something that we love, including something we hate. We all know your history, all the wives you got, your new stock, your old stock and all your movements at work, at home and in your bedroom. We know what you eat, what you cook, what you drive, what you watch, we even know what you think, because you write it on your social media wall. But one thing we’ve never seen, your spouse.")]), _vm._v(" "), _c('p', [_vm._v("When we just join social media, there is a form to fill in, are you a female or a male? Are you a human or a chicken? Do you have a history of mental illness or mental bastards in your family history? Do you have allergies to peanuts? Have you removed your jewellery? Is your hair middle parted or side parted or does it have no part at all? And there is the most crucial question, which is the status of your relationship:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("I am married but I can make an exception")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Special offer today! If you are a lucky winner, you’ll get a free fridge! Hurry while stocks last!")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Collect 10 empty plastic bottles to get a free date with me")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Buy one get one free")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Discount 50% if you apply today")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Out of order")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Complicated but excited")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Waiting for a miracle")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Waiting for a restraining order")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Back by popular demand")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Position vacant, apply within")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Yes, we’re open. Come in please, all cards welcome")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("No job is too small and no job is too big")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Wife needed! She must have 13 horsepower, 420 cc, OHV engine, this riding lawn mower is not only designed for heavy duty but also for comfort and fun")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Satisfaction guaranteed! Or money back within 30 days")])])]), _vm._v(" "), _c('p', [_vm._v("We have seen your house, your friends, your handbags, your holiday, your cars, your bras, your backside, your intimate and explicit photos such as photos of your boobs from upside down and even back to front, and including your bathroom. We know how all your bathrooms look, we know most of your lingerie you wear, but we haven’t seen your spouse?")]), _vm._v(" "), _c('p', [_vm._v("Some people are too proud to display their girlfriend or boyfriend on social media because they love them or because they are so hot, “Look at me, I got a hot girlfriend.” Or they do that as a revenge to their ex, “Na na na, I have a new lover now, I am happier now than those times I spent with you.” Some hide their lover away for some reasons that only the Police knows. Some hide their lover because the family and children don’t like to see mum or dad has a new lover, especially when dad’s new lover is not a good role model.")]), _vm._v(" "), _c('p', [_vm._v("The majority of social media users who don’t have the reasons above, why don’t they want to show off their lover on social media? Because their partner is not suitable for display. If your lover looks like Clint Eastwood or Marilyn Monroe, surely you will be proud to post it on your social media. “Go ahead, make my day.” Meanwhile if your boyfriend looks like a piñata or your girlfriend looks like the spitting image of a Vespa, it is not going to be, “Go ahead, make your day.” but it is going to be, “Go ahead, ruin my day.”")]), _vm._v(" "), _c('p', [_vm._v("You avoid posting photos together with your spouse on your social media to avoid comments like these:")]), _vm._v(" "), _c('p', [_vm._v("“Good on you, you have saved an orang-utan.”")]), _vm._v(" "), _c('p', [_vm._v("“Did you date your grandpa?”")]), _vm._v(" "), _c('p', [_vm._v("“Are you on medication?”")]), _vm._v(" "), _c('p', [_vm._v("“And the horse walks into the bar, hey what’s with the long ass?”")]), _vm._v(" "), _c('p', [_vm._v("“She has the biggest heart. Beauty is not forever but good hearts lasts forever.” This is another expression for, “Yes, she is ugly. I hope she has a good heart. Ugly person must have a good heart or be rich or talented. If she doesn’t have them, you’re fucked!”")]), _vm._v(" "), _c('p', [_vm._v("“Beauty and the bloated.”")]), _vm._v(" "), _c('p', [_vm._v("“I was expecting your boyfriend was a Chris Hemsworth look alike, not a Chris Hen Wong.”")]), _vm._v(" "), _c('p', [_vm._v("“The most attractive man is a man with a wallet, not man with the looks.”")]), _vm._v(" "), _c('p', [_vm._v("“Now I know why they invented alcohol, so ugly chicks can get laid.”")]), _vm._v(" "), _c('p', [_vm._v("If your partner is very good looking, it is your pride and triumph. He will be your trophy just like when you post photos of your gorgeous body nude, your waterfront mansion, expensive cars and your expensive handbag.")]), _vm._v(" "), _c('p', [_vm._v("“In presidential suite, enjoying the view.”")]), _vm._v(" "), _c('p', [_vm._v("“Relaxing in my private jet.”")]), _vm._v(" "), _c('p', [_vm._v("“Hey baby, look at my car. This is a chick magnet car.”")]), _vm._v(" "), _c('p', [_vm._v("“Hi, did you fancy my new handbag? I bought it in Paris.”")]), _vm._v(" "), _c('p', [_vm._v("“Did you see me in my lingerie?”")]), _vm._v(" "), _c('p', [_vm._v("“Nude sunbaking.”")]), _vm._v(" "), _c('p', [_vm._v("That’s the moment when you are so proud to show what you’ve got on social media.")]), _vm._v(" "), _c('p', [_vm._v("It is a fine line between pleasure and pain, between triumph and tragedy. You hide your spouse away from social media but you are more proud to show off your body, your handbag or your sports car, it must be a sign that your handbag is better looking than your spouse. The question is, is your spouse that bad? Why do you hide him/her away from social media? We won’t say anything bad about your partner. If he or she is that ugly, we still will not say anything, we will just pass out.")]), _vm._v(" "), _c('p', [_vm._v("It is your choice if you want to hide your spouse away from social media, but the truth will come out eventually. If you hide a monster in your backyard sooner or later, that monster will make a guest star appearance in your social media. As the years go by, your social media friends would be wondering,")]), _vm._v(" "), _c('p', [_vm._v("“Are you in a relationship? We’ve seen you with lots of guys but never seen you with your real boyfriend or husband.”")]), _vm._v(" "), _c('p', [_vm._v("“Ten years ago, when he joined social media, he said he was single, now a decade later from all the thousands of photos he posted on social media, we have never seen him with his girlfriend or his wife.”")]), _vm._v(" "), _c('p', [_vm._v("“We are sure she is in a relationship even though she never said anything. But the question is, is she dating a human? Does he have two hands, two legs and a face? Does he only appear by a full moon? Do his feet touch the ground when he walks? Do we need a sixth sense to see her boyfriend?”")]), _vm._v(" "), _c('p', [_vm._v("Look, if you are too embarrassed to show off your girlfriend or boyfriend, we completely understand, we never do anything to endanger ourselves. We can read your mind on your social media about why you don’t post your lover’s photos. For you who get embarrassed to post your lover on social media, these signs could be appropriate on your social media if you post a photo of your lover,")]), _vm._v(" "), _c('p', [_vm._v("“Danger! Flammable materials. No smoking or open flames within 50 feet.”")]), _vm._v(" "), _c('p', [_vm._v("“Beware of the dog.”")]), _vm._v(" "), _c('p', [_vm._v("“Danger! Hard helmet must be worn in this area.”")]), _vm._v(" "), _c('p', [_vm._v("“Caution! Slippery when wet.”")]), _vm._v(" "), _c('p', [_vm._v("“Unfiltered face! Eye protection required in this area!”")]), _vm._v(" "), _c('p', [_vm._v("“Beach closed! Due to shark sighting, until further notice!”")]), _vm._v(" "), _c('p', [_vm._v("“Do not feed the crocodile!”")]), _vm._v(" "), _c('p', [_vm._v("After seeing your boyfriend on social media, we are tempted to make a phone call,")]), _vm._v(" "), _c('p', [_vm._v("“Nine one one.”")]), _vm._v(" "), _c('p', [_vm._v("“Ambulance, fire or police?”")]), _vm._v(" "), _c('p', [_vm._v("“Police please.”")]), _vm._v(" "), _c('p', [_vm._v("“What’s your problem, sir?”")]), _vm._v(" "), _c('p', [_vm._v("“I think I just found that missing llama.”")]), _vm._v(" "), _c('p', [_vm._v("“Where did you find that missing llama, sir?”")]), _vm._v(" "), _c('p', [_vm._v("“On this person’s Facebook, when llama turns bad.”")]), _vm._v(" "), _c('p', [_vm._v("Or we just take a pain killer then sleep it off. Try to focus tomorrow, what we just saw is just history. Always look forward, never look back. Forget about the bad times and think about the good times.")]), _vm._v(" "), _c('p', [_vm._v("There is another reason why you don’t post the photos of your lover on social media, it is because you are afraid you are going to lose your admirers. You get worried that your market will go down and drop. If a guy sees the sign ‘sold’ on the house, it means he can’t put a bid on that house anymore because it’s been taken, when the sign is ‘deposit taken’, it means someone has put a deposit to secure the purchase of the house. That’s how the property market goes.")]), _vm._v(" "), _c('p', [_vm._v("Same as the girls, they have to present themselves as if they are available in the market to get more interest from male admirers. If men know their crush already has a boyfriend, men will not chase that girl again, because men already see a ‘sold’ sign. If the girl is already pregnant, men would see the sign ‘deposit taken’, as a sign ‘off the market’, that’s why girls are reluctant to show their boyfriend on social media, because they’re afraid men will stop chasing them.")]), _vm._v(" "), _c('p', [_vm._v("You want to give the impression to your fans that you are still on the market. Always available, open 24 hours like a convenience store so guys can chase you and drool over you because you are still available on the market. You want to be in a relationship with your lover, but on the other hand you don’t want to lose your fans because you love being worshipped by men. In this case, it seems to love your lover isn’t the first priority in your life. Your first priority is to be adored and chased by fans, you want your fans to worship you as a goddess, that is your first priority.")]), _vm._v(" "), _c('p', [_vm._v("The question is for how long, this strategy is effective temporarily only but not permanently. Logically in the next 40 years you won’t be as good looking as now, your skin won’t be as firm as now. Your skin will be dry and thin, your tits would be down to your waist, you will have more dogs chasing you than men chasing you. Once you were a man magnet, and now you are a fridge magnet.")]), _vm._v(" "), _c('p', [_vm._v("Your social media is your cyber life, this is how you want the world to see you, not the world wants you to be seen (if they disagree with your choice and the way you conduct your social media, it will be shown in the comments section). You have an option to show your pride and achievement but on the other hand you are reluctant to show anything that makes you uncomfortable or embarrassed. We all have our cross to bear and secrets.")]), _vm._v(" "), _c('p', [_vm._v("It is your choice to hide your partner away from social media as if your partner is your dark secret, or maybe you’re too embarrassed or maybe you’re worried the numbers of your fans will be down because you’re off the market now, or even worse maybe your partner is your sister or brother. You must have a valid reason why you don’t post your partner’s photo on social media, it’s your life and your choice but in real life you still sleep with your choice that you’ve hidden well from social media. There’s a saying, it is fun to sleep with an unattractive person, till someone sees you.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "money-talks"
    }
  }, [_c('h3', [_vm._v("Money Talks")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("This is a popular belief, and this is what we’ve been taught: money can’t buy happiness but money can buy you stuff. You like stuff. You can’t measure happiness in life with how much money you have. No, money can’t buy class, happiness, morals, IQ, dignity and reputation. But money can buy your virginity, money was the reason of your fight with your pals or family. Money was the reason why girls are willing to wait in a long queue just to marry a billionaire. The magic of money, it can make your friend become your enemy, your enemy become your friend, your wife become your neighbour, your neighbour become your wife. Money is like a golden ticket to get almost anything in the world.")]), _vm._v(" "), _c('p', [_vm._v("You meet one of your ex-girlfriends in the street, you pretend you don’t know her, “Sorry mate, no English. Wrong person.” You meet your mother-in-law in the street, you pretend you’re in a hurry to pick up your kids. You meet your wife in bed, you pretend you are dead, play dead. But when you see one dollar note on the street, you are alive! You will climb the highest mountain, you will swim the ocean to get that one dollar note.")]), _vm._v(" "), _c('p', [_vm._v("The first words that come out from your mouth after you spotted money on the street are, “Fuck me! It’s mine! It’s mine!” When you see your ex-wife accidentally on the street, the first thing that comes out from your mouth, “Oh God! I am fucked!” See, you are thrilled when you see money, but you are grilled when you see your ex-wife. See the big difference?")]), _vm._v(" "), _c('p', [_vm._v("This is why money is also the one of the reasons why flaunting wealth on social media is attracting more attention and controversy. Who doesn’t want to live debt-free? Not a worry in the world about paying bills and rent. Money is the reason why most people get up early in the morning and go to work. Money is one of the reasons why a husband and wife never stop arguing, and also the reason to make love.")]), _vm._v(" "), _c('p', [_vm._v("Well, money is also the reason in social media to get your social status. A luxury sports car and high-end handbags are two of the most popular choices as a background to post on your social media. Ladies love to show off their expensive handbags with the price tag that makes you bend over for sugar daddy for months to get that handbag. The top end handbag is more expensive than a brand-new car.")]), _vm._v(" "), _c('p', [_vm._v("In real life, you don’t have that much money and all the luxury you want, but you are dying to show the world that you are filthy rich. To compensate for your unsatisfactory life that you don’t have, you turn to social media. You want a new car, but you can’t afford it? Use social media:")]), _vm._v(" "), _c('p', [_vm._v("“Just bought a new car,” you are standing in front of your neighbour’s car.")]), _vm._v(" "), _c('p', [_vm._v("“This is my new house,” you are standing in front of this luxury home somewhere which is not your house.")]), _vm._v(" "), _c('p', [_vm._v("“This is my walk-in wardrobe, this is my collection of my handbags and my shoes, these are my designer clothes. This one is the real brooch that Elizabeth Taylor used to wear.”")]), _vm._v(" "), _c('p', [_vm._v("Either it is real or fiction, you feel happier when you look successful on social media.")]), _vm._v(" "), _c('p', [_vm._v("Flaunting wealth on social media is one of the signs of narcissism, attention seeker. The more you get compliments of how wealthy you are, the more you get happiness. But the happiness wears off when someone else beats you. You just post the photo of your 4-level mansion in this affluent suburb, then somebody else posted a photo of his 10-level mansion plus a gold swimming pool.")]), _vm._v(" "), _c('p', [_vm._v("In your world as a narcissist, you have to be the best, the superior. The best place for a narcissist who loves flaunting wealth is to be the top of the world, you love to be showered by endless attention and validation. The less you feel, the more you want to show off. The lonelier and more insecure you are, the more you are motivated to flaunt your wealth to the world. In your world, it is a competition when it comes to wealth. In your mind, no one can beat your wealth because you are the most special person on earth. Even if the money and wealth you post in social media isn’t real, you’ve got to do anything to get that position: the best, the richest, the luckiest person.")]), _vm._v(" "), _c('p', [_vm._v("“My handbag is $100,000. It has diamonds, and is made from a crocodile skin.”")]), _vm._v(" "), _c('p', [_vm._v("“My handbag is $150,000. It has diamonds and pearls, and is made from a virgin crocodile skin.”")]), _vm._v(" "), _c('p', [_vm._v("“My handbag is $200,000. It has diamonds, pearls and gold, made from the king of crocodiles. His mama is a crocodile and his papa is a chicken, yes that crocodile was a biracial. This crocodile didn’t snap but he clucked! How good is that! Beat that!”")]), _vm._v(" "), _c('p', [_vm._v("“This is my car, the top of the range!”")]), _vm._v(" "), _c('p', [_vm._v("“My car is more expensive than your house, my car has a gold steering wheel and everything is gold!”")]), _vm._v(" "), _c('p', [_vm._v("“My guns are made from gold and have two fangs on the front to suck up to people with money.”")]), _vm._v(" "), _c('p', [_vm._v("“My car is the best, it has diamonds and gold everywhere, it has all the whistles and wait, it also can wash itself when it gets dirty, it washes me too when I get dirty.”")]), _vm._v(" "), _c('p', [_vm._v("“My car is gold too and it can moan like a girl in bed whenever I stop the engine or when my car sees a beautiful girl.”")]), _vm._v(" "), _c('p', [_vm._v("“My private jet is gold!”")]), _vm._v(" "), _c('p', [_vm._v("“My private jet is bigger than yours. It has more gold and diamonds, it has a shopping mall inside, it has many beautiful chicks, it has a spa, it has a basketball on top, it has swimming pools on the wings.”")]), _vm._v(" "), _c('p', [_vm._v("“My private jet is bigger than yours. It has an amusement park, five big hotels, a zoo, a casino, a roller coaster, a botanical garden. Even better, it has your sisters and your girlfriend inside. How big is that!”")]), _vm._v(" "), _c('p', [_vm._v("“My private jet is bigger than all of yours! How big is it? It is as big as your girlfriend’s private parts! Nothing is bigger than that. Beat that!”")]), _vm._v(" "), _c('p', [_vm._v("When you are bragging, flaunting and exaggerating your wealth on social media, that is a sign of a small tool in big tool clothing, you measure your dignity with money, not a sign you are a good and honest person. These could be the opinions about you from the majority:")]), _vm._v(" "), _c('p', [_vm._v("“It is confirmed that you perceive and measure your dignity, happiness, and love and life with materials. You have no dignity.”")]), _vm._v(" "), _c('p', [_vm._v("“Are you an honest person or not? Are you a narcissist?”")]), _vm._v(" "), _c('p', [_vm._v("“Are you a manipulative and calculating person?”")]), _vm._v(" "), _c('p', [_vm._v("“If it is true, where did you get so much money from?”")]), _vm._v(" "), _c('p', [_vm._v("“If you work for the weather bureau, are you going to exaggerate about the weather too? Did you exaggerate your wealth to the tax man too?”")]), _vm._v(" "), _c('p', [_vm._v("“We know you are lying and exaggerating about your wealth just to get validation, attention, compliments and the top position in social media. The question is, are you trying to compensate for something?”")]), _vm._v(" "), _c('p', [_vm._v("“When was the last time you were humble, embarrassed and honest?”")]), _vm._v(" "), _c('p', [_vm._v("Your narcissistic behaviour on social media will give you more critics than compliments from people who are struggling on a daily basis then they view your social media. To put it this way, if you are talking about how much you have spent to buy those high-end handbags, shoes, and first class to struggling families who keep their head above water, this will cause more ill feelings than love, talking about insensitivity. Now this is a question, if you don’t have wealth and all this luxury, what are you going to show off on your social media? What makes you feel good as a person? Being honest, patient and humble? Or will you lose your confidence without your handbags and luxury goods?")]), _vm._v(" "), _c('p', [_vm._v("What makes you proud of yourself apart from the materialistic world? Honesty? Your IQ? You say you love helping people, you do that to be seen by people around the world so they will admire you for loving to do charity. You love the compliments on how good you are, how heroic your action is after you become a good Samaritan, you become a do-gooder not because you really want to help but you love to be seen as a hero and validated. So basically you use poverty and tragedies to boost your reputation and ego.")]), _vm._v(" "), _c('p', [_vm._v("As if you’re saying, “I am very wealthy, successful, very good in bed and also a good person who feeds people who live in extreme poverty.” You post photos showing how heroic you are that you have been helping starving people and the elderly. The caption on your photo with those children in a third world country, “My happiness is to love them and help them.” Another post on your social media, “We should respect people who live in poverty,” then the next day you post your expensive handbags again which costs more than building 100 huts in a village. Isn’t it a double standard? This is like from all of your 100 photos of church activities, you slip one photo of your wild night with a stripper and llamas in lingerie amongst them, which don’t mix at all.")]), _vm._v(" "), _c('p', [_vm._v("Just curious, when you exchange wedding vows with your legal spouse, what is the vow you make?")]), _vm._v(" "), _c('p', [_vm._v("“Do you take this lovely lady to be your lawfully wedded wife, to have and to hold, in sickness and in health, to love, honour and obey, in good times and woe, for richer and… poorer?”")]), _vm._v(" "), _c('p', [_vm._v("That sentence, “For richer and poorer…” Did you agree with that? Or does it sound like this:")]), _vm._v(" "), _c('p', [_vm._v("“Do you take this lovely lady to be your lawfully wedded wife? To love, honour and obey for social media selfies, for richer because of corruption or delusions, likes or validations on your selfies, for flawless skin with photoshop and no filter?”")]), _vm._v(" "), _c('p', [_vm._v("According to data in 2018, just nine of the richest in the world have more combined wealth than the 4 billion people in the world or more than half of the world population. There are more than 7 billion people in the world right now. A recent study released by Oxfam shows 1% has more wealth than the rest of the world population since 2015. There’s a possibility in the next 25 years we could see the first trillionaire in the world.")]), _vm._v(" "), _c('p', [_vm._v("After seeing the rich kids or the rich on social media, did you ever see the top ten richest in the world flaunting their cars, money, private jets, handbags and their mansions on social media? The answer is no. There are the richest and there are the rich who are dying to be the richest but they can’t. Did you see Bill Gates showing off his car collections or his wife showing off her jewellery and handbags on social media? No. Warren Buffet never posts on social media about how many private jets he has, even though he has the world’s largest jet company.")]), _vm._v(" "), _c('p', [_vm._v("Why do the top richest in the world never flaunt their wealth on social media? Firstly, because they are not stupid. Secondly, because they value the money, not the money values them. Thirdly, they are in the top position of power in the world because they have brains, are competitive, innovative, self-disciplined, focused, they never give up even though they have failed, they keep going, they take risks, they are not lazy and they BELIEVE that they can make it. They control their money and emotions, not their money controls them and their emotions. They have something to offer to the world, their products have a good reputation, are accountable and are very competitive, and meanwhile you keep producing selfies. When you want to buy something online, you use their product. When you search for something online, you use their search engine. When you look at your computer or smartphone, you use their product. You post selfies or want to have a chat online by using their product. And what do you offer to the world? Your photoshopped selfies.")]), _vm._v(" "), _c('p', [_vm._v("This is the difference between the richest and the narcissistic. If you don’t have a worry in the world to buy food and clothes, we are happy for you. We don’t salute you because you can buy cars but we salute you because you have invented that machine and the technology that benefits many people in the world, not just you. We salute you for what you have innovated and produced, we don’t salute you for your handbags you have purchased. If you have innovated the fastest helicopter in the world, hats off to you. We salute you for being an innovator. But if you are a consumer, well, you are just a consumer, a follower, not a leader.")]), _vm._v(" "), _c('p', [_vm._v("One of the traits of people who love flaunting their wealth or lie about their wealth on social media is they don’t treat people the same. You treat people based on how much money they have, the more they have money, the nicer you are to them. If you know some billionaire or some high-profile people, you will approach them because of their status, they are on the same level as you, in your mind. But you will belittle people that you think are just below you, such as the homeless, garbage collectors, cleaners and all people who live in extreme poverty. In your mind, they are beneath you, not worth it. You suck up to the max to people who have wealth and power but meanwhile you insult and bully people who live in extreme poverty or those who are not on the same level as you are. Also, narcissists are well known to get jealous when they see someone who is ahead of them or has more than them.")]), _vm._v(" "), _c('p', [_vm._v("There are some comments as the response for your selfies that always show off your wealth, such as:")]), _vm._v(" "), _c('p', [_vm._v("“Do you really think we believe you? Next you’re going to tell us that you dialled 999 with your tongue because your two hands were tied up. If only a pig could fly.”")]), _vm._v(" "), _c('p', [_vm._v("“You have every right in the world to post anything on your social media. But we are entitled too to have our point of view of what you are.”")]), _vm._v(" "), _c('p', [_vm._v("“Suppose you want all homeless and struggling families here to like your photos. You are very insensitive and insecure.”")]), _vm._v(" "), _c('p', [_vm._v("“Compensating for something?”")]), _vm._v(" "), _c('p', [_vm._v("You will be very outraged if someone taps you on your shoulder, you will hit them back by saying, “You’re envious, this is my life. I can do whatever I want.” To you, no one can tell you what you do, your life is your life. You may say no one can tell you what to do, but I am afraid the tax office, the laws and the authority will disagree with you, they will tell you what to do. You may say you can do whatever you want, but you are not above the law. Your body will tell you what to do because you are not immune from any disease. Yes, you use three words as your weapon if you don’t like someone criticising you, “You are jealous.”")]), _vm._v(" "), _c('p', [_vm._v("You say, “You say that because you are jealous and you can’t afford what I have.” This is your defence.")]), _vm._v(" "), _c('p', [_vm._v("We are not jealous and racist, we don’t like Ted Bundy not because we’re jealous and racist towards him. We don’t like him because he’s an evil serial killer, not because we’re racist. Maybe we would be jealous of Nikola Tesla because he was the great inventor, we are jealous of those Field Award winners because of their contributions to math, as they are at the top of the tree as a mathematician. We are jealous of Mahatma Gandhi because we wish we all had his wisdom and strength. That was a man with conviction. We say your social media photos, which are flaunting so much wealth, are the reflections of what you are, not what you think who you are.")]), _vm._v(" "), _c('p', [_vm._v("Is money the root of evil? Can money buy happiness? It is up to you to answer it. It is up to you to decide what you’re going to do with money or how to get the money. Yes, some people go to jail because of money. Some people get hurt because of money. Look again, money is a piece of paper and numbers on a bank account balance. Money doesn’t ask you to hurt people, money doesn’t ask you to lie. It is you who lies and hurts people because of money. Because? You don’t have morals. Lacking morals is evil. Money in the hands of an evil person means someone or some people will be hurt.")]), _vm._v(" "), _c('p', [_vm._v("Money is a powerful energy to bring happiness when it is in the hands of a good person. He will use his money for good intentions so children can go to school, sick people can get medicine, money for food and shelter so the homeless and people who live in extreme poverty don’t have to worry where they’re going to sleep and what food to eat. It is a rewarding feeling and makes you feel happy inside to do this without telling anyone. If money is in the hands of a bad person, you know what will happen. A bad person will use anything (not just money) for bad intentions, and money is on the top of their list to get themselves rich by manipulating or hurting people.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "drama-queen"
    }
  }, [_c('h3', [_vm._v("Drama Queen")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("For this section, please bear with me. It is a bit longer than any section, because social media is fuelled by drama queens, especially in politics, race and religion. Before reading this section, please shake your head side to side before use. Caution! Slippery when wet. Hearing protection required beyond this point. Enter at your own risk.")]), _vm._v(" "), _c('p', [_vm._v("Are you a drama queen? Are you an actress who uses social media as your stage? Are you addicted to nuts? Have you touched the animals in the last 24 hours? Are you having trouble being honest? Are you on medication or were you just born constipated? Of course you are not a drama queen at all. Who says you are a drama queen? You just get angry if you don’t get enough attention. No, it is not a big deal when you don’t get any likes, comment or attention on your social media, you just have a sleepless night lamenting because you’re too upset no one likes your post.")]), _vm._v(" "), _c('p', [_vm._v("No no, you are not offended and upset at all, you just make a death threat. Does it make you a drama queen? No way, of course not, you are not a drama queen you are just a grown-up woman with a mentality like a 5-year-old girl who gets maniacal in the supermarket just because you don’t get a lolly. Ohh, poor you, we feel for you. Here, I’ll give you a big warm hug, as warm as Kim Jong Un’s heart.")]), _vm._v(" "), _c('p', [_vm._v("I see you as a nice and loveable person. You are so charming and full of attention. Your attention is overwhelming me. You never failed to ask me how my day has been. You keep reminding me to take care of my health and well-being. You say we have something in common. That is true, we do. Actually, you and I look the same, your ears look like my ears. See, we do look alike. You ask your social media friends how they’ve been doing, including the family. You never forget to send your friends a birthday wish on their birthday.")]), _vm._v(" "), _c('p', [_vm._v("First, you are everybody’s best friend on social media. Because you have given them the attention you want (not what they want), you demand all people give you more attention and special treatment. You are not happy, you complain that your friends distance themselves from you, without any time in the world for you. You get upset because you think you’ve been too kind to everyone but they never show they care for you. You want everyone without an exception, you want all social media users in the world (yes, in the world) to give you a pat on the back for all the miseries and tragedies you’ve been through and you still survived! This is very typical of a drama queen to say this, “I’ve done that, been there.”")]), _vm._v(" "), _c('p', [_vm._v("But actually you what you mean to say is, “Been there, done that, stuffed that.”")]), _vm._v(" "), _c('p', [_vm._v("Yes, you give attention to some people not because you care but because you want something back in the future from them. In fact you turn a blind eye, no sympathy to people who deserve to be helped such as the homeless or people who live in extreme poverty, yet you are still complaining your friends are not good enough. To you, all the attention, love, tears, time and care in the world should go to you, not to anyone else. You just give sympathy to some people because in the future you know you will take advantage of them because they have money or status or both. So if you are kind to someone, it is not purely from the heart, but there is a string attached.")]), _vm._v(" "), _c('p', [_vm._v("To you, not everyone is qualified to be your friends. Only a special person can understand you because you are special. To be qualified in your ‘special’ level is more difficult than applying to be a NASA astronaut. Even though many of your friends have been so kind and supported you, but in your eyes, they are still not good enough, because they are still not special until you say so. Yes, you are a special person. In the supermarket if you see a sign on some items ‘On Special’, it means those items will be expired soon, it means the quality is quite dodgy and the price is cheaper than ordinarily, it means nobody wants to buy it and the supermarket wants to get rid of it, that’s why they put the sign ‘On Special’ today, and that’s you.")]), _vm._v(" "), _c('p', [_vm._v("You don’t want to waste your time to be with friends below your standard. You want to be friends with a person with social status or with money or a person who always agrees with you or sucks up to you a lot. You don’t want to waste your time with someone who doesn’t have money or social status. A friendship to you is a business, you give something, and you want something in return. When you give to someone, you will keep reminding them that you have given her this and that by saying, “I have helped you in the past, you wouldn’t have made it without me,” you use those words as ammunition to weaken her and take advantage of her.")]), _vm._v(" "), _c('p', [_vm._v("You demand everyone to treat you like a person. What you mean by ‘treat you like a person’ is all of your friends have to swim the ocean, climb the highest mountain, stop the volcanoes, go to the sky and vacuum all the clouds till you can see sunshine, go to Africa to perm all the lions’ hair because we know you love curly hair and curly noses, you want all people in the world to live and die for you. That’s what you call a real friend. No no, you say, you don’t demand anything at all. You just demand your friends to live and die for you but you when we ask you to do the same, you disappear.")]), _vm._v(" "), _c('p', [_vm._v("You don’t care if your friends juggle their time between work and family commitments. You demand the answer why they are not online so much to keep you company, at least to say hi. If a friend of your social media friends never says hi or likes your post, it means she has committed the biggest crime ever! Never say hi on social media? Oh my God, this is the end of the world! Bigger than genocide! Bigger than smuggling drugs! And you want all of that now, now, now, no excuse.")]), _vm._v(" "), _c('p', [_vm._v("No, you can’t accept the fact that no one would say ‘hi’ on your social media after all the attention you gave them, at least say ‘aloha’ or ‘bonjour’. You say to be your best friend is to give unconditional attention, love and care on social media. You forget that your friends live in the real world, not in the online world. Forget about war and nuclear weapons, it is nothing if you compare that to your disappointment which is that nobody says hi or likes your post! This is the biggest crime ever! You’ve been ignored! They should imprison anyone who never says hi or likes your social media post, this would give you insomnia and starvation because they don’t say hi to you, not even a like!")]), _vm._v(" "), _c('p', [_vm._v("You go mad like a little girl with the wrong diapers. You start to see anyone who doesn’t give you enough attention as your enemy. You start writing your problems on your social media based on your emotions, not on your intelligence. A little harmless thing that your friend says becomes a big thing as you take it as a red flag, even though your friend didn’t mean to offend anyone. You write, “I hate my day.”")]), _vm._v(" "), _c('p', [_vm._v("One of your friends replies, “Just stay positive.”")]), _vm._v(" "), _c('p', [_vm._v("She just wants you to be positive, but your response is, “What did you say to me? Are you telling me that I am a negative person?”")]), _vm._v(" "), _c('p', [_vm._v("This is one of the signs of a drama queen. You see a little thing as a threat, but you see the big thing as a small thing. If one of your friends says you have a big heart, in the drama queen’s brain those words are translated into, “You have a big nose.” That makes you go ballistic because of those harmless words. When it comes to a much bigger scale such as your government, drug dealers and criminals who are terrorising your society, you are too afraid to act, but when an ant eats your chocolate cake it is like a nuclear war to you. You see someone disagree with you on social media as if you see a giant tornado ready to attack you but you don’t see the bigger picture, your family and children are begging you to stop staring at your smartphone and computer.")]), _vm._v(" "), _c('p', [_vm._v("You see harmless words as a threat to you, but the big threats in your society and country are invisible to you. If I may say, man up. Pull yourself together, pull your panties up and stop being a child. If you can’t stand the heat don’t stand in the kitchen. If you get offended easily, don’t live on Planet Earth, it is because you are mentality weak. If our heroes were weak and got offended easily, they would’ve never fought for freedom and independence so we can enjoy the freedom and welfare right now. A drama queen acts like a sunburn victim. If someone just touches you gently, oooh you moan and roar in pain as if a blender is stuck up yours but in your mind you are a calm person, you never act like a child, in your mind you are the most charming person that we all have ever come across, as charming as Idi Amin.")]), _vm._v(" "), _c('p', [_vm._v("You are not shy to drop some names on your social media wall. You blame the world and everything in life. You become irrational, you are irritating. Your social media posts are full of curse words or the blame game, “I am the victim.” You play the ‘victim’ card a lot, even though you insist you are not a victim, you say, “I am just a survivor.” What did you survive? You can’t even survive your emotions and all those childish behaviours.")]), _vm._v(" "), _c('p', [_vm._v("If you hate someone, you would dedicate days, weeks, months just to slander that person, non-stop on your social media. The whole world must know you don’t like him, and we have to hate him too, according to you. As usual, a drama queen thinks she is right and he’s wrong, even the whole world is wrong. You just got ditched by your boyfriend, you curse him with inappropriate language on your social media, and we should know your private problems that you should discuss behind closed doors.")]), _vm._v(" "), _c('p', [_vm._v("We could tolerate you if you only post one or two hate posts about him, but everyday non-stop, all day, for weeks and months? Didn’t you want to communicate with your children or do something useful instead staring at the computer for hours just to put curses or blame someone? How are the children coping when their mum is just staring at the smartphone or computer while the children need more love and attention in real life, not the cyber life? I think you’d better dedicate your time and love to your children, life is not about your heartache, it is about giving your time and love to your family and people around you.")]), _vm._v(" "), _c('p', [_vm._v("Drama queens are notorious for preaching moral standards, preaching being happy and wise in contrary to the majority of your posts dedicated to the disappointments in your life, what you should’ve had but you don’t, someone you hate or some friends that have offended you. When you are upset, you have to go public by posting it online, you write your problem on your wall and blame that person for hurting you.")]), _vm._v(" "), _c('p', [_vm._v("With posts like this, if we don’t respond, you’re going to label us ignorant, call us a bad friend because we don’t give you enough attention. But if we respond, we don’t want to get involved in your problems. It is because we focus on our family and real life as our first priority, apart from that we have enough problems in our life that need to be sorted out, we don’t want more problems and also we don’t want your problems to become ours. You’re a grown up, you can sort it out. Come on, chop chop! Move your ass from the internet and solve your own problems.")]), _vm._v(" "), _c('p', [_vm._v("If you are a man, not a nasty little coward, you have a problem with Alpaca, go and see Alpaca or talk to him on the phone to solve the problem with maturity, not like a child ranting on social media, at least you’ll make an effort to solve the problem.")]), _vm._v(" "), _c('p', [_vm._v("“Yes, Alpaca, I’d like to solve this matter with you. What time would be convenient for you, I’d like to drop by to have a chat.”")]), _vm._v(" "), _c('p', [_vm._v("“Anytime after 5 pm today, I have an appointment with my hairdresser at 3, I think around 5-ish should be all right.”")]), _vm._v(" "), _c('p', [_vm._v("That is how an adult solves the problem. Complaining about your private problem on your wall doesn’t solve the problem but it adds more problems.")]), _vm._v(" "), _c('p', [_vm._v("In saying that, there is a big difference between social media user seeking some advice for a better solution so we all can solve the problem and live peacefully, and social media users who use social media to seek revenge, slander some people and provoke followers to punish that person she hates. These are some posts looking for positive outcome:")]), _vm._v(" "), _c('p', [_vm._v("“Hi there, I have this problem. My children don’t want to eat vegetables. Any advice on what I should do?”")]), _vm._v(" "), _c('p', [_vm._v("“Good morning pals, I would like to ask your help, does anyone know the best treatment for eczema? Thank you.”")]), _vm._v(" "), _c('p', [_vm._v("That is the kind of post that asks the social media for a better solution and positive outcome, not for negative outcomes such as seeking an enemy and asking all of your friends to hate someone.")]), _vm._v(" "), _c('p', [_vm._v("Drama queens don’t ask for guidance, but they are seeking revenge. Their posts are defamation posts to frame someone or a business. Drama queens are unreliable and lacking details when providing information:")]), _vm._v(" "), _c('p', [_vm._v("“From now on, I am not related to Zach Ash anymore! He’s a jerk! A mistake to know him.”")]), _vm._v(" "), _c('p', [_vm._v("“I was in this Lusty Eggplant restaurant. The food was terrible, the service was lousy. I’ll never go back to that Lusty Eggplant restaurant again!”")]), _vm._v(" "), _c('p', [_vm._v("If you hate bananas, it means the whole world must hate and punish that banana too. The more you can influence people to hate bananas, the happier you are. To you, one of the benefits of having friends is you will use your friends to back you up to bully someone you hate.")]), _vm._v(" "), _c('p', [_vm._v("If some of your friends or your boss acted like you, what would you do if your sins and your name were shamed by them on some social media, with users spreading bad words about you like you campaign the sins of your enemies?")]), _vm._v(" "), _c('p', [_vm._v("“Never want to employ a drama queen again, she was lazy and unreliable. She spent time more whinging than working. Caught her hands in the till! CCTV captured images of her stealing things!”")]), _vm._v(" "), _c('p', [_vm._v("“A drama queen was dining in our restaurant, she ordered a whole roast chicken and demanded the chef to serve the roast chicken with chicken legs crossed like a scene in that movie, Llama Instinct. Then she demanded the lobster with the big breasts, then she got upset when she was told to do something about her children running amok in the restaurant, plus they left a big mess on the floor.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, she said she’s been discriminated because she let the children scream and run amok. If she were a good mother, she would’ve taken her children to the park, not to the restaurant. Children love the park, not a restaurant.”")]), _vm._v(" "), _c('p', [_vm._v("“Her table was so loud it made the other tables in the restaurant uncomfortable. Yet, she complained about the loud music from the neighbour.”")]), _vm._v(" "), _c('p', [_vm._v("Imagine this, do you think World War One and Two would have ended in peace if all the leaders and soldiers just attacked each other on social media?")]), _vm._v(" "), _c('p', [_vm._v("“I so hate German soldiers, they have better uniforms than us,” say French soldiers.")]), _vm._v(" "), _c('p', [_vm._v("“I am so totally upset because French soldiers ruined my manicure and pedicure,” say German soldiers.")]), _vm._v(" "), _c('p', [_vm._v("“Like and share if you agree Russian Army has the best moustaches,” says Stalin.")]), _vm._v(" "), _c('p', [_vm._v("“Sorry Russians, Hitler has a sexier moustache than you,” reply German soldiers.")]), _vm._v(" "), _c('p', [_vm._v("“Are we going to chat or what? You didn’t reply to my inbox, you never like my post, you never tag me. If not, I will unfriend you,” says Hitler to Stalin.")]), _vm._v(" "), _c('p', [_vm._v("“Does this gun make my hips bigger?” asks Mussolini to Hitler and Stalin.")]), _vm._v(" "), _c('p', [_vm._v("“Hitler, I totally hate you. You photo bombed my selfie,” says Stalin to Hitler.")]), _vm._v(" "), _c('p', [_vm._v("“Sorry, I photo bombed your selfie with a V-1 flying bomb,” replies Hitler.")]), _vm._v(" "), _c('p', [_vm._v("“Guys, guess what, last night I heard Napoleon Bonaparte say I like your bomb,” a Spanish soldier writes on his social media.")]), _vm._v(" "), _c('p', [_vm._v("“Amigo, what you heard was wrong. He said I like your bums, not bomb. D’oh!” replies a French soldier.")]), _vm._v(" "), _c('p', [_vm._v("“Oooh I see, they sound almost the same. I like bums too. Who came first? Napoleon first or his girlfriend?” asks a Spanish soldier.")]), _vm._v(" "), _c('p', [_vm._v("“Me!” replies a British soldier, “Napoleon said we British should watch, so I watched!”")]), _vm._v(" "), _c('p', [_vm._v("Thank God social media didn’t exist during World War one or Two, otherwise there would’ve never been peace in the world.")]), _vm._v(" "), _c('p', [_vm._v("Dear drama queens, I see those posts on your wall, I cry hard, cry me a river. I think I need a bucket and a mop to clean up all the tears. Drama queens exaggerate the problems by adding more spices such as salt, vinegar, MSG, chilli and pepper into your story. Many times your story seems too salty to us. Ancient wisdom says if your cooking is too salty, it means it’s been a long time that you didn’t get laid. Or many times the food you cooked is too sour to us, because you put in too much vinegar. Just taste one teaspoon of your food, our faces puckers up within a nano second and lasts all day. Both our eyes, our noses and mouths are too close to one another because it’s too sour. As usual, a drama queen is always sour, more sour than her armpit.")]), _vm._v(" "), _c('p', [_vm._v("Does it solve the problem? No. Does it stir the problem? Yes. Secondly, to see the truth, we have to hear from all sides, not just from one side only. In the court room, we have to see the case from all sides, from the defence team, the witness, the accused and the prosecutors. The jury can hear the story from both sides to get a fair verdict. In a drama queen court room, it has two sides too. You can hear the story from both sides, from the drama version and the delusional version.")]), _vm._v(" "), _c('p', [_vm._v("Everything is a competition for you, in a dramatic way. We say we have a headache, you say you’ve got a brain tumour. We say we are nine months pregnant with twins, you say you are two years pregnant with triplets, just like an elephant pregnancy, two years. We say we have hiccups, you say you have had hiccups for years which causes your neck to grow longer than your legs, so you say. We say we have a bruise on our leg, you say you have bruises on both your legs, arms and backside (due to being ‘upgraded’ by King Kong maybe).")]), _vm._v(" "), _c('p', [_vm._v("We say we get a pimple you say you get a huge pimple like a volcano with lava that needed you to call fire fighters and an ambulance to be hospitalised due to that pimple. You say even all the doctors in the world are so worried about your huge pimples so they have a conference to discuss your pimple that might affect the world weather, not just your body. I know how to cure your pimples, you need a facial with Thor’s hammer. Guaranteed, no pimples on your face again after having a facial with Thor’s hammer.")]), _vm._v(" "), _c('p', [_vm._v("If you have a bad day, the whole world must agree with you that you had a bad day. In fact, you want the whole world to pay tribute and five minutes silence for you just because you have constipation. This is Armageddon, you have constipation and a bloated stomach because you haven’t been to the bathroom for two days, and on top of that you have a blocked nose. Oh no, God please stop this. You want all of your friends’ full attention and for them to feel so sorry for you, you even want all the leaders from superpower countries to have a summit to discuss your bloated stomach, constipation and blocked nose. Forget about the war and nuclear material in the world, this is about you. Your bloated stomach, constipation and blocked nose need more attention than a man on the moon.")]), _vm._v(" "), _c('p', [_vm._v("How do we spell your name backwards? Born to fuck, but forced to watch! Born to fish but forced to moan. Moan moan go away, moan again another day. Knock knock! Who is it? Moan Ami. Good moaning, how are you? I moan, thanks. Just like the lyrics of the song: Moaning has broken, just like the first moaning… Moaning glory, oh Lord forgive you for how much you’ve been mistreated, abused and victimised.")]), _vm._v(" "), _c('p', [_vm._v("Oh poor darling, here I’ll give you a tissue. You say you need a ton of tissues, so I say why don’t we bury you with tissues and shove up yours with that tissue instead, now you can feel the tissue. You write on your wall there’s always something wrong or some person wronged you. Sometimes you realise you put too much tele-nova on your social media, to balance it you put some posts of how you are actually a good Samaritan, you have helped some people. Then you go back to your childish mood again, drama galore. All your tears, heartache, anger, and stress are there on your social media.")]), _vm._v(" "), _c('p', [_vm._v("All drama queens are manipulative and calculating. You love being the centre of attention. You often use a religious leader, your husband or father to back up your argument and manipulate others to believe in you as if you’re not the only one who has that point of view:")]), _vm._v(" "), _c('p', [_vm._v("“I told my husband about that story. My husband said the leader of this political party was wrong.”")]), _vm._v(" "), _c('p', [_vm._v("“According to the Head of Religion, this was out of line.”")]), _vm._v(" "), _c('p', [_vm._v("You use drama to gain attention. You love sending invitations too, not inviting everyone to a party or a wedding but you invite them to hate, to be on your side, to stand up for your mistakes and lies. When you have a problem with Juju, let’s say her name is Juju, you slander her on your wall and you ask anyone who reads it to curse and punish Juju. If they disagree with you, they will be cursed and punished by you by blocking you or unfriending you. Don’t forget to use the word ‘God’ to justify your action, as if God backs you up and loves you so.")]), _vm._v(" "), _c('p', [_vm._v("You may say you’ve been hurt, betrayed, backstabbed and broken, but behind all the tragic life you have, secretly inside your inbox you have provoked many of your friends to hate someone. You tell all the gossip to your friends. You love talking behind their back. You twist the truth, you make the good person become bad and vice versa, aren’t you a Machiavellian. You whisper to your friends in your inbox or group chat about the sins of this person and that person. You play off against each other, you are an expert in this field.")]), _vm._v(" "), _c('p', [_vm._v("Most drama queens are consumed by envy. You get envious when you see some photos on social media because those posts show something that you can’t afford or can’t have, such as showing their holiday, showing their happy moments and so on. As usual you use your social media to express your feelings, you are jealous of anyone who posts their holiday photos, their happy snaps or even just a harmless ‘Mother’s Day’ wish makes your blood boil, this is coming from someone who is not shy to post all the misery and tragedies in her life. You compare your life with other social media users.")]), _vm._v(" "), _c('p', [_vm._v("Apart from being difficult and demanding, you put your best act on to be the cutest and the most cuddled cactus in the world. Why? Because you want something from your friends, in the worst-case scenario you would ask for money despite your social media posts saying you are not asking anyone for anything as your family is very successful, l but you turn to your rich friends when it comes to money.")]), _vm._v(" "), _c('p', [_vm._v("You say you want to be free from all the troubles but we don’t see you make an effort to do something to rescue yourself, such as actively looking for a new job or being creative to make something to sell to get a few more dollars. In fact, we see you stay online all the time. Did you say you want to improve your life? You want the best solution for yourself? But your backside seems to be glued to the chair because you spend hours and hours just staring at the computer or smartphone. Didn’t you want to spend time by doing something more useful in real life not the cyber life? So you want us to work hard for you while you just sit there doing nothing, crying and waiting for a train crash.")]), _vm._v(" "), _c('p', [_vm._v("Everything and everyone is not perfect enough to you, you still haven’t found anyone that is as special as you. You return the food in the restaurant because the tomato is cut in the wrong way. You are not shy to demand the hotels remove some drinks because they are offensive to you, even though you know you’re in a different country and culture that is totally different from yours. You want every hotel, restaurants, airline and everyone to bend the rules for you. But you are too afraid to criticise the leader of your country because you know their army will bend you over. In your homeland, tourists obey the culture and the law, for examples: they can’t take a video (unless they get permission from the authority) to capture the moments like most tourists do but when you are a tourist outside your country you act as if you have more right than anyone. You are a drama queen to people who don’t retaliate to you but you are too cowardly to be a drama queen to bad people such as big corruptors in your homeland.")]), _vm._v(" "), _c('p', [_vm._v("A drama queen is notorious for not making an apology. It’s the world’s fault, not yours. If you do make an apology, it is not a genuine apology. To make an apology is beneath you. No, you can’t do that because to say you have made some mistakes is the same as surrendering in a world war, it is a defeat. One of Mahatma Gandhi wisdoms, “The weak will never forgive. Forgiveness is the attribute of the strong.” A forgiveness according to a drama queen’s wisdom is, “The strong never ask for forgiveness. Forgiveness is the attribute when a man comes too fast or too soft.” Hence, your husband always plays dead (in his mind he wishes he was dead) when you ask him to make love to you.")]), _vm._v(" "), _c('p', [_vm._v("If you make an apology, it is not exactly for your mistakes you make but it was people’s mistakes, blame them, not yourself. Because those people put you in trouble. You know you are guilty, but you are more aggressive than the innocent one, as usual you accuse someone else for your problem and mistakes. You know why you are more aggressive than others? Because it is a sign you are guilty.")]), _vm._v(" "), _c('p', [_vm._v("“It was my mistake that I have known him.”")]), _vm._v(" "), _c('p', [_vm._v("After you verbally abused someone or some people, to make those people (the ones who got abused by you) look even worse, you twist the truth by saying:")]), _vm._v(" "), _c('p', [_vm._v("“My apologies to anyone who suffers seeing me being bullied.”")]), _vm._v(" "), _c('p', [_vm._v("“My apologies to my family and friends who have witnessed the pain and disappointment they gave me. Thank you for your big heart and understanding, I’ll survive.”")]), _vm._v(" "), _c('p', [_vm._v("“It was my mistake that I have asked my friends to give me more attention and care! Never ask again! My mistake is that I have come into your life to know you all!” Then you run into your room crying like a baby and throwing all your sex toys at the wall.")]), _vm._v(" "), _c('p', [_vm._v("A typical drama queen, when you have to apologise, is you excuse yourself by using other lies and drama to make people sympathetic to you. You twist the truth by indirectly pointing out some people’s faults, that they should apologise to you, that was not your fault but it was somebody else’s fault.")]), _vm._v(" "), _c('p', [_vm._v("“When I was young, I was bullied because of my race. I used to blame myself for all the troubles I have.”")]), _vm._v(" "), _c('p', [_vm._v("“I was a product of a broken home, I used to cry all day and was ignored. It was hard.”")]), _vm._v(" "), _c('p', [_vm._v("“I was discriminated because of my gender and my faith, I spent most of my life being useless and abused.”")]), _vm._v(" "), _c('p', [_vm._v("“My life was hard and difficult, my parents couldn’t afford to put food on the table.”")]), _vm._v(" "), _c('p', [_vm._v("“After so many tragedies and all the horrors we’ve been through, we managed to stand up strong again to apologise.”")]), _vm._v(" "), _c('p', [_vm._v("“I was at the lowest point where I lost my trust in anyone. I was abandoned by my family and friends.”")]), _vm._v(" "), _c('p', [_vm._v("“I was heavily medicated, I can’t remember anything. I am so sorry and apologise to my wife that I went to the strip club.”")]), _vm._v(" "), _c('p', [_vm._v("These are what drama queens mean to say when they say they are sorry:")]), _vm._v(" "), _c('p', [_vm._v("“If I say I am so sorry, it means all of you will be sorry.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t want to say I am sorry not because I have lied and made some mistakes, but I need to re-establish my reputation. To make people sympathise with me rather than blame me, I have to make up some sad drama stories that actually I am the real victim, not the guilty one.”")]), _vm._v(" "), _c('p', [_vm._v("“I have to say I am so sorry because I don’t want to lose my job.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t care what you think. Now I am going to hurt you and tell the world how bad you are because you knew my sins and my lies.”")]), _vm._v(" "), _c('p', [_vm._v("“If I say I am so sorry it means watch out, there is revenge coming!”")]), _vm._v(" "), _c('p', [_vm._v("When a drama queen out of the blue manages to give accolades to someone on your social media, this is a bit suspicious because the only one you always give accolades is yourself. This is like a chicken saying to the other chicken, “No, I don’t lay eggs but I give birth to baby chickens.” Do you believe that chicken? If only a llama could fly. If you post something nice about someone on your social media, it means you are fishing for a reaction from us:")]), _vm._v(" "), _c('p', [_vm._v("“It is a blessing to have met someone like Kim Mun Ching, he is beautiful inside and out. When nobody cares for me, he’s the only one there for me. When I was down, he picked me up, without him I’d be nothing in this world. A big special thanks to him.”")]), _vm._v(" "), _c('p', [_vm._v("The reason you write that not because you really thank him, but because you are broken hearted and hurt due to lacking attention from all of your online friends. By posting that, you try to make your friends feel guilty and small that they all should give you attention and care in the world like Kim Mun Ching, even though Kim Mun Ching was not really a caring person at all like you say, or he is just a fictional character.")]), _vm._v(" "), _c('p', [_vm._v("Because you have surrounded yourself with your drama world, your stories are tall and exaggerated, it is you versus the world, show some signs that you have suffered honesty phobia; because all of the dramas you make, no one believes you. You have lost your reputation. Imagine if you were really in real big trouble and seriously need help, you are crying, and call 911 and the operator just happened to be one of your exes who had enough of you:")]), _vm._v(" "), _c('p', [_vm._v("“911, please help…”")]), _vm._v(" "), _c('p', [_vm._v("“Can I have your name and address, ma’am?”")]), _vm._v(" "), _c('p', [_vm._v("“My name is Dramalina and I live in 22 Acting Street.”")]), _vm._v(" "), _c('p', [_vm._v("“You are Dramalina, aren’t you? Remember me? By the way is this real or fiction?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, is it you? I am so sorry for what I have done to you but please I need help as soon as possible. There’s an armed robber here, he took everything and now he has taken me as his hostage here, help.” You are very afraid and crying, begging for help.")]), _vm._v(" "), _c('p', [_vm._v("“I would’ve loved to help you if you hadn’t stolen my bank account and slept with the milkman! On top of that you had written a defamation upon me to persuade your career! You deserve to be a hostage!”")]), _vm._v(" "), _c('p', [_vm._v("“Please… please… I am begging you. I am so sorry for what I have done to you.” You are sobbing and begging for mercy from one of your exes, “This man wants one million dollars now from the police or else he’s going to kill me.”")]), _vm._v(" "), _c('p', [_vm._v("“Okay, calm down. Let me talk to him.”")]), _vm._v(" "), _c('p', [_vm._v("“Yo, this is Jack The Cheaper. Now you all listen up, I demand one million dollars cash right now and a helicopter to get me out the country. If not, I’ll kill this girl.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you have her now?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes!”")]), _vm._v(" "), _c('p', [_vm._v("“Do you know I am one of her ex-husbands? I used to have 4 years in hell with her! She was a drama queen, manipulative, a liar and I tell you what, she slept with all the milkmen in town when I was still married to her!”")]), _vm._v(" "), _c('p', [_vm._v("“A drama queen? And the… milkman? The milkman? No way!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, that bad, but wait, there’s more, actually that house you are in now was mine before, all the furniture there was mine, her car was mine. She took all of my money, my house, slept with all the milkmen in town, almost cost me my job yet she posted on her social media that I was abusive and horrible to her! I had enough of her drama and lies of four years. You want one million dollars? Yes? You kill that bitch now then I’ll give you one million dollars to save the world from another drama!”")]), _vm._v(" "), _c('p', [_vm._v("“Dude, calm down. I am so sorry you married a drama queen.”")]), _vm._v(" "), _c('p', [_vm._v("“You want more? She gave a fraudulent signature on my cheque to the bank to clean out my bank account! She told the police and posted on her social media that I had abused her physically, the fact was that when I was at work all the milkmen in town had the pleasure of enjoying milk together with her!”")]), _vm._v(" "), _c('p', [_vm._v("“Oh… dude, I feel for you. By the way, it is not soymilk, is it?”")]), _vm._v(" "), _c('p', [_vm._v("“No, you want her? Good luck! Take her! She deserves to die! If you kill her now, I’ll give you one million dollars! Kill her now! Do it!”")]), _vm._v(" "), _c('p', [_vm._v("“Look, I think I am so overwhelmed by this. I didn’t really want to be in the situation you’re in. My intention before was to get one million dollars, if not I’d kill her. But after listening to you, I give up, not interested anymore. I think I’d better go now, take some pain killers, try to sleep it off, forget about this drama queen and definitely will be thinking of you. I am so so sorry for you, man!”")]), _vm._v(" "), _c('p', [_vm._v("“Hey, before you go, you still have those valuable things you got from her such as jewellery, cash and white goods?”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, why? They are yours, aren’t they? You want me to return these items to you?”")]), _vm._v(" "), _c('p', [_vm._v("“No no, take them. I’d rather give them to you than her! Take more if you want, must be plenty more in the house.”")]), _vm._v(" "), _c('p', [_vm._v("“Thank you, dude, I think I’ll buy you a coffee one day.”")]), _vm._v(" "), _c('p', [_vm._v("“You’re welcome, please take care.”")]), _vm._v(" "), _c('p', [_vm._v("“No, you’re the one who should take care. You’ve been fucked up by that drama pussy, you should rest and take a holiday.”")]), _vm._v(" "), _c('p', [_vm._v("A drama pussy can’t take any disagreement or disapproval, even just a simple thing and you blow it out of proportion. We all are entitled to have our point of view, we respect the differences including different point of view. We don’t force our point of view on you and vice versa. I know you are entitled to have a point of view, but it does not mean you are more superior than others. If we disagree with your point of view, it doesn’t mean we bully you or because we are racist. Look at your bank account balance, if you are not happy with your wallet, are you going to call your wallet a racist? Why you didn’t get 100% in math or won a Gold medal in Math Olympic? Oh, it was because the math was a bully.")]), _vm._v(" "), _c('p', [_vm._v("There are 7.7 billion people in the world (in the year 2018). All of them are very unlikely to agree with everything you say and think. It means you have to spend the rest of your life to attack and abuse people who disagree with you. If someone says something about your favourite celebrity, you will attack them and mock them. Even though she says it very carefully and politely, you still abuse her because she has a different point of view.")]), _vm._v(" "), _c('p', [_vm._v("In your mind, everyone must agree with you and approve of you no matter what or else you’ll be cursing them, naming and shaming them on social media, and writing their names not in your heart but on your voodoo dolls and also throwing a tantrum just like when you’re watching a movie scene when two love birds are tearing off each other’s clothes, they are about to have a strong sex scene but suddenly your internet connection is a goner or your battery is dead. We can hear you screaming and cursing from the other side of the world, “Noooooo…!” However, you always claim yourself as a rational person, you say you always use your common sense. “I use my common sense,” these words coming from a person who got offended easily and cannot control her emotions.")]), _vm._v(" "), _c('p', [_vm._v("In social media, there are more people who idolise, defend and stand up for their favourite celebrity than their own family and people who live in extreme poverty. Biased people are more inclined to defend people who have the same race, nationality, religion or their own group. Are drama queens biased? Of course, you are biased towards your ego, ignorance, lies, selfishness, emotions, narcissism and machiavellianism. Hence, you can’t play chess because you want to impeach the King and abdicate the King to serve the Queen, you. Hence, you are not excelling in math because math deals with the logic of shape, quantity and arrangements. You can’t argue or doubt the answers with math. However, drama queens claim they are really good at math.")]), _vm._v(" "), _c('p', [_vm._v("Math for drama queens is exaggerating the numbers when it comes to their wealth and drama, such as:")]), _vm._v(" "), _c('p', [_vm._v("“I have five designer handbags.” In fact, you only have one handbag or even none.")]), _vm._v(" "), _c('p', [_vm._v("“I have twenty-two million dollars in my bank account.” In fact, you only have five dollars.")]), _vm._v(" "), _c('p', [_vm._v("“I have been hospitalised eight times.” In fact, only once.")]), _vm._v(" "), _c('p', [_vm._v("“I tried to commit suicide three times.” In fact, you just use the word suicide or make a threat to kill yourself to get attention. You accidentally sting your eyes when shampooing, ohhhh you tell the world you attempted suicide.")]), _vm._v(" "), _c('p', [_vm._v("Before I continue, I have noticed the most unexplained and the rarest thing is happening now. Do you know what it is? Drama queens read! Yes, all drama queens are reading this book! And they are offline! Wow, this is a rarity, this is same as Kim Jong Un decided to be an Avon sales representative. I caught you reading! Gotcha! Now, shall we continue? Where were we?")]), _vm._v(" "), _c('p', [_vm._v("Being a mother for a drama queen is not being the role of love for the family. You are using, “I am a mother,” as a chip on your shoulder, untouchable, you are immune from any law and anything, above the law, because, “I am a mother, you know.” Since you became a mother, you became the Holy God, are never wrong, have the highest moral standards and are also guaranteed a ticket to Heaven with all the right in the world to complain. You misuse your role of being a mother, being a mother is an honoured gift and also a blessing that a woman has as an opportunity to give love, raise her children and guide them.")]), _vm._v(" "), _c('p', [_vm._v("You wear the badge ‘I am a mother’ for ego and to punish anyone including your children, to make them feel so bad, guilty and disgusted in themselves. You have been given every opportunity in the world to love, guide and care for your children but your main mission is not the happiness of the children but your selfish ego. It’s all about me, me, me, give me, give me, give me, in your mind what matter the most is not about what you give to your family and the world but it is how much the world and you family have given you. But on social media you exaggerate things and keep banging on how much you love them, care for them and how much money you have spent for their education, diapers and shampoo.")]), _vm._v(" "), _c('p', [_vm._v("Don’t ask a drama queen to dote on and play with children or grandchildren like a normal mother does, a drama pussy wouldn’t. Your social media is more about how good you look, focusing more on how you are seen, how successful and wise you are, just to ask for validation that you are morally conscious. You are number one, and children are number two or three, if they’re lucky. Don’t forget to mention the trauma, morning sickness and nine months in the womb, your children will hear this over and over again for the rest of their life. On top of that, you will remind your children how much money you have spent on diapers and education for the best of children. Right, this is more like living with a tax man than living with a mother.")]), _vm._v(" "), _c('p', [_vm._v("It is not often but there are some disturbing posts which are self-harm photos posted by drama queens or drama kings, you wanted to end your life but you still managed to post it on your social media. It is very inappropriate as children can see those graphic images too. Also, there are some photos on social media where the drama king or drama queen was pretending they passed out after self-harming (fact: suicide is a very serious problem, they need help. Untreated mental illnesses can lead to a suicide. Suicide is not for a joke and drama but it is for us to stand up together because it can be prevented).")]), _vm._v(" "), _c('p', [_vm._v("How do we know it is a drama queen’s car? When the car stops, the engine is still whining, that whinging sound keeps following us all day all night. How do we know the differences between a drama queen’s crying on social media and real crying? Drama queen starts crying when she logs in and stops crying when she logs off. Real crying happens when she logs off, and she stops her crying when she logs in. Do you know the sound of drama queen’s alarm and car? Boohooo… hoo… Her car is in tears when it runs out of gas.")]), _vm._v(" "), _c('p', [_vm._v("A drama queen does not need a shoulder to cry on but she needs a selfie and likes on her post to give her strength. In real life, you have seen someone crying and wailing totally over the top by hitting her chest or her head because the camera is on or she started wailing when she’s surrounded by people, but the crying stops when no camera or people are around her, that’s a drama queen. In social media, a drama queen had been practising how to cry before posting. After she is well rehearsed, she has her camera ready to post it on her social media. Warning: if a drama queen cries, there’s a big possibility your wallet will be crying, too (note: Lack of empathy and emotion are traits in narcissists and sociopaths).")]), _vm._v(" "), _c('p', [_vm._v("Perhaps many of us have seen this kind of post, “Leave me alone, me time, do not disturb.” It means, the whole world should know that you don’t want to be disturbed. Oh poor darling, it’s been a long and hard day for you so you have to post that sign ‘Do not disturb’. Yes, we feel for you. No, we don’t want to disturb your precious time. No worries, we’ll leave you alone… with a time bomb!")]), _vm._v(" "), _c('p', [_vm._v("But it will be more distressing for you if we really, really leave you alone, not a single like and comment on your post. Not a single like on your post will turn a drama pussy into a distressing pussy. Because when a drama pussy says “Leave me alone,” what you mean to say is, “Show me you care when I am alone.” Also another reason you post, “Leave me alone is,” is you are sad and disappointed because you did not get enough attention from a particular person or your followers as you expected. Typical of a drama queen, when you have a problem with one or two people, you will punish the whole world. Those ‘Do Not Disturb’ or ‘Leave Me Alone’ signs are just some of your attempts to get more attention.")]), _vm._v(" "), _c('p', [_vm._v("These days there are more interracial marriages than before, two lovers from two different countries and cultures tied the knot together. These days, you don’t have to go to Europe if you want to get married to a European man, just one click on your computer and you are connected to the world. When a drama queen married her Prince Charming, in her dream it would be like a Cinderella story.")]), _vm._v(" "), _c('p', [_vm._v("Love has no boundary, love conquers the differences. I know it sounds shallow but very few women chose to marry a man outside her country for financial gain or to get a green card or because they want to be in the elite club. Meanwhile for drama queens to have a husband from a foreign country means to upgrade their social status.")]), _vm._v(" "), _c('p', [_vm._v("“Look at me, I am married to a foreign man.”")]), _vm._v(" "), _c('p', [_vm._v("“Do you know my new surname? My surname sounds like a foreigner now, Dover. Yes, I took my husband’s name, Ben Dover.”")]), _vm._v(" "), _c('p', [_vm._v("“I live in a foreign country now, not in my village anymore.”")]), _vm._v(" "), _c('p', [_vm._v("“Did you see my house and my car in my new country on my social media?”")]), _vm._v(" "), _c('p', [_vm._v("Before you get married, you are actively seeking a foreign man to be your husband. You mention the reasons why you don’t want to date or get married with a local man, or your country man. You say men in your country have more expectations than a foreign man even though those local men have the same language and culture as you. No, you still insist on seeking a foreign man to be your husband, because it’s more fashionable.")]), _vm._v(" "), _c('p', [_vm._v("Finally, you have found your Prince Charming from a different country, he’s the one for you and it seems he’s so smitten with you. It is all like a fairy tale story, Prince Charming asks his Princess’ hand in marriage, you live happily ever after in his castle in his fairy tale country. Not exactly like a fairy tale story because your Prince Charming doesn’t have to fight a fiery dragon to rescue you, well similar to a dragon, your Prince just had to fight his fiery mother in-law who is more dangerous than a dragon.")]), _vm._v(" "), _c('p', [_vm._v("Then you live in this foreign country where everything and everyone is a stranger to you. The culture, language, food, weather, even their look is different. You have left your old friends and your privileges in your own country as a sacrifice to your marriage. Before you had a cosy job, now you are jobless. Before you married, you didn’t have to do anything, you just pointed your fingers to your maid to cook dinner for you, clean up the house and everything. In your homeland you had four maids that you paid so low to do housework, now you have to do it with your own precious hands. Oh… we feel for you.")]), _vm._v(" "), _c('p', [_vm._v("You were so spoilt before marriage, now after marriage you complain everything is different and stranger to you. You start wailing and whining on your social media how much of a burden you have now. You start comparing your homeland and your new country. Now you start complaining about the culture, weather, people and everything. You are more focused on lacking than blessings. More concentrating on what you don’t have than what you have.")]), _vm._v(" "), _c('p', [_vm._v("How many times we read complains like that on social media? Before you start complaining again about how poor and unfortunate you are now, so trapped in this foreign country. Let me remind you that you were fully aware in making a decision to marry a foreign man then live in his country under your conscious mind, not when you were in a coma. You knew these would be the consequences you would take when you married a foreign man. You know there are millions of people living in your homeland, working 24/7 for under one dollar a day, living in a shack, no electricity, no support from your government, yet they never complain and they still manage to find happiness and blessings in their extremely hard life.")]), _vm._v(" "), _c('p', [_vm._v("You say you’re not used to washing your clothes, iron them or doing the washing up. You must have blisters on your hands because of all that hard work for your husband and your family.")]), _vm._v(" "), _c('p', [_vm._v("“I used to have five maids in my homeland, no need to do house work. Now I have to do it all by myself, oh such a burden.”")]), _vm._v(" "), _c('p', [_vm._v("“I used to have a cosy job, well paid. Now I have no job, no friends, on top of that I am so tired looking after my two kids. Oh, I miss my homeland.”")]), _vm._v(" "), _c('p', [_vm._v("Not just about the housework, you complain about the culture shock and differences in your husband’s country:")]), _vm._v(" "), _c('p', [_vm._v("“Before I had so many people to cheer me up, now I am alone…”")]), _vm._v(" "), _c('p', [_vm._v("“I can’t do things I like, because the culture is different and the politics here suck.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t like the selfish culture and the leader in this country.”")]), _vm._v(" "), _c('p', [_vm._v("“Before I had everything, now I am so poor… I wanna go home…”")]), _vm._v(" "), _c('p', [_vm._v("But wait, there’s more, you start blaming your husband for bringing the mess into your life. Your husband is the one who should take responsibility for your loneliness, miserable and poor life just because you did all the house work by yourself, you didn’t have any friends, no maid, no high tea with friends in a trendy café and on top of that you didn’t like the politics and culture in your husband’s country. D’oh! Of course everything is different between your country and his country, you knew that before you came to your husband’s country. You may say you disagree with their politics, however you’ll be executed by the government or royal family in your country if you disagree with them.")]), _vm._v(" "), _c('p', [_vm._v("Is it a crime and a shame to you that you do housework like 99.99% of housewives in the world do? Your great-great grandma, your grandma, all women in any country and any culture do the housework and domestic chores. If you think it is insulting to do housework and get your hands dirty in the kitchen, it means you insult yourself as wife and a woman. To us, it is insulting if you put your ignorance first before love for yourself and your husband. You are full of yourself, you use tragedies and drama to manipulate us.")]), _vm._v(" "), _c('p', [_vm._v("Well, Princess, when you were single, you insisted on marrying a man from a foreign country. You knew you were going to face many big differences but you still wanted to marry a foreign man because it made your social status on your social media look good. If you keep complaining online, why didn’t you marry a man from your country who has the same culture, language, faith and religion that fit in so you wouldn’t have had these problems?")]), _vm._v(" "), _c('p', [_vm._v("These are the words that pussy dramas often say because you are hurt and mad, but as usual what a drama queen says doesn’t necessarily match the reality:")]), _vm._v(" "), _c('p', [_vm._v("“Fine!” You said this after we explained to you the real facts didn’t match with what you said. You put your hands up, your face is frowning, you didn’t want to see the proof and evidence that you were wrong. Fine is the translation for, “I have had enough of you. I don’t want to listen to you anymore!”")]), _vm._v(" "), _c('p', [_vm._v("“Sorry, I am standing in your happiness!” It is the translation for, “Is that all you get? I can give you the worst and you’ll be sorry!”")]), _vm._v(" "), _c('p', [_vm._v("“I hate you!” It means, “You hurt me.”")]), _vm._v(" "), _c('p', [_vm._v("“I was laughing hard reading your stupid comment!” It means, “You disappointed me, you make me upset because you don’t have the same view as mine.”")]), _vm._v(" "), _c('p', [_vm._v("“Correct me if I am wrong!” It means, “I’ve never been wrong and can’t be wronged. If you dare to say I am wrong, you won’t come out alive!”")]), _vm._v(" "), _c('p', [_vm._v("“That’s it, from now on I don’t want to ask you anything anymore!” It means, “You don’t give me enough attention. Now I want you to go down on your knees, beg for my love and attention.”")]), _vm._v(" "), _c('p', [_vm._v("“It is time to unfriend and say goodbye to my social media friends who never keep in touch with me. It’s nice to have known you though.” It means, “I am so disappointed and hurt that they never pay enough attention to me at all. They didn’t realise that I am so special and they will never, ever find a person like me again.”")]), _vm._v(" "), _c('p', [_vm._v("“Nothing!” you say in anger but your eyes get teared up. Because you say nothing, so we act like nothing happens. In a drama queen’s dictionary nothing is a translation for, “Yes, there is something bothers me. Can’t you see? I want you to act right now to give me all attention you have.”")]), _vm._v(" "), _c('p', [_vm._v("“Leave me alone,” If we leave you, you’ll be upset. But if we don’t leave you, you’re going to give us more of a hard time. In this case, the words you are searching for are, “I am having trouble to calm myself down. But please don’t leave me because it will be more hurtful if you really leave me for good.”")]), _vm._v(" "), _c('p', [_vm._v("Not all drama queens are women, when it comes to politics on social media, grown up men turn into the bitchiest sluts and the most bitter Tupperware ladies who act like a delicate little flower. Often we see you as a big muscly man and some other bullies are having pillow fights and nail polish fights over politics in social media. If social media came with a sound, we could hear these big tough men screaming like a little girl over politics. We can see the big differences between a big man wearing pants and panties in social media.")]), _vm._v(" "), _c('p', [_vm._v("These are what those men arguing on social media:")]), _vm._v(" "), _c('p', [_vm._v("“Don’t hurt me! You ruined my manicure and pedicure!”")]), _vm._v(" "), _c('p', [_vm._v("“Stop it! Give me back my lipstick!”")]), _vm._v(" "), _c('p', [_vm._v("“You are totally so wrong! Listen up, always, always a foundation first than the powder, not the other way around!”")]), _vm._v(" "), _c('p', [_vm._v("“I think you are so uneducated! Fake eyelashes are eyebrows extensions!”")]), _vm._v(" "), _c('p', [_vm._v("“No no no! It’s not true. Just wax your armpit, shaving your armpit hair would make it grow longer and more bouncy!”")]), _vm._v(" "), _c('p', [_vm._v("“You don’t deserve my lipgloss. I want my mommy…!”")]), _vm._v(" "), _c('p', [_vm._v("“Ohh… it hurts so bad! I am crying now. My mascara is smudged and my eyeshadow is falling apart!”")]), _vm._v(" "), _c('p', [_vm._v("“I disagree with you, a duck selfie is sexier than an egg holder mouth selfie.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes! I am proud of my big backside, so what. But don’t you ever… ever… call me a hairy ass.”")]), _vm._v(" "), _c('p', [_vm._v("“I am so broken hearted! You didn’t even notice I am wearing my glitter eye shadow! I think I am going to report you and block you!”")]), _vm._v(" "), _c('p', [_vm._v("“It is not a thong, it’s a brief! By the way, you wear your briefs back to front, Einstein!”")]), _vm._v(" "), _c('p', [_vm._v("“So so so wrong, all panties should come with a fortune cookie!”")]), _vm._v(" "), _c('p', [_vm._v("“No, I think what you mean is a fortune dick!”")]), _vm._v(" "), _c('p', [_vm._v("“You insult me by calling me a slut! And this is coming from a man with his eyebrows back to front!”")]), _vm._v(" "), _c('p', [_vm._v("“I am going home now! No one here compliments my tattooed eyebrows! Not even one!”")]), _vm._v(" "), _c('p', [_vm._v("“Stop fighting and screaming, girls! You’ve been throwing panties and lipstick at each other! Be a man! What’s this? You’ve been wearing my ballerina tutu, too? You all are so super evil. No one, ever ever touch my ballerina tutu!”")]), _vm._v(" "), _c('p', [_vm._v("Believe me, politics can turn a testosterone fight into a menopause fight. These big grown up men and so-called trolls are fighting to death about politics until their breasts are lactating. Pump baby pump! See, talking politics is making all big men scream in pain. Politics is like a man’s balls, they are very sensitive and private, they help you balance your body and the way you walk. However, if you squeeze them, you will scream in pain. A little advice to all drama dickheads AKA grown up men who fight tooth and nail over politics, don’t forget to use panty liner when you argue about politics because it makes you more comfortable, no leakage and more confidence. It comes with wings too so you are attached to common sense first of all, and you can argue with a fresh feeling and feeling clean without embarrassment.")]), _vm._v(" "), _c('p', [_vm._v("Because you always exaggerate and dramatise anything, you can’t really distinguish between the truth and the fake. In the end you see the fake as the truth and the truth as the fake. You see a simple thing as complicated and a big thing seems invisible to you. Hence, a drama queen is a soft target for a fraud or con, because drama queens can’t distinguish the real from the drama. When you laugh, your laughing must be the most distinguished one so everyone in the room must know you’re having fun. When you see the other table is having more fun than you, you have to compete with them by showing them that your table is more fun than them. Drama queen often thinks of herself as the life of the party.")]), _vm._v(" "), _c('p', [_vm._v("According to Psychology, drama queens are diagnosed by histrionic personality disorder (HPD). Behaviour may include constant seeking of attention or approval, self-dramatisation, theatricality, and striking self-centredness of sexual seductiveness in an appropriate situation. HPD may embarrass their friends and family by displaying excessive public display of emotions, passion, sobbing uncontrollably over a little thing or having a tantrum.")]), _vm._v(" "), _c('p', [_vm._v("HPD is diagnosed four times as frequently in women as in men. It affects 2-3% of the general population and 10-15% in inpatients and outpatients in mental health institutions. HPD exhibits excessive emotion to get more attention. They are not comfortable when they are not the centre of the attention.")]), _vm._v(" "), _c('p', [_vm._v("According to Psych Central, if you have five or more of these symptoms, you suffer HPD:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Self-centred, you are not comfortable when you are not the centre of attention or the life of the party.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Interactive with others often characterised by inappropriate sexually seductive or provocative behaviour (proven by the way they show their half-naked photos online).")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Constantly uses physical appearance to draw attention to themselves.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Rapidly shifting emotional states that appear shallow to others.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Your speech is excessive, impressionistic and lacking in detail.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Shows self-dramatisation, theatrically, and exaggerated expression of emotion.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Tendency to believe that relationship are more intimate than they actually really are.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Is highly suggestible (easy influenced by others) or circumstances.")])])]), _vm._v(" "), _c('p', [_vm._v("Paul Joseph Goebbels, a German Nazi politician and Reich Minister of propaganda quotes:")]), _vm._v(" "), _c('p', [_vm._v("“If you repeat a lie often enough, people will believe it, and you will even come to believe it yourself.”")]), _vm._v(" "), _c('p', [_vm._v("“Propaganda works best when those are being manipulated are confident they are acting on their own free will.”")]), _vm._v(" "), _c('p', [_vm._v("“Accuse the other side of that which you are guilty.”")]), _vm._v(" "), _c('p', [_vm._v("Wisdom from wise llama,")]), _vm._v(" "), _c('p', [_vm._v("“It takes 43 facial muscles to frown, 17 facial muscles to smile, and zero muscles just not to give a fuck. And you are happier when you don’t give a fuck.”")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "pregnant-selfie-and-post-baby-selfie-syndrome"
    }
  }, [_c('h3', [_vm._v("Pregnant Selfie and Post Baby Selfie Syndrome")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("We all know some of the pregnancy signs are morning sickness, tender and swollen breasts and mood swings. Not in cyber life, the pregnancy symptom is a nude selfie. The first nude pregnant photos were done in the 1980s, it was quite controversial then. Now, it is not controversial anymore, it is a part of fashion. You are not a part of fashion if you don’t take a nude photo of yourself when you’re pregnant. This is the time, your pregnancy is a part of your sexuality. Do not lose this moment, this is the time you show it to the world that being pregnant is sexy on your social media. Being sexy is number one, and the baby is the runner up. You rule!")]), _vm._v(" "), _c('p', [_vm._v("You look very good, I think pregnancy suits you. No, you don’t pose like Marie Curie or the Queen of England. You choose to pose in a very seductive way. You don’t wear a conservative maternity dress like in the Victorian era, you choose to wear a skimpy dress which is showing your baby bump and so much skin, even in a nude. Your pregnancy photo is very suggestive as if saying,")]), _vm._v(" "), _c('p', [_vm._v("“I know I am pregnant but I can still make men drool over me and make all the girls envious of me.”")]), _vm._v(" "), _c('p', [_vm._v("“I am pregnant, but the vacancy is still available.”")]), _vm._v(" "), _c('p', [_vm._v("“No one can stop me from seducing men, not even this baby.”")]), _vm._v(" "), _c('p', [_vm._v("“Pregnancy is not about the baby, it is about how good I look with this baby.”")]), _vm._v(" "), _c('p', [_vm._v("That’s what you think when you post your sexy pregnant and baby photos.")]), _vm._v(" "), _c('p', [_vm._v("This is what we think when we see your sexy photos showing your baby bump:")]), _vm._v(" "), _c('p', [_vm._v("“Swimming pool under construction, keep children out!”")]), _vm._v(" "), _c('p', [_vm._v("“Caution! Speed bumps!”")]), _vm._v(" "), _c('p', [_vm._v("“High visibility jacket must be worn for your safety!”")]), _vm._v(" "), _c('p', [_vm._v("“All visitors and drivers must report to the site office!”")]), _vm._v(" "), _c('p', [_vm._v("“Truck dumping area ahead!”")]), _vm._v(" "), _c('p', [_vm._v("“Temporarily under construction!”")]), _vm._v(" "), _c('p', [_vm._v("“Do not feed the crocodile!”")]), _vm._v(" "), _c('p', [_vm._v("“Safety helmets must be worn on this site all time!”")]), _vm._v(" "), _c('p', [_vm._v("“U-turn prohibited at all signals unless signed otherwise.”")]), _vm._v(" "), _c('p', [_vm._v("The baby was born, you share the most wonderful feeling that all mothers could have. We all are so happy for you, she is a beautiful and healthy baby. You post your bundle of joy on your social media. There are so many likes and congratulatory comments on your social media. What a joy!")]), _vm._v(" "), _c('p', [_vm._v("Less than one month after the birth, you go back to where you belong, attention seeking. How quickly you post your sexy body, a post-baby selfie. Those photos you post don’t seem like you’re enjoying motherhood but you are more enjoying the attention you get because you still keep your figure after birth. You are wearing your gym gear, sometimes you go topless. We can see you don’t have a baby bump anymore, like you never gave birth.")]), _vm._v(" "), _c('p', [_vm._v("This is what you are trying to say:")]), _vm._v(" "), _c('p', [_vm._v("“Look at me, I am still goddamn hot after giving birth.”")]), _vm._v(" "), _c('p', [_vm._v("“I am still a man magnet, not a fridge magnet.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, we’re open. Come in please.”")]), _vm._v(" "), _c('p', [_vm._v("“All cards welcome.”")]), _vm._v(" "), _c('p', [_vm._v("“Free test drive, no obligation to buy.”")]), _vm._v(" "), _c('p', [_vm._v("“Premium roasted peanut spread, crunchy on the outside and smooth on the inside.”")]), _vm._v(" "), _c('p', [_vm._v("“Location location, your dream house, close to all amenities. Lifetime opportunity.”")]), _vm._v(" "), _c('p', [_vm._v("“Full air-con inside.”")]), _vm._v(" "), _c('p', [_vm._v("This is what we think:")]), _vm._v(" "), _c('p', [_vm._v("“Danger! No smoking, switch engine off before opening fuel tank!”")]), _vm._v(" "), _c('p', [_vm._v("“Trucks and buses must use curb lane.”")]), _vm._v(" "), _c('p', [_vm._v("“Caution, nailing tool in use!”")]), _vm._v(" "), _c('p', [_vm._v("“Warning! Watch for falling debris!”")]), _vm._v(" "), _c('p', [_vm._v("“No through road, I’d go back if I was you!”")]), _vm._v(" "), _c('p', [_vm._v("“Notice site office if unattended ring for service.”")]), _vm._v(" "), _c('p', [_vm._v("“Protective footwear must be worn.”")]), _vm._v(" "), _c('p', [_vm._v("“Caution, heavy equipment crossing.”")]), _vm._v(" "), _c('p', [_vm._v("“Hearing and eye protection must be worn on this site when requested.”")]), _vm._v(" "), _c('p', [_vm._v("“In case of fire, break glass.”")]), _vm._v(" "), _c('p', [_vm._v("On social media, the pregnancy and post-birth is not about the baby. It is about the competition for how good you look when you’re pregnant and after birth. It is a competition, attention to you is number one, and the baby is second. Post baby syndrome in social media is a post-birth selfie, a very suggestive photo after birth. Another syndrome is you act like your newborn baby, your baby cries when she’s hungry and tired, meanwhile you cry too when you don’t have enough likes or compliments on your selfie. Also, you sleep like a baby, every two hours you’re awake and cry because someone else in social media has more likes and attention than you. For you, the more likes you get the more you can sleep better.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-recovery-photo"
    }
  }, [_c('h3', [_vm._v("The Recovery Photo")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("Attention, that is the number one reason for many of you to join social media. Not all, but plenty of social media users love receiving the attention from all over the world on their social media. Some celebrities have millions of likes on one photo without trying too hard or taking their clothes off to get attention, meanwhile many of us have to do something extreme such as bungee jumping in North Korea or going full frontal nude in your bathroom, doing a River Dance with King Kong or having a shower together with your brother and sister. I know it is sickening, but in the name of likes, you have to do extreme sport. But I know one extreme sport that men won’t do, which is complaining to their wife. Wow, that is a really, really extreme sport.")]), _vm._v(" "), _c('p', [_vm._v("In social media there are two kinds of attention, wanted attention and unwanted attention. You put your sexy photos on social media in order to get so many likes and attention, you want the attention. Many of you are in fierce competition to get the most attention. If someone else gets more attention than you, you’ll be unhappy and ask yourself, “What’s wrong with my photo, I have to beat her selfie.” This is why you put yourself in danger to get the most attention such as lying down on the train tracks, or you try to tickle a crocodile’s stomach.")]), _vm._v(" "), _c('p', [_vm._v("As much as you like the attention, this time you don’t want attention at all. Especially when you get so much attention from the police. The more you get attention and comments on your social media, the angrier you are. Why? Because you were in hot water. Before you took your clothes off to get the most attention, this time you put your orange uniform on with your number and name on. This cell-fie is taken by the police. No filter, no photoshop, no duck mouth. Actually, the police is the first one who invented a selfie, they used to take a selfie of prisoners. Selfie is taken from the words cell-fie.")]), _vm._v(" "), _c('p', [_vm._v("Before you loved getting so many compliments and likes, now you are grilled with questions by your followers and the authorities. Before you were blushing, now you’re having hot flushes, and it is not a symptom of menopause, but it is one of the symptoms when you are facing the backlash in response to your scandal. Before your fans commented on your selfie, “I’ll move heaven and earth just to be with a hot-looking guy like you.”")]), _vm._v(" "), _c('p', [_vm._v("Now the police call to you, “Don’t move! Hands up! Face down!”")]), _vm._v(" "), _c('p', [_vm._v("To get your good reputation back, you have to do something to save your credibility. If you don’t do this, it will cost you your job, your dignity, your pride, your many years of hard work, your endorsement, your fans and most of all, it will stop your money. Here are the suggestions to get your smooth reputation back, you may post these photos:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Your baby photo, the photo that melts everybody’s heart such as when you were smiling or laughing sitting on Santa’s lap or your mother’s lap. No, not that photo of your mother on Santa’s lap and you’re on the reindeer.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Kissing any children or any baby if you get a chance. Get the cutest baby, go and kiss her or cuddle her. Make sure that baby smiles when you kiss her, don’t make her cry. This photo will make you look good. As if you’re telling the world, all babies love me and you should too. You should make those children and baby smile when they’re around you. To make them smile and be happy, tell her, “Hey kid, here’s $10 to buy lollies and ice cream. Now please smile for my photo.” Don’t get it wrong, the baby takes bribes too, you know. Never underestimate the baby, they are smarter and more organised than we think.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You are doing charity. Such as feeding the animals, squeezing the milk out of cows, helping the elderly to cross the road, teaching the Playboy bunnies how to do math so they can count how many ears they have. Telling the camels how good they look with those humps, cuddling a koala and telling that koala, “Just shut up and pretend to be happy.”")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Giving donations to those in need. Some people are really desperate to have shoes, such as a former first lady from some Asian country who needs more shoes. Giving food to those people who are struggling on daily basis such as super models and catwalk models. They need shelter and food as they don’t eat properly.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Go to the church or pose yourself praying or go up a mountain doing some meditation. Do this, this will help your image. Post some quotes from Holy Book or act as if you were reborn again, a ‘new you’ that is more innocent than a baby. If needed, mention the word God, as if you’re the chosen one from him. By mentioning the word ‘God’, you have a reason to punish and attack anyone who disagrees with you on social media, as if God is angry at anyone who disagrees with or disapproves of you.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Pretend you are really ill, in bad health or you have suffered some syndrome. To gain more sympathy from your fans and people, post a photo of yours on social media. Make sure you put some make-up on but not to look glam and pretty, but do some make-up to make you look more pale, sick and frail or bruised. If needed, put some bandages on your head, arms, your wallet and anywhere you want. This photo will protect you from any harassment and attacks from other social media users. It is a sin to attack a sick person, regardless of what that sick person has done.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Support some charity or foundation, not for a good cause but for your good reputation. Or find someone who has experienced an unfortunate event or is in bad health. By pretending you support them, you will reduce the amount of attacks from enemies.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Mental breakdown, trauma and bad childhood. If needed, go to rehab. Pretend you can’t recall the incident, say that it was a drug which caused you to misbehave. Or you were experiencing some panic attack, you couldn’t think or act with common sense. Or blame the food you ate. “I experienced delusions, hallucinations and nausea after I ate the grass in my backyard. I don’t go to the restaurant, I go to the park to eat the grass. I only eat greens.”")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("If paparazzi are chasing you around, you must address your issue at a media conference, get a baby and carry him up during an interview or bring all of your young children and grandma too. By having your family there, especially with your infant son and your frail grandma being present, media would think twice if they want to ask you some hard questions.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Change your name and leave town.")])])]), _vm._v(" "), _c('p', [_vm._v("You posted your photos holidaying with your new boyfriend, partied on, shared your intimate photos with him on your social media, meanwhile your underage children who still need your attention and care are at home with the nannies. After you posted those photos, within seconds you are under attack from every direction, they label you a bad mother and an irresponsible mother because you left your underage children who still need you just to party and have fun with your new boyfriend for days.")]), _vm._v(" "), _c('p', [_vm._v("Here is what you should do, post your happy snap with your children often, after that incident. This is like a response as if you didn’t forget your duty as a mother. Put a caption “My children are the life of my life,” and, “Love spending time with children.” This will work, even though in reality you spend more time on your smartphone checking your social media.")]), _vm._v(" "), _c('p', [_vm._v("For a high-profile man who is in hot water, the paparazzi just caught you canoodling with another woman, not your wife. As you expected, your social media was flooded with angry comments. Here’s what you should do, post some photos of you helping the homeless or earthquake victims. Post the photos when you were carrying a bag of food and medicine for those who lost their homes due to a massive flood.")]), _vm._v(" "), _c('p', [_vm._v("The recovery photos will divert the attention from your mistake to something else which is the good side of you. As if you were saying, “I know I slept with someone else’s wife and use illegal drugs, but you should judge me from the good things I’ve done.” We know no matter what you’ve done in the past or no matter how many charities you do, when it comes to a crime it is a crime, it doesn’t mean you are immune from the law when you make a mistake. Justice is justice, the law is the law, moral is moral.")]), _vm._v(" "), _c('p', [_vm._v("We know you did good things in the past but to use those good causes to protect your mistakes is a big mistake. Mistakes shouldn’t be protected. You play with fire, you know what the consequences are, don’t complain if you get burnt and are in pain. All good causes are for humanity, a good cause is not to protect your sins, or for your ego to make you look good by using tragedies and starving children.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "unfriend-and-friend"
    }
  }, [_c('h3', [_vm._v("Unfriend and Friend")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("According to the dictionary, a friend is a person with whom one has a bond of mutual affection, typically one exclusive from sexual or family relations. There’s a saying, if life is war, friends are our best allies. They are the ones who come, help and support us to beat enemies and when we need support. They are the ones who patch up our wound because we’re wounded by enemies, they’re the ones who are there for us when we win and lost. There are three words to make a friendship great: honesty, trustworthy and respect. To make friends we have to be honest, trustworthy and respectful.")]), _vm._v(" "), _c('p', [_vm._v("According to science, there are 13 scientific facts about friendship:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Animals have best friends too. Many studies show baboons, cows, chimpanzees, horses and dolphins, and even whales have best friends.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("In a lifetime, you make 396 friends, but only 1 out 12 friendships survive.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("No friends can be dangerous to your health.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("A 2004 study published in American Sociology Review states the average number of trusted friends fell by a third in the last 20 years. In the same duration, people with no confidante have doubled.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("It is the friendship that makes a marriage last.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("When faced with a major illness, a person with good friends are more likely to survive.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("When you are in danger, your brain and your friends’ brains react the same.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("It is scientifically proven that when you are stressed, the company of good friends can reduce your stress in life.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Close friends share 1% of DNA.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("There’s a saying, a friend is the family we chose, with genetically the same closeness as fourth cousins. Research by University of California and Yale University.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Your best friends influence your diet. If your best friends eat junk food, you are more likely to eat junk food too. If you eat healthy food, your best friends will eat the same too.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Our best friends are just like us. In most cases, you and your best friends share the same identity for other friends and social circles.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("When friends have problems that disappoint them, if we are there for them, it makes the friendship stronger and stable. Dr Charity Fiesen called this the ‘if-then’ profile. Knowing friend’s reaction when she faces difficulties is as important as knowing their tastes.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Friendship is the emotion babies recognise even before they start talking or walking.")])])]), _vm._v(" "), _c('p', [_vm._v("Once upon a time, our friends were real, we could see them, touch them and talk to them face-to-face. Now, we don’t see them face-to-face, we can’t touch them, we can’t talk to them, but we store all of them in our smartphone. This is what we call social media, cyber life. Well, we can see them and talk to them via some apps, but it is not the same as face-to-face conversation. All we see is filtered, we can’t really see your real face as you filter your face too much even though we can see your video. When we talk to you via some app, we can see your face but we can’t see your full body. I don’t know if your legs touch the ground or not or if you have four knees.")]), _vm._v(" "), _c('p', [_vm._v("We know for sure that all of the photos we see on social media are not necessarily presenting the real face. That means, we all know that you don’t look exactly like your photo. In real life we can touch our friends, see them without filters, we know exactly how they look and their body language. However, everything that we can touch, see and smell doesn’t guarantee us a happiness.")]), _vm._v(" "), _c('p', [_vm._v("Sometimes we feel so distant from someone who lives in the same house with us but we feel so close to someone who lives on the other side of the world. Sometimes we feel alone and lonely in a crowd in real life. We can see, talk and touch them but we feel we don’t belong and we are not accepted. Meanwhile some friends whom we met online, we never touch them, never see them in real life but they show more support and respect towards us even though we can’t touch them or even ever see them at all in real life. What we can touch doesn’t mean it can touch our heart, what we can’t touch sometimes touches our heart and gives us happiness.")]), _vm._v(" "), _c('p', [_vm._v("In saying that, real life can make us feel so lonely and like a stranger, while we feel we belong and are accepted in cyber life. Hence why many of you are attached to social media. Somehow you are more connected to cyber life than real life. It is the cyber friends who make you addicted to social media. The love, the reunion, the friendship, the support, the help, the make ups and the break ups, the hate, the gossip, the dramas, the enemies, the allies, family, the exes, mother in-law, ex mother in-law, the new friends, the old friends, all in one postcode: social media. Regardless of those, the first reason we check our social media so often for is our close friends. For narcissists, the first reason they check their social media is not the friendship but counting how many likes they got apart from checking what their rivals are up to.")]), _vm._v(" "), _c('p', [_vm._v("There are lots of things that divide and reunite friends in social media. Three things that are a very obvious reason to break up the friendship and form a new group of friends: politics, religion and money. Yes, I know it is a very delicate subject but religion, politics and money will test how strong your friendship is with your friends. Also there are some factors to break or make up with a friend, one of them is the love triangle. For example, you are in love with him, but he is in love with your best friend, and your best friend is in love with you, but you’re not in love with your best friend, you’re in love with him, but he is not in love with you because he’s in love with your best friend, and your best friend is not in love with him but she’s in love with you, a love triangle, that goes on and on and on. Confused? Yes, me too.")]), _vm._v(" "), _c('p', [_vm._v("However, there are many friendships that survive despite differences because they embrace and respect the differences amongst them. First of all, because they have emotional maturities to focus more on how to work together to appreciate the value of life rather than focusing on the differences, lacking, mistakes, hates and pointing out each other’s faults.")]), _vm._v(" "), _c('p', [_vm._v("The good old days when you didn’t like your friends, you just decided that you don’t see them anymore, that’s it. That was the solution. Or perhaps you’re still seeing your friends not because you want to but because you’re being polite, you still talk to them but you keep your distance. Some people might say, “Oh, you’re being fake.” No, it is not fake when we choose to be polite, choose not to hurt one’s feeling and be well mannered. Fake is, you are so sweet as candy in front of us but behind us you stab us in the back, you become the cutest cuddled soft toy in front of people with money or position, but you are so cruel and rude to people who don’t have money.")]), _vm._v(" "), _c('p', [_vm._v("A friend of yours shows you a picture of his girlfriend, the first comment from you is, “Wow, aren’t you a lucky man. She is beautiful.” Regardless of that your mind says otherwise. Why? Because we chose to be polite and to be an adult, because we don’t want to hurt the feeling of our friend. Being fake is when you choose to pretend to be someone else. Being fake is, you choose to lie to make yourself look good, you choose to be helpful because you want something in return, you act super nice to wealthy people and act super low to people who live in poverty, or you overdramatise anything by lying and being hypocritical. That is a fake person.")]), _vm._v(" "), _c('p', [_vm._v("In real life, you will call a Cop if you are afraid and being threatened by someone who has been stalking you, or if the case gets worse you issue a Restraining Order. In cyber life, you don’t like someone, easy: unfriend. You get hurt because your social media friend gets more attention than you: unfriend. You disagree with your friend: unfriend. Your friend and you have differences in politics: unfriend. You are chased by someone because you owed her money: unfriend or even block. Anything that you are not happy with your social media friend: unfriend.")]), _vm._v(" "), _c('p', [_vm._v("You want something from someone: send a friend request. You see someone hot: send a friend request. You see your crush: send a friend request. You see a successful person: send a friend request. You want to borrow money: friend. You want to stay in touch with that person: send a friend request. She is special to you: friend. Your friend’s spouse is hot: send a friend request. You always disagree with some people and find them difficult to deal with but there’s nothing you can do: family. You are a part of them because you love them: family. If you unfriend family, it means the inheritance will unfriend you.")]), _vm._v(" "), _c('p', [_vm._v("There’s a saying, if you don’t have anything nice to say, don’t say anything. This has been taught from generation to generation. Not in cyber society, bullies tend to say things to hurt or to downgrade someone. Bullies are fake, they become a bully to compensate for being insufficient, unhappy and insecure in real life.")]), _vm._v(" "), _c('p', [_vm._v("To give feedback is not bullying or downgrading. Feedback is the response you get because of your actions, tasks, performance etcetera which is used as a basis for improvement, according to Oxford dictionary. Feedback is positive, feedback is to motivate you to perform better with a solution. Bullying is offering you nothing but negativity and designed to knock you down and punish you to make you feel bad about yourself.")]), _vm._v(" "), _c('p', [_vm._v("To give feedback is because that’s what friends are for, or because we care, feedback in friendship is making the bond stronger. To bully is because you feel so superior to others, to intimidate the relationship. A bully will threaten others to unfriend if friends disagree or don’t compliment the bully or ignore the bully’s demand. You don’t do as I say, I unfriend you, is bullying. Just like a dictator, if you say something against the dictator of the country, you will be jailed, and killed eventually.")]), _vm._v(" "), _c('p', [_vm._v("Good examples of positive feedback is, “You have provided details to customers, also you give customers some options when the product is not available, they are very happy with your service.” In everyday life, your wife sometimes gives you some feedback, “Darling, the sex was fantastic. Perhaps if you didn’t turn my body over roughly like you turn the steak too many times, it would’ve been more moist and tender, perfect.” That’s feedback. A bully will not give you a positive outcome but he will belittle you such as, “You are ugly and don’t fit in this society.” That’s the bully. You should stay firm and take action to stop the bullies AKA the cowards, unfriend and reporting is good feedback for the bully.")]), _vm._v(" "), _c('p', [_vm._v("If a dog attacks you it means he unfriends you, that’s the dog’s feedback. If a dog is approaching you and licking you, it means either he sends you a friend request or you look skinny like a bone, or both. If you see a beautiful girl on the street then you send her a friend request by saying, “Lovely tits!” In a second you feel her shoes in your face, it means you got a dislike, unfriend. In social media, girls show their tits on purpose just to get that feedback, “You’re hot!” Girls do that to get the most friend requests as she gets. There are many girls on social media who use their sexy photos just to make the followers stay in touch, let’s be friends. Same as to friend and unfriend, that is the feedback in cyber life.")]), _vm._v(" "), _c('p', [_vm._v("To see some people send you a friend request is boosting your mood and making you feel happy. But sometimes you have suspicions when you see a notification from someone you don’t know who has sent you a friend request. You open your wallet, then you see some girls smile at you, they want to send you a friend request. You open your Ferrari car door, some girls flirt with you, it’s a friend request from them. One of the reasons you are reluctant to have more friends outside your inner circle in your social media is because you are happy as it is now, or secondly because it could be the FBI or your mother-in-law sending a spy to spy on your social media.")]), _vm._v(" "), _c('p', [_vm._v("Doctors and scientists don’t unfriend people with health problems, in fact people come to see a doctor when they have a health problem. Scientists always try to find the answer for the problems, they solve the problems by learning about the disease, examining it, doing much research and trials, and doing much research to get the answers and cure for the disease. If engineers unfriend the problem, they would’ve never innovated a smartphone like these days so you can selfie. Why are some people smart? Because they face the problems to solve the problems. Because they are smart, the complex problems become so simple, the problems challenge them to be more innovative and smarter. Meanwhile some people in the cyber world, and real world, run away from the problems.")]), _vm._v(" "), _c('p', [_vm._v("These are the major reason for break ups AKA unfriending and blocking amongst social media users:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Differences in point of view, especially in politics and religion")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Money")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Heartache")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Lies")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Envy")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Bullying")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Stalking")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Violence")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Being two-faced, manipulative, Machiavellian and a backstabber")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Not the real person, a fake social media account")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Weird personality")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Betrayal")])])]), _vm._v(" "), _c('p', [_vm._v("The reasons why you unfriend your friend or out them from your group:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Differences in point of view")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("The election is on, he chose to vote for a person you don’t like so it is time to unfriend him")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You just split from your lover, and are still broken hearted and in pain. To punish her, you unfriend her")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You envy her because she is very beautiful and has so many male admirers or she is more successful than you")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("The conversation in the group is a one-way street, if you show disagreement with them, you will be bullied and harassed")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("There is a hierarchy in the group you’re in. This group has a system where members are ranked according to their importance. The most important members in the group have absolute power. There is the upper class, middle class and the lower class in your group")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You unfriend some people because they are full of themselves, narcissists and such drama queens. Craving attention and compliments. Everything has to be a big announcement, such as love, a relationship, career, achievement and so on. Too much flaunting of wealth, too much animation and gimmicks, and how great she is. For a drama queen, you unfriend her because her wall is like your old car. Constantly whinging, always had problems, always had something to fix or broken, the battery is dead, sometimes the honk didn’t work so you have to use your mouth to beep.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("He is racist and discriminative.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Money. You borrow money from him, you didn’t want to return his money so you unfriend him or the other way around. You lent him money but he did a runner when you asked him to return your money, he unfriends you. Or someone uses you for money and takes you for granted.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Inheritance, family rift over wills.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You unfriend some friends because they are in your enemy’s friends list. In your mind if someone is friended to your enemies, it means she is your enemy, too.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Machiavellian, she is so sweet in front you but talking bad about you behind your back")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Because they don’t give enough attention to you online, not even a like! How dare they after you approved their friend request. In your mind, everyone must say hi to you online, if not, it is time to unfriend. It is about you, you and you, the give me, give me mind set. If morally right, if you are a good person, you don’t make a demand from anyone but you give respect and understanding. You should be the first to make a move, go and inbox her, ask her nothing but wish her all the good health after so long where she is not online. Never make a demand for anything from anyone, also from anyone who doesn’t keep in touch with you online as long as she’s in good health and happiness.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You unfriend your cyber friends because they are not on the same level as you are. It could be social status, economy, profession, and many more reasons. You only make friends with people who come from well-to-do family or a high-profile person.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You didn’t get invited by them, you’ve been abandoned and left. You are angry and hurt, then you decide to unfriend them.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Your group is full of drama queens, whinging and whining all the time. Always talking about people’s faults, how much money they have and always playing the victim card. That’s why you’re out from them.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Some people know you are up to no good, before you get busted you’d better unfriend them. Or you know they are up to no good, you decide to unfriend or out them for good.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You use a fake identity, before one of your friends finds out, unfriend them. Or you know he is not a real person, he uses a fake account.")])])]), _vm._v(" "), _c('p', [_vm._v("The reasons why you get unfriended from a person or a group:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Different points of view")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("The election is on, they unfriend you because you voted for a candidate that they really hate")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("She is no longer your girlfriend, that’s why she unfriended you")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("She is so envious of you, because you are everything that she dreams of but she can’t have")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Because you become angry when anyone disagrees with you, so they unfriended you")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You think you should be the leader of the group, you get upset and disgruntled when they didn’t appoint you as the admin of the group")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You make a racist and discriminative comment")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Money. You ask her to return your money that she borrowed, she disappears and blocks you. Or you took money from her, because you don’t have any intention to return her money, you do a runner and block her.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Inheritance. Some family members think they are entitled to have more inheritance, not you")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Narcissistic, too much bragging about how great you are, how wealthy, how successful you are and how fantastic your life and love is")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Because you make friends with his/her enemy or ex-lover")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You are a Machiavellian, you are so sweet in front of them but behind them you stab them in the back")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Because you don’t give her enough attention on her social media, not even a like. She hates it when you ignore her, she wants to be the centre of the universe which she doesn’t get from you, thus she unfriends you")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Because you are not on the same level as her, it could be due to social economy status or a profession. Or she knows you belittled her because her economy level and profession is not up to your standard. To keep her dignity and pride, she unfriends you because you don’t have moral values")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You didn’t invite her to your party, she is so upset by this")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You are up to no good, they know it or they are up to no good and you know it. Before you become a whistle blower, they unfriend you.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You are not real, you use a fake identity to play them off against each other or to manipulate someone. Or he uses a fake identity, the moment you find out he’s not real, he unfriends you.")])])]), _vm._v(" "), _c('p', [_vm._v("What about blocking someone? It means, it is a restraining order. All doors are closed. In the court system, it means no going back, the verdict is down, you lost your last appeal. Your parole has been rejected, sorry. Unless you get a pardon from the President.")]), _vm._v(" "), _c('p', [_vm._v("Imagine if social media was used from a century ago, there would’ve never been a war. The soldiers just used unfriend, report and block. No ammunition needed, because in the cyber world emoji is more powerful than a nuclear weapon.")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God, Hitler declared to attack Russia. Everyone report and block him now!”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, General, we have reported Hitler’s social media account then blocked it.”")]), _vm._v(" "), _c('p', [_vm._v("“Did you see so many dislikes on Genghis Khan’s post? He just invaded next door villages and took all the hot chicks with him!”")]), _vm._v(" "), _c('p', [_vm._v("“This is hot news, Marilyn Monroe gave the President a big kiss emoji. Who’s going to retire now, wow.”")]), _vm._v(" "), _c('p', [_vm._v("“This photo went viral, China has invented paper. So we don’t have to chip on rock or write on leaves anymore!”")]), _vm._v(" "), _c('p', [_vm._v("Do most couples block each other when they break up? Some media users block their exes. Why? Because he/she still loves the ex-spouse but the pain is still there. It is a confusing feeling, you want to block him because of the pain he gave you but if you block him, you’re going to miss him. You hate but love, love but hate. You block him to make him realise what he’s been missing, to make him realise that he’d better beg for your forgiveness and love before it is really too late. I know many of you will disagree, but the reason you block an ex is because you still love your ex. But some people didn’t block their ex, they say they’ve been hurt, heartbroken, promise not to be in love again, love hurts, but they don’t block the ex-spouse. You say you close all the doors but you always leave one door open. Why? Just in case, you know what I mean. Leave one door open for air circulation. To put it this way, on Christmas Eve you don’t block the chimney to let Santa in so he can leave a present secretly for you.")]), _vm._v(" "), _c('p', [_vm._v("If you want to know the personality of a person, take a look at her friends. Usually (not all) they share a common personality. If her friends are handbag maniacs, there’s a possibility she is a handbag maniac, too. If her friends are selfie psychos, there’s a possibility she is a selfie psycho, too.")]), _vm._v(" "), _c('p', [_vm._v("These days, how to test your friendship: election day, religion and money. Will you unfriend your friend because he votes for and supports your least favourite political party? Will you unfriend your friend when you know he has no money at all? Will you stay friends because you know you want to borrow money from your friend? The answers are with you.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-make-ups-and-the-breaks-ups-on-social-media"
    }
  }, [_c('h3', [_vm._v("The Make Ups and the Breaks Ups on Social Media")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("What is the main reason for divorce? Marriage. If there is no relationship, there won’t be any break up. Does social media influence a relationship? This is like asking an obvious question whether a porn star is a virgin or not.")]), _vm._v(" "), _c('p', [_vm._v("It started when you join a conversation with your friends on your friend’s wall. There’s one of your social media friends who replies to your comment. She’s not in your friend list but she is a beauty. Just one comment from her, it sends you off to the moon. When she likes your comment, you can’t sleep. When she writes she agrees with you in her comment, you can’t remember your name, ohh you feel so good. When she says you look fine, you can’t speak English anymore and you treat everyone in the pub to a free drink, you are more excited than a man on the moon.")]), _vm._v(" "), _c('p', [_vm._v("This is too good, you can’t let this beauty go. This is the moment, you lose it or you use it. You pretend you ask her something, just to continue the conversation. This time you are not pretending, you inbox her telling her that she is special, surprisingly she’s flirting back. You send a friend request to her, she said yes! Sounds like a marriage proposal but it is not exactly.")]), _vm._v(" "), _c('p', [_vm._v("Now every time you open your eyes in the morning, you check your social media. Your hand is brushing your teeth and the other one is checking your social media. While waiting for a bus, you’re texting her just to say, “Good morning, beautiful.” All the way to the work, you keep checking your social media waiting for her to reply. First minute after you enter your workplace, you check your social media. You knew she would reply, your eyes lit up when she inboxed you saying, “I miss you, handsome.” Just one sentence, it is more powerful than a dozen Viagra for you.")]), _vm._v(" "), _c('p', [_vm._v("A milestone moment, you change your status on your social media from a single fighter to a guitar hero in love. Yes, love motivates you to pick up your guitar and sing a love song. Love makes rain so good, wet is good. Love makes sunshine look like a supernova. Love makes you wake up in the morning like a Lazarus rising. You look forward to getting up in the morning and starting the day. Vitamin L for love is more energising and powerful than Vitamin C. When you’re in love, soy sauce will taste like a fine wine, a stool will taste like a chocolate, love is blind. When you are in love, you dream more than you work, you agree more, you smile more, suddenly all the love songs are dedicated to you and her. It’s a two-way street, she feels the same, how good is that.")]), _vm._v(" "), _c('p', [_vm._v("Just like fishing, you have to throw bait till you get a fish. Keep throwing the baits and wait till you feel you catch something. The thrill when you know you’re about to get a good fish. Take a photo of it, share it on your social media. Cherish the moment like you just scored a goal for your soccer team. You are running around the soccer team, putting your hands up in the air, screaming ‘goaaallllllll’… the soccer fans in the stadium go berserk screaming ‘goaall’… Celebration all day, all night, a week, even a month. After a month, and then what? You don’t keep running in ecstasy and screaming at the top of your lungs ‘goallll’ all the time throughout the year. As time goes by, the thrill slowly fades too. Before you get up and look forward to her message, now you get up and look forward to getting a payday.")]), _vm._v(" "), _c('p', [_vm._v("Just like fishing, after you get your favourite fish you don’t need to keep throwing more bait, do you? Because you have it in your hand. Just like fishing, before not a single fish approached you. But the moment you caught a very good fish, suddenly out of the blue all the good fish swim around you begging to get hooked by you even though you didn’t throw any bait at all to them but they want you… Temptations online, now it seems more beautiful girls are flirting with you after you change your status from single to a soldier of love. If this were a property business, your status before was ‘for sale’, but now is ‘deposit taken’.")]), _vm._v(" "), _c('p', [_vm._v("Your girlfriend starts to get jealous, she asks you and inquires more about all the beautiful girls on your social media. Who’s that, who’s this, why does she like your photo, why did you reply to her comment, why do you also like her selfie etcetera. You act the same too, you ask her why there are these good-looking roosters on her social media, why she keeps posting her suggestive photos online as if she is still in the market, knowing she is in a relationship with you now.")]), _vm._v(" "), _c('p', [_vm._v("The jealousy keeps you distant from her, before, the moment you opened your eyes in the morning, you checked your social media for her. Now you wake up in between your sleep just to check how many girls inbox you. Sometimes you reply to another beauty before you reply to your girlfriend. She is angry at you and so you are at her, it is a mutual feeling.")]), _vm._v(" "), _c('p', [_vm._v("Before, you looked forward to chatting with her, you used to spend hours and hours just chatting about anything because everything with her was precious. Now she gives you the silent treatment, you ask her, “What happened?” She said nothing so you act like nothing happened. The cracks start to appear in your relationship.")]), _vm._v(" "), _c('p', [_vm._v("Before she posted how happy and blessed she was with you, now she keeps posting some wisdom or some quotes in life not to share, actually those posts are aimed at you. In most cases, the more angry and upset a person is, the more she keeps posting online, or the more she becomes more flirtatious with other men because she’s angry at you. Women are more visible when they are upset, they tend to express their feelings more on social media while men are more unpredictable. However, there are many cases too when men are more obvious in expressing his emotion because he is hurting.")]), _vm._v(" "), _c('p', [_vm._v("How many times do we see a social media wall is filled with posts and quotes solely dedicated to an ex-spouse? How many times do we see a couple fight online, and their walls are full of posts which are attacking each other? In the good old days a couple would fight behind closed doors, now many of them fight online, they bounce back at each other, not with good vibes but the opposite. They still talk to each other, not face-to-face but from wall to wall, her status update and his status update. This is one example:")]), _vm._v(" "), _c('p', [_vm._v("“Life is better without a man with no conviction.”")]), _vm._v(" "), _c('p', [_vm._v("“She has breast implants, a Botox lips, a Botox face, she photoshops and filters her photos all the time… and she is asking for… a real man?”")]), _vm._v(" "), _c('p', [_vm._v("What are the online signs a former spouse still has strong feelings for you?")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("When a couple is falling apart, the first person who unfollows or unfriends is the one who has the stronger love and emotion")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Suddenly your ex posts a song, poem, photos of you and your ex’s favourite place, and anything that has a sentimental attachment for you both, anything that used to be so special for you and your ex")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Look at your ex’s social media status update, the more she shows emotions, aggression, anger, and the more extreme it is, that is a stronger indication your ex still loves you, to compensate for feelings and the fact that she can’t get you out of his/her mind. The more your ex finds it difficult to stop loving you, the more your ex hates you and blames you")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Suddenly your ex’s social media is full of wisdom quotes, not because your ex has found peace, but because your ex can’t find peace after breaking up with you. Those quotes are dedicated to you")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Mirroring you."), _c('br'), _vm._v("Whatever you do, your ex will post that he/she gets the better one than you. You post your photos of the happy moments when you’re attending a party. Your ex will follow you by posting that your ex is happier and having more fun with more people. You post a photo with two beautiful girls, next hour your ex posts a photo with a dozen good looking young men")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Your ex maintains a relationship with you."), _c('br'), _vm._v("Even though your ex unfriended you but she still leaves one door open for you, which is her giving you a chance to send her a friend request again. She wants you to beg her that you want to be with her again. There are cases where your ex doesn’t unfriend you even though she is no longer your girlfriend. Just in case in the future you change your mind because you are still in his/her mind.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Your ex still maintains a relationship with your family or your friends."), _c('br'), _vm._v("Even though you are not a couple anymore, but your ex still keeps in touch with your parents or your friends, still sending them a Christmas card, birthday card to your mother and father. Why? Because even though you are not with her anymore but by keeping in touch with your inner circle it makes your ex feel closer to you, because you are a part of them")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Your ex wants to be your friend."), _c('br'), _vm._v("Not just being a friend, your ex wants to be your best friend. “Can we be friends?” Even though your ex already has a new love but he is still completely in love with you, there’s always time for you, no matter how busy your ex is. You are still a part of his life because your ex still loves you. When you see a couple broken up but they still keep in touch, it’s because they still love each other. How many times do we read social media status update, “We are a modern family.” Yes, they may say they are a modern family now but the truth is, ain’t no such thing about modern lust or ancient lust. Admit it, the sparks are still there."), _c('br'), _vm._v("“We are a modern family.” Yes, we hear you. We understand you and your ex still keep in touch because you and your ex have mutual respect, it is not impossible to still have a mutual fantasy about each other…? However, there are many couples who have moved on but still are in touch because they share children together.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Your ex tries to compete with you."), _c('br'), _vm._v("If you are just in a new relationship, your ex did the same, got a new love too. If you post your photo with your new love, your ex will post many photos of him and his new love looking more intimate, more passionate and more in love than you and your new boyfriend as if telling you that he is happier and madly, deeply in love with his new squeeze."), _c('br'), _vm._v("\nWhy did he constantly post his intimate moments with his new girlfriend? The truth is your ex is still deeply hurt. The truth is better than fiction, in some cases jilted lovers did extreme things just to compete with an ex-spouse. Why? To make you feel like a loser and your ex is the winner. For example: you just got engaged with your new love, suddenly you heard the news that your ex just got married. Your wedding is very simple, low budget and very private. Your ex’s wedding is more simple, lower budget and more private than yours.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Your ex is bragging about his new life, a happier life, how successful he is, his achievements, and he keeps posting about how fantastic his new love is. He keeps posting how proud he is with his new girlfriend, sharing an intimate photo together, telling everyone that she is the one, she is the only one he truly loves, he has never been happier since he met her and all that romantic crap. Why? Because he is still hurting, the fact is he is not happy, he is still in love with you, he can’t stop loving you but you are not his girlfriend anymore or you have moved on. The more hurtful he is, the more he is bragging about his happy life and new girlfriend. The difference is, you are very careful to post a photo of you and new boyfriend, but your ex is not shy to show off his new girlfriend to the world. You don’t post photos of you and your new love together but there are some photos tagged which proved that you have a new boyfriend while your ex didn’t have a tagged photo of himself and his new girlfriend, but he posts the photos of him and his new love by himself on his social media. Why? He wants you to see his post, and tells you, “This is what you missed out. You should regret it that we are not together anymore.”")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("He moves on too quickly."), _c('br'), _vm._v("Suddenly he has a new girlfriend too quickly or been seen with too many girls. This is the way he copes to deal with his stress after the break up with you.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Your ex completely cuts all ties with you.\n\n\n"), _c('br'), _vm._v("You are no longer in his social media friend list, he returned all your belongings, he removed you from his mailing lists, his social media group, he even unfriended your friends on his social media. If he deletes your photos on his social media first, it means he still has a strong feeling for you. The one who doesn’t have a feeling towards an ex-lover usually doesn’t give a damn, if he deletes her photos, she doesn’t give a damn. If he blocks her, she doesn’t give a care. She just goes with the flow, no harsh words towards the ex but kind words to wish him luck.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("He is not moving on."), _c('br'), _vm._v("\nJust like the song "), _c('em', [_vm._v("Nothing Compares to You")]), _vm._v(". That’s why. He is still devastated by the fact that you and he are not together anymore. He wants to mend a relationship with you, everything is not the same without you. He wants you back.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("There is always unfinished business."), _c('br'), _vm._v("\n\nHe keeps mentioning there are still some problems that he needs to address with you because he wants to finish the problems. He always says, “We need to talk.” He keeps explaining the problems between you and him, in some cases your ex is begging you to talk with him just because, “I need to clear everything up, our problems are not finished yet.”")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Your ex changed her appearance."), _c('br'), _vm._v("She cut her hair or has a bang or dyed her hair blue.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("She becomes a party animal."), _c('br'), _vm._v("\nSuddenly a nice and respectful girl that you used to love has changed after you broke up with her. She dresses and poses in her social media in a very provocative way, she is not shy to show off her skin on social media, parties hard with her friends or her new boyfriend.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You are his wonder wall."), _c('br'), _vm._v("Even though you are not together with him anymore, he still calls you whenever he has a problem. He calls you when he needs a shoulder to cry on, he calls you whenever he has good news or bad news.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Competing with your new love."), _c('br'), _vm._v("\nIf your new love climbs Mount Andez, your ex will climb Mount Everest. Your boyfriend just posted a photo he was doing a marathon, the next day your ex posted he was competing a triathlon. Your boyfriend has a six pack, your ex posts a photo that he has 10 pack abs.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("One obvious sign is when your wife asked you whether you have deleted all the photos of your ex in your social media, you said you have deleted them but whenever you are thinking of her, you still have a big smile on your face, you even say quietly, “Hooyaa!” Then you’re off to the bathroom with the hand lotion.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("A more obvious sign, is you. You are reading this with enthusiasm right now, checking all the boxes just to know if you still have a chance to get back with your ex again. I heard you say, number one ticked, number two ticked, yes, yes, yes, yes, no, no. Aha! You still have feelings for your ex. Gotcha!")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "introverts-and-extroverts-on-social-media"
    }
  }, [_c('h3', [_vm._v("Introverts and Extroverts on Social Media")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("Introversion is a personality trait characterised by a focus on internal feelings rather than on external sources of stimulation. Introvert comes from a Latin word ‘intro’ it means inward and ‘vertere’ means turning. A person who tends to turn inward mentally. Introverted people prefer calm.")]), _vm._v(" "), _c('p', [_vm._v("Introverts can spend time with many people but feel drained after spending too much time with many people. Because an introvert’s brain responds to dopamine differently than an extrovert’s brain. So if you’re an introvert, you are more likely born that way. Shyness and introversion are different, shyness is the fear of negative judgement. Introversion is a preference for a quiet, minimally stimulating environment.")]), _vm._v(" "), _c('p', [_vm._v("Extroverts are outgoing, gregarious people. Many people believe extroverts are outgoing and friendly, that may be correct but it is not the real meaning of extroversion. An extrovert person is energised by being around other people. Meanwhile, the introvert is energised by being alone. An ambivert is a person who has a balance of introvert and extrovert features in their personality.")]), _vm._v(" "), _c('p', [_vm._v("Showing off you are an introvert or extrovert on social media is a statement. You wear that badge ‘I am an introvert’ very proudly, as a medal for your achievement. Who gives you an introvert title? Yourself. There are many social media users who claim they are a real introvert. How do you know they are an introvert in social media? Don’t worry, they’ll tell you.")]), _vm._v(" "), _c('p', [_vm._v("Why do many social media users announce to the world that they are an introvert? This is like asking the question all porn stars dies as a virgin (not even their ears are a virgin). Because they don’t know what introvert is. You think introversion really belongs to the intellectual/imagination domain, you don’t like to hang out with many people because it is not a trait of a highly intelligent person, or you think you love being alone because they have more understanding about life than party people like extroverts.")]), _vm._v(" "), _c('p', [_vm._v("You think introverts have depth, spirituality, intellectual curiosity, intellectual depth, ingenuity, reflection, introspection, imagination, emotional richness, artistic engagement, and aesthetic interests. This is why many of you (social media users) think you are an introvert because of those reasons. You think you have good sense of humour like a stand-up comedian, but the fact is you are not even a lay down comedian.")]), _vm._v(" "), _c('p', [_vm._v("If you think you are an introvert because you hate people, it means Kim Jong Un is an introvert, too. No, he is not a dictator, just an introvert, according to you. You hate people is not because you are an introvert but because simply you never feel grateful and you don’t feel blessed with your reality. If you love scrolling social media just looking for sexy beauties on social media, drooling over them, like every single sexy photo, leave a flirtatious comment, it is not because you are an extrovert, it is because you are a pervert.")]), _vm._v(" "), _c('p', [_vm._v("If you love posting your sexy photos on your social media, uploading your photos from your bathroom or bedroom half-dressed or wearing nothing at all, then you claim that you are an introvert, yes I might say you are an introvert but your lingerie and your backside (drill baby drill) say you are an extrovert. We can see the sign on your knickers ‘all welcome’.")]), _vm._v(" "), _c('p', [_vm._v("You post on your social media that you are an introvert because of these personality signs:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Highly sensitive")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Deep thinker")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Reflective")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Introspective")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Socially anxious")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Spiritual")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Vulnerable")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Always prefer solitude over social interaction")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Highly intelligent")])])]), _vm._v(" "), _c('p', [_vm._v("Do you think if you tick one or two of those, it might indicate that you are an introvert? Guess what, none of them is a sign of introversion. If you view yourself as an introvert because of those signs and brag about being an ‘introvert’ on your social media too often just to get recognised and get the world’s attention that you are an introvert, you are a narcissist.")]), _vm._v(" "), _c('p', [_vm._v("Your status update is, “I love spending time by myself,” says someone who has social media and has many followers. Preferring to be alone is not a sign of introversion, it could be a sign you are under Police protection or you are in custody. Portray yourself as an introvert on social media just to seek approval, accolades and attention from others is a sign of narcissism. Your words are not consistent with your actions, you are proud and loud in calling yourself as an introvert, but you have a selfie stick and many selfies or sexy selfies on your social media. You love the attention from followers on your looks, you got caught enjoying attention in the party because you are the prettiest girl at the party, you are not shy to take your clothes off then post it on your social media for everyone to see. This is the same as you calling yourself prudish, but you work as a porn star.")]), _vm._v(" "), _c('p', [_vm._v("The terms of introversion and extraversion were popularised by Carl Jung, a Swiss psychiatrist and the founder of analytical psychology, who was famous for his theories of the Collective Unconscious, including the concepts of archetypes, and the use of synchronicity in psychotherapy. Jung’s ‘The Association Method’ article started in 1910, it included the response to Virginia Case’s book, ‘Your Personality – Introvert or Extrovert’. Rather than focusing on interpersonal behaviour, Jung defined introversion as an “attitude type characterised by orientation in life through subjective psychic contents” and extraversion as an “attitude type characterised by concentration of interests on external objects.”")]), _vm._v(" "), _c('p', [_vm._v("Hans Eysenck, PhD, DSc, (1916 – 1997), a German-born English psychologist described extraversion and introversion as the degree to which a person is outgoing and interactive with other people. The differences between extraversion and introversion is based on differences in brain psychology. One study found that introverts have more blood flow in the frontal lobe of their brain and the anterior of the frontal thalamus, which deals with internal processing, such as planning and problem solving. Extraverts have more blood flow in the anterior cingulate gyrus, temporal lobes, and posterior thalamus, which are involved in sensory and emotional experiences. And narcissists, perverts and morons have more blood flow in between their legs, where their brain is.")]), _vm._v(" "), _c('p', [_vm._v("There are many explanations about the brain differences between introverts and extraverts. After reading scientific articles about psychology, you can see in the comment sections, “Stop judging people!” This is coming from someone who poses nude and filters her photos but she thinks she is an introvert. You forget when you see a doctor, he will judge your health and tell you what to do to stay healthy. If you think to have interests in awareness and knowledge in studying psychology is the same as judging other people, it is the same as you getting offended by seeing children going to school and people going to college again to pursue their education. Hence, you hate yourself because you can’t compete with smart and skilled people.")]), _vm._v(" "), _c('p', [_vm._v("Why? Because you fail to know what your weakness is which is your willingness to learn, read, study and put more knowledge for your insight. Now look at yourself in the mirror, do you think mirror didn’t get offended to look at you? That mirror wish it could’ve tasered if it could you whenever you looked in the mirror. Studying psychology is offensive to you because psychologist can tell you are the real introvert or not, this is like all men get offended with elephants because they have such a big trunk.")]), _vm._v(" "), _c('p', [_vm._v("Studying psychology is not just about introverts and extroverts, all study about human mind and its functions especially those effective behaviour in a given context. The end of the day, it is your ego which consumed all of your body and health till your disease is spreading around your body and mind till it’s too late. When a man calls you ugly, it means he’s being mean. When a woman calls you ugly, she’s being jealous. But when a child calls you ugly, it means you are really ugly. Did you get offended by a child, too?")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("You may say you are an introvert, extravert, upvert, prudish person, pervert, extra pervert, extra spicy, savoury or nuts allergy person but if you feel:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("You are more superior than others, smug:"), _c('br'), _vm._v("\nYou don’t like listening, you’d rather talk than listen. Easily expressing these emotions: eye rolling, aloof, condescending looks, dismissive gestures, groans and sighs, high distractibility,")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Self-absorption"), _c('br'), _vm._v("\nOften you make a quick assessment about someone or a situation, find it uninteresting, flawed, wasting your time, unworthy, you’re mentally tuned out, block yourself out. If anyone disagrees with you, you will label them as a bigot, boring or stupid.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Lack of empathy"), _c('br'), _vm._v("You are more interested in yourself, you want all the sympathy and accolades go to you, not to the others")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Passive aggressiveness"), _c('br'), _vm._v("You deal with disagreeable people or situations in passive aggressive ways. You may say okay, my pleasure, definitely, but you don’t do anything about it.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Highly sensitive"), _c('br'), _vm._v("There’s a saying, if you can’t stand the heat don’t stand in the kitchen. Easily offended by a little thing, feeling humiliated at any signs of real or perceived slight and they deal with criticism poorly. You say you respect differences including different points of view but you send us a death threat if we disagree with you. You easily call us a bully, bigot, racist, misogynist, and any other name, but you demand respect from us."), _c('br'), _vm._v("\nThere’s a Kim Jong Un in you, if anyone disagrees with you or you get insulted by little things, you’re going to put them in prison. If we say flowers, you get offended. We say cupcake, you get offended too, a little thing will upset you. Just like two little girls fighting over a selfie, but when it comes to much bigger problems such as child soldiers or many women who work as a maid in foreign countries and were brutally tortured, you pretend you don’t know, you are too afraid to speak up.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Think highly of yourself"), _c('br'), _vm._v("I am unique, I am one of a kind, I am special and only special people understand me, I am so smart and everyone is just jealous of me. Self-statements which reveal you are narcissistic, have tendencies of superiority, grandiosity, and entitlement. I am so special that everyone should fantasise about me and look up to me. Actually, you are right, spot on. We always fantasise you are stuck up in a tree and everyone just look up at you.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Always have problems with anyone"), _c('br'), _vm._v("\nEither in relationships or with friends, you always have a problem or a falling out. Because of your insecurities and personality, smugness and being aloof, it limits your inner circle. If they don’t qualify to be your friend, you block them. It is very difficult for you to maintain a genuine relationship.")])])]), _vm._v(" "), _c('p', [_vm._v("After bragging about your friends as your best friends forever on social media, now you are busy exposing their inadequacies. Because you are emotionally vulnerable, you get offended easily. Being emotionally vulnerable is like a broken car, there’s always something that breaks down every second day. You spend more time to fix it than enjoying it.")]), _vm._v(" "), _c('p', [_vm._v("Life is your choice, you may choose or perhaps you were born as introvert or extrovert. But in life it is not about whether you are an introvert, extrovert, extra spicy, ambivert, pervert, upvert or downvert or whatever you call yourself, the questions are:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Can we trust you? Are you reliable and can take responsibilities?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("If you are trusted with lots of money, can you be trusted?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Are you an honest person? Do you lie?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Do you deliver and keep what you promise?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Do you treat people equally? The rich, the poor, whether young, old, regardless of skin colour and disability?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Can we trust you that you are not seducing someone else’s husband or someone’s wife if you are left with her/him alone?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Do you have empathy? Do you get angry easily or are you a patient person?")])])]), _vm._v(" "), _c('p', [_vm._v("No matter who you are in the world, we don’t care as long as you are honest and respect others. It is about your honesty, moral values, emotional maturity and the kindness you have. It is the way you conduct yourself that matters the most, not your introvert status.")]), _vm._v(" "), _c('p', [_vm._v("You don’t have to be an introvert or extravert to be a good Samaritan or stand up together for justice and help people who live in poverty. Isn’t it nice when we all stand up together to help others, not because we are an introvert or extravert but because we have empathy and we value humanity. I think we should be more proud that we can stand united together for justice, love and peace, rather than having pride of being introvert or extravert.")]), _vm._v(" "), _c('p', [_vm._v("Bragging about being an introvert or extrovert to upgrade your reputation is the same as bragging how much you have helped starving children to boost your image. It is narcissistic. You don’t have to be a child to act like a child. You don’t have to be a porn star to display your skin on social media. You don’t have to be a baker to bake a bun in the oven. It doesn’t require a big dick to be a dick. You don’t need a red carpet to get attention on social media, you can get the attention by taking off your clothes. But it does require more love than hate to live as a human.")]), _vm._v(" "), _c('p', [_vm._v("It requires time, effort and dedication to build a reputation and credibility so we can trust you. Trust is an honoured gift that has been given to you by someone. Being humble, not pretentious and being honest is a choice you make every time you think, act, write and open your mouth that earns you respect from anyone. It is associated with kindness, politeness, empathy, compassion and emotional maturity. Bragging about being humble and honest is associated with the desperation to be seen as a good person by everyone. Because what people think of you does matter a lot to you. Those are not signs of being honest but signs that you are a vulnerable, narcissistic and immature dick.")]), _vm._v(" "), _c('p', [_vm._v("Addition: talking about honesty, there are some social media users who are so proud that they are so introverted but they are inviting the boys to drool over them by posting their extroverted backside and gregarious cleavages photos, we can tell you are inviting people to come to you. You say you’re an introvert but the way you pose on social media with your legs wide open as if saying, “Yes, we’re open!” We know the moment you take your underwear off, you are a very giving and generous person, no one gets refused, yet you call yourself an introvert. Maybe the only one part in your body that is still an introvert is your ears. They are also social media users who are proud that they don’t use filters and photoshop but later they forget what they wrote in the past as they started using filter and photoshop.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-fake-love"
    }
  }, [_c('h3', [_vm._v("The Fake Love")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("How do you decide to accept or choose a friend in social media? Perhaps you just accept friend requests from family, friends, relative and workmates. What if there’s a friend request from a random person? You’ve never met him and also he doesn’t have a mutual friend. Would you accept his friend request? It is very likely the answer is no. That’s fair enough, as grandma says, stranger is danger. Good on you, stay alert.")]), _vm._v(" "), _c('p', [_vm._v("Well, as grandma says, stranger is danger, but what if that friend request is coming from a very beautiful girl? Would you resist? Does ‘stranger is danger’ still apply for this? We all know you are very flattered to see the fact a very beautiful girl wants to be your friend. In your mind, hooyaa! I still got it! That must be something so alluring in you that makes a beautiful girl send you a friend request. The other side of you is thinking, really? A beautiful girl like that wants a guy like me? If you don’t accept it, she is too beautiful to be rejected, if you accept her friend request, you would betray your own principles which is you don’t accept anyone unless you have met that person in real life.")]), _vm._v(" "), _c('p', [_vm._v("Should you reject her friend request is the same as if you married a very busty girl but you have a milk allergy. So don’t waste it, this is a once in a lifetime opportunity after many years you didn’t get a friend request from a beautiful girl, finally you got one! It’s about time you have a beauty in your friend list.")]), _vm._v(" "), _c('p', [_vm._v("Then another friend request, this one is coming from a middle-aged lady. You never knew this lady, doesn’t have a mutual friend, she is no super model but she looks like a nice person. Would you accept her friend request? I think the answer is possibly no. How many media users accept a friend request based on the appearance and wealth? Would you approve a friend request from the real celebrity? What if that friend request is coming from a genuine person who doesn’t have a bad intention but good intention, she genuinely wants to be your friend but she is no Victoria Secret model nor wealthy? Would you accept her friend request? Yes? No? Probably you say no.")]), _vm._v(" "), _c('p', [_vm._v("Accepting a friend request is like inviting someone to your house, not everyone is welcome, you have to be wary. You don’t let anyone who knocks at your door stay in your house, do you? Just like applying for a job, you must check the experience and background. There is a friend request and a friend request, you might say rules are made to obey, you can’t bend the rules. But when you will bend your rules the moment you see that person who sends you a friend request is too irresistible and too sexy.")]), _vm._v(" "), _c('p', [_vm._v("You are really smitten by her, who doesn’t want to be befriended by a beautiful girl with big breasts? Wait, it’s getting better, before you brush your teeth you have someone very special who just inboxed you. It’s her! She thanked you for adding her. Did a beautiful girl thank a guy like me for giving her a green light? This gives you more energy and nutrition than your breakfast cereal. You’re pumped, at the speed of light you reply to her message, “You’re welcome!” Come on, you wanted to say more than welcome, don’t you? You would love to say, “Please, please… come in, make yourself at home, tea and biscuits are available.”")]), _vm._v(" "), _c('p', [_vm._v("Those five words ‘Thank you for adding me’ is the thing that makes you smile all day. Roses are red, violets are blue, she is so hot, come and sit on my lap. You know you’ve got a hot spot for her but you still keep your cool, you wanted to start a chat with her but you have to control yourself. This temptation keeps torching you, this is like dangling a bone over a dog but the dog keeps refusing, “No, thank you. Please don’t bone me.” It is as hard as Dracula choosing to refuse to suck blood, instead he chooses to become a blood donor.")]), _vm._v(" "), _c('p', [_vm._v("She makes an impression on you which prompts you to check her social media profile. You are curious to see what her husband or her boyfriend looks like. Who knows, you might be hotter than him. Deep down in your heart you know she has many men admire her. As one of the most infamous movie lines says, “Of all the social media users in the world, she has to walk into mine.”")]), _vm._v(" "), _c('p', [_vm._v("One day out of the blue, while you are chatting with some friends online, suddenly you see someone just inboxed you. It’s her! She said, “Good morning, how are you my new friend?” with that emoji. Yes, that kiss emoji. What’s this? Whatever it is, you feel like you just won the jackpot. Should you reply as soon as possible? Or are you playing too hard to get? We know what you’re going to do, yes, you reply to her chat as soon as possible.")]), _vm._v(" "), _c('p', [_vm._v("“I’m good, thank you for asking. How are you?”")]), _vm._v(" "), _c('p', [_vm._v("“I’m well, thank you.”")]), _vm._v(" "), _c('p', [_vm._v("When you are having fun, especially when you chat with a beautiful girl, one hour feels like a second as opposed to one minute with your wife feeling like you are sentenced to life in jail. This beautiful girl makes your machine more powerful than 8000 horsepower, meanwhile your wife makes your engine less powerful than one old frail donkey.")]), _vm._v(" "), _c('p', [_vm._v("Chatting with a beauty make you forget what time it is, what day it is, is it dusk or dawn, you even forget you already have a spouse. Chatting with your wife for too long makes your wife down on her knees, her head down, looking at you and saying, “Hey asshole! Come out from your hiding place under the bed now!”")]), _vm._v(" "), _c('p', [_vm._v("Your wife keeps saying, “I don’t like it!” meanwhile your crush keeps asking you, “How do you like it?” Chatting with your wife, you remember all the jobs you must do, all the rules you must obey and all the nags. You have practised these sentences since getting married that you don’t know why you say it, but you have to keep saying,")]), _vm._v(" "), _c('p', [_vm._v("“Yes, dear.”")]), _vm._v(" "), _c('p', [_vm._v("“I’m sorry dear. I’ll stop it, I’ll never do it again, no more.”")]), _vm._v(" "), _c('p', [_vm._v("“I made a mess, I’ll keep my nose clean.”")]), _vm._v(" "), _c('p', [_vm._v("“I know I am going to sleep on the couch tonight because I am being disciplined because I’ve been naughty. This is not on.”")]), _vm._v(" "), _c('p', [_vm._v("Meanwhile, when you are with your online crush, you desperately want to say,")]), _vm._v(" "), _c('p', [_vm._v("“Yes yes yes.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh babe, you’ll be sorry because nothing is stopping me! Hooyaa, do it again and again, more… more.”")]), _vm._v(" "), _c('p', [_vm._v("“Mess with me baby, mess with me… You make my nose dirty, I like it!”")]), _vm._v(" "), _c('p', [_vm._v("“Do it on the couch, I’m going to discipline you tonight. You’re naughty, oh yess… naughty turns me on…!”")]), _vm._v(" "), _c('p', [_vm._v("Days go by, weeks, months, even almost a year, you keep the relationship strong. She says you’re the only one, you’re the sunshine and you believe in every word she says even when she says she is as pure as a Holy virgin, she was one of those astronauts who walked on the moon (well, we know you’ve been mooned), she was the one who parted the sea (and parted your backside too), designed the Eiffel Tower, and all those webs of lies. Even if she says her vagina can do yodelling and sing your favourite song, you still believe that.")]), _vm._v(" "), _c('p', [_vm._v("Then she says to you, “Now… empty your mind… just relax… breath in slowly… breath out slowly… the moment I drop my bra, you do as I tell you…” Ha! You’ve fallen into her trap. Remember what grandma says, not all that glitters is gold. Not all people who say, “Oh God, this is so good,” is religious. Not all hand lotions are to moisten the hands, not all mattresses are for yoga, not all baby oil is for a real baby, not all phone sex is done with a physical phone. If yes, there would be so many people admitted to the ER and so many surgeries would have been done to remove the smartphone from inside ‘private parts’ because of phone sex. Hope someone didn’t call you when it was inside your private part, that would be difficult to answer. Hey, they could leave a message anyway.")]), _vm._v(" "), _c('p', [_vm._v("Back to the topic, we all know the fake lover will propose to you, and all that romantic crap. She pours her heart out to you, she says you are her wonder wall, she plays herself as the victim, sad life, how cruel the world is to her till in the end she says those magic words, “I am in trouble, could you please send me some money?” With her crocodile tears, first you have hesitation to send her money.")]), _vm._v(" "), _c('p', [_vm._v("But after she dropped her clothes to the floor wearing nothing but her lip gloss, faster than the speed of light you respond, “Oh yes, I’ll send you money right away.” As mentioned above, you get hypnotised, “Now after I take my bra off, empty your mind… relax… concentrate on my nipples, then shift your focus in between my legs because ‘that eye’ in between my legs is the window to the soul, I’ll count from five to one slowly… and tell me your bank account number, then send the money to me… Do it now… then you quack like a duck for me.” You are being hypnotised as you reply, “Yes, master…” Before you insisted that you can’t bend the rules for anyone but after she shows you her two breasts you get breasts washed, oh I mean, brainwashed. Okay, all the breasts. Wish you nothing but breasts wishes, hope you have the breast day.")]), _vm._v(" "), _c('p', [_vm._v("After all the promises she will meet you halfway but she can’t make it because suddenly her grandma is in the hospital, a very serious condition, the doctors say it is almost her time. Because you love her, you understand and offer her some support. Time goes by, days, weeks, months, she says her grandma is getting much better. She promises to see you soon, you just can’t wait for the day you touch her for real after too many times you purchased hand lotions.")]), _vm._v(" "), _c('p', [_vm._v("You’ve been counting the days as the day to meet her is getting so close. You’ve been pumping iron and dieting. You have shaved your beard but still have your Elvis Presley sideburns to give her a tingling sensation when she kisses your lips. No more hairy chest as you polish it with olive oil to improve your appearance. Also you have bought two pairs of tight leather pants and a leather jacket to make you look like Mad Max, plus you injected some Botox into your face.")]), _vm._v(" "), _c('p', [_vm._v("Two days to go, the excitement is getting bigger. What is it like to touch her, to see her in person, to hear her voice, does she have fairy legs or hairy legs, but nothing makes you happier than seeing her in person. As the excitement is getting higher, she drops the bombshell, “Baby, I’m so sorry. My grandma is in the hospital again. This time the doctors asked the whole family to be there for her as her time is getting closer…” She is sobbing, crying hard. It hits you hard too, you are so devastated. This feeling is like when you’re having sex and about to come, suddenly you hear your grandma yelling desperately asking for help from the bathroom as she is locked in, she can’t get out. That’s how you feel.")]), _vm._v(" "), _c('p', [_vm._v("She knows how to press your button and you love her so much, you believe she tells you the truth. She says she is so blessed to have met you, you are the best thing to happen to her and you are her shoulder to cry on. She says she doesn’t know what to do without you, she says you are her sun, always shining down on her. You say to her, that she is like your GPS, you are lost without her. That’s exactly true, actually your GPS is her panties. Wherever her panties are, that’s where you go. You are guided by your GPS, she says she needs money to buy a return ticket to see you plus accommodation, you follow the instructions.")]), _vm._v(" "), _c('p', [_vm._v("Because you are so over the moon, you fall hard for her, you have lost all your common sense. Even Teletubbies know that you are being fooled. As expected, she makes another promise to see you again. This time she swears by the Holy Book that she will see you no matter what happens. And you believe that, do you think she reads the Holy Book? Have you ever seen a crocodile blushing so shyly, embarrassed because the crocodile is always naked? The answer is super impossible.")]), _vm._v(" "), _c('p', [_vm._v("She sets the date again to make it happen. This time it’s got to be real. You are more motivated than a fat bastard at the buffet. Nothing is going to stop you from seeing her, you’ll climb every mountain, swim the oceans, you are even willing to clean and polish the whole Eiffel Tower by hand, just for her. Hey, don’t forget to polish the Great Wall of China, too.")]), _vm._v(" "), _c('p', [_vm._v("As the day is getting closer, you are so assuming this time she’ll make it, especially after you sent her so much money, not once, not twice, but thrice. You just can’t wait for the day, this is like the day the Berlin Wall collapsed, the most important day of your life. You get up early in the morning, shower, shave, wear your best outfit to pick her up at the airport. So excited to see her.")]), _vm._v(" "), _c('p', [_vm._v("You have been waiting and waiting, your eyes scanning the crowd searching for her. No sight of her, one hour has gone, two hours, three hours, she hasn’t arrived yet. You keep checking all the arrivals, it is shown that her plane had landed three hours ago but she is missing. Where is she? Four hours waiting, till you realise she is not coming. You feel so hopeless and useless. You curse yourself for being stupid. She lied again. Who would believe a story that her grandma is dying, twice? Even if she tells you that her grandma is dying for the third time, you would believe her, only you.")]), _vm._v(" "), _c('p', [_vm._v("Another fake reason to con man online, “My grandma is sick, she needs money.” This is a very common lie from girls (from one of South Asian countries) when they just dated a foreign man, “My boss touched me up, so I had to quit my job. But you have to pay me $100 because weekly because I quit my job for you.” Sadly, many men got trapped.")]), _vm._v(" "), _c('p', [_vm._v("For girls, who doesn’t love the happy ending fairy tales? A drop-dead gorgeous Prince Charming asks for your hand in marriage, to live in a castle happily ever after. Nothing but filled with happiness. As you are dreaming about Prince Charming, there’s a notification that you have a friend request from a very good-looking guy! He is devastatingly handsome! You check his profile, wow, you are even more amazed. He works as a CEO in a big company. Too good to be true? In the social media world, if it is too good to be true, it is not true. Too good so you bend the rules and in the end you will get a blender stuck up yours.")]), _vm._v(" "), _c('p', [_vm._v("Check these signs:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("The photo looks devastatingly handsome or poses himself as a very influenced/very successful. Look at his photos, does he show so much wealth, meet important people, he travels in first class, his house is a mansion and full of expensive cars")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("His occupation is very promising, such as a CEO, entrepreneur, lawyer, pilot, surgeon, Army general, company director, and all top jobs that most people dream about.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Graduated from a top university such as Harvard or Yale")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Only a few friends. Most of his friends are young girls or you can’t see his friends at all because of the setting. There’s something missing in his friend list, no family, no work mates, no childhood friends. It seems most of his friends are random people who are not related to his work, family or real friends. When you point it out that he doesn’t have any family or workmates in social media, he’d say his social media isn’t intended for family or his colleagues. He says his social media is for diversity for people around the world. He likes multiple cultures in his cyber life, he says. Or suddenly he makes a new social media account pretending to be his brother or his staff just to convince you that he is real, not fake.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("There is not much interaction from others in his social media, most comments come from his new friends. No tagged photos, well there are some tagged photos but they are not photos of him, just someone tagged him in some wise words. There is no talk about his work, his social activities, his family, his everyday routines. He just posts quotes of life or his photo without details. Lacking details and information, watch out for these signs")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("He said he graduated from a top university with a top job, lives in the US or Europe, but his English skill and grammar is so poor. Really? Is this a Harvard graduate? Stay alert")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("He is too quick to fall in love with you and propose to you. A good-looking guy like him with the world at his feet, plus he has millions of dollars in his bank account, has fallen hard for you? From all the beautiful girls in the world who keep chasing him but he has chosen you via social media? Did you see a Brad Pitt look for love on social media? What’s next, he tells you that he is a virgin?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Have you ever wondered how a multi-millionaire and a good-looking guy like him sent you a friend request on social media? This is like you heard someone knocking at your door then the moment you open the door, it is a Chris Hemsworth who never met you at all but he has a bouquet of flowers for you, down on his knees and asking for your hand in marriage. If that happens, you must have been taking the magic mushroom again. When you’re on drugs, a milkman will look like Thor, you look in the mirror and you can see two wings like an angel, actually it was the drug that made your armpit hair look like wings Back to the topic: ask him how he found you, his answer would be interesting. He’d say he accidentally found your social media profile and fell in love with you at first sight. Whatever his answer is, if you believe that, it means you were born drunk and stoned. No alcohol required")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("He avoids live camera, doesn’t even know what Skype is. His excuse is he has some acne, his face just got a laser treatment, he hasn’t trimmed his eyebrows, and so many lame excuses. However, there are some con artists who are willing to do video calls and even using video calls to lure the victims. They use the power of their tits and naked bodies to hypnotise the victim")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Sad life, his life has been full of tragedies and dramas. His wife or his parents has passed away. Or he has survived brain cancer.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You can hear his voice but his accent isn’t right. When you look at his photo, clearly he is a Caucasian, lives in Denmark, very successful, but his accent sounds like Idi Amin’s accent? Trust your gut instinct. If you still believe he is not a fake, this is like you believe James Bond has a Peking duck accent. Bond… James Bond… Become, Sim… Dim Sim… When this happens, you say to him, “Lost… Get lost.”")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("He dropped the bombshell, he tells you he is in trouble, can’t access his credit card. He’s asking you for money. He’s in tears, sobbing like a bimbo crying in a Chinese restaurant after realising that her Chinese letter tattoo means deep fried chicken with soy sauce. He swears in front of his mother’s grave to marry you and pay you back")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("He falls in love too quickly and forces you for commitment, he asks for your hand in marriage, proposes to you, he says he can’t live without you. You’re the best thing that happened in his life. He wants to come see you and ask your parents to marry you. But when the day is closer, he always comes with so many excuses that he can’t make it. Usually the excuse was he had a bad accident, he was hospitalised for weeks or his grandma is in a serious condition, all the family is gathered together as grandma’s time is near. Isn’t it funny all these excuses only appeared on the day you were supposed to meet your love. But one thing he never fails at: taking your money and dignity")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Ask him where his office is and the address, I know some criminals steal many identities of very successful men to lure the victims. Tell him that you would like to contact him in his office or come see him at his work, if he hesitates it means he is not the real deal. Or you just play detective, send him a love letter to his office. Wait for a reply, if a reply letter informs you that he’s a happily married man who never met you online or he does not have social media, it means you are being manipulated")])])]), _vm._v(" "), _c('p', [_vm._v("Look, who doesn’t want to be loved? I think if anybody says he or she doesn’t need love, it is a big lie. Saying you don’t want to be loved and to love is the same as saying I love to be abused and disrespected. I don’t think anyone loves to be abused and disrespected. I believe we all love to be loved and respected. Love generates happiness and peace. Hate generates anger and revenge.")]), _vm._v(" "), _c('p', [_vm._v("The thing is, how do we find true love and learn to love someone if we are addicted to social media? If we want to be loved and love, we have to be loving and loveable. If we want to be respected and trusted, be respectful and respect others. If we want an honest soulmate, be an honest person. If we want peace not war, be a peaceful man. If we don’t like people lying to us, don’t lie. Just like social media selfies, 99.99% of selfies are blurred, heavily filtered and photoshopped but you’re asking for transparency, a real man and honesty.")]), _vm._v(" "), _c('p', [_vm._v("With love comes respect, with respect comes honesty and maturity. Love doesn’t lie, you lie. Love doesn’t take advantages of the absence of evidence, if it does, it is called a dildo, a sex toy who takes advantage of the absence. Why so many love rats on social media? Because they are criminals, they cheat, lie and manipulate for their own benefit. They take advantage and prey on their victim’s vulnerability. It is painful to be broken hearted, but it is more painful it was someone you love who broke your heart and betrayed your trust.")]), _vm._v(" "), _c('p', [_vm._v("If he loves you, he will not ask you for money. Love is about giving happiness, respect, honesty, kindness, empathy and compassion. If he loves you, he would respect you, pay for your dinner, open the car for you, he wouldn’t make a demand and he’d be honest with you. Love is to give, because with love comes empathy and humanity. To give love, is to give some help and support to those in need. We need more love than hate in the world. If someone says he loves you but he makes some list of demands, terms and conditions, it is called a bank mortgage, don’t sign it!")]), _vm._v(" "), _c('p', [_vm._v("Well, you may say love is blind, beauty is about our inner insight, beauty is about self-confidence, so why the hell do girls on social media filter and photoshop their photos? In fairy tale stories, Prince Charming has to chop the woods to see the castle, then he has to rescue the Princess from the fiery dragon. In the online world, Prince Charming has to look at every bathroom in the world to look at his future Princess taking a mirror selfie. But again, you can’t find true love in the bathroom with heavily filtered and photoshopped selfies because love can’t be filtered and photoshopped.")]), _vm._v(" "), _c('p', [_vm._v("The thing is, with social media where you can’t see them and touch them, you can be anything you want. What you see doesn’t necessarily present the reality, what you read doesn’t have to be the truth, what you hear doesn’t have to be the real voice. Not all that glitter is gold, not all barking dog sounds are from a dog, it could be your neighbour doing the doggy. If con artists were a mosquito, social media is like a nudist camp for mosquitos. Usually the love rats choose the vulnerability of lonely people, coming as a Prince Charming, stealing your heart and breaking it, including breaking your virginity, then gone.")]), _vm._v(" "), _c('p', [_vm._v("Also be wary and stay alert when you come across videos with the spectacular titles like these,")]), _vm._v(" "), _c('p', [_vm._v("“No one tells you this.”")]), _vm._v(" "), _c('p', [_vm._v("“The secrets are about to disclosed.”")]), _vm._v(" "), _c('p', [_vm._v("“Warning, if you watch this, there is no going back.”")]), _vm._v(" "), _c('p', [_vm._v("“Warning, if you watch this, you’ll never be the same again.” (wrong, an asshole is still an asshole, no matter what video he watches)")]), _vm._v(" "), _c('p', [_vm._v("“This works like magic.”")]), _vm._v(" "), _c('p', [_vm._v("“You’ll be rich if you use me.”")]), _vm._v(" "), _c('p', [_vm._v("“Your illness will be gone, it’s a miracle.”")]), _vm._v(" "), _c('p', [_vm._v("In saying that, there are many genuine people who have skill and knowledge to solve your problems such as your health, spirituality, business, finance and so on. But before you are sucked up into their video, you should ask this question to fake spiritual healers or your fake financial gurus:")]), _vm._v(" "), _c('p', [_vm._v("“Who taught you this?”")]), _vm._v(" "), _c('p', [_vm._v("“Do you have a licence or certificate to practise this?”")]), _vm._v(" "), _c('p', [_vm._v("“Have you healed or helped a client’s affair with your ability face-to-face, not via YouTube?”")]), _vm._v(" "), _c('p', [_vm._v("“How many years have you been studying this?”")]), _vm._v(" "), _c('p', [_vm._v("“How many clients you have helped? Are there testimonials?”")]), _vm._v(" "), _c('p', [_vm._v("“Do you have any proof that you’ve been so successful and have an alignment with God?”")]), _vm._v(" "), _c('p', [_vm._v("Sadly, there are a few fake spiritual gurus online that attracted hundreds of thousands of followers online. This fake spiritual guru says, “I know the answer if you’re looking for alignment from God and can shift your reality to manifest what you want.” Too quickly to claim himself that he has experienced the highest level of a human being, he knows and he’s been in a parallel universe, matrix or vortex that only a person who has alignment with God has been.")]), _vm._v(" "), _c('p', [_vm._v("He has zero experience in meditation, he refuses to seek more spiritual knowledge and inner peace in India, the Himalayas or China from the real spiritual monks that have been meditating and definitely know about having spiritual knowledge for decades. Don’t ask him about the differences between heaven and hell, he doesn’t even know how to do proper meditation because he has no skill at all, but the title of his meditation videos are, “The most powerful meditation ever,” and, “You will never be the same again after you do this meditation.” This is coming from someone who has zero experience in meditation and the spiritual.")]), _vm._v(" "), _c('p', [_vm._v("But because he already has so many followers, his followers will do anything that he says. Exactly like being brainwashed. In followers’ minds, he is the guru of God, he can do no wrong. He is the answer for all their problems even though he has zero experience, no reliable people or high-profile person to back him up, no proof of his alignment with God but his followers still admire him, brainwashed. This spiritual coach and his followers are not forming an alignment with God but they are forming a cult, they refuse to see the truth because they’re too blind to see. Until the truth will come and confront them.")]), _vm._v(" "), _c('p', [_vm._v("Stay alert, follow your instinct. Look around, don’t just stick with one guru. Compare this guru and that guru. Look at the background and details about that person, do you own Google search. Has that guru (that you admire) had some reliable high profile or reliable person to back him up and proof that he is the real deal or is he just fake? In the online world, you can be anything you want, it’s limitless. But to be a pretender is only temporary, because sooner or later, the whole truth and nothing but the truth is revealing who you are. One thing typical of the liars is they keep changing their story. That’s why you have to have a good memory if you want to lie.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "bragging-about-relationships"
    }
  }, [_c('h3', [_vm._v("Bragging About Relationships")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("It’s a beautiful feeling when we are in love. Everything is flawless. No faults in life, everything seems so easy. According to science, love at first sight happens as early as 0.2 seconds after the first sight. Scientists refer to love as a basic emotion. Stephany Ortigue, a neurology professor, and many researchers conducted a study "), _c('em', [_vm._v("Neurology of Love")]), _vm._v(", on the explanation of love at first sight and whether it occurs in the heart or the brain. Many people say love is complicated, they were right, in Ortigue’s study, Ortigue and her colleagues found that 12 areas of the brain work together to release many chemicals and hormones that induce the feeling of love as early as 0.2 seconds after first sight.")]), _vm._v(" "), _c('p', [_vm._v("According to science, falling in love is as addicting as cocaine or nicotine. Dopamine is released and activated when using cocaine and nicotine, the same thing happens when you are in love. Dopamine is a chemical messenger that carries signals between brain cells. It is also blamed for addiction. When you hear love is a drug, that is so true. It gives you a rush of happiness and pleasure. But when the hormone vasopressin was suppressed, Romeo and Juliet didn’t protect each other anymore. They lost interest in their lover. The thrill was gone.")]), _vm._v(" "), _c('p', [_vm._v("Well, that’s a bit of fun facts about love. As grandma says, when you’re in love, a stool will taste like a chocolate, a cactus will be as soft and fluffy as a cushion. Love makes you crazy, love is not the destination, it is how we feel, think and do every day. We fill and spend our time every day with love. That’s how you spend your time on social media, you fill your social media with your declaration of love. The things that you love to post, including your relationship.")]), _vm._v(" "), _c('p', [_vm._v("Thank God for social media, we all know the story, the feeling and the relationship of you. We all know how you started it, how you met your lover, how you fell in love and all that jazz, how your lover surprised you with flowers, chocolates and a dildo (no, you didn’t write dildo on your social media. Facts: young couple always fight over the remote control of a dildo, married couples fight over the remote control of the TV). We don’t have to ask you how you met or how you feel about your soul mate. It’s all there to see.")]), _vm._v(" "), _c('p', [_vm._v("“My life was empty, I thought I was alone till the day I met you. I am not perfect but your love makes me perfect. My life has been so wonderful, how lucky I am to have met a monkey like you. You are my sunshine, my everything, my banana, the best thing I could ever have. Every day I have to pinch myself, I can’t believe how blessed my life has been. I am amazed by your heart, kindness, support and love. You are the softest and the most beautiful person I’ve ever met, I love you forever.” A monkey writes how she feels about her boyfriend #blessed, #lucky, #relationship goals.")]), _vm._v(" "), _c('p', [_vm._v("“What a wonderful way to start my morning, my husband dropped off these flowers at my work this morning. My husband is my best friend, my rock, my wonder wall. Thank you for making my life so amazing, I couldn’t imagine my life without you. I know God always gives me the best, I am the luckiest crocodile in the world. I have tears in my eyes as I write this.” A crocodile expresses her love to her husband #blessed, #lucky man, #relationship goals.")]), _vm._v(" "), _c('p', [_vm._v("“You are my best friend, my human diary, thank you for your daily support and love @Coco Nutnut. You tell me every day how much you love me and how beautiful I am. You give me strength to stand up for myself, love you from @Numbnumb.” A zoo celebrity just posted her love letter on her social media, with #numbnut, #CN, #your nut drives me crazy.")]), _vm._v(" "), _c('p', [_vm._v("Yes, we read that a lot. How lucky you are, how blessed you are, we understand how you feel when you’re in love. There’s a big difference between the feeling when we are in love, and we’re loving the attention from the world to see you and your love as a couple who are madly in love.")]), _vm._v(" "), _c('p', [_vm._v("There are many cases when some of you are upset with your new lover because he doesn’t declare how much he loves you on his social media and you force him to post on social media and dictate him to write how much he loves you.")]), _vm._v(" "), _c('p', [_vm._v("“Baby, did you see my social media? I just posted how much I love you, I’ve seen your social media, there is nothing. You didn’t acknowledge me as your new love. What’s this? If you love me, you must follow and reciprocate what I write about us. You have to show the world that you are madly in love with me.” Everything has to be displayed on social media because the comments, the likes and the compliments from your followers and the urge you want to be seen with your new lover, does matter a lot to you.")]), _vm._v(" "), _c('p', [_vm._v("When you post about how much you miss him, he must post on his social media how much he misses you, too. You post about how blessed and lucky you are with him, he must do the same too on his social media or else he’s in trouble. So it doesn’t look like you’re the only one who got smitten. We read your love letters on your social media, you can’t stop complimenting how lucky you are, she is the angel from heaven for you. Usually a new couple created their own hash tag, for example: milkhole is a hash tag for Milzhaks and Holetata, Babarella is a hashtag for Ali Baba and Cinderella. Also the hashtags such as, prince and princess, love, blessed, lucky, bliss, lucky in love, happily ever after, so humbled.")]), _vm._v(" "), _c('p', [_vm._v("It is wonderful to love and to be loved. We are so happy that finally you have found the one. But be careful, when you keep jumping on the couch, dancing in the rain and swinging from the tree together with those monkeys, keep pointing your finger to the ceiling as the expression of how happy you are being in love, writing your wedding proposal in the sky and on your forehead, climbing the highest mountain to propose, or do a James Bond stunt hanging upside down from the tallest building, telling the world how much you love her but when everything goes south, it is the same as if you throw egg at your own face. Same as you’re bragging about how smart you are but you failed when you are asked who came first in the world, dinosaurs or your mother? You said your mother.")]), _vm._v(" "), _c('p', [_vm._v("It is not a crime to share your happiness, we love to see you happy. But when everything is so animated, unnatural, trying too hard and proving too hard by bragging how blessed and lucky you are by your relationship, when everything is a big announcement, it shows you do a desperate act for confirmation and validation. Usually you posting your relationship is like composing a novel, with an introduction, chapters, highlights and conclusion. What are you expecting from the audience? Are you expecting us to reply, “Yes, you are the luckiest person in the world,” or, “Man, I’m shocked. Did you sleep with that? It must have been so dark when you met her.”")]), _vm._v(" "), _c('p', [_vm._v("What happens in your private life stays private as it is not our business, so you would reply, “Oh, you’re jealous. You’ve never been loved.” No, we are not jealous of your relationship, we just know the differences between braggart narcissism and real love. Couples who always brag about their relationship are the ones who get jealous of seeing another couple who are happier and more popular than them. It is a big difference to see the volume of love and the volume of promoting your love life which is too loud like an ice cream truck. Too much advertisement and marketing means you are selling something dodgy. Did you see Rolls Royce and Rolex push their marketing too hard? Rolls Royce doesn’t have to advertise heavily because we all know the quality. When the product is pushed too much, being advertised heavily, most likely because the products don’t have good quality.")]), _vm._v(" "), _c('p', [_vm._v("What if we brag the same way and even take it to the next level such as,")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God, I’m so blessed. She faked her orgasm twice,” with hashtag: blessed, fake.")]), _vm._v(" "), _c('p', [_vm._v("“Oh wow, that was even quicker than two-minute instant noodles,” with #too quick, #faster than the speed of light.")]), _vm._v(" "), _c('p', [_vm._v("“It was too good,” with #slippery when wet.")]), _vm._v(" "), _c('p', [_vm._v("“My girlfriend floored me,” with #her cave was as big as a Walmart, #echo chamber.")]), _vm._v(" "), _c('p', [_vm._v("“When you heard the dog was barking last night, don’t worry. It was us doing the doggy,” with the #woof woof, #I thought his was a German shepherd but it was a shepherd’s pie.")]), _vm._v(" "), _c('p', [_vm._v("“She likes it when I use my head,” with #I don’t use my finger, I stick my head into hers to please her, #use your head.")]), _vm._v(" "), _c('p', [_vm._v("“He doesn’t take the top job,” with #lazy bastard, too lazy to be on top in bed.")]), _vm._v(" "), _c('p', [_vm._v("And this is what you are trying to tell the world:")]), _vm._v(" "), _c('p', [_vm._v("“We are the best couple in the world, my lover is better than yours.”")]), _vm._v(" "), _c('p', [_vm._v("“Come on like my post, tell us that you’re happy with us, lie if you have to just to make us look good. I need to be acknowledged.”")]), _vm._v(" "), _c('p', [_vm._v("“We are too good, I don’t like to see another couple who is more popular online and better than us.”")]), _vm._v(" "), _c('p', [_vm._v("“I perceive my relationship based on how people see me and my lover by the way they leave a comment and like.”")]), _vm._v(" "), _c('p', [_vm._v("“The more likes I get, the more orgasm I get.”")]), _vm._v(" "), _c('p', [_vm._v("“The best relationship comes with the most likes and compliments.”")]), _vm._v(" "), _c('p', [_vm._v("“The more details I tell the world, the more insecure I am.”")]), _vm._v(" "), _c('p', [_vm._v("“Actually, in the back of my head I have many doubts about my relationship and I am not 100% satisfied with my current relationship, that’s why I compensate for my uncertainty and doubts by posting how perfect and happy I am.”")]), _vm._v(" "), _c('p', [_vm._v("“The more likes and validation I get from my social media posts, the more confident I become.”")]), _vm._v(" "), _c('p', [_vm._v("“I am happy not because I know what love is but because of the attention and likes I get on social media.”")]), _vm._v(" "), _c('p', [_vm._v("Your post, “I just want to share my happiness with the world.” If we’re smarty pants we could’ve replied, “Sorry, I am not one of your people.” But our common sense says, “Happiness is to be felt, to be done, to be touched by the heart, it is not a declaration online, it is a declaration of your time, your thoughts, your heart and your action. Love and happiness is not reliant on how much you want to be seen as someone who’s in love and counting how many likes and comments you have.” Love is not the urgency or the need to be seen online or public, love is the urgency to be felt in every second you breath and every time you make a decision.")]), _vm._v(" "), _c('p', [_vm._v("Because of the backlash of your posts from bragging too much about your happiness and love life, you respond by saying, “I don’t look for likes and compliments on my social media because…” I think you lie, it is very obvious you are addicted to likes and compliments online like a cocaine addict, or this is the same as you taking all your clothes off then posting it online then saying, “I don’t want to be seen and to get noticed.” If you say you ‘don’t care’ how many likes and compliments you get, why bother posting it online? You said that because you are hurt by the responses from your followers that you’ve been bragging too much, but secretly you are desperate for attention the most. When people are angry then say, “I don’t care!” Actually, what they try to say is, “I am hurt.”")]), _vm._v(" "), _c('p', [_vm._v("You say, “You never know what love is, you’re jealous I post about love.” If we were smarty pants we could’ve replied, “Spot on, we agree with you, all brothers and sisters should hook up together to avoid jealousy and rifts in the family.” Our common sense says, “We are not jealous of a narcissist. Love doesn’t make you scream out loud online, love doesn’t make you a narcissist, love makes you maintain your dignity, pride and stay humble. Love is not a competition to show off, love is shown by respecting others and yourself. It is your ego, dishonesty, insecurity and selfishness that makes you brag online.”")]), _vm._v(" "), _c('p', [_vm._v("You say, “Some people are not happy seeing others happy.” If we were smarty pants we could’ve replied, “I couldn’t agree more with you. We all love dyslexia, I mean we love sex daily.” But our common sense says, “We assume your family and loved ones are jealous of your social media because you are more attached to your online world than your real world, even when you are with them but your eyes, your mind, your communication and attention goes to your smartphone, not to the family who are sitting next to you. They are happier if you reply to their attention rather than replying to comments online. Imagine you give up your social media for one hour just to be with your loved one. Imagine if you replied to all starving children like you reply to all your comments, if you did this, there would never be a starving child in the world.”")]), _vm._v(" "), _c('p', [_vm._v("Most of us don’t agree with anyone who shows off too much including wealth, but because we are being polite, we still give likes and blessing to you. We won’t say, “Hey, we have had enough of bragging online, actually bragging about anything shows insecurity.” The less you feel, the more you want to show off. The more you are disappointed in real life, the more you are boasting online because the likes and comments are like cocaine to you to reduce your loneliness and anxiety.")]), _vm._v(" "), _c('p', [_vm._v("Couples who have been married for over 30, 40 or even more than 50 years are the ones who deserve to brag about their relationship online. When your relationship is over 30 years, you have a right to brag about how happy your relationship is. The facts are, all the happy couples who have been together for many decades never brag online. Why? They don’t have to prove ‘how happy we are’ on their social media because they have to prove how in love they are to each other. As time goes by, it is life itself that proves to them the truth of love, thus earning them our respect towards them.")]), _vm._v(" "), _c('p', [_vm._v("Just like TV, bragging online is like a TV commercial, you try to sell and convince the audience as it is a part of marketing. What happens when a TV program has too many commercials? We press the mute button because we watch TV for the show, not for the commercials. Or we just switch to a different TV station to avoid watching commercials. Why? Because an advertisement sounds louder than a TV program, it is played by paid actors, and it is designed to capture our time for their own benefits only, the ad says it is good for you but actually it is only good for their own product, not us.")]), _vm._v(" "), _c('p', [_vm._v("This is how they make money. Just like you on social media. When we watch YouTube, the majority of us press the skip button to avoid the commercials. YouTube knows most of us don’t want to see commercials in between or before the video, so they offer YouTube Premium, watching anything without commercial interruptions. For you who likes bragging online, does this make sense? Now it is up to you to have a premium relationship without too many advertisements, or you want to have a cheaper one with too many ads in between.")]), _vm._v(" "), _c('p', [_vm._v("A recent study shows couples who post often about their relationship are more likely to be feeling insecure. Researchers from Northwestern University found that you post more about your relationship when you are feeling insecure about your relationship, after studying more than 100 couples. Another reason you brag about your relationship, you measure your relationship based on what people say about you and your partner. Likes and comments give you more motivation when you have some doubts about your relationship.")]), _vm._v(" "), _c('p', [_vm._v("According to Wikipedia, a self-affirmation theory, a psychological theory that focuses on how individuals adapt to information or experiences that threaten their self-concept. This theory is your concept of yourself as a good, moral person, a worthy person who acts in ways that are in accordance with cultural and social norms, this leads you to seek affirmation on social media. Professor Claude Steele popularised this theory in the late 1980s.")]), _vm._v(" "), _c('p', [_vm._v("Narcissists love to brag about anything including relationships. The dark triad personality traits all have somewhat malevolent connotation. The three traits are machiavellianism (manipulative attitude), narcissism (excessive self-admiration) and psychopathy (lack of empathy). Individuals who tend to brag when they share positive events reported less agreeableness, less conscientiousness, and less empathy.")]), _vm._v(" "), _c('p', [_vm._v("Narcissists post how much they care for orphans and people who live in extreme poverty, but they do that to be seen, seeking accolades to boost their reputation and image. Yes, it is quite a low act when you use orphans and extreme poverty to benefit your image. In August 2018, there was one social media post of one celebrity having so much fun on her holiday with her son. That is fair enough, she is just having fun, but what makes this post cringe-worthy was there was a killer earthquake that just happened in her country which killed hundreds of people, but she turned a blind eye even though she was next door to the tragedy area.")]), _vm._v(" "), _c('p', [_vm._v("Instead she continuously posted how happy she was with her new love without acknowledgment of the big tragedy that just killed over 400 people. That was a national tragedy, but she kept promoting her relationship and herself online. Still posting selfies and preaching about the moral values but never mentioning that tragedy, double standards. When we asked her why she didn’t acknowledge or have any empathy or at least send a prayer to those who just lost everything due to an earthquake, in her defence she said when she had helped many people, the thing was she didn’t need to be seen online, she did it quietly, so she said.")]), _vm._v(" "), _c('p', [_vm._v("This is coming from someone who is constantly posting selfies everywhere, even in the bathtub, asking for compliments. But when it comes to a big tragedy that needs attention and love, an earthquake that killed more than 400 people, it is not as important as her selfies and how perfect her life is, that measures up to her moral level. It is all about me, me, me. And she was right, it is only her, her, and her in her world, nobody else. It is a very lonely world to live in.")]), _vm._v(" "), _c('p', [_vm._v("Another two reasons why you keep bragging about your relationship online is to make your ex jealous. As if to say, “This is what you missed. I am in demand, I can get a better one than you and you should be jealous.” Secondly, the more narcissists know that people hate braggarts, the more you keep bragging of your relationship online, just to annoy them. Like a kid, if your mother says to you to not eat too much chocolate, you will eat more and more chocolate in front of her, just to annoy her. If you are being criticised that you’ve been constantly posting your sexy body on social media as it is inappropriate for your underage followers, in response to that you will post more of your sexy body, even crazier, you go all nude full frontal. Why? To make your critics annoyed. It sounds childish but that’s very common on social media.")]), _vm._v(" "), _c('p', [_vm._v("If someone tells you he doesn’t like ice cream, you will show him and put it in his face by eating more and more ice cream every day, just to annoy him. So your actions are dictated by what others say about you, you are easily influenced. Your thoughts and actions didn’t come from a strong mind and common sense, but from your emotion and pain. If we say, don’t give us drama posts, you will keep posting more and more drama. What if we say, don’t give us more money, would you do the same too? Can’t wait for that.")]), _vm._v(" "), _c('p', [_vm._v("Braggarts are narcissists. Narcissists have a problem with being honest. Definitely it is your social media, you can brag, do summersaults, walk back to front, anything you want, any words you want to post, it is your right to do so. But remember, bragging will cost you your reputation, including your best friends and loved ones, the more you brag, the more they keep their distance from you.")]), _vm._v(" "), _c('p', [_vm._v("After you bragged about your relationship too much then suddenly your relationship went south, your boyfriend left you, guess who are you searching for, for a shoulder to cry on? Your family and best friends again, the ones that you forgot and left behind because you were in love and too busy with your ex-boyfriend then. Braggarts will come to us only when they need us or when they are in a bad situation. When they are having fun, they don’t even look at us with one eye, they don’t even spit one us if our body is on fire.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "stealing-identity-and-no-identity"
    }
  }, [_c('h3', [_vm._v("Stealing Identity and No Identity")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("As mentioned before, social media is like a nudist camp for mosquitoes. It is like an open vault for all thieves. Social media is like a buffet for all con artists, an open home for all, all welcome, including burglars. Even though you have a strong password, there’s always a possibility some hacker will break into your account and steal your photos, your information and your secrets. Then they will blackmail you for them.")]), _vm._v(" "), _c('p', [_vm._v("In real life, there are bag snatchers, pick pockets, burglars, shop lifters, wife stealers, criminals steal anything, and so it is on social media. The number of crimes in social media is increasing because they are untouched as there is no such law to punish the criminals and the fake social media users. Simply put, you will do anything when you know there are no consequences for you, but you won’t take action when you know the consequences are so heavy. You can steal a poster in the USA without suffering consequences but if you steal a poster in North Korea, you know the consequences you’re going to get. Imagine if North Korean laws applied to social media, there would never be a bully, no stealing of identity, no selfies, just nothing, because they would be in prison or dead.")]), _vm._v(" "), _c('p', [_vm._v("Even a cupcake photo and chicken satay photo are targeted. The real chef who made the cupcake and satay isn’t impressed as her hard work has been stolen. It is quite understandable because when you’ve been working so hard, putting so much effort and energy into it but suddenly somebody steals it and claims it as theirs, that would change your mood. Some people stole other people’s videos on YouTube and made money out of them. You stole someone else’s ideas and put the title of your video as, “No one tells you this.”")]), _vm._v(" "), _c('p', [_vm._v("According to The Federal Trade Commission, as many as 9 million Americans have had their identities stolen each year. A study by the DOJ has found that victims of identity theft has a combined average loss of US$1,343. In the year 2014, identity victims have lost US$15.4 billion.")]), _vm._v(" "), _c('p', [_vm._v("Your social media provides your information. Your birthday, your house, your holiday, your family, your pets and everything. Your post that you are on holiday on social media is as if you are telling the burglars, “Come to my house, I’m on holiday, make yourself at home. Tea and coffee are available. I also left some money for your taxi home.”")]), _vm._v(" "), _c('p', [_vm._v("Protecting your social media is like protecting your virginity. You don’t want to give it to the wrong person, then he’ll run away after you have his baby. Also, protecting your password is equal to protecting your marriage. If you want to stay married, change your passwords now to a stronger one!")]), _vm._v(" "), _c('p', [_vm._v("If this is a marriage, treat your password as if it is your wife. She is the only one you love, she is the only one who knows every part of your life and your body. She is the only one you can trust and who knows your secrets (well, there are cases when the wife is the last one to know her husband’s dirty secret). You give your strength in bed to make her happy and adore you, only her, no other. Exactly like your password, make it super strong so the only one who can enter your social media is you (unless, a hacker got into your wife).")]), _vm._v(" "), _c('p', [_vm._v("Apart from pet names, your partner’s name and child’s name, these are the lists of passwords that are desperately asking to make love with hackers:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("qwerty")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("123456")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("123456789")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("12345678")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("111111")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("1234567890")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("1q2w3e4r5t")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("password")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("letmein")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("football")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("iloveyou")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("admin")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("monkey")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("abc123")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("welcome")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("login")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("123123")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("starwars")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("dragon")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("passw0rd")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("master")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("hello")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("freedom")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("whatever")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("qazwsx")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("tustno1")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("654321")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Harley")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("password1")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Robert")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("ninja")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("mustang")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("qwertyuiop")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("mynoob")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("123321")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("666666")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("7777777")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("1q2w3e4r")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("google")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("asshole")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("1qaz2wsx")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("cheese")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("computer")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("fuckyou")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("hunter")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("tigger")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("ranger")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("solo")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("banana")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Maggie")])])]), _vm._v(" "), _c('p', [_vm._v("Never share your driver’s licence number, social security number, the barcode of your flight ticket, your full name including your middle name, date of birth, relationship status, school location and graduation dates, pet names; minimise your personal information, home address, only adding people you have known or you have met, not some random strangers, vary your password and change it regularly (contrary to what I mentioned before that a password is the same as your wife, to protect your social media you have to change your password regularly but in this instance if you want to stay alive, stay married, don’t change your wife regularly).")]), _vm._v(" "), _c('p', [_vm._v("We don’t disclose our identity on our social media to protect ourselves, but it doesn’t mean we lose our identity. In saying that, there are many social media users who really don’t have a real identity, we don’t know who he or she is, their friends are random people too or we can’t really see their friends. These social media users never use their photo or their real name, instead they use strange names. What they do on social media is to steal your identity, many of them are on social media purely to troll you, they will bully you about whatever you say and whatever you do on social media. However, we are looking forward to seeing their selfie with the word ‘captured’!")]), _vm._v(" "), _c('p', [_vm._v("Usually these type of cowards are found on YouTube, Instagram and Facebook pages. One of the words they always use the most is ‘bullshit’. Exactly, just like they are, they have no face, no identity, no real name, and no bravery to show who they are, they are just bullshit. Or they use their real name and photo, but their Instagram profile is private. Double standards, trashing anyone anywhere and anytime they want on Instagram but when we want to trash his or her profile, it’s a private account. Requirements to be a cyber troll is: good at hiding, cowardly and hypocritical. You can’t see cyber trolls but you can smell them. Cyber troll’s last words before being hospitalised are, “Hey guys, look what I found!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4.68831in",
      "height": "6.31865in"
    },
    attrs: {
      "alt": "",
      "src": "media/file2.jpg"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Con artists have studied you before they con you, they know your weaknesses which are beauty and money. You can’t resist a beautiful woman or money. If a beautiful woman sends you a message, “Hi, how are you?” Would you reply? There’s a possibility of yes, you would reply. You say, “I am good, thank you. How’s the weather over there?” She answers, “It’s been raining love, raining missing you like it’s bucketing down.” Now, as a man with common sense, would you believe that? The questions are, do you think it is really her profile picture, or did she steal some beautiful girl’s photo from Google? Do you really believe she actually misses you and is in love with you? Do you think you’re the only one man she seduced online? What if that girl is actually a King Kong who disguised himself as a Goddess?")]), _vm._v(" "), _c('p', [_vm._v("Do you know what the things are that can’t be stolen in the real world and social media? IQ, kindness, honesty and the truth, those can’t be stolen. We must use our brain, kindness, love and honesty to respect, accept and motivate our life because without them we lose our identity and dignity as a human. They can be shared but cannot be stolen.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "celebrities-minions"
    }
  }, [_c('h3', [_vm._v("Celebrities’ Minions")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("On social media, you don’t have to be the nicest, have the highest IQ, be the most good looking, be the richest, have the most followers or be the most popular in cyber life. So who are the most popular and the most followed on social media? The celebrities, who follows them? The fans. Social media brings you closer to your favourite celebrity as you admire their work, talent and accomplishments. These celebrities have influenced and inspired you, they have become a part of your life as you scroll through your social media every day.")]), _vm._v(" "), _c('p', [_vm._v("Before social media, the only one way to connect you to your idol was through fan mail or reading about them in the gossip magazines. Now, no more spending money on stamps or magazines as you can search about any celebrity you want on social media. You may say, no I’m not really into any celebrity. Good on you, the question is, how many social media users are out there who don’t follow a celebrity? It is very rare. Most of you are not die-hard fans of celebrities but you have your own favourite movie stars, singers, musicians, models, sport stars, TV profiles, and anyone in the public eye. It is totally harmless to admire their work and accomplishments, In fact, it brings positivity and joy into your life.")]), _vm._v(" "), _c('p', [_vm._v("We know what they are up to, what their new movies are, their holiday, their political point of view, their endorsements, their family, their sister, brothers, grandmas, boyfriends, girlfriends, marriages, divorces and remarriages again. You even know what they have for lunch and how their bathrooms look. No, you are not related to them, you are not in their inner circle nor family, but social media gives you a chance to have a closer connection to them.")]), _vm._v(" "), _c('p', [_vm._v("Celebrities are just like you, there are the good, the bad and the ugly. There are many who inspired and gave you joy, they entertain you. Their movies and songs make you cry, happy, dance, and laugh, even spice up your sex life. You have a bad day then you hear their song on the radio which is your favourite song, as if the song asks you, “Hey, what’s with the long face? Come on, I’ll cheer you up.” It changes your frowning and long face into a smiley face and happy face. You sing the song at the top of your lungs till you forget your bad day.")]), _vm._v(" "), _c('p', [_vm._v("When you are broken hearted suddenly their lyrics mean a lot, as if the song is there to agree with you and comfort you and says, “Yes, I agree with you. He’s not worth it, you’d better stay bungee jumping.” You feel connected to the song as if the song is the only one who understands you. When you’re in love you feel their songs are dedicated to you, the song celebrates and cheers you on about how you feel as if the song says to you, “Wow, how was that last night? Love the handcuffs and whipped cream, hiyaa,” which is a very wonderful feeling.")]), _vm._v(" "), _c('p', [_vm._v("They even make your marriage more romantic and spicier. Your wife asks you,")]), _vm._v(" "), _c('p', [_vm._v("“Darling, could you please make love to me like that movie?”")]), _vm._v(" "), _c('p', [_vm._v("You got sparkles in your eyes, at last she gets inspired! You push your wife on the couch, put a high visibility vest for road construction workers on her, then do her from behind, spank her backside then you scream loudly at her, “Say my name! Say my name, you bitch!” You slap her again, then come all over her face, your wife just looks at you in the eyes and says, “I think we watched different movies.”")]), _vm._v(" "), _c('p', [_vm._v("Who makes these celebrities strong? The fans. Who makes the celebrities become the most influential people in the world? The fans. Who makes celebrities rich? The fans who buy their products and follow their social media. Who defends the celebrities when they are in trouble? The fans. Celebrities have more chance to be rescued, to be heard, survive, defended and supported than the starving children in a third world country. Many of their fans would live and die for their idol.")]), _vm._v(" "), _c('p', [_vm._v("When they are sick, who comes and prays for their health? The fans. When they are sad and feeling so lost, who is coming to offer them shelter? The fans. When they are so excited since they just got good news, who congratulates and gets even happier? The fans. When they put a foot wrong, who still defends their sins and still assume they are a saint, with no faults at all? The fans. When they are promoting their products, who puts their hands up to buy the products? The fans.")]), _vm._v(" "), _c('p', [_vm._v("Do orphans who live in extreme poverty or child slavery have fans? No. Do they have more help and support than celebrities? Some people might say no but I believe the majority of the world has empathy and compassion to help these poor children and families, but they don’t brag about it on social media, than the minority who are not quiet and seem addicted to post that they are a very good person.")]), _vm._v(" "), _c('p', [_vm._v("Why do big brand companies use celebrities to endorse their product? Because celebrities have more influence and power than a porn star or a plumber. People will buy products when they like the person who endorses the product. If you don’t like or you don’t know the person who endorses the product, there’s a possibility you won’t buy the product. If your idol says coconut oil is good for you, you’ll use coconut oil. If Kim Jong Un says you should do meditation every day because it brings you inner peace and is good for your health, would you meditate? I think if you were in North Korea, whether you like it or not you have to do what he tells you.")]), _vm._v(" "), _c('p', [_vm._v("As I mentioned it is harmless to admire a celebrity because of their talent. But when you dedicate all of your energy, time and goals to them, this is dangerous when they are not a part of your life because they have become your life. You worship them, are so obsessed with them, this can harm your mental health. In severe cases some of you think you are their soulmate, have a crush on them, dream of them and even actually think you are married to them. Hence, some of you think you are the real SpongeBob or some of you act like Teletubbies.")]), _vm._v(" "), _c('p', [_vm._v("The term of Celebrity Worship was first coined by Dr Lynn McCutcheon in the early 2000s. A Daily Mail article was the first to use "), _c('em', [_vm._v("Celebrity Worship Syndrome")]), _vm._v(", written by James Chapman who reported a study by Dr John Maltby in the Journal of Nervous and Mental Diseases entitled "), _c('em', [_vm._v("Clinical Interpretation of Attitudes and Behaviours Associated with Celebrity Worship")]), _vm._v(". There are three aspects of CWS:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("The entertainment social dimension where individuals are attracted to celebrities because their talent and skill to entertain and become social focus of conversation with like-minded others.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("The intense personal dimension where individuals have intense feelings and compulsive feelings for a celebrity.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("The borderline pathology when individuals show uncontrollable behaviours and fantasies relating to a celebrity.")])])]), _vm._v(" "), _c('p', [_vm._v("Dr Maltby and his colleagues have found a pathological effect of CWS and poor mental health in the UK such as high society, more depression, high stress levels, increased illness and poor body images. People who worship celebrities for entertainment and social reasons are more happy, outgoing and optimistic. The individuals who worship celebrities for personal reasons are more obsessed, more anxious, more solitary, more impulsive, more anti-social and troublesome.")]), _vm._v(" "), _c('p', [_vm._v("When you have a chance to get a photograph or selfie together with a celebrity, would you post it on your social media? Probably yes, and the majority of the responses from your social media friends are:")]), _vm._v(" "), _c('p', [_vm._v("“Oh, my God, I am a fan of him, too.”")]), _vm._v(" "), _c('p', [_vm._v("“How awesome, he is a living legend.”")]), _vm._v(" "), _c('p', [_vm._v("“I couldn’t believe my luck when I met him. I had to pinch myself, is this real? Man, I was so nervous. I almost cried but he was so down to earth and so likeable.”")]), _vm._v(" "), _c('p', [_vm._v("“He makes great songs. Sometimes I got tears in my eyes when listening to his songs, so beautiful and touches my heart.”")]), _vm._v(" "), _c('p', [_vm._v("Now imagine this, if you have a selfie with a random milkman then post it on your social media, would you get the same response?")]), _vm._v(" "), _c('p', [_vm._v("“Dude, are you desperate for milk?”")]), _vm._v(" "), _c('p', [_vm._v("“A milkman? Brother, you’ve been lactating lately?”")]), _vm._v(" "), _c('p', [_vm._v("Your selfie with the milkman wouldn’t get the same responses as your selfie with a celebrity, I don’t think your social media friends would respond like this:")]), _vm._v(" "), _c('p', [_vm._v("“Oh, my God, I am a fan of milkman too.”")]), _vm._v(" "), _c('p', [_vm._v("“How awesome, he is a living legend.”")]), _vm._v(" "), _c('p', [_vm._v("“I couldn’t believe my luck when I met the milkman. I had to pinch myself, is this real? Man, I was so nervous I almost cried but he was so down to earth and so likeable.”")]), _vm._v(" "), _c('p', [_vm._v("“He makes great milk. Sometimes I got tears in my eyes when drinking his milk, so beautiful and touches my heart.”")]), _vm._v(" "), _c('p', [_vm._v("Now how many of you have been fighting on celebrities’ social media in defence of your favourite celebrity? How much time did you spend just to reply and attack those who criticise your favourite celebrity? How many times do you have to go back to social media just to check who attacked your hero? Why did you act like a celebrity minion? Because you’re biased, you feel an urgency to defend your hero. They can cheat, kidnap, torture even kill some innocents but one word against your idol, they will suffer the consequences. Your children are hungry and lacking attention from you, your family is in debt and sick, no that’s no problem for you, but when your idol is hungry, lacking attention and sick, you will steal a banana from a hungry King Kong and melt Mount Everest for your idol.")]), _vm._v(" "), _c('p', [_vm._v("The question is, when things go south, when you are no longer wanted, who comes and offers you some help? It is not your favourite celebrity, because he doesn’t know you. It is the ones who love you, they could be your family or your best friends because they love you unconditionally even after you ignored them when you were having a good time, but nothing changes their love for you. They are the ones who are trying to reach out to you when you’re having hard times. You will see the truth of who loves you the most when you are in tough times, you are no longer wanted, you are ignored, feeling so hopeless and alone. In saying that, there are many celebrities who have helped some fans who need help and give them support quietly.")]), _vm._v(" "), _c('p', [_vm._v("You may say you treat people equally. Test this, when two people are in the same trouble, they are your hero idol and a random person, who gets better treatment from you? I think the answer will be your idol. Even if your idol has made some serious mistakes in his life, in your mind he is a saint and untouchable forever. You always find a justification to hide your hero’s sins as if you’re saying your hero didn’t make a mistake, it was the environment and people around them who influenced them to make some mistakes. For example, when your idol has been unfaithful to her husband. As a die-hard fan you act like a pro bono lawyer for your hero:")]), _vm._v(" "), _c('p', [_vm._v("“Leave her alone, she’s been in a difficult time for a long time. Everybody gives her a hard time, give her a break, she doesn’t need that. She needs some privacy.”")]), _vm._v(" "), _c('p', [_vm._v("Privacy? Did you give your ex some privacy too when you just broke up because he had an affair with someone one who is younger and more beautiful than you? Did you give your ex a break or did you constantly badmouth him because what he did was obviously wrong? This is what you’ve done and said to your ex when you found out he left you for a younger and more beautiful woman:")]), _vm._v(" "), _c('p', [_vm._v("“How could you do this to me after all the sacrifices, love, time and hard work I’ve done for you!”")]), _vm._v(" "), _c('p', [_vm._v("“Is this how you respect me? Here, respect this blender, up yours!”")]), _vm._v(" "), _c('p', [_vm._v("“Well, if that is your choice, that is your choice. I respect your decision. I wish you nothing but the best. Jesus loves you.” You kiss him and keep praising him while your hand is busy tying his mouth and his body with the duct tape.")]), _vm._v(" "), _c('p', [_vm._v("Your hero had a hissy fit at a fan after he was asked to have a photograph with him or your hero had thrown a punch at a paparazzi, “He had a long flight. He had jet lag, you are not in a good mood to talk to anyone when you have jet lag. It’s totally understandable he’s angry because he’s so tired. We all are human, we do the same, too.”")]), _vm._v(" "), _c('p', [_vm._v("If your husband has a hissy fit because he doesn’t want to take a selfie with you due to jet lag, this is what you probably would do:")]), _vm._v(" "), _c('p', [_vm._v("“Oh, I see. You don’t want to be photographed with me, do you? Here, take a selfie with my slippers in your forehead!”")]), _vm._v(" "), _c('p', [_vm._v("“Ooh… ooh… I had jet lag. Is that what you’ve been telling me? What a princess, meanwhile I’ve been working non-stop at home, cleaning up the house, doing the laundry, ironing your shirts and the kids’, doing the grocery, cooking, all that jazz and I do that on a daily basis and I never complain about housework lag! Meanwhile you just had jet lag once a month after a 12-hour flight, you complain like a princess, you moron lag!”")]), _vm._v(" "), _c('p', [_vm._v("You say your hero has a valid reason to throw a punch at a paparazzi. But imagine if your boyfriend accidentally poked you in the eye, I think that laundry bucket would be on his head. If your boyfriend slammed the door, you would slam the door twice. He punches the table, you would punch his face with your frying pan. No one has a right to abuse someone physically and mentally. You abuse someone not because he or she is weak but because you are mentally weak and it is against the law.")]), _vm._v(" "), _c('p', [_vm._v("Meanwhile if your favourite celebrity pokes you in the eye, you would be so excited you would even post it on social media as a trophy, “Oh, he poked me in the eye. I think I am wet.” He slams a door in front of you, you post it on social media, “No one slams the door like he does, he slams it so good yeaahh…” He punches the table, you post it on social media, “Oh poor darling, just lean on me. Life is unfair sometimes, much love from your biggest fan.”")]), _vm._v(" "), _c('p', [_vm._v("Many celebrity minions like you are there to protect their hero, 24/7. Here are most comments the minions made to defend their God, their idol, against those who speak against your God:")]), _vm._v(" "), _c('p', [_vm._v("“He is just a human like us. Give him a break, please.”")]), _vm._v(" "), _c('p', [_vm._v("“My hero, do not worry, just ignore all those comments from those who try to bring you down. They are beneath you. You are a lovely person, you definitely don’t deserve all these spiteful comments.”")]), _vm._v(" "), _c('p', [_vm._v("“What’s wrong with you people? You all need to grow up and stay positive.”")]), _vm._v(" "), _c('p', [_vm._v("“Anyone who comes here just to rubbish her is a racist and a bully.”")]), _vm._v(" "), _c('p', [_vm._v("Meanwhile these are what you say to your ex when he makes mistakes:")]), _vm._v(" "), _c('p', [_vm._v("“Are you a human or not?”")]), _vm._v(" "), _c('p', [_vm._v("“I used to ignore and worry about what people said about you. Guess what, they were right. They were spot on. You are a sick puppy who definitely deserves all of this.”")]), _vm._v(" "), _c('p', [_vm._v("“Why did you do that? You need to grow up and stay positive, you moron!”")]), _vm._v(" "), _c('p', [_vm._v("“Anyone who curses you and rubbishes you is a good person who deserves a medal.”")]), _vm._v(" "), _c('p', [_vm._v("You always make an effort in your busy time to reply and respond to those people who try to bring your hero down on social media because you feel you are his army who defends your God, your favourite celebrity has become your God. Real life is much more important than the social media world, do you make efforts too to reply and respond to all homeless, starving children and people who desperately need help like what you have done to rescue, defend and support your social media hero? You turn a blind eye when you see someone getting abused on the street but one word on social media against your fave celeb, you will sacrifice your body and soul for your hero.")]), _vm._v(" "), _c('p', [_vm._v("The length of the comments from celebrity minions and celebrity trolls AKA celebrity haters are thousands and thousands of words. Meanwhile, the length of where you are standing at the traffic light and the homeless man who is sitting on the street not even 10 meters away but you choose to ignore him because in your mind he doesn’t deserve to be helped, apart from that you don’t really care where he sleeps on a winter cold night or whether he has food to eat or not, but if your hero celebrity had a mosquitoes bite, oh no, shock horror! The end of the world! It can’t happen. For a second, imagine this, if that homeless person is your celebrity hero or someone you love dearly, what would you do? You’d be crying like a baby and would do anything to help him and give him shelter.")]), _vm._v(" "), _c('p', [_vm._v("Celebrity minions worship their idol like a God, meanwhile celebrity trolls love to hate the celebrity or a particular celebrity for nonsensical reasons. For example, one celebrity posts a harmless photo on his social media, “Enjoying my coffee.” These celebrity grinches quickly curse and condemn that celebrity because he drinks a coffee, as if that coffee is more deadly than a nuclear bomb.")]), _vm._v(" "), _c('p', [_vm._v("Celebrity trolls always find a fault about anything in the celebrity they hate, then blame him for that. They will blame the celebrity for anything, even for your acne, it’s his fault. It is raining, it is that celebrity’s fault. It is a sunny day, it is his fault too. Meanwhile the celebrity minions do the opposite, sacrificing their life and soul for celebrities. But when it comes to the much bigger problems, celebrity minions and celebrity grinches refuse to see them. The big corruptors or local gangs are committing a serious crime which causes so much damage, these celebrity trolls and celebrity minions turn a blind eye. Why? Because they are too afraid to stand up for justice, because they are too afraid of big criminals, so they just bark at little puppies, not the bear. Celebrity trolls and celebrity minions have something in common, they don’t see an elephant in the room but they can see an ant on the other side of the ocean.")]), _vm._v(" "), _c('p', [_vm._v("Treat someone and do something as if you do it for someone you love. Treat everyone equally, it is not about occupation, social status, the colour of the skin, a gender, appearance, marital status, disability, religion, nationality, age, or how much they have in their bank account, but it is the way you conduct yourself that matters the most. God doesn’t give you what you want but God gives you what you are.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "news-anchor-social-media-hero-and-the-news-breaker"
    }
  }, [_c('h3', [_vm._v("News Anchor, Social Media Hero and the News Breaker")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("If social media existed in the year 1912, the sinking of the RMS Titanic would’ve been the biggest talk on social media as the news would’ve spread around the world within seconds. Now these days, you don’t need a TV to give you a news break. Just look at your social media home page, someone out there will share the news break faster than your man in bed.")]), _vm._v(" "), _c('p', [_vm._v("There is a competition for who is the first one who posts breaking news on social media. Breaking news or first news is like food, you like your food fresh from the oven, you don’t like the leftovers or yesterday’s food. Everyone loves fresh food, served warm. And that news has got to be something so big, so bizarre, so spectacular, so viral, something that can attract the most attention and make their jaw drop on social media such as Kim Jong Un receiving a Nobel Prize for being so romantic. If the news is your grandma just knitted you a poncho, it won’t sell on social media.")]), _vm._v(" "), _c('p', [_vm._v("“Breaking news, my grandma just finished knitting my poncho. According to witnesses it took three days to knit this pink poncho. As I am standing here, grandma just packed her knitting equipment. I said to grandma we all need more people like her and my grandma said to me to fuck off.”")]), _vm._v(" "), _c('p', [_vm._v("“Breaking news, a milkman has been here. We found evidence of some milk drops in our front yard. No witnesses but CCTV captured that the milkman just left the building with soymilk and full cream milk.”")]), _vm._v(" "), _c('p', [_vm._v("“Breaking news, my teacher’s pants have no back pockets.”")]), _vm._v(" "), _c('p', [_vm._v("Most of the news on social media is not about current affairs, it is about yourself. News about promoting how good you are. One of the most common posts on social media is a filtered and photoshopped selfie with a wisdom caption:")]), _vm._v(" "), _c('p', [_vm._v("“My greatest contribution may not be something I do but something I raised,” the caption on your selfie with your mouth open like a mini egg holder to give a sexy impression like a Marilyn Monroe.")]), _vm._v(" "), _c('p', [_vm._v("“Never stop chasing your dream,” on your selfie with a duck face.")]), _vm._v(" "), _c('p', [_vm._v("“Happiness is not my destiny but it is my life.”")]), _vm._v(" "), _c('p', [_vm._v("“I feel deeply, I am oversensitive and emotional. You recognise the lies before they’ve been said,” coming from someone who uses Botox and photoshopped social media photos and your social media is full of your photos of being half undressed or wearing nothing at all. Right, we see your point. You think deeply and recognise the lies before they’ve been said.")]), _vm._v(" "), _c('p', [_vm._v("The news anchors who deliver the news, nothing but news about herself and how good she is, usually use this strategy to attract more viewers on their news by posing:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_vm._v("Duck faced, this pose makes your lips move forward, curled up, sensual and making your lips like a ponytail on your face.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4.6161in",
      "height": "6.60738in"
    },
    attrs: {
      "alt": "",
      "src": "media/file3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("2-   Sitting down and spreading the legs with pointy toes or standing with the legs wide open, on tippy toes, as if you are a goalkeeper in a soccer match. This spreading legs pose makes your legs more toned, longer, more open plan for air circulation as if you are saying, “Yes, I am open. Come in please, all welcome.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("3-  Seductive lips on social media by moving your lips forward, curling them up and opening them slightly, showing a bit of your teeth as if you’re saying, “Mooo…” like a cow.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("4-  Head tilted to the side a bit. If the photo is taken from the left side, the head is tilting to the left, if the photo is taken from the right side, your head is tilting to the right. Not too much tilting as if your forehead was 2 tons heavy. If your photo is taken from both sides, left and to the side, you tilt your head back showing off your smiley nostrils.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("5-  On tippy toes, to leave an impression that your legs are longer and one hand on the hip. That pose when you have big toes. Those toes are really screaming, shaking, perspiring and doing anything they can to hold your body weight, “Oh my God! I am suffering here!” Your toes are the only ones that touch the ground. It’s easy to distinguish social media users who use this pose a lot, ask her to take her shoes off. When you see her toes are like a ginger or she looks like an escargot, ha! You know she likes posing like that.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("6-  Baby giraffe pose, sticking your bum out and putting one foot forward and the other behind with heels raised a bit. Why? Because this pose makes your legs longer in the photo. This baby giraffe pose was coined by Eva Chen, Instagram director of fashion partnership. This pose is much sexier than the monkey swinging pose.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("7-  My handbag is my identity. Your handbag must be seen from every angle, the brand of the handbag must be in front, not back to front. So anyone who sees your post will know that you are the owner of that expensive handbag. You’ve got to have a variety of expensive handbags. The more expensive the handbag is, the more secure you feel."), _c('br'), _vm._v("\n\nYou post a photo of your holiday, your handbag is there. You have dinner, your handbag is on the table too having dinner. You get together with your friends, your handbag gets social too. Sometimes your handbags have the privilege to be photographed alone, without you. You’re having a shower, shampoo in your left hand and your handbag is in the other hand. You’re having sex, you’re still carrying your handbag."), _c('br'), _vm._v("\nIt is everywhere you go, even when you’re diving in the ocean, your handbag is there to show it off to the sharks, whales, crabs, prawns and all those sea creatures. We can see a group of dolphins looking at you in disbelief, “This human must be nuts.” You go to the moon, you’re carrying your handbag, too, showing it off to the aliens, “You might be the most intelligent in the milky way, but you don’t have a handbag like mine.” The aliens just shake their head, and respond,"), _c('br'), _vm._v("\nThis is why we don’t live on Planet Earth. Those trailer trash, nutters, handbag maniacs, psycho selfies, duck face selfies, mirror selfies, and those cow lips selfies with moo moo lips. We conquered the universe while they conquered every bathroom to get a selfie. On top of that, those bra fights over politics on social media. We think with our brains and they think with their armpit. No, we don’t do that crap, we travel faster than the speed of light while they travel with the speed of selfie sticks. Let’s go."), _c('br'), _vm._v("\nWhen you get arrested, your handbag gets arrested too. In your mugshot, your handbag is there with you. Without your handbag, you feel nothing, hopeless, poor and with no identity. You don’t remember what your name is without your handbag, because it makes you who you are. Expensive handbags make you feel powerful, optimistic, self-confident and they upgrade your social status.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("8-  Mirror selfie, ain’t no news anchor delivering the news from the bathroom like social media users. The news is about the anatomy of your body. It’s great news you have six packs, two big papayas behind your bra or without a bra, your lingerie, and your two back seats AKA your behind (they’re not recliner chairs). This news is designed to leave a memory, stimulate the imagination and be open for interpretation by the viewers. Many viewers see it like a super discount on online shopping, some might find it distressing, some need parental guidance, some see it like a house layout; as they can see where the laundry and the double garage is, some just need a cigarette after enjoying the discount.")]), _vm._v(" "), _c('p', [_vm._v("There are some of you who become the first news witness on the site filming the moment, then post it live on your social media,")]), _vm._v(" "), _c('p', [_vm._v("“Guys, I am here at the location. Yes, I can hear the volcano rumbling and there is a huge mushroom cloud of smoke coming out of the volcano, it is really scary.”")]), _vm._v(" "), _c('p', [_vm._v("“What about that smoke coming from that house behind you? Did you see that?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, it is not the volcano. That white smoke is coming out from that house because they’re smoking the ganja.”")]), _vm._v(" "), _c('p', [_vm._v("Sometimes you don’t need the weather bureau to tell you the weather today or what’s coming:")]), _vm._v(" "), _c('p', [_vm._v("“I can feel it. The wind is so strong, a storm will be here anytime soon.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God, it is a beautiful double rainbow.”")]), _vm._v(" "), _c('p', [_vm._v("“At last we have some rain, we need rain.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh my God, it’s raining, bucketing down. I forgot to get my laundry, it is still hanging on the clothesline.”")]), _vm._v(" "), _c('p', [_vm._v("In some cases when an accident happens, the first thing to do is not to help the victim who got trapped inside the car and call the police but the first thing you do is take a photo of that accident then post it on your social media:")]), _vm._v(" "), _c('p', [_vm._v("“Poor man, trapped inside the car:”")]), _vm._v(" "), _c('p', [_vm._v("“Has someone helped him out of the car yet?”")]), _vm._v(" "), _c('p', [_vm._v("“No.”")]), _vm._v(" "), _c('p', [_vm._v("“How far are you from that man?”")]), _vm._v(" "), _c('p', [_vm._v("“I am standing in front of him.”")]), _vm._v(" "), _c('p', [_vm._v("Social media has this ability to detach your morals value from life. Dead bodies and graphic images are used by you to get attention on social media, some of you even use those graphic images for your lies and political propaganda or you just use those inappropriate images for likes. Imagine if that victim was your father or your loved one, or imagine if that victim was you. They don’t want to be used by you as your breaking news on your social media just to get attention and comments, they want your empathy and your action to help them. Respect the victims, respect the deceased more than getting obsessed about getting likes on your social media.")]), _vm._v(" "), _c('p', [_vm._v("News doesn’t have to come from TV stations or the radio. Social media news comes from anywhere, from your bathroom, from your bedroom, from random people, random news and just tuning in. Your social media is your TV station, the news on your TV is your news, your version. It doesn’t have to be based on the truth, it just comes from what you think and feel. There are three kinds of news: you want the world to see you, you try to convince the world this is wrong or right, and how you see the world through your eyes and your mind. Sometimes you are too emotional when you deliver your news, it is 90% based on your anger and disappointment and 10% based on common sense.")]), _vm._v(" "), _c('p', [_vm._v("There is good news and happy news that puts a smile on our face. There is news that make us laugh hard and entertain us, because some people have a great sense of humour, as we all need a few laughs after all the drama and self-promotions on social media. It requires brain cells to produce very witty humour that makes us laugh. It is easier to take your clothes off then take a selfie to make men worship you than make men fall in love with you because of your sense of humour.")]), _vm._v(" "), _c('p', [_vm._v("The good thing about sharing good news is, it’s infectious. They’re happy you’re happy too. Don’t you love good news on social media? Love to see social media sharing happy moments such as wedding photos, graduation photos, a new addition of a newborn baby, anniversaries, and so on. Happiness is limitless, is the thought that gives you energy and happiness (Except for narcissists, Machiavellians, and trolls. They will be happy if you are in trouble).")]), _vm._v(" "), _c('p', [_vm._v("Happiness is the response from what you see, hear, think, do, say, taste, feel, touch and smell. It makes you happier when you make someone happy and you give something to help those in need. Or you receive a little thing from someone, such as a kind word, that makes you happy. With happiness, comes gratitude, you are blessed for all the life and love you have and give. We need more happiness from all over the place, anytime, from random people; kindness and love is priceless.")]), _vm._v(" "), _c('p', [_vm._v("Even looking at a baby photo will make you happy. When some social media user shares her newborn baby photos, you smile and feel happy too as you’re looking at those photos. Give them a heart emoji, feel the joy, “Ooh… isn’t she adorable?” It melts your heart away. So cute and super adorable, melts your heart. Then you see the photo of the father, “Jesus!” Your jaw is dropping and your blood pressure is going higher and higher than Mount Everest! Why? Because he is one of your exes.")]), _vm._v(" "), _c('p', [_vm._v("Now you’re in a dilemma because you like the baby but dislike the father. There he is, your ex, the one who said he loved you forever, he would love to have a family with you but it didn’t happen and now he is happily carrying his new son looking at you as if he says, “You like?” Should you like or dislike? Should you click the slap in the face emoji or kiss on the face emoji? Or you are just simply happy to see your ex is happy, I am sure you wish him nothing but all happiness in the world (Did I hear you just bumped your head on the table?).")]), _vm._v(" "), _c('p', [_vm._v("We are overloaded with news because this is social media, so it makes our attention span shorter. If the Titanic happened after social media, definitely it would’ve been the biggest news on social media and the most hash tagged, but because too many news would come in and out, the Titanic news would only be viral for a short period like it was yesterday’s news because we shifted our attention to different news.")]), _vm._v(" "), _c('p', [_vm._v("Please discover all the latest news, live from bathroom and bedroom around the world. If you are considering to be a news anchor, dress the part like social media news anchor! They keep you informed in their lingerie, topless even in nude, but wait, there is more, you have to deliver the news with the duck face and filtered camera.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "food-eyes-and-our-mind"
    }
  }, [_c('h3', [_vm._v("Food, Eyes and Our Mind")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("There are five basic things humans need to survive, air, alkaline water, food, shelter, and sleep. In extreme conditions we can survive without air for three minutes, three hours without shelter, three days without water and three weeks without food.")]), _vm._v(" "), _c('p', [_vm._v("Food is related to all of us. In many Asian countries, food is not just food. You want to respect their culture, you have to respect their food, too. It is a big thing as food is a part of their life, culture, family and tradition. This is one of their customs through which they communicate. Eating out and eating together is considered a family tradition in many countries.")]), _vm._v(" "), _c('p', [_vm._v("They respect food as a part of family and their culture. In some countries, it is rude to clean one’s plate but in some, it is considered as honouring the host who gave you the food. In many countries it is considered rude to slurp food, meanwhile in some countries slurping is encouraged to improve the flavour of the noodles and as evidence that we enjoy the food. In some Asian countries, the eldest of the family is the first to have the first bite as a sign of respect to the elderly.")]), _vm._v(" "), _c('p', [_vm._v("Food is also closely linked to religion. Sacrifices and feasts were part of rituals in ancient history. Before the Olympics were started in Olympia, Greece, they sacrificed 100 oxen for Temple of Zeus. These 100 oxen were roasted on an altar and consumed in a huge feast. For many people who live in gadget times, food is considered as a social media post, something you consume every day to live. We live in cyber life closer than real life, and according to a study in 2017, 69% of millennials take photos of their food before eating it.")]), _vm._v(" "), _c('p', [_vm._v("According to science, our brain is the most bloodthirsty organ, the brain uses 25% of blood flow or energy despite the brain being only 2% of our body mass. The largest increases in cerebral blood flow occur when a hungry brain is exposed to images of delicious food. In seconds, our brain makes a judgement call on how much we like the food we see and the quality of the food.")]), _vm._v(" "), _c('p', [_vm._v("The most important thing in our life is not something we can touch or something we can see, but it is something we can feel. The right answer is love, but for soberdicts, AKA social cyber addicts, the answer would be Wi-Fi. It is a very important thing in their life. This is cyber life, visual life. You can’t see it (only the Wi-Fi sign), you can’t touch it, but you can feel it. You eat with your eyes, you have sex with your eyes, you complain because of what you see with your eyes. That’s why there are like buttons and dislike buttons.")]), _vm._v(" "), _c('p', [_vm._v("Before aeroplanes, internet, smartphones and Wi-Fi, food photos didn’t exist for a very obvious reason, cameras had not been invented yet. No camera, so how did they capture the moment of food? They painted it. There are many famous food paintings done by famous artists such as Vincent Van Gogh, Claude Monet, Paul Cezane, Edouard Manet, and many more. Even Pablo Picasso painted food, too. This is when food turns into an art, something so beautiful that gives you pleasure and joy to look at. It will cost you your grocery bills for decades and also your house as the price of those paintings will make you go be exiled in Tibet.")]), _vm._v(" "), _c('p', [_vm._v("That was then, now you don’t paint the food to capture the food, you photograph your food and use the hashtag food porn, yummy. When you read this, there are 168,375,343 food posts on Instagram. There are pros and cons about this food photo. The majority don’t have any problem at all looking at a photo of a long potato making out with a sweet potato, a glazed doughnut or two frankfurters trapped in one bun whilst some get offended by those buns and sizzling sausages. Taking photos of their food is a part of many social media users’ ritual.")]), _vm._v(" "), _c('p', [_vm._v("The reasons why you are against meat lovers, doughnuts and all those food photos on Instagram are:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Look at me, this is what I have for lunch.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Over-sharing.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("People share their food photo because they have nothing to do.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Have you ever seen the food before? Do you have to take photos of those tortillas and chicken wings so you can remember them? Your argument is we eat the food, not look at the food. We don’t have to look at the singer but we listen to the song she sings.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Mental illness.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Asking for validation.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("I can afford this food whilst many children are starving in third world countries, imagine if those people who can’t afford to buy food are looking at your Instagram.")])])]), _vm._v(" "), _c('p', [_vm._v("Here are the answers for those cupcake rangers from the food lovers who enjoy sausages, sweets, greens and that food that you can swallow and digest.")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Yes, this is what we have cooked for lunch. No, this is not about look at me, look at me, but please pay attention more to the food, not to yourself.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Yes, guilty. We take photos of food that we enjoy swallowing. We don’t swallow things we don’t like, contrary to your view against food photos, you point your finger at chicken asparagus with soy sauce as the biggest criminal of all, more than drug dealers and slavery. Hang on, we don’t see you pointing your finger at the crime gangs and drug syndicates as they cause more grief in our society than a cucumber sandwich. We feel good to capture the moment of food because it’s a wonderful feeling when we can touch it, smell it, and taste it. Just like you when you snap a photo of a beautiful girl in a bikini on your social media, because you post photos when you like the view, in this case your view is a sexy girl in a bikini. Sorry if you get offended by pickles, perhaps those two watermelons’ juice left a bad taste in your mouth or you get hiccups because of those small gherkin pickles. A sausage in the wrong mouth can taste so bad, too, you know. Yes, we can see your point.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Yes, when we’ve got nothing to do. We post anything we like on social media, it could be a food photo. As you say, you don’t look at the music sheet but listen to it as food is to eat, not to look at. Meanwhile, you don’t turn the volume up when you watch that movie, erotica granny. You taking photos of two mountains doesn’t mean you have to climb those mountains, you are just simply enjoying the beautiful view. You taking photos of beautiful girls doesn’t mean you have to enjoy those beautiful bodies, but we just admire the beauty without thinking of the karma sutra. Well, you wouldn’t have any hesitation to say no when a beauty asks you to date them.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("As the answer for that question, “Have you ever seen food before?” This is the same question for them, “Have you ever seen a smartphone before?” Is that why you keep staring at your smartphone just to search for something you don’t like and complain about it? Of course we capture it to remember it, share it, cherish it and respect it.\n\n"), _c('br'), _vm._v("Just like when you post something on your social media, not because you want to remember it but you want to share something you love and which makes you happy. Or in many cases, you express your point of view on social media not because you want to be remembered but because you are entitled to expressing your opinion as you have the right to share your thoughts.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Mental illness"), _c('br'), _vm._v("\nMental illness is a condition which causes serious disorder in a person’s behaviour or thinking. Mental illness is a very delicate matter, never label someone as having a mental illness just because you disagree with someone or some people. It is a serious problem, and a major factor of suicide. There are about 4,000 family homicides in the USA every year, individuals with serious mental illnesses are responsible for 29% of these. 67% of children who killed their parents are seriously mentally ill, as are 10% of spouses who killed their spouses."), _c('br'), _vm._v("\nBe careful and more sensible before accusing someone of having a mental illness problem just because you are upset with those cupcake photos. If you explode just because you see a cupcake, now you know which one has the mental issue. Asparagus doesn’t kill, but anger, revenge, or lacking morality or empathy can kill. Well, for some people looking at those doughnuts, it can send them a wrong message, especially when the hole is glazed by the wrong person")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Asking for validation, some of you might have asked for validation, but the majority don’t. Actually, the most questions have been asked not for validation, but for recipes, how to make this food. Many people also ask why their cakes are not raised but domed or why my soufflé doesn’t jiggle. People do things for reasons, some for good reasons, some craving compliments and many other reasons. Every post that you have posted on social media has intentions and motives. When it comes from the heart, it is genuine. But when you put ego on it, it becomes selfish.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("The critics who criticise that food photos are an act of selfishness because some children are starving in Africa, are entitled to say that. The thing is, all those starving children don’t have a smartphone to access social media. Logically, if they can’t afford to pay for food, they can’t afford to buy a mobile phone."), _c('br'), _vm._v("\nTo view a food photo, it doesn’t have to be seen on social media. It is everywhere, in magazines, TV ads, billboards, buses, and many more. If they say that chocolate muffin photos might offend some starving children, what would they think when those starving children see holiday photos, beautiful houses, cars, designer label bags and much more on social media or any other media, which are much more expensive than a muffin."), _c('br'), _vm._v("\nUsing starving children to make food lovers feel guilty is a strategy gone wrong. Never use starving children to make you look like a saint with the best moral values. It is the same as using a homeless man just to put down people who just bought their first house after many years of saving money and hard work. Do you get offended too by the clothes we are wearing? Are you going to say this, “Starving children can’t afford to buy those clothes?” Did you take your clothes off of social media because people in extreme poverty can’t afford to buy clothes?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Some might say, it is okay if the food photo is taken by chefs, restaurants or people who work in the industry for their business. Absolutely agree, it doesn’t have to be a travel agent to travel around the world, it doesn’t have to be a news anchor to share news on social media, it doesn’t have to be a real singer to sing a song, it doesn’t have to be a baker to stuff cream in the tart. However, there are some high-end fine dining restaurants that forbid photo taking in their restaurant.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Food is a culture in many countries whilst in some countries, food is just merely something you eat, thus causing you to not understand why many share their homeland’s food on social media.\n\n"), _c('br'), _vm._v("Some religions don’t eat pork, some don’t eat meat, some don’t eat with their hands, whilst in some cultures eating with hands is to respect food apart from Ayuverdic teachings, as extensions from five elements: space, air, fire, water and earth."), _c('br'), _vm._v("\nSharing food is sharing culture, if you get offended by their food, it could be a translation that you get offended by their culture. You say, “But those food photos aren’t of their homeland food.” Yes, we get it. Sharing food photos makes them happy. You sing because either you like the song or you love singing, or both, and singing makes you happy. Just like them. They miss their homeland, they share their food. By sharing their homeland food, it makes them feel close to home because they miss their family, country and home."), _c('br'), _vm._v("\nIt is the experience like when you travel the world, you share your travel photos. Do we get offended by your mountains and lake photos? Do we use ‘starving children’ because we get offended by your holiday photos (however, narcissists post their expensive holiday photos to get validation)?"), _c('br'), _vm._v("\nSocial media is universal, many languages, cultures, religion, races, countries, food, places and we share those experiments, as we respect each other, including each other’s culture.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Sharing food photos is the same as sharing art photos or make-up tutorial photos or videos. You may disagree with people’s dinner as you see it as a bad attitude to share food photos on social media. If you get stressed seeing those paw paw salads, we recommend you stay away from the kitchen and social media. Because social media contains some traces of nuts.")])])]), _vm._v(" "), _c('p', [_vm._v("Several studies published in Psychology Science found that some people who took their photo before eating it reported enjoying the food more compare to those who just sat and ate right away. The longer delay between the ritual and the meal works even better, as it increases pleasure anticipation.")]), _vm._v(" "), _c('p', [_vm._v("Researchers from the University of Pennsylvania, University of South Carolina and Yale University, presented in detail the act of photo-taking: when it is done in a positive experience, as long as it doesn’t interfere with the experience. 23% of Instagram users post their photoblog with daily meal photos. 22% of food photos are homemade to show talent. Pizza, coffee, beer and Starbucks are the stars of social media. The most searched recipe on Google is pecan pie. While you’re reading this, already over 200,000 food photos have been posted on social media.")]), _vm._v(" "), _c('p', [_vm._v("Social media has produced so many stars, not just people, including food. Some of them are mirror cakes, which became viral and still is the major star in social media in the food category. Unicorn cakes, rainbow bagels, crazy milkshakes, pokes, cronuts, mousse cake with velvet spray and many more.")]), _vm._v(" "), _c('p', [_vm._v("The positive reasons why social media users post their supper:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Food is their culture, their food represents their culture. Respect the culture, respect their food, especially cultures in Asian countries where food is one of the media of their communication. They are proud of their food just like some people are proud of their national anthem. In some countries, a particular sport is a part of their culture and represents their culture.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Sentimental attachment, memory. Sharing food photos can stir some memories. Same as when you share your favourite song that has a special attachment to your heart. It could be family, friends, or childhood memories.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Because you are creative and have skills. Some people show their skill of drawing, making a dress, cooking, knitting, making furniture and toys, and so on")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Encouraging others to be creative, innovative and to learn. Learning and presenting the food is like a making a piece of art. When you have passion doing something, you do it from the heart. There are many food tutorials on social media.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Business purposes or it is a part of their job"), _c('br'), _vm._v("\n\nMany professional chefs and restauranteurs post their food photos almost every day to promote their business.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Sharing the experience to make them happy. Some people play piano to make them happy, some people bake, some people share their family photos, some people share their photos when they are swimming or doing other sports.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Homesickness. I know this sounds a bit weird, but many Asians who live outside their homeland share their homeland’s food as an expression of feeling homesick. To cook the meals they love or the popular food in their homeland makes them feel closer to where they’re from")])])]), _vm._v(" "), _c('p', [_vm._v("The negative reasons why social media users post their food photo:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("I am so great"), _c('br'), _vm._v("\n\nNarcissists write their accomplishments or how great they are on social media. They’re not shy to describe themselves as a self-taught chef, a sky diver, a singer, a scuba diver, a dancer, a Nobel Prize winner (even though they never won any medal in their life) on their social media. They cook not because they love cooking or sharing their experience or giving other cooking tutorials but because they post their food photos for their ego. They get jealous when another social media user has the same skill as her or even is more talented than her. Narcissists post on their social media for competition:"), _c('br'), _vm._v("\n“Whoa, I have to put more cream in my eclair because the other foodie just posted a photo of eclairs. I have more cream than yours.”"), _c('br'), _vm._v("\n“Oh my God, she made a unicorn cake with a golden horn and received more likes than me. That’s it, I am going to post my unicorn cake too with two golden horns which are bigger, longer, stronger and glow in the dark. I’ll get more likes than her.”")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("They post the receipt of their dinner"), _c('br'), _vm._v("My dinner is bigger and more expensive than yours, they posted the receipt to show off that they can afford a ten-thousand-dollar dinner (the most expensive caviar is more than US $30,000). They want people to be amazed by how much they spend on a bottle of wine, and of course they want you to like their post. The more desperate you are, the more you want to show off.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("The location of where they take their food photo"), _c('br'), _vm._v("We’ve seen some social media users post their high tea at a Presidential Suite of a five-star hotel, having lunch on a private jet, having salad on their super boat. The locations matter the most, it is not the food but the location that screams so loud where they’re eating.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("The intention and motive as to why you post food photos"), _c('br'), _vm._v("\nThis applies to any social media post, some posts come from good intentions, there is no malice there. Some are motivated by ego, anger, jealousy, and attention seekers. Two ordinary people share a photo of a cupcake. One is motivated by good intentions (sharing the experience, sharing the recipes, cooking hacks, and tutorials) and the other one is motivated by how many likes she gets on her post.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Unhealthy lifestyle"), _c('br'), _vm._v("You are obsessed about food and addicted to food. There is a difference between people who share their food photos as a part of their joy, and food is the only one joy for some people. People who respect food have one button which is called a control button. They can control their emotions, they know when to start and when to stop. They enjoy everything and blessings in their life including their family, their job, their well-being including food.\n"), _c('br'), _vm._v("Some people with food addictions don’t have that button: the control button. They don’t know when to stop. The medical definition of obsession is a persistent disturbing preoccupation with an often-unreasonable idea or feeling, an impulse that continually forces its ways into consciousness.")])])]), _vm._v(" "), _c('p', [_vm._v("In saying that, it doesn’t have to be food, some people don’t enjoy their life because they don’t have that button: the control button. That is why they turn to criticising people on social media. They don’t know how to control their life and start learning to accept their life and to be happy and grateful for what they have. If there’s no control button, they won’t be able to control their mind and emotions. Being without a control button is like having a car without a brakes, it can speed but it can’t stop, when it stops, it stops violently. The worst-case scenario is that someone is going to get hurt, the one who will get hurt the most is you.")]), _vm._v(" "), _c('p', [_vm._v("According to Apicius, a Roman gourmet and author in the first century, the first taste is always with the eyes. In social media, the first judgement is always with the eyes because social media is a virtual world. One hour reading or looking at your social media, your eyes make nearly 10,000 coordinated movements. The most active muscle in our body isn’t your muscles in the legs or arms. It is your eye muscles. Our eyes have over 2 million parts with the ability to process 36,000 bits of information every hour.")]), _vm._v(" "), _c('p', [_vm._v("Our subconscious minds can process 20 million bits of information per second, the conscious mind only processes 40 bits of information per second. So the subconscious mind can process 500,000 times more what the conscious mind is able to process, according to The Biology of Belief by Dr Bruce Lipton. As mentioned above, from those 20 million bits of information per second passing through our subconscious minds, we are only able to catch 40 bits of information. When you read your social media, your conscious mind grabs 40 pieces of information per second. They could be who’s dating who, the weather, politics, likes, comments, emoji, and so on.")]), _vm._v(" "), _c('p', [_vm._v("Some of you use those 40 bits of information every second like this: 20 bits for money and 20 bits for food, so nothing left. Or 10 bits for work, 10 for Netflix and 20 for nice tits. That’s it, no more space in your conscious mind as you’ve used the maximum capacity. Even many men use those 40 bits exclusively for nice tits, this is not a matter when men don’t want to think, it is because their capacity is already full, they can’t think of anymore as they used all 40 bits for nice tits. You see there’s a sign in their brain: no vacancy. Meanwhile women use those 40 bits to the maximum, their conscious mind is running like a super athlete, chasing those 40 bits faster than Wonder Woman picking up the kids, groceries, what they’re going to cook today, doing the gardening, laundry and much more.")]), _vm._v(" "), _c('p', [_vm._v("This is the problem with men. You are given an opportunity to have 40 pieces of information per second. But many of you use those 40 bits of information just thinking of nothing, AKA zero, blank, nothing at all. Your conscious mind doesn’t want to catch those 40 information pieces per second, don’t ask to be active and grab those 40 bits of information, your subconscious mind doesn’t even bother to move, it chooses to lie down under instruction from you, the commander. Men have this talent, which is thinking nothing at all. If it is a house, just nothing inside, don’t ask for a chair, they don’t even have a bathroom.")]), _vm._v(" "), _c('p', [_vm._v("Why do men like this nothingness? Because it makes them happy and relaxed. So when you ask a man,")]), _vm._v(" "), _c('p', [_vm._v("“What are you thinking?”")]), _vm._v(" "), _c('p', [_vm._v("“Nothing.”")]), _vm._v(" "), _c('p', [_vm._v("It means they really think about nothing, and they really mean it. While women are quiet because they are upset or they are giving their spouse punishment to figure out for himself what he’s done wrong, when a man asks his lover why she’s so quiet she would answer, “Nothing.” She says that but you know there is something.")]), _vm._v(" "), _c('p', [_vm._v("Pay attention when a woman says, “Nothing.” That ‘nothing’ will cost you big things. Why? Because you’re the one who caused her such upset and you should know about it. When a woman is quiet, she is giving you the time to figure out what you have done wrong to upset her (not all women are quiet when they are upset). A man has to figure it out before the deadline, or else he will suffer the consequences. Sooner or later your woman will post something on her social media about her ‘nothing’. You want to know how your woman feels? Read her social media. Then you know if you’re going to sleep on the sofa or in bed tonight.")]), _vm._v(" "), _c('p', [_vm._v("Actually, social media posts are like food. Some look tasty, some look like road kill. Some taste sweet after you read it, some make you throw up or even pass out after tasting it. Some of that food is familiar to you as you know the real ingredients and the authenticity, but you know it’s been modified. Your eyes see and taste it by looking at the colours, presentation, the authenticity, the shape, the calories, its nutrition, and the ingredients. Some look tasty but are full of bad calories, some look not so tasty but are good for health. Some food tastes so bad that it will make your jaw drop or you’ll roll your eyes or wrinkle your forehead or a combination of those. Some people become a food critic, but many just enjoy the food. Just like social media posts, they are like food in your eyes and mind as you feel the aftertaste after reading it.")]), _vm._v(" "), _c('p', [_vm._v("If you think food is overshared and irritating, you’ve got nothing to do, how many of you have viewed porn sites when you’ve got nothing to do? Do you enjoy viewing woof woof style, cluck cluck chicken style and quack quack style? You enjoy watching and looking at that food that has been placed strategically on that porn star body. We understand that, I can’t believe it’s not butter. The difference is, enjoying food photos doesn’t betray your spouse, and enjoying adult movies or some beauties on social media does betray your spouse.")]), _vm._v(" "), _c('p', [_vm._v("If food photos offend you, stay away from the light.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-mosquitoeses-aka-big-girls-blouse"
    }
  }, [_c('h3', [_vm._v("The Mosquitoeses AKA Big Girl’s Blouse")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("Yes, I love to troll and put people down. I love to make you afraid and angry, I take pleasure in doing this. I’ll do anything to make you feel bad. I’ll call you names, I’ll slander anything you say. I’d slander Einstein, too, for being too much of a genius even though my math and physics score was bad, and on top of that I don’t understand and will never understand his theory. But I don’t care, as long as I can make him feel bad, that’s what I care about.")]), _vm._v(" "), _c('p', [_vm._v("The more you are angry, the happier I am. This is my mission online. I’ll hunt you down, I’ll go anywhere you go, you can’t run, you can’t hide, because I am your nightmare. But don’t ask me to show my real face and real name, especially my real address. Because when I turn my computer off, I am a coward, too scared to face anything. If you come and confront me in real life, I’ll wet my pants and run like a little girl. But in the online world, I am your Satan, a tough and frightening Satan even though my mental stability is like a soufflé, undercooked, easy to dissolve and melts.")]), _vm._v(" "), _c('p', [_vm._v("I do this because I am so insecure, weak, and afraid because I have been bullied and abused in my own house too. Trauma at home and in my environment makes me a bully online. This is how I compensate for myself to escape the bitter reality I deal with. I don’t like to see people happy, I hate it when they are smarter than me, I have to do something to make that person as stupid as possible. If they feel happy, I have to make them upset as possible. Why? Because I want everyone to be like me, unhappy, weak, insecure and miserable. Of course I will not confess that online. I have to show them how tough I am, even though I get beaten up and abused every day at home.")]), _vm._v(" "), _c('p', [_vm._v("I am a prisoner of my own fears. I can’t escape from reality. That’s why I directed my frustrations, pain, hurt, broken heart, anger and difficulties towards bullying someone online. It hurts me when I don’t have enough attention from my parents and people I love. I am falling apart deep down inside myself. I am envious of you who have everything I want but I can’t have it, which is love and security. I don’t have them, but I wish. That’s why I become a bully at school and online to make me popular and tough.")]), _vm._v(" "), _c('p', [_vm._v("It frustrates me that I can’t take you down, I can’t defeat you, even after all my best efforts to knock you down. I say the worst to you but you just laugh your head off. I think I am scary but you say I am fluffy, a joke. I hate this, when people are not afraid of me online. I say I am so vain but you say I am so plain. I say I am scary but you say I am sentimental scary. I say I am so strong but you say the only strong parts in me are my eyebrows. I say I am your nightmare, you say I am your teddy bear, soft and cuddly. I say I am so sour, you say the only sour part in me is my armpit hair.")]), _vm._v(" "), _c('p', [_vm._v("Look at me in the eyes, I am evil but you say the only evil part in me is my cholesterol level, that I should stay away from fries and cakes. Didn’t you listen to me? I’m so bad, a badass. You say not as badass as my earwax. I love it when people call me a psychopath, but you say I only turn into a psychopath and brutal when I open the fridge. I scream loud again that I am a real psychopath, but you reply by saying that I am a chocopath, yes I am a big fan of chocolate cake. I say I am scary, you say I am so tasty.")]), _vm._v(" "), _c('p', [_vm._v("I will savage and demonise every word you say. Don’t you get it? I am a troll online. A trolll… But suddenly your eyes light up and look so happy, you say, “Ohh… I love a troll, I do love a troll cake. Trolled by a baker and fill it with jam, yummy yummy.” Again, you cut me deep by saying that I am your rolled cake. I am your recipe for disaster but you say I am your cupcake recipe.")]), _vm._v(" "), _c('p', [_vm._v("Yes, I can do and say anything I want. All of my posts and childish emotions show that I have unstable mental health. I can invite my friends to hate you too, this is why when I turn my computer on, I just concentrate my attention on hurting you. Do I have a real job in real life? No, I can’t make money, I can’t even make a dollar to support myself as I’ve been unemployed for long time. I turn this sadness into bullying online. Do I have a good score at school? No, I spent 24 years at school, passed high school twice. This is why I turn my stupidity into bullying.")]), _vm._v(" "), _c('p', [_vm._v("Yes, I am a hypocrite, too. My spouse never pays attention to me. I miss my spouse so much but he is too busy, even too busy to miss me. My family always mistreats me, there is no respect from my family towards me. My brothers and sisters continuously bully me at home. I hide this pain for too long and it’s too hard, no one listens to me when I cry. No one understands me when I am down and feeling humiliated. My parents abuse me physically, drain me mentally. I feel so powerless at home. I only feel so empowered by bullying people online. I feel angry when I remember all of this, please don’t make me dwell on my past. It broke me.")]), _vm._v(" "), _c('p', [_vm._v("Those are the confession from a bully AKA a big girl’s blouse AKA a mosquitoes.")]), _vm._v(" "), _c('p', [_vm._v("A bully is the victim of life, the result of trauma and mental issues. When you are smarter than them, you are stronger than them, they will bully you. When they can’t compete with you, they will bully you. As much as they want to be called a psychopath, a bully, a troll or evil. But they can’t do it globally, they are too afraid to bully in some countries. Why? Because the punishments are so severe. If they show any disagreement to the Governments or royal family (not bullying, just freedom to express their point of view), they can be exiled permanently for criticising the government, they can be canned, imprisoned, even become a missing person. In some certain countries, you can’t film anything unless you have permission from the authority, if you get caught filming the view (like tourists do), you will pay big time for that.")]), _vm._v(" "), _c('p', [_vm._v("Mosquitoes are small, midget-like flies that constitute the family Culicidae. Their life span is not long, the female lasts only 42 – 52 days, and the male only 10 days. They are in every region except Antarctica, Iceland and a few islands. They love warm and hot weather, this tiny creature loves your flesh and sucking your blood. Mosquitoes are a health hazard, they are not just a nuisance but also transmit disease. To get rid of them we use mosquito repellent, but most of us just use both our hands to slap them dead.")]), _vm._v(" "), _c('p', [_vm._v("Sounds familiar? They are the comment chasers on social media. They reply to all the comments who opposed them on social media. They are everywhere, they only come in heated conversation. Just like a mosquito, their life span is not long. Only days, because so many social media users report that account or just slap them.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4.73611in",
      "height": "6.54137in"
    },
    attrs: {
      "alt": "",
      "src": "media/file4.jpg"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("These social media mosquitoes are delighted to search for any fault in your photos or any fault. Even when a photo is totally innocent, they will find some fault to point out. They want you to feel itchy and scratch it, which is their intention. They definitely don’t come to your social media because they want to make you happy.")]), _vm._v(" "), _c('p', [_vm._v("For example, you post a photo of yourself having fun. It is a harmless photo, you look casual, you don’t scream, “Look at me look at me,” here come the mosquitoes:")]), _vm._v(" "), _c('p', [_vm._v("“You look older than your age.”")]), _vm._v(" "), _c('p', [_vm._v("“You look like a transvestite.”")]), _vm._v(" "), _c('p', [_vm._v("“What’s with the long face?”")]), _vm._v(" "), _c('p', [_vm._v("“Her breasts have gone south.”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t pick on her because of her body weight, because whales are a protected creature.”")]), _vm._v(" "), _c('p', [_vm._v("There are mosquitoes who put too much concentration and energy just into replying to all the comments who disagree with them, these big girl blouses chase one social media to another just to reply. In their mind, the person who leaves the last reply is the winner, and it’s got to be them. They are like a dog chasing a bone that is being dragged and tied up on the back of the ship, it is going to be a long time and journey to get that one bone, until no energy is left as the ocean is too big for that dog. Sadly, he gets drowned.")]), _vm._v(" "), _c('p', [_vm._v("Not talking about politics, how many of you watch science videos on social media, which are explained by highly scholared and brilliant minds who graduated from the best university (the odds of being accepted by this university is very slim as you must pass the math score)? But look at those mosquitoes who left comments on those videos, they act as if they know more and are smarter than those scientists who have been experts in that area and are highly academic.")]), _vm._v(" "), _c('p', [_vm._v("These mosquitoes are likely not able to solve 5th grade math but act like they’re smarter than Nikola Tesla. If they think they are smart, I bet you many of these mosquitoes don’t know and can’t answer this simple math formula: a2 + b2, or it could be written as (a + b)^2 – 2 ab or (a – b)^2 + 2ab. They don’t even know what is the difference between overseas and overboard, a fake orgasm or real orgasm, real leather or fake leather, a photoshopped selfie and a non-photoshopped selfie, they think all the girls on social media look exactly like their photo on social media. These mosquitoes also think all burgers look like those burger ads on TV and in magazines, smart… Not!")]), _vm._v(" "), _c('p', [_vm._v("We love knowledge, your IQ and knowledge upgrades and expands when you watch science videos or tutorial videos about ideas and innovations, but when you read the comments your knowledge is being downgraded and your IQ is disappearing again, back to a score of one. If you want to upgrade your knowledge, don’t read the comments as those comments might bring you down to their level.")]), _vm._v(" "), _c('p', [_vm._v("Have you ever heard of ‘crabs in the bucket mentality’? You put crabs in a bucket. The one crab which manages to climb free of the bucket is being pulled down again by the other crabs, and they keep pulling each other down. None of them can be free because of the mindset. Or it is a way of thinking, "), _c('em', [_vm._v("If I can’t have it, neither can you.")]), _vm._v(" That is the mentality of the trolls AKA mosquitoes on social media.")]), _vm._v(" "), _c('p', [_vm._v("It is a thin line between love and hate, and between being stupid and being a moron. You (yes, you, the mosquitoes) pretend to be smart but are still stupid. Why? Smart people have a good mark in math and science, stupid people leave a moron trademark in life. Remember, being a moron is not fashionable but it’s a trademark of being stupid. Smart people can pretend they are stupid, actually, most highly intelligent people think they are still not clever enough as they are aware of so many things they don’t know in this universe, but stupid people pretend to be smart, they know everything. Pretending to know everything when you don’t know is very difficult, this is like trailer trash pretending to be a virgin as we all know trailer trash down there is like a train station, where all trains from different places stop and depart, and take hundreds of commuters at once. You know what stupid people suggestion to make trains run faster? They say train would run faster when they stand up rather than lying down on the track. Wow, so genius… Not!")]), _vm._v(" "), _c('p', [_vm._v("This is like a donkey wearing a Marilyn Monroe wig, of course we still recognise it is a donkey. You talk like a donkey, you hee-haw like a donkey, you walk like a donkey, smell like a donkey, so you must be a donkey. Technically, it is very hard to pretend to be smart. You may tell your teachers and everyone you are excellent in math, then they send you to a Math Olympics (which happens annually) to compete with many other math geniuses from around the world. You can say it, but practically no. Just take one look at one question of those highly complex math problems from Olympic maths, how are you going to answer it:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Say this mantra, “I want my mommy…”")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Pretend you have to go to the bathroom and never come back.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Suck your thumb then chew your shoe.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You scream out loud and slam the table, “I did not have sex with this math.”")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You say to yourself, “I can do this,” take a pen in your hand, scream loudly, “Banzzzaaaaiiiii…!” Do a harakiri and poke it in your forehead.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You don’t ask for paper and a pen but you ask for a priest to give blessings and wisdom.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Wait for a miracle from God.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Put a sign on your forehead, out of order.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You take a deep breath, stand up, stretch your muscles, walk, and do bungee jumping.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Do it anyway even though you don’t know the answer. In your mind, any answer will do as long as you don’t leave it empty.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You just spend the entire time staring at it. Why? Because in stupid people’s minds, if you stare at anyone for too long, they will back up and disappear like when you scare off a little girl, so you believe if you give that question a Mexican standoff, the question will disappear.")])])]), _vm._v(" "), _c('p', [_vm._v("You can pretend you are rich, you have a big dick, you are famous, the royal jelly family, the Messiah, and so on. But when it comes to being a genius, it is a very difficult task to imitate. Genius can’t be imitated. Why? Our brain is different, a smart brain and stupid brain is different. The occipital lobe, ventrotemporal occipital cortex, and the prefrontal cortex in their brains are different. Math is unbiased, you like it or not. One plus one is two, regardless of whether you look at it from the moon or upside down or backward, one plus one is two (unless you didn’t wear a condom).")]), _vm._v(" "), _c('p', [_vm._v("Knowledge is to be learned, to be searched for, and to be applied. It takes time to get it. Without knowledge, you can’t survive. Without love, you can’t live. You can’t learn the Chinese language in one minute, it takes years to be able to speak the language. They are the facts, information, and skills acquired through experience and education, theatricality and practical understanding of a subject.")]), _vm._v(" "), _c('p', [_vm._v("Many people go to China, India, the United States, the North Pole, the South Pole and many other places in the world just to get more knowledge, chase the knowledge to the core of the earth, even to end of the universe. Mosquitoes don’t study knowledge in university or places, they just go from one social media to another. Mosquitoes don’t chase knowledge but they chase all those comments who opposed their opinion, till they get slapped in the face.")]), _vm._v(" "), _c('p', [_vm._v("It takes five years or more to get a Ph.D. program in astrophysics, requiring in-depth course work in physics, astronomy, mathematics, computer science, and statistics as well as original research culminating in a dissertation. It takes two minutes to make a baby, and It takes zero seconds to make a stupid comment on social media with no academic requirements. Why? Quicker and easier to be stupid than being smart.")]), _vm._v(" "), _c('p', [_vm._v("This is the fact, out of approximately about 1,000 sperm that enter the Fallopian tube, only 200 reach the egg. The rest get attached to the lining of the oviduct, or just give out and die. Out of that 200 sperm, only one sperm successfully enters the egg to fertilise it. No, this is not about the American Idol competition. Well, it’s the same, technically. According to a study which was published on 25 September in Current Biology 2011, the slower moving sperm or the most patient sperm is the one which becomes successful while the rest of the sperm enters the tube faster.")]), _vm._v(" "), _c('p', [_vm._v("Just like sperm, so the conclusion is that so many of you too quickly claim you know the answer, you are smart and always win. That mindset will make you fall apart and become a loser, because the ones who have patience are the winner, and the ones who are too quick and too desperate to win will be the loser. The winner has the key to the highest power, knowledge and love. If you are still confused, read again the facts about sperm, above.")]), _vm._v(" "), _c('p', [_vm._v("Highly intelligent people speak with knowledge, they answer when they know and recognise the problem. Morons speak without knowledge, they will answer it anyway even though they don’t know the answer. Yes, they lie a lot. See the difference between a highly intelligent person and a mosquito? Knowledge is not a point of view which is based on emotion, mood, lies, superiority and ego. It is not knowledge, it’s an emotional moron. You don’t have to go to school to learn to be a big girl blouse, you’re born as a moron and die as a moron, a moron never changes, nothing changes but the skin texture. Same with narcissists, Machiavellians and psychopaths. They don’t change except for skin textures.")]), _vm._v(" "), _c('p', [_vm._v("This is why they spend too much time on social media, just looking at any exposure to blame. They see faults in anything, anything. Because their life is a fault. If it is a product, you should return it to the retailer to get a refund because it is faulty. Some psychologists say, hurt people are hurt people. They’ve been hurt, that’s why they want to hurt. Chasing those comments, responding to those posts online, but they are very slow to respond to their real problems in real life as they don’t know what’s going on in their life.")]), _vm._v(" "), _c('p', [_vm._v("There are five missing buttons in mosquitoes: the control, politeness, intelligence, honesty and respect buttons. They just lost their control button to stop and to think. If this were a car, this would be a SIAT car, screw it again today. Have you ever seen a mosquito asks your permission to suck your blood?")]), _vm._v(" "), _c('p', [_vm._v("“Excuse me, sir. Your body looks so adorable, if you don’t mind, can I suck your blood because I’m thirsty?”")]), _vm._v(" "), _c('p', [_vm._v("“Oh, please go ahead, suck my blood. But I am drunk at the moment, so I guess you’ll be nauseated and vomiting after you suck my blood then go to rehab.”")]), _vm._v(" "), _c('p', [_vm._v("“Excuse me, sir. I respect this is your body and your wife’s body. We know you also enjoy your wife’s body, but with your permission, I’d like to enjoy your wife’s body too as I am so hot and so thirsty. May I, please? Thank you for understanding.”")]), _vm._v(" "), _c('p', [_vm._v("“If you want to suck her, please. She’s a big woman, it’s a big canvas. Don’t get lost, some people went missing in the Grand Canyon, you know.”")]), _vm._v(" "), _c('p', [_vm._v("It is very unlikely these mosquitoes who love making childish, impolite and stupid comments on social media posts can make the same comments in real life when they face their boss, family, their wife, daughter, sons, uncle or their exes. Did you notice the trolls online don’t have a real photo and real name? Plus, their profile is private or fake.")]), _vm._v(" "), _c('p', [_vm._v("Did you notice too, that the mosquitoes who love saying the word ‘bullshit’ or ‘lie’ are the ones who look like bullshit because they don’t use a real name and photo? Aren’t they a hypocrite and a coward? If you can criticise anywhere, show us your real name and photo, open your profile to the public so we can criticise you on your social media. Imagine if those cowards troll their boss and family,")]), _vm._v(" "), _c('p', [_vm._v("“Boss, why is your backside back to front?”")]), _vm._v(" "), _c('p', [_vm._v("“Hello, my dumb wit and ugly family.”")]), _vm._v(" "), _c('p', [_vm._v("“Good afternoon, my mother in-law. You have such a long ass.”")]), _vm._v(" "), _c('p', [_vm._v("“Poor wife, is your face manufactured like that? It must be a burden to wake up with a face like that.”")]), _vm._v(" "), _c('p', [_vm._v("You know the consequences if you speak to your wife like that, I think those boots on her feet will be flying and be stuck up yours. It would be an embarrassing trip to the emergency hospital, “Doctor! We have an emergency, this man has a boot stuck up in his you know what,” say the nurses.")]), _vm._v(" "), _c('p', [_vm._v("“What?? Aren’t boots made for feet not for asses?” reply the doctors in disbelief.")]), _vm._v(" "), _c('p', [_vm._v("“Not this one.”")]), _vm._v(" "), _c('p', [_vm._v("The doctor looks at you in disbelief and that boot, he says, “Just do it, that’s written on that boot.”")]), _vm._v(" "), _c('p', [_vm._v("If you act the same as you do on social media, you sit next to this stranger on the bus, your comment to her, “You look like a dolphin with fake eyelashes.” Slap! She just slapped you with her handbag. You’re waiting in line in a supermarket, you ask the girl behind you, “Why did you buy so much grass? Oh I see, your husband is a grass-fed cow.” There you go, you just came home with a fruit salad on your head and a pineapple mark on your cheek. If you keep making negative statements to everyone you see, you’ll get a slap in the face every two seconds.")]), _vm._v(" "), _c('p', [_vm._v("Now, let us judge you but you must not reply. Are you brave enough? Firstly, we’d like to give you an IQ test and math test because you think you know everything, more than Einstein especially about how to solve world problems and politics. We hope you pass the test, because if you can’t pass, you will be called stupid, a dumb wit and bullshit by us like you did to us even though we passed the IQ test.")]), _vm._v(" "), _c('p', [_vm._v("Secondly, post your photo on social media, let us search for any fault in you or some make-up fault in you and criticise your appearance. Even if there’s nothing wrong with your appearance, we guarantee you will hear something bad from us to you such as, you look too old and too fat for your age, just like you did to those teenage girls to kill their self-esteem.")]), _vm._v(" "), _c('p', [_vm._v("You may bully, criticise, harass and abuse everyone on social media but in some countries if you dare to do the same, you will be jailed as they screen every word you say online. If you insult or say a bad word about their royal family or Government, you will face jail up to 20 years or you’ll be canned. If those mosquitoes try to criticise and bully drug lords in some countries, there’s a possibly the mosquitoes’ dead bodies would be discovered the next day on the beach. Take it to the bank, those bullies are too cowardly to do that because they know the consequences are so severe. Just like mosquitoes, their life span is not long because cowards don’t last long, lie doesn’t last long either.")]), _vm._v(" "), _c('p', [_vm._v("Here are the reasons why you find any faults in any post or photo:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Your life is faulty.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Low self-esteem.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Jealousy.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("The pack, some of you become a bully when you’re with your group. There’s a saying, cowards only come with a pack. But when you’re alone, you’re a chicken.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Big ego and superiority.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You are an attention seeker, you want to impress with your glitter lip gloss and a tattoo on your arm: Mama loves me no more.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You’ve experienced trauma or depression.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You’ve been bullied and abused by your own family member or someone close to you when you were young.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Insecurities and loneliness, you try to compensate for your loneliness and insecurities by bullying online.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Unhappy relationship with your spouse.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You can’t compete with them, you can’t have what they have: intelligence, kindness, emotional maturity, patience and knowledge. You want those but you can’t have them, that’s why you are against them (crabs in the bucket mentality).")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Your loved one or your family has been criticising you a lot, they ignore you so you turned into an online bully.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("The last valid and strong reason why you behave like a little school girl who fights over an eyebrow pencil because when you were being ‘baked’ by your parents, they ‘manufactured’ you in a hurry as some kids were knocking at the door wanting some lollies for Halloween. Yes, you were the result of two second sex. When a human makes everything in a hurry, he must have forgotten some important ingredients. Imagine if a man makes an aeroplane but has no time left, don’t ask that aeroplane to fly, that plane can’t even crawl as there is no time to attach the wings and the machine.")])])]), _vm._v(" "), _c('p', [_vm._v("According to a famous psychologist, Gordon Allport, personality is: the dynamic organisation within the individual of those psychological systems that determine his unique adjustments to his environment. Personality is not determined by one factor, but by many accumulation factors. But these five factors are the most influential factors in shaping a personality:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Brain"), _c('br'), _vm._v("\nIt is believed that a father and child almost adopt the same type of brain stimulation. Later differences in personality between father and child are the result of the environment in which the child has grown.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Physical Characteristics"), _c('br'), _vm._v("These factors are important factors in determining one’s behaviour in social organisation. Physical characteristics are included, but are not limited to: Height, skin tone, weight, hair colour and beauty.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Social Experiences"), _c('br'), _vm._v("The circumstances and things happening around that person on a daily basis and routine will shape that person’s behaviour and how they perceive themselves and the world. Thus it will influence: coordination, cooperation, family relationships, organisational relationships, workplace relationships, and involvement in communities.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Culture and Religion"), _c('br'), _vm._v("Traditional practises, norms, customs, procedures, rules and regulations, precedents, values.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("The most surprising factor is heredity"), _c('br'), _vm._v("The genes one receives from their parents will influence their behaviour. According to a book, "), _c('em', [_vm._v("Essentials of Organisation Behaviour")]), _vm._v(" by Stephen P. Robbins, Timothy A. Judge, and Sheema Sanghi:"), _c('br'), _vm._v("Research in many different countries has studied thousands of identical sets of twins who were separated at birth and raised separately. For instance, one set of twins who had been separated for 39 years and lived 45 miles apart were found to drive the same model and colour car. They also chain-smoked the same brand of cigarette, owned dogs with the same name, and regularly enjoyed vacations within 3 blocks of each other in a beach community 1,500 miles away.")])])]), _vm._v(" "), _c('p', [_vm._v("Why are there no scientists, Nobel Prize winners, smart, and wise people who are interested in involving themselves in social media bickering?")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("They use their common sense and knowledge more, meanwhile the mosquitoes use their emotion and ego more than their common sense. They invented something because they think, mosquitoes don’t think, that’s why they’re falling apart. Smart people think with their brain, mosquitoes think with their knees.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("They are so content and satisfied with their real life, they don’t use social media to prove who they are or what they are. Social media is for positive purposes only. They see social media as a media through which to share knowledge and communication.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("They don’t go to social media with a chip on their shoulder, just like how mosquitoes think they go to social media because know how to fix the world or complain (narcissists go to social media to prove who they are and desperately seek validation)."), _c('br'), _vm._v("Highly intelligent and wise people are trusted with responsibilities because they have knowledge, wisdom and skill to solve the problems for a better world. While mosquitoes can’t be trusted as they always escape from the responsibilities, problems and the real world. There’s a difference between fixing the problem and adding to the problem (mosquitoes can’t fix the problems but they can add more problems). Basically, mosquitoes can’t take any responsibility, even for themselves.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("People with emotional maturity handle the differences with common sense, they won’t fight but they offer a consensus for decision making for the best solution for all parties. Childish people can’t face the differences, they get sentimental, angry and emotional when they face the differences. That’s why they come to social media to hate, punish and point out faults without offering a solution."), _c('br'), _vm._v("Manipulative people and liars preach hate and war online, they try to break anything and anyone who’s standing in their way. Honest and smart people don’t preach, but they encourage others for peace and to stand together instead of preaching hate.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("They have dignity, mosquitoes don’t. This is why mosquitoes don’t care if their words lower their (mosquitoes’) dignity or hurt anyone, or not. Why? Because if you don’t have knowledge, you will not care about your own life. Why? Because you don’t know what life is. “I know where I am going, no one tells me what to do.” If you know, why aren’t you happy? Why are you on social media a lot? Why do you have unhappy relationship? Why do you fall apart with your friends?"), _c('br'), _vm._v("People care because they have knowledge, patience, remorse, compassion, emotional maturity, and empathy. Thus making us strong spiritually and mentally also stops us from denigrating our dignity by getting involved in bickering with people who refuse to be adult and respect each other. We hold our dignity high.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("We don’t depend on social media as our wonder wall. It is good to share happiness and ideas, but when we go to social media as compensation because we feel insufficient, angry, sad, insecure or envious, this routine become an unhealthy habit."), _c('br'), _vm._v("If we are sad, we still stay positive or we go to Church or to a Mosque, or make someone out there happy by giving them kind words or giving food to a homeless person. Or do some activities such as taking a walk or making ourselves busy. We have the power to overcome our weaknesses, meanwhile bullies, narcissists, and Machiavellians don’t have the power to overcome their weaknesses."), _c('br'), _vm._v("There are case that some psychopaths are proud to be psychopaths, proud to be evil. Why? Psychopath brains are different from normal brains. Their brain shows less activation in the amygdala. As proud as they are as a psychopath, they are too afraid to be honest. Honesty frightens them the most. And they forget that the power of good people is much stronger than evil. They are afraid of us."), _c('br'), _vm._v("You (mosquitoes) go to social media when you are mad. Do you need to let the world know that you are outraged? If you have a problem with someone, why don’t you solve it in real life, not whinging and whining in Wi-Fi land. You want to fix the problems? Turn off your computer and face the problem in real life")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("We can tell someone has depth or not when they open their mouth and by how they conduct themselves. The more narcissists, Machiavellians and bullies open their mouth, the more they make an idiot of themselves. Better be silent to show wisdom rather than open your mouth to reveal your stupidity.")])])]), _vm._v(" "), _c('p', [_vm._v("This applies to anyone in the real world and online world. Be polite and respect each other. If you want to be respected, respect others. Simply put, if you smile at someone, he will smile back at you. If you hit someone, he will hit you back. Hate attracts hate, like attracts like. I know many of you will ask this question, if you give someone money, will he give you money, too? Depends on the type of the person you gave money to. If he’s a good person he will thank you and appreciate it but if he’s shonky, he would ask for more in the future.")]), _vm._v(" "), _c('p', [_vm._v("If they still hate you after you’ve been nice to them, it is not a big deal as long as you don’t downgrade yourself to act and to become like them. God forgives and loves men with small sausages, too. Perhaps you might ask that question again, “I’m always nice to them but they dislike me, why?” If you’re wondering why they are such a moron, this is the answer why: punch yourself in the face. Now you know why, because that’s how it feels to be a moron, they are always in pain.")]), _vm._v(" "), _c('p', [_vm._v("Imagine you touch a hot plate, you’ll be screaming like hell, you can’t listen, can’t talk properly even when they ask you politely you still can’t answer correctly because you’re in so much pain. This explains why bullies and trolls always scream. They are still hurt by their own experiences, childhood, traumas and fragile mentality.")]), _vm._v(" "), _c('p', [_vm._v("Or this is another explanation for why they behave so childishly, try to put one straw on the floor, it can’t stand up because the straw is very fragile and not strong enough. One tiny, tiny small breath of wind can make that straw fall down, just like those bullies. They don’t have a strong mentality, that’s why they are easily falling apart. To all mosquitoes, mind your own business! Look at your own backyard before criticising others. You can see an ant on the other side of the world, but you can’t see a mama elephant sitting on your lap.")]), _vm._v(" "), _c('p', [_vm._v("There are many social media that share their creative ideas or their tutorials about gardening, hair, make-up, fashion, toys, or anything. What do these mosquitoes do? Trash them. Or when a highly educated person writes their research or some scientist publishes their study, the mosquitoes will say these because they don’t like the post:")]), _vm._v(" "), _c('p', [_vm._v("“You’ve got too much time in your hand.”")]), _vm._v(" "), _c('p', [_vm._v("“This post is about nothing.”")]), _vm._v(" "), _c('p', [_vm._v("“Rubbish.”")]), _vm._v(" "), _c('p', [_vm._v("“Useless.”")]), _vm._v(" "), _c('p', [_vm._v("“Bullshit.”")]), _vm._v(" "), _c('p', [_vm._v("“You are a piece of shit.”")]), _vm._v(" "), _c('p', [_vm._v("Before you call some studies, creativities and ideas (that have been researched for a long time, many people have spent many months, even years, to come up with that idea or creativity) as rubbish, bullshit, useless, or any demeaning words, think first before you say it, because that word ‘rubbish’ becomes useful for you and many people. Because when we use our brain, we can turn rubbish and trash into a useful thing. The food you eat is used as waste for fertiliser.")]), _vm._v(" "), _c('p', [_vm._v("In the year 2020, people in Tokyo will enjoy the sun on the beach on garbage AKA rubbish. Japan will make an artificial island on the disposal site. Also, the bullshit you dispose of in the toilet can be used as fuel, one Colorado city is already using human waste to run its vehicles, and to generate electricity. The words that you use to belittle people backfire on you. Basically, without people’s waste, you can’t do anything. Remember your electricity and vehicles depend on our shit. Next time you call us bullshit, no, no, no, we ain’t giving you any shit because without our shit you can’t even charge your smartphone, can’t do anything.")]), _vm._v(" "), _c('p', [_vm._v("Have those people who shamed scientific studies or any creative ideas on social media published their own science theory published in credible magazines (not in gossip magazines or blogs), or have they had any creative and good idea to share? No. We don’t want their comments on social media but we want them to produce it in papers or tutorials or in a book so it looks convincing, more intelligent and more credible. And before that, we would like to give them some math and science test to see if they pass or not, don’t cheat, you have to do it live so we know what you look like and the results of your math and science test.")]), _vm._v(" "), _c('p', [_vm._v("As Benjamin Franklin said, “We are all born ignorant, but one must work hard to remain stupid.” Confucius said, “Real knowledge is to know the extent of one’s ignorance.” Plato said, “Opinion is the medium between knowledge and ignorance.” In social media, “Knowledge is the extent of emojis, tags, likes, shares, and comments.” Why do those mosquitoes constantly shame and belittle innovative ideas, creations, talents, innovations, science, wisdom and harmless posts? Because they don’t have one bright idea, they don’t know even know they are stupid, they only believe in lies and bullshit. The words that come out of their mouth is a reflection of what they are. They say, “You lie,” because they are a liar.")]), _vm._v(" "), _c('p', [_vm._v("Last one to all mosquitoes, man up! Stop whinging and whining over the glitter eye shadow or push up bras, face your own worst enemy. Yes, your number one enemy: yourself. No, we are not afraid of you, actually you are afraid of your own life and us. You escape from life and problems. We rule the world, not you. I know you won’t accept this and deny the truth, all we can say about you is, “God works in mysterious way.” If they keep bullying all the time, send them to North Korea and bully away on Kim Jong Un. Let’s see if they are brave enough.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-controversial-sexy-photo"
    }
  }, [_c('h3', [_vm._v("The Controversial Sexy Photo")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("Hi boys, admit it, you fancy me, don’t you? Yes, I am the seductress on social media. I use every single photo I take to seduce men and to be admired by men. I want men to worship me, no one else. I am so beautiful. I am all men want and all women dream about. I love to get compliments on how hot I am. This is why my photos are very suggestive.")]), _vm._v(" "), _c('p', [_vm._v("I have a very seductive body, I am so proud of my body and my look. I have dreamy and alluring eyes, my lips are full and sexy. Every word that comes out on my mouth must sound sexy and seductive, too sexy, I can’t even save my friend when I told her, “Look…! It’s a… a… vess… vssss…” She looked at me, puzzled, and kept asking me, “What? What…?” Then I continued saying in my sexy way, “Vsss… vsss… vessss… vesspp…” The moment I finally added, “ppaaahhh…!” She already got a big bump on her forehead. Got hit by a vespa. I can’t play the harmonica, because a harmonica isn’t for thick sexy lips like mine. I can swallow a harmonica, I can sound like a harmonica but I can’t play it.")]), _vm._v(" "), _c('p', [_vm._v("If you don’t like me and fantasise about me, it means you’re gay or you don’t have good taste or are even blind. I am special, if I were fried rice it would be a very special fried rice. It comes with prawn crackers, seafood, fried egg and even with lobster, don’t forget pickles and a sprinkle of fried onions. Unless you have an allergy to seafood and nuts. I don’t look like an ordinary girl, to me if they are an ordinary fried rice with only rice with soy sauce and fried onions, not as special as me.")]), _vm._v(" "), _c('p', [_vm._v("My body is to die for. I want men fighting over me. Look at my cleavage, I don’t need my hand to hold an umbrella. I just stick it in my cleavage. I know men like big boobs, so I went to see a plastic surgeon to get my boobs renovated to two storeys high. When I am feeling hot in the scorching day, I am fanning myself by using one of my boobs to cool me down. I use my boobs to cover my ears when I don’t want to listen, I cover my eyes with my boobs when I see something scary. See no evil, hear no evil.")]), _vm._v(" "), _c('p', [_vm._v("Men get down on their knees and cry for me, men begging me not to hurt them.")]), _vm._v(" "), _c('p', [_vm._v("“Please, stop hurting me… I can’t take this pain anymore…” I look at him and whisper, “Cry me a river… pain is your friend… my friend.” He is still crying, then I hear, “For fuck’s sake! Can you take your high heels off my feet, you bitch!” Oops, I accidentally stepped my high heels on his shoes. I didn’t know that, sorry that my sexy heels got in between your toes. But I know you are madly in love with me even when you’re in pain, or else I’ll you call you a racist, bully, coward, and a bigot for not falling in love with me.")]), _vm._v(" "), _c('p', [_vm._v("I love to be photographed in half a dress or even nothing at all. Why? Do you think I do sexy stuff for your grandma? Of course not, all I do is for men to worship me and all to compliment how beautiful I am. Read my lips, they’re for men and for validation. When I pose, I love to make a duck face and curl up my mouth outward then open my mouth a bit showing a bit of my front teeth as if I say, “Moo…” Yes, exactly like that cow, moo… Aren’t cows so seductive? After doing cow lips and duck lips 1000 times, 2 hours in the making, I took only one photo to post on my social media. Of course, the best one.")]), _vm._v(" "), _c('p', [_vm._v("The moment men look at my selfie, I want them to say, “Oh my God, you are so beautiful!” Or, “You must be God’s gift from Heaven, so hot!” Listen, I don’t want people to comment on my sexy selfies like this:")]), _vm._v(" "), _c('p', [_vm._v("“Oh… my… Goddd!” Then he passes out.")]), _vm._v(" "), _c('p', [_vm._v("“Jesus Christ!” He quickly turns his computer off and prays for God to give him strength and wisdom as he needs it the most now.")]), _vm._v(" "), _c('p', [_vm._v("“Wow, you look fantastic! Where did you get that mask for Halloween? I like that.”")]), _vm._v(" "), _c('p', [_vm._v("“God works in mysterious ways.”")]), _vm._v(" "), _c('p', [_vm._v("“This is why, we men should use condoms, to prevent something like this!”")]), _vm._v(" "), _c('p', [_vm._v("“Any damage caused by neglect, misuse, abuse, or collision is not covered by warranty!”")]), _vm._v(" "), _c('p', [_vm._v("“To attract more customers, you have to lower your price.”")]), _vm._v(" "), _c('p', [_vm._v("“Lousy products, good marketing!”")]), _vm._v(" "), _c('p', [_vm._v("I am so desperate for attention, “Come… come to my house. Come and fix my sink,” this is the impression I want from men when they see me. Ladies, if you want to pose sexy like me, I suggest you should practise your lips like saying, “Moo…” like a sexy cow. If you don’t want your lips to look like a cow, try saying this, “Sshhh…” when you say this just imagine there’s a coconut stuck up yours, thus makes your lips automatically whisper, “Ssshh…” So irresistibly sexy…")]), _vm._v(" "), _c('p', [_vm._v("I call myself a man eater, but many call me a snake eater. My looks can charm all men, men say I should work in India as a snake charmer. I am as hot as capsicum spray. This is why police use capsicum spray to break fights, also to catch criminals. Since the police know me, they ditched their dogs! You know why? Because I am better than a dog, I can smell dick miles away. They hide under a bunker, I can smell them. They hide inside a big building, they duck down behind a concrete wall, I can find them by smelling dick. They are underwater, I can find them too, “Officer! There’s one here. Under the water, hiding!” No matter where men are, I can find you! Even if you hide behind the Great Wall of China. You can’t hide, you can’t run, I may not see you but I can smell you!")]), _vm._v(" "), _c('p', [_vm._v("Not just women, some men also suffer this, too good to be true. They love taking mirror selfies showing their six packs. They know they are chick magnets, before they go to bed, they kiss their cock good night, too. Ohh… feels good. All of the above is the mindset of social media users who love posting provocative photos. Not all social media is like that, but being a nudist attracts more followers more easily than being a mathematician.")]), _vm._v(" "), _c('p', [_vm._v("Surely we’ve seen so many young girls, including mature ladies, post their photos on social media in a very suggestive way. We’ve seen so many girls in bikinis on the beach, we have no problem with that. In fact, we will be puzzled if we see a girl in her pyjamas lying on the beach, “What’s wrong? Why pyjamas?” Some countries have a dedicated place for nudists, a nudist camp. They get together naked, do everything naked, they also have a special beach where all can bare their leather jacket AKA skin freely.")]), _vm._v(" "), _c('p', [_vm._v("It is a common view to see sexy photos, even nude photos, on social media. Most female celebrities have their sexy photos in magazines and social media. Also, there are many movies containing nudity and sex scenes. Yes, I guess many men have lost their virginity over porn movies or magazines.")]), _vm._v(" "), _c('p', [_vm._v("These young women, even not so young anymore, are proud and loud to show off their body on social media for everyone to see, no exception. Some people might ask why and some men say wow. To put it this way, if we dangle a bone, guess who comes and gets it? The dogs. If we dangle sugar, the ants will come and get it. We dangle bananas, monkeys will come and eat them. I know so many of you would ask, where’s this leading to? The point is, depending on what you dangle. If you post a math question on your social media, who comes and answer it? People with brains. You dangle your bra and underwear on your post, who comes and answers it? Perverts. You dangle your $50, everyone will come, even a straight man can turn into a gay for $10.")]), _vm._v(" "), _c('p', [_vm._v("Before social media, we locked our bathroom door for our privacy, we didn’t want anyone to see us naked. Not after social media, we all can see everyone’s bathroom and naked body. No need to lock your bathroom, no privacy. There’s a sign on your bathroom: ‘All welcome’. Thank God for social media, now we all know what every girl’s bathroom looks like.")]), _vm._v(" "), _c('p', [_vm._v("But the problem is, you get angry when you have some backlash about your nude photos. Your excuses would be like these:")]), _vm._v(" "), _c('p', [_vm._v("“Freedom of speech.”")]), _vm._v(" "), _c('p', [_vm._v("“Liberation.”")]), _vm._v(" "), _c('p', [_vm._v("“I am happy with who I am. I am here not to please you but to please myself.” (Are you sure you say you do that to make yourself happy? If yes, why bother posting it online to make all people see your naked body? We would like to believe if you have no likes and compliments from guys after you pose nude, it will make you angrier and upset.)")]), _vm._v(" "), _c('p', [_vm._v("“Nobody tells me what to do.”")]), _vm._v(" "), _c('p', [_vm._v("“I don’t ask you for much but respect!”")]), _vm._v(" "), _c('p', [_vm._v("“This is my body, not yours. This is my life, not yours. This is my world, not yours!”")]), _vm._v(" "), _c('p', [_vm._v("“Don’t you come to me and judge my life as I don’t judge yours.”")]), _vm._v(" "), _c('p', [_vm._v("“I rule my life, not yours.”")]), _vm._v(" "), _c('p', [_vm._v("Why they love posting suggestive photos:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("It is fun to know men are lusting over me, desire me.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("I love showing my nude body because I am an exhibitionist.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("I suffer some syndrome, when I am not myself. I post nude selfies.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Love to read the comments from men who are lusting over me.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("I love turning men on as it makes me happy.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Boosting my self-confidence.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("I love to control my sexual desire.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Definitely for ego as many men want me.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Love the attention and hate from women.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("I enjoy it. I don’t care what people think of me.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("I do nude selfies because my ex ditched me, I am still hurt and broken hearted so I show him what he’s been missing. On top of that, I want to let him know that I am in demand.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("I am the most beautiful woman in the world, no matter what people say. I don’t like to see a better-looking girl than me. This can’t be done, so I have to do something more provocative than the other girls to attract more men.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Because I know all men want me.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("When I feel less, I show more of my skin.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Last reason, because the competition on social media is very fierce. To compete with others, I have to look sexy to gain more attention. The likes and comments are oxygen for me. Without it, I can’t breathe, I suffer as I feel powerless and hopeless. My self-confidence and the way I perceive myself depends on what people say about me.")])])]), _vm._v(" "), _c('p', [_vm._v("That’s what you think. You assume men are madly in love with you and will be faithful to you. Cut to the chase, you love the attention, you love men worshipping you and you are the only one that they want. If men don’t chase you, you will be wondering why they don’t give a damn, don’t they know you look that hot? Well, they missed the opportunity.")]), _vm._v(" "), _c('p', [_vm._v("Do you really think those men who are drooling over you, only have their eyes on you? Those men go to social media from one to another just to check girls like you, you are not the only one for them. Do you believe a pervert making a statement, “I only have my eyes on you.” And you believe that? They are in lust with all sexy and beautiful girls on social media. Perverts on social media act like a hungry fat bastard in the buffet, they are so excited to see so many varieties of food. They don’t go to the buffet only for one kind of food, no, they pick anything they want, anytime they want, and as much as they want, and they leave with a full stomach.")]), _vm._v(" "), _c('p', [_vm._v("Apart from that, they don’t have to subscribe to porn websites which debit their credit card monthly, while they can look at you for free. It’s a win-win. But after reading some forums and survey on what men think about you on social media from one of the most credible social media platforms, I am afraid to say, they think less of you. These men are professional people, have a cosy job and highly educated. From all the comments, they share one opinion: asking for validation. There are several men who think what you do is shameless and dangerous.")]), _vm._v(" "), _c('p', [_vm._v("There are lingerie models who post their nude or sexy photos on social media because they are paid in million dollars. It is in the job. They promote a lingerie company. There are many movies and magazines that contain nudity, but it seems a part of social norms. We know you will use these excuses to justify and defend your actions on social media. “But some girls are topless on the beach,” that was your defence. You forget again, they do that on the beach not on social media. So is it appropriate to pose nude on social media?")]), _vm._v(" "), _c('p', [_vm._v("Why these photos are so controversial? There are locations, values, cultures and ages. And the most important thing is moral value. Location; we go to funerals, school, church, to parents-in-laws’ place, court, an interview for a job (unless you apply to be a porn star or erotic dancer) or many places where standards must be maintained and dress codes are applied. You may go to some awards ceremony in a bonsai dress AKA very small clothing, but to go to some prestigious awards or events such as meeting the royal family or a President, you are required to dress appropriately. Why? Because we respect ourselves and customs.")]), _vm._v(" "), _c('p', [_vm._v("Values, laws and cultures, as mentioned above you may strut around social media in a Tarzan dress or only one grape covering your body. But this behaviour is considered dangerous, inappropriate, shameless and breaking the law in many countries. If you wear a mini skirt and a crop top in some countries, you will be arrested and jailed. There was a case where a lady wore a see-through skirt for some award in this country, the result was she faced five years in jail for wearing that skirt which was inappropriate for the culture of that country. These countries also employ fashion police, to dictate and enforce the citizens with a strict dress code, or else they will face fines and imprisonment. In North Korea, even a hairstyle must have approval from the Government. Only 15 hairstyles are legal for men, and it is for women, 15 hairstyles. Wearing pants is also illegal for women in North Korea. If you don’t follow the dress code and above, you will be sent to hard labour for years and to prison.")]), _vm._v(" "), _c('p', [_vm._v("“But we are not in North Korea nor those countries with a strict dress code.” That’s your response. You are right. There are many countries that don’t apply a strict dress code, but most of the population is very religious, respects their culture and values too. But you forget one thing, not all your followers are perverts. Many of them are family-oriented people, children, law abiding citizens, and people who keep their dignity and reputation high, and people who are highly educated and have a very good job.")]), _vm._v(" "), _c('p', [_vm._v("If you dress inappropriately on social media but you live in a country with a religious population, or most of them are Dudley Do-Right, don’t complain if you get criticism and backlash from the citizens. Because you don’t respect their social norms, cultural values and their beliefs. You live in their country, you earn your fame and money from these people, without your fans from this country, you would be jobless. But your posts on social media are disrespecting their culture and values. You live in Rome, play like a Roman. Respect.")]), _vm._v(" "), _c('p', [_vm._v("If your boyfriend or husband drooled over and fantasised about another naked woman on social media, not you, what would you do? Get revenge by posting a naked selfie too? Imagine if that happened in real life, your boyfriend is approached by a beauty who doesn’t wear anything but fake eyelashes, she asks your boyfriend to be her roommate. Or your husband’s beautiful secretary is always naked whenever she’s near your husband at work. Well, they call it overtime, at work. He got held up at work.")]), _vm._v(" "), _c('p', [_vm._v("You also say, “Some movies have nudity, too. But you don’t attack the actress, so why did you attack me?” The answer is, those movies are rated R18, adults only, and they are paid to do that. In many countries that nudity has been censored as it is considered a taboo and inappropriate behaviour in their culture and country. If you think posing nude is a norm on social media, this is like you think it is okay to play a porn movie in primary school for education.")]), _vm._v(" "), _c('p', [_vm._v("It is up to you to take your clothes off and take your brain off too. But be careful if you do this in some countries. Well, you play with fire, don’t complain if you get burned. You strut around your nude body on social media, don’t complain if you have some backlash and perverts stalking you.")]), _vm._v(" "), _c('p', [_vm._v("These are what people think of suggestive photos on social media:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Low self-esteem")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Insecurities")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Seeking validation")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("The desire to be a sexual object is unusually high")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Lacking self-respect and moral value")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Pressure to be admired and look desirable")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Competition with others")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Pride in appearance and sexual interest is unusually high")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Drama queen")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Lower prices are just the beginning")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("If you find a lower price on a stocked item, we’ll beat it by 50%!")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Would you like fries with that?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Looking for buyers. Condition: 50% new, pre-loved. Material: genuine leather. Remarks: scuffing, stains, the zipper doesn’t work, the stitches are open. Type: wallet")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Total fat: 50%. Ingredients: Orange skin (20%), two watermelons, light whipped cream (10%), seedless grapes (10%), salt, English Walnuts (60%)")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("This packet may contain traces of nuts and shellfish")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Allergy information: manufactured in a facility that also processes nuts")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Weather warning! Strong wind, gusts of 80 km/hour and large hailstones")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Business strategy, you have to lower the price to attract more customers")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("No eating and drinking on this bus")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Choice of wonton soup, teriyaki chicken or walnut shrimp")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Combo vending machine, slide your fingers in to get a free bag of chips")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Friendly fire, waterproof, might contain choking hazards")])])]), _vm._v(" "), _c('p', [_vm._v("There are also some considerations that people think of you:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Are you an honest person? Can you be trusted?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Would they hire you as their employee after seeing your social media?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Are you a reliable person with strong work ethics?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Can you be trusted with large amounts of money and not be corrupted by it?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Are you mentally stable?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Would mothers hire you as a nanny for their children or a secretary for their husband?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Are you a faithful person?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Can you take big responsibility?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("When you promise something, do you deliver on your promise?")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Do you always exaggerate what you have and what you say? Those with narcissism and Histrionic Personality Disorder seem to always exaggerate things")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Do you need to take selfies all the time and take your clothes off to be remembered by your fans, or do you want to be remembered by others as someone who respects moral value and life? Gandhi and Nelson Mandela are remembered and respected for their dedication to peace, justice and freedom. Nikola Tesla and Albert Einstein are remembered for their contribution to science and knowledge, which we use now. GPS, which we use now, is one of the proof that Einstein’s theory, Relativity Theory, was right. And you will be remembered as a…?")])])]), _vm._v(" "), _c('p', [_vm._v("One definite answer as to why you love posting suggestive photos on social media is because you suffer HPD (Histrionic Personality Disorder) and Narcissistic Personality Disorder.")]), _vm._v(" "), _c('p', [_vm._v("Symptoms of NPD include:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Inability to listen to others.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Fantasising about beauty, power and achievements.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Exaggerating achievements and abilities.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Superiority, specifically towards people perceived as ‘lower’ in status.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Lack of awareness regarding others.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Increased risk of using drugs and alcohol.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Inflated sense of entitlements.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Obsession with class and status.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Exploiting others for personal gain.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Lacking empathy, especially for perceived weakness.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Strong desire to control relationships.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Envy for those perceived as of a higher status.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Inability to admit wrongdoings.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Distant, practical in manner when in relationships.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Believing that others are envious of them.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Severe anger if orders or directions are not followed by others.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Can eliminate friends permanently over a small thing or imagined issues.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Great pride in their accomplishments by family and children.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Expecting constant praise and recognition for achievements.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Unrealistic goal setting.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Difficulty maintaining healthy relationships.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Feeling hurt and rejected easily.")])])]), _vm._v(" "), _c('p', [_vm._v("Narcissists have deep insecurity beneath and an arrogant exterior. Meanwhile, some of the obvious symptoms of Histrionic Personality Disorder (HPD) are self-centredness and feeling uncomfortable when you are not the centre of attention, constantly using physical appearance to draw attention to yourself, interaction with others is often characterised by inappropriate sexually seductive and provocative behaviour, and being highly suggestible (easy influenced by others). All HPD symptoms have been explained in the Drama Queen Section above.")]), _vm._v(" "), _c('p', [_vm._v("Read again, according to psychology, you are highly suggestible. Having seen your social media and social media of those with HPD, you might appear highly suggestible. But the facts are, you are not likeable, no. You hate us if we don’t like, comment or say something nice to you. You call us names if we don’t say you have nice tits or a fluffy backside.")]), _vm._v(" "), _c('p', [_vm._v("But these four are given characteristics of HPD and NPD:")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("You think everyone who disagrees with you do so because they’re envious of you.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You are envious of others who have better achievements or are more beautiful than you.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("When you talk, it is exaggerated. Let’s say you only have $2, but you tell the world you have two million dollars in the bank.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("You are not faithful to your spouse, secretly you seduce someone or still try to attract the opposite sex to lust over you."), _c('br'), _vm._v("\nTake this to the bank.")])])]), _vm._v(" "), _c('p', [_vm._v("You consistently post a half-naked or nude selfie online but you’re asking for respect? This is the same as you closing your bathroom door to protect your privacy but coming out from the bathroom naked, why bother? And those men who drool over you on social media are perverts. Are you asking respect from the perverts? Is there such thing as a respectful pervert? The story is, two drunks are arguing and debating whether the shining star in the sky is the moon or the sun. Then they both ask a total stranger, “Why don’t we ask him, he looks sober. He knows, he is not drunk like us.” One drunk asks that stranger, “Excuse me sir, the shining one up there in the sky,” while his finger points at the sky.")]), _vm._v(" "), _c('p', [_vm._v("“Yes?” he replies.")]), _vm._v(" "), _c('p', [_vm._v("“Is that the moon or the sun?”")]), _vm._v(" "), _c('p', [_vm._v("That total stranger looks so shy and apologetic, he answers, “I am so sorry. I just moved here. I am new to the area. I don’t know if it is the sun or not.” Then he walks off and apologises again. That’s how I put it if you ask a pervert for respect.")]), _vm._v(" "), _c('p', [_vm._v("First, respect is to be earned, it’s not from something you claim but something you have achieved by the way you conduct yourself. “I respect my body and my choice, that’s why I chose to post my nude body.” That’s your definition of what respect is. Well, there’s a saying; respect the elderly. Does it mean we have to take our clothes off to respect them? No. We don’t respect our guests to come to our house nude, “Hello, welcome to our house.” Wow, that is called an extreme welcome.")]), _vm._v(" "), _c('p', [_vm._v("Talking about men, we know why men ask, “Respect me in the morning.” Then they add, “I want a 21 gun salute.” This is why some men got the wrong message when they see their girlfriend yawning. No, girls are yawning because they’re tired, not because they want to salute your sausage.")]), _vm._v(" "), _c('p', [_vm._v("Most photos you post have a string attached and are open to interpretation. Everyone is different, you can’t dictate and control them to love you or hate you (unless you’re in North Korea). But by using the photos you use, indirectly or directly you send a message behind that picture. You are fully aware that people from around the world will see your photo on social media and review your photo. Look, we all love watching the Discovery Channel, animals do it too, you know. We all got the message from you, we are not stupid, we know why you posted it.")]), _vm._v(" "), _c('p', [_vm._v("“Do not judge, unless you be judged.” This is coming from you who love posting suggestive photos and use filters and photoshop, “Because I enjoy it, it is my happiness and I don’t care what people say.” If it is your happiness, so be it. Your happiness is being naked. Meanwhile for the rest of us, happiness is not the destination, but it is every second we breathe as we feel grateful for the blessings we have and keep our moral values and love high.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "confused-identity-the-pretenders-this-section-is-dedicated-to-many-celebrities-in-some-asian-countries"
    }
  }, [_c('h3', [_vm._v("Confused Identity, the Pretenders (this section is dedicated to many celebrities in some Asian countries)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("I am proud of myself. I put my best pose to present myself to the world, not just for my own country. I am elite, I am not an ordinary person. I don’t consider myself as a part of the majority. Because I am special, I might say I am a special species, I am above the majority.")]), _vm._v(" "), _c('p', [_vm._v("I don’t represent the majority as I am not in their league, but I want the majority to follow my social media, shower me with compliments or at least recognise that I am different and more elite than them. I am nice to the majority, because I am of a high profile, this is what I do. 99.99% of my fans are from my country. They don’t really speak English, because English is not the official language or second language in my country. Only elite people speak English, like me.")]), _vm._v(" "), _c('p', [_vm._v("But I use the English language anyway, even though my fans don’t understand a word as they come from a non-English speaking country. It sounds cool, hip, modern, posh and puts me as an A-lister. If I don’t use the English language, it is the same as me not following the trends and fashion. It is pulling me backward if I use my mother tongue language. I refuse to recognise my blood, my nationality, my DNA, my mother tongue language, my culture, because I am not a primitive. I refuse to know who I am and what I am, you can call me a fake, a porn star, a hypocrite, a liar, a socialist, a communist, but I am not an Asian.")]), _vm._v(" "), _c('p', [_vm._v("Even though there are over 60 native languages in my country apart from the official language, I always use English as my language in social media. Why? I want to go global and get fans from around the world. Who knows, I might get discovered by some producers in Hollywood. Psst… I’d like to tell you a secret that embarrassed me the most, why don’t I speak my own language? Because I am not really an Asian, please don’t tell anyone. Yes, I look like an Asian or a half-half, the left side of my body is Asian and the right side is German… shepherd. I am just a European girl who got trapped in this Asian body! Oh God, please help me. I can’t take this anymore, I have to be a pure Westerner. I want to be a European, look like them, talk like them and walk like them.")]), _vm._v(" "), _c('p', [_vm._v("Am I proud of myself? Of course I am. Am I proud of my blood, nationality, language and homeland? Hmm, this is embarrassing, secretly not really. To me, being proud of my homeland, my language, culture and nationality is beneath me. To talk in their language and respect their culture? No, please don’t ask me that question. I think if I talk in my mother tongue, it will make my backside steam like the steamed engine of an old train. It is not me to act like them, talk like them, and look like them, sorry. So I have to look, act, talk and sound as Western as possible.")]), _vm._v(" "), _c('p', [_vm._v("I may be one of them, but I am not a part of them. I always fantasise my ancestors and culture came from somewhere from Europe, so posh. Even if I had a bit of European blood, I would still consider myself 100% Western. Actually, it is embarrassing if I say I am not 100% Westerner as it would downgrade my reputation. It is like having 50% cheese and 50% tofu. I want to be cheese, not tofu.")]), _vm._v(" "), _c('p', [_vm._v("To make me more ‘foreigner’, I put on a Western accent when I speak my mother tongue. When I talk in English, I still sound like an Asian but I do my best to have a Western accent. When I interview someone or talk to someone on TV, I use English language in between. So a mixed language, 50% native and 50% English. Because being a Westerner is in my blood, you know, so you have to understand I become clumsy when I use my mother tongue because I forget some of my native language.")]), _vm._v(" "), _c('p', [_vm._v("When a tragedy happened in my homeland, I just ignore it even though that tsunami killed more than a thousand people, I’d better post my selfie on my social media instead of paying tribute to them. But when a tragedy happens in the West, I pay tribute to those victims. Because I am part of Europe and I am proud of it. When animals have been slaughtered, I have to stand up for the animals because it is a trend from Hollywood, and I am a part of them, you know.")]), _vm._v(" "), _c('p', [_vm._v("No, I don’t care if the earthquake, killer flood, volcanoes and tsunami happened in my country because I am not really of these people. I am from the West and act like one of them. I know I speak English all the time but all of my songs and movies are in my native language, I need to use their language because the majority of people in my country don’t speak English, secondly because I want them to buy my songs and watch my movies, thirdly because my source of income is from these people, my fans from my homeland who don’t speak English.")]), _vm._v(" "), _c('p', [_vm._v("Because of my attitude as a proud Western wannabe, it creates a gap. It is me and them, I don’t want to be a part of people from my country. Don’t you ever think one of these people are on the same level as me. No! I am on an upper level, which is from the West. If you want to communicate with me, you have to speak English and act like a Westerner, like me. My English skill is not sophisticated and eloquent, just mediocre. You don’t need to open a dictionary to understand my English, but you need to open your dictionary when you watch an astrophysicist or scientists on social media. I wish my English skill were like theirs.")]), _vm._v(" "), _c('p', [_vm._v("I do anything I want on social media, I post my sexy photos, nude photos, I am in the bathtub, or I swing like a monkey, but don’t ask me to speak my native language, don’t call me one of these people, don’t compare me with them, don’t even ask me to embrace my culture. But I need these people to buy my songs, my movies and don’t forget – to subscribe to my channel or follow my social media.")]), _vm._v(" "), _c('p', [_vm._v("I’d rather get drunk on soy sauce than speak my own language. I have developed this allergy, an allergy to my mother tongue and my roots. My skin starts to get a rash when I speak their language, it makes my body itchy. There’s a saying: don’t forget your roots. In my case, yes, I forgot where I came from. I forgot my blood, my ancestors, and most of all I forgot who I am. I believe I will turn into a dumpling if I speak their language.")]), _vm._v(" "), _c('p', [_vm._v("This is a confession from many Asian celebrities who forget their own roots, they don’t have national pride and identity. Yes, we’re talking about you, bok choy. Your expectation is to be a Jerk And The City but you actually are A Prawn Cracker And The City. You use social media as your stage to act as a shiny star that is disconnected from your reality. You are a pretender. Should we trust a pretender? Are they an honest person? They don’t even trust themselves, so how could we trust anything you say?")]), _vm._v(" "), _c('p', [_vm._v("You forget that the people who share the same nationality, language, culture, and blood as you, are the ones who put you in the top position. Without them, you would’ve never enjoyed your fame and wealth like you have now. You need them to buy your songs, movies and merchandise. You need them more than they need you. You disrespecting your own motherland is you disrespecting your soul too. You disrespect your fans who are proud of their nationality and culture, in the end it will cost you your future and source of income. Remember, you need these people for your income.")]), _vm._v(" "), _c('p', [_vm._v("We don’t slander you for using the English language, as it is a universal language with which to connect the world. We think English is important but there is a big difference between people who use English to communicate with others but they still have national pride, and someone who uses English because they think their identity is that of a Westerner, as they are too embarrassed to speak their mother tongue.")]), _vm._v(" "), _c('p', [_vm._v("You can say anything you want, but when you forget your own roots and distance yourself from the rest of the majority as you act more Western or hip hop, it means you disrespect your own nation, heritage, culture and people. By doing this, the person you disrespect the most is yourself. Be honest, by accepting reality and the most important thing is to accept yourself, don’t be a pretender and a follower.")]), _vm._v(" "), _c('p', [_vm._v("If you feel you are not really a part of your country, leave your country and move to a country where the language and culture just fit in, as you desperately want to be a part of them, their language and culture, don’t you? Oh, you don’t want to do that because the competition is much more fierce outside your country, you don’t want to be unpopular and an unemployed celebrity. One trait of a pretender like you, you seek attention and validation.")]), _vm._v(" "), _c('p', [_vm._v("Look at Discovery Channel, even all the animals are proud of who they are. Have you seen a crocodile cluck like a chicken? No, you don’t see a crocodile too embarrassed of being a crocodile by acting like a chicken and clucking like a chicken. A duck is proud to be a duck, they refuse to bark like a dog as the dogs are proud to be a dog, and as dogs refuse to quack like a duck. You may call them an animal, but they are not fake and they are proud to be an animal. We’ve never seen a rhino running around in ecstasy because he is proud to be a mermaid, “Oh look at me, I am so super cute, I am a mermaid, put me in an aquarium. Woohoo…” Only a human can do that.")]), _vm._v(" "), _c('p', [_vm._v("But sometimes, a human pretends to be an animal when he is up to no good. Grandma is alone at home. She hears something just fall to the floor in the kitchen. Grandma is worried, she is hoping that it was her cat.")]), _vm._v(" "), _c('p', [_vm._v("“Hello… is that a cat or a human?” asks grandma in hesitation.")]), _vm._v(" "), _c('p', [_vm._v("“A cat… meow…”")]), _vm._v(" "), _c('p', [_vm._v("Grandma just rolls her eyes and says, “I guess that would be you, my grandson, Kim Mun Cheeng. If you want to steal a cake from the fridge, just say so. Don’t pretend to be a cat!”")]), _vm._v(" "), _c('p', [_vm._v("What would you think if you encountered a pretender?")]), _vm._v(" "), _c('p', [_vm._v("“Look, Grandpa! This goat sounds like a human.”")]), _vm._v(" "), _c('p', [_vm._v("“What? This goat sounds like a human? That is really impossible and so stupid.”")]), _vm._v(" "), _c('p', [_vm._v("“Yes, it’s me, you asshole. This goat sounds like a human, I am a human trapped in this goat body,” says the goat. “Hey, you got any cigarette and a lighter? I need to smoke now. I used to quit smoking for one year, but after seeing that hot chick over there, I have an urge to smoke again.”")]), _vm._v(" "), _c('p', [_vm._v("“Hi beautiful,” there’s a man’s voice, whistling at two beautiful girls.")]), _vm._v(" "), _c('p', [_vm._v("“Did you hear that? I didn’t see anyone but I heard voices…” The girls try to figure out who’s talking to them as they don’t see anyone around.")]), _vm._v(" "), _c('p', [_vm._v("“It’s me, the donkey behind you, yes I was whistling at you.” A donkey tries to pick up some chicks.")]), _vm._v(" "), _c('p', [_vm._v("“What? You’re talking to me? A talking donkey?”")]), _vm._v(" "), _c('p', [_vm._v("“No, I am not a donkey, I am a mannish man. I am a chick magnet that is trapped in this donkey body. Hey, would you like to have heehaw from this man? What you reckon, you nice and solid tits.” Donkey looks happy and winks at the girls.")]), _vm._v(" "), _c('p', [_vm._v("“You bastard!” Slap! The girls slap the donkey in the face, “Go and heehaw yourself! Stop pretending to be a human to impress a human, and heehaw up yours!”")]), _vm._v(" "), _c('p', [_vm._v("If you have encountered things like that, it means it is time for you to see your doctor again.")]), _vm._v(" "), _c('p', [_vm._v("To be able to speak English is not a bad thing, actually it does you a favour. The English language is the bridge to connect the world. There are over 6500 spoken languages in the world. People who came from English speaking countries and non-English speaking countries from around the world are proud of their language and culture, so they should be. According to data, in 2015 there were 879.7 million social media users in the Asia Pacific alone. The language that is used the most on social media is English. Not all of us understand English, but English is the language that connects the social media world, apart from selfies and emoji.")]), _vm._v(" "), _c('p', [_vm._v("There are 54 countries where English is the first language. In Africa, over half of Nigeria’s population speaks English. About 232 million people in India use English as their second language, the Philippines uses English as their second language too. The only country in Asia where English is the official language, is Singapore.")]), _vm._v(" "), _c('p', [_vm._v("In many non-English speaking countries, to learn English is a must at school as it is one of the most important subjects at school. With English language skill, the chance to get a job is bigger. In social media, this is the language that we use as there are about 6500 languages in the world. The most spoken language in the world is not English, it is Mandarin. There are 1.2 billion people in the world who speak Mandarin, followed by Spanish and the third one is English.")]), _vm._v(" "), _c('p', [_vm._v("You don’t have to be able to be fluent in English to communicate or attract followers on social media, because a picture speaks more than a thousand words. Social media is more a visual world than a physical world. We can hear voices too on social media by watching short videos, but we need our eyes more than any other sense we have. Well, if we could smell on social media, there would’ve been so many aromas coming out from social media.")]), _vm._v(" "), _c('p', [_vm._v("Those pretenders who don’t have national pride should look at the one case in China where one refugee told her children to never speak Chinese, because they don’t want their kids to ‘forget English’ and become Chinese. This report has angered many Chinese and stressed the stereotype of refugees as arrogant, ungrateful and disrespectful of their Chinese hosts. Because these pretenders are the opposite, they don’t want to speak their mother tongue because they think they are the foreigners who live in this random country.")]), _vm._v(" "), _c('p', [_vm._v("Fun facts about one of the celebrities from this country: when she gets bored in between TV interviews, she plays with her smartphone (yes, live on TV) and looks so annoyed because she doesn’t get enough attention from others.")]), _vm._v(" "), _c('p', [_vm._v("Credits to social media users from these countries:")]), _vm._v(" "), _c('p', [_vm._v("Korea, China, Russia and Japan for being proud of their culture, language and national pride, as they never forget their roots. As for India, Singapore and the Philippines, they use the English language because it is their formal language or second language, but they are proud and respectful of their ancestors, culture and nationality. And credits to all social media users from around the world who are respectful of who you are, your roots, culture, national pride, and respect for the culture of your fans who put you where you are now.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "variety-of-social-media-parents"
    }
  }, [_c('h3', [_vm._v("Variety of Social Media Parents")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_vm._v("I am proud to be a parent and raise my children. My family is my happiness and joy of my life. It is not always perfect and peachy dandy moments but no matter what happens, we always stand together and we fill this house with love, that’s what we call home. I want to share my happiness with the world. Whether my children are high achievers or not high achievers doesn’t really matter the most, as long as they are honest, value love and life, have empathy and respect others, not because I want my the best for my children but because this is morally right.")]), _vm._v(" "), _c('p', [_vm._v("Did you see photos of my children grinning and holding their awards on my social media? It doesn’t have to be one of our golden moments to be posted on my social media. I also post our failure moments, such as when we baked those flop cakes. My daughter and I made an attempt to make a Princess cake, but unfortunately our cake didn’t turn out looking like a princess cake at all, it looked more like a park ranger. As my wise husband says, it doesn’t have to be necessarily a baker to stuff cream into the tart.")]), _vm._v(" "), _c('p', [_vm._v("I share so many family moments on social media; when we are on holiday, doing the gardening, swimming, and many things. I share the photos of my children and I going camping in this remote area. People say never work with children and animal. I would say going camping with my rebellious children was like that TV show, “I am a moron, get me out of here.” I would discipline my children when they make a mistake because I want them to learn to take responsibility for their actions.")]), _vm._v(" "), _c('p', [_vm._v("There is no pretention in my family. What you see is what you get. Our family doesn’t act or try their best on social media to impress people. We just want to share our moments, whether it is our silly or our happy moments, as long as it entertains you. We never try to lecture about life or to be the wisest parents just to get likes or to be complimented by others. Just go with the flow. Our children ask us, what will the future be? We say, “"), _c('em', [_vm._v("Que sera sera")]), _vm._v(".” Then they ask again, “What if we want to be a pimp, you like?” We say, “Que sera sera, whatever will be, will be. The future is not ours to see, now go and fuck yourself.”")]), _vm._v(" "), _c('p', [_vm._v("That was a confession from many parents on social media, never try to be perfect but it makes them perfect as they have entertained and shared their precious family with the world. No pretention, nothing animated, what you see is what you get and good on them.")]), _vm._v(" "), _c('p', [_vm._v("There are parents who have more selfies on their social media than the children. Yes, I am one of those mothers. I check my social media more than I check my children. I love myself, I love my children, too. Why do I post many suggestive selfies and meanwhile my children don’t have a suggestive selfie? Because I know I am hot and still got it. I still crave attention from the opposite sex, being a mother or married doesn’t stop me from doing this. I love turning men on.")]), _vm._v(" "), _c('p', [_vm._v("What do my children say about my sexy even nude selfies on social media for everyone to see? I think they’re okay with that, I think. Do you think I am not a good role model as a mother? I want the world to give me more attention and likes than the world gives to my children. Many people think it is bad form to post suggestive photos on my social media because they are worried it would give a bad example for my children. No, I call it parenting. I am very comfortable when I take my clothes off or are half-naked or only in my underwear on my social media.")]), _vm._v(" "), _c('p', [_vm._v("I love reading the compliments from men and how they fantasise about me after they see my sexy selfie. I also have so many criticisms from women that I am not fit to be a good mother. No, I disagree with that. I think my children are proud to have a hot mama like me. I know I make myself so cheap but if that’s what it takes to have so many likes from men, I’ll do it. Most negative comments on my social media have been deleted by me. I don’t like people criticising me because I only accept compliments, likes, and sex from men. Apart from that, I just delete it and brush it off.")]), _vm._v(" "), _c('p', [_vm._v("That was a confession from a mother who loves nude or sexy selfies on social media. We have found many mothers like that on social media. Are they a good role mother for their children? What is the moral message? This is a rhetorical question. Should I ask for fifty-fifty? Call a friend? Ask the audience or call an ambulance? I think the answer would be: I’d better ride a camel than an old long board.")]), _vm._v(" "), _c('p', [_vm._v("Some mothers preach a vegan diet or refuse to wear a fur skin or buy a leather bag, but are not shy to show off their skin on social media. Contradiction? If you say you refuse to buy anything with leather but you’re showing off your leather? She depends on likes and compliments as the source of happiness, her children make her happy too, but it is not as much happiness as she gets from likes and compliments on her social media about how good she looks. The compliments about her looks are way greater than anything else in the world.")]), _vm._v(" "), _c('p', [_vm._v("There are loving and very attentive parents on social media. I am one of them. Of course, I give my endless love and attention to my children, take it to the bank. What I am trying to say is, I don’t have to communicate with my children face-to-face even though we live in the same house.")]), _vm._v(" "), _c('p', [_vm._v("Whenever I want them to do something for me, I just post it on social media and tag them, or I write it on their wall. I am sure they will reply, if they don’t reply I’ll report and block them. I cook chicken casserole for dinner, call my children for dinner,")]), _vm._v(" "), _c('p', [_vm._v("“Dinner is ready, please come down,” I write on my social media.")]), _vm._v(" "), _c('p', [_vm._v("“I am coming…” replies my daughter.")]), _vm._v(" "), _c('p', [_vm._v("“I am still in the bathroom, I’ll be there in five minutes,” replies my son.")]), _vm._v(" "), _c('p', [_vm._v("My daughter took a selfie with my chicken, posted it on social media with the caption, “My mother cooks the best chicken casserole in the world,” then she adds, “but where is the chilli sauce?”")]), _vm._v(" "), _c('p', [_vm._v("“Just next to your elbow, Einstein,” I answer her comment with an Einstein emoji.")]), _vm._v(" "), _c('p', [_vm._v("We all are sitting together at the same table enjoying our dinner. We all love our dinner conversation. Not on the table but with a smartphone in our hands. My children are chatting with their friends on their smartphone, so am I. Don’t you love our dinner conversation? Our cutlery on the table is: a plate, a fork, a knife and a smartphone. Yes, this is social media culture.")]), _vm._v(" "), _c('p', [_vm._v("My children are chatting about their crushes at school and all school stuff, I am talking about recipes with my friends and my husband is talking about soccer with his friends, and in between he checks out some hot chicks on social media. We are too busy occupied with our little world, social media, it is really weird to have communication face-to-face, look at them in the eyes and start to say something. We only communicate via social media.")]), _vm._v(" "), _c('p', [_vm._v("At night as the night closes in, as a good parent, we’re bidding our children good night and give them a good night kiss before they go to bed.")]), _vm._v(" "), _c('p', [_vm._v("“Good night my princess and my prince, sweet dreams. I love you,” I write on their wall with a kiss emoji.")]), _vm._v(" "), _c('p', [_vm._v("“Good night mom and dad, I love you, too,” they replied with the same emoji too.")]), _vm._v(" "), _c('p', [_vm._v("See, this is how social media brings family together. We don’t need to interact by talking and looking at them in the eyes. Who says communication is very important to build a strong and loving family? All we need is Wi-Fi, love is the runner up. As long as we have Wi-Fi and a full battery, we can build a strong family.")]), _vm._v(" "), _c('p', [_vm._v("If there’s no internet at home, we all can’t breathe properly and suffer hallucinations as we are apart from our social media. We are lost without the internet, it was like living in the dark ages. No internet, no Wi-Fi, no smartphone, the only one missing is the dinosaurs. It sucks when a husband and wife have to talk to each other and see each other face-to-face. Do I have to see my husband’s face? Oh, come on. This is cruel. The last time I saw my husband was his photo on social media. How long do we have to suffer like this? My husband makes a desperate phone call to the electricity company:")]), _vm._v(" "), _c('p', [_vm._v("“Hello, we have a blackout here. Could you please tell me when the power will be back on so we all can recharge our smartphone and get connected to social media?”")]), _vm._v(" "), _c('p', [_vm._v("“We apologise for that, sir. There are some technical problems that we are fixing right now.”")]), _vm._v(" "), _c('p', [_vm._v("“Look, I don’t whinge because I can’t watch TV, but the fact is I have to see my wife’s face and have to talk to her? Do you know what my family are doing right now without internet?”")]), _vm._v(" "), _c('p', [_vm._v("“No, sir.”")]), _vm._v(" "), _c('p', [_vm._v("“We are forced to talk to each other and see each other’s face! You can’t do this to me, you can’t force us to talk to each other! This is so cruel, and the fact is I have to see my wife’s face? Now, turn the power back on or else I’ll wait for you in the car park, you bastard! I want to save my marriage now!”")]), _vm._v(" "), _c('p', [_vm._v("That was guidance from a parent on how to maintain a loving family by using social media. The secret of a happy marriage and happy family is a Wi-Fi. Happy Wi-Fi is a happy wife. In their house, a family portrait is a mother and father, children, Wi-Fi signal on top, tag and emoji. That is a normal family photo album these days.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4.5342in",
      "height": "6.19494in"
    },
    attrs: {
      "alt": "",
      "src": "media/file5.jpg"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Communication is very important, you’re in the same house and you all start talking with Wi-Fi, emoji and likes, it means you are the same as fake news on social media. It is a fake family. You should have a family reunion to remind you that all of you are a family, introduce yourself to your family again. Try to get to know each other again, ask them what their hobbies are including their real name. This is a good start to rebuild a family. Due to too long never using face-to-face interactions and using real voices without a speaker, maybe the parents and the children forgot each other’s voices and real face without filter.")]), _vm._v(" "), _c('p', [_vm._v("“Hi, my name is Bazza. I am your father, and who are you, little bastard?”")]), _vm._v(" "), _c('p', [_vm._v("“I am your first son, dad. My name is Zach.”")]), _vm._v(" "), _c('p', [_vm._v("“Oh I see, I thought I saw you before. Nice to see you, Zach Ash.”")]), _vm._v(" "), _c('p', [_vm._v("We are shaped by people we love and who love us. Family is our first exposure to love and guidance. How we are here and how we perceive the world is because of the memories we have from the past, including all the love and pain we have carried in it.")]), _vm._v(" "), _c('p', [_vm._v("There are mothers who can’t go wrong and are entitled to do anything. I am one of those. I wear ‘I am a mother’ badge like a park ranger, I use my child as an excuse too, to back up my argument. Anyone who denies me will be shamed by me on social media because I am a mother, I have more entitlements than others.")]), _vm._v(" "), _c('p', [_vm._v("My children spilled drink and food in the restaurant, run like a Forrest Gump in the restaurant, screaming at the top of their lungs, banging the table and glasses with cutlery, but I have no problem with them. Let them play, let them explore, let children be children.")]), _vm._v(" "), _c('p', [_vm._v("The problem is not my children but the other diners and the restaurant manager who approach me that my children are causing the other patrons to be uncomfortable, they feel it is a nuisance. It is bothering them to see my children playing and screaming in the restaurant. I don’t accept the blame as I am a mother, nobody tells me what to do with my children or else I will curse you and name you on my social media to let the whole world know what a terrible person you are.")]), _vm._v(" "), _c('p', [_vm._v("I am shopping at the mall, busy checking my social media while my other hand is pushing the shopping trolley, at the same time my children are doing risky business as they play around the shops. My children know the consequences, they won’t break the glass and all the china in the shop. Children love to play, let them play. I can multitask, I can drive, watch my children and text at the same time. If someone tries to criticise me, I will fight back and shame them on social media. I won’t apologise for being a mother, I am a mother, I can do no wrong.")]), _vm._v(" "), _c('p', [_vm._v("I don’t care when people say a restaurant isn’t the best place for children. I don’t care when I check my smartphone while I am crossing the road and pushing a stroller with my baby in it at the same time. I don’t care my children are swimming without my supervision while I am busy checking my social media or whatever. I have a right to do anything I want because I am a mother, don’t you dare use my children to point out my mistakes. I am a mother, I have the golden ticket to Heaven. I am above the law, I am untouchable.")]), _vm._v(" "), _c('p', [_vm._v("I lose my cool in restaurants, hotels, hospitals and many places because they have some restrictions for children as a part of their policies, and also some of the restaurants told me to discipline my children. I don’t buy that. I don’t know how many businesses I have killed by writing a nasty letter and spreading it on my social media. I did that on purpose to punish them, I write nasty letters online to let all people in the world see how bad you are, as you deserve to be punished. The more people hate you, the happier I am.")]), _vm._v(" "), _c('p', [_vm._v("That was a statement from some mothers who defend themselves and their family on social media. They are entitled to have their point of view and so are we. They can do anything they want, but we live in a civilised country where the law applies to all of us, no one is above the law. Unless you live in a corrupt country.")]), _vm._v(" "), _c('p', [_vm._v("You can do anything you want, but there are limits and laws. We have to respect and obey the law wherever we go. In advanced countries, you will be in jail if you refuse to put your children in school. By law, children under 18 are still your responsibility. You don’t allow your five-year-old child to take over the cockpit of an Airbus A380 with over 400 passengers on board, do you? If something happens to them, you will be questioned by authorities. You make a mess, you clean up your own mess. You break the law, you know you have to face the consequences.")]), _vm._v(" "), _c('p', [_vm._v("When you are not on your own premises, you must respect their rules and policies in the places you go. If you go to your mother-in-law, you wouldn’t move her furniture, would you? Because you respect your mother-in-law as the host of the house, or else she’ll stand her ground and draw the line for you. Same thing happens in the restaurants, hotels and many public places, respect their rules and policies. Would you allow your house guest to instruct you and dictate to you what to do in your own house? Would you allow your guest to make a mess, have a wild party, invite strangers, play loud music, sleep on your bed or do anything they want in your house without your permission?")]), _vm._v(" "), _c('p', [_vm._v("You may say you will trash anyone who denies you on social media. But in some countries, when you write a complaint on your social media about their authorities or country, you will face imprisonment. You don’t want that, do you? To use the badge ‘I am a mother’ is not to be a human shield, you play the ‘I am a mother’ card to shield your childish and irrational actions. To include your children as an alibi to protect your selfish behaviour is not a responsible action. If you want to do the best for your children, spend time with them, play with them, love them, talk to them and give up your social media, teach them respect, take them to the park or garden so they can explore the beauty of nature and expand their horizons instead of taking them to a restaurant where they can’t do much.")]), _vm._v(" "), _c('p', [_vm._v("To use the ‘I am a mother’ card is not a getaway card from anything. If you believe that, you are a manipulative mother, a bad mother. To be a mother doesn’t guarantee you a free ticket to Heaven and put you above the law. Motherhood is an honoured job, you have all the blessings in the universe to have that privilege to raise and give love to your family. You are given an opportunity to care, guide and bring your own children up to respect and value life.")]), _vm._v(" "), _c('p', [_vm._v("Loving your children, it doesn’t mean that your children can get anything they want with no rules, tell them to respect the rules and others. Guide your children, “Son, if you play with fire, you’ll get burned. If you cross the road without me, you’ll get hit by a car.” Tell them to share well and have self-discipline. Tell them to appreciate what they have and teach them to say these words, “Thank you,” and, “please.” Support their dreams and guide them towards the right directions. According to one piece of research, to be a successful person is not based on their IQ, but based on self-discipline.")]), _vm._v(" "), _c('p', [_vm._v("This section is for ‘special mothers’ who use the word ‘mother’ to manipulate and punish their children. To use these sacred words ‘I am a mother, you were in my womb for nine months’ to manipulate and hurt your children is a very evil and calculating thing. If you use those words to hurt your children because you didn’t get what you want, you are not a mother, but a manipulative and evil person in a mother’s clothing. Whenever you didn’t get enough money or attention you will use and bring those words up just to hurt your children and make them feel so small, “You would’ve never been in this world if not for me,” and, “I raised you, I fed you, I paid for your school, and this is how you treat me.”")]), _vm._v(" "), _c('p', [_vm._v("This is one of the warning signs that the children are dealing with a very callous person. You will keep reminding them what you have sacrificed and how much you have given them to hurt them and to get what you want. Just because your children give their full attention to their wife/husband and their children or they simply didn’t send you money or pay for your groceries. Or even worse, just because your children didn’t upgrade their mother’s lifestyle. You keep spreading lies about how bad your children are, but the facts are different, your children always respect and send their mother love, but it is not good enough for you because you are not the centre of attention.")]), _vm._v(" "), _c('p', [_vm._v("“You are here because of me, you were in my womb for nine months.” First of all, we didn’t ask to be born suddenly, we just turned up in this world. Secondly, if you are a good mother, you will not use those words to hurt or punish your children. If you are a good mother, you will give your children nothing but prayers for happiness and love. You use those words because you are a liar, have no compassion and commit a desperate act through which you can’t win. The more desperate you are, the more you want to hurt your children, the more you put yourself on the same level as God by mentioning religion, God as a support argument as if this is not from me but this is from God, you hurt your mother the same as if you hurt God, “God will send any child who hurts their mother to hell.”")]), _vm._v(" "), _c('p', [_vm._v("The question is, do you think God is not that smart? Do you think God has no idea you have manipulated your children and you even have manipulated your own God by using the word God to get your evil way? Really? Do you think God doesn’t know what you’re up to? I think everyone in Heaven is laughing at you. What’s next? You are going to use the word God when your children didn’t pay for your groceries? If the children are happy and in good health as they love their mother and respect their mother, would you be happy as their mother? Why do you use social media and real life to spread lies and hate towards your children to make the whole world hate your children, too? Meanwhile your children keep sending their prayers and love or even money, in Asian cultures many children send their parents money monthly.")]), _vm._v(" "), _c('p', [_vm._v("Blinded by your unhappiness, insecurities, greed and evil ways, instead of sending them love, you choose to punish your children, and condemn them to get all the bad luck and bad karma in the world by using the word God, religion and special karma from mother. Why is every word and action that comes from you having to be special and Holy as if you are the chosen one from God? Your answer is, “Because I am a mother.” No, you are not God, secondly God doesn’t protect all the mothers, God will send you to Heaven if you have a good heart and unconditional love, if not God just sends you to hell.")]), _vm._v(" "), _c('p', [_vm._v("The happier the children are with their family, the more you are enraged. Why? Because you want your children to put you above their family and above God, because ‘I am a mother’. Good mothers will be happy to see their children are happy with their family. Bad mothers perceive daughters/sons-in-law, including their children, as their rival. They see daughters-in-law or sons-in-law as not good enough for the family status or level. Fake mothers will act like a parking ranger, will bark at their daughter-in-law just because of minor mistakes and perceive their daughter-in-law as not good enough for their son.")]), _vm._v(" "), _c('p', [_vm._v("Bad mothers always brag that a mother is always the most powerful figure for their children and still have total control over their children’s life and married life, meanwhile good mothers always stress to their children how important and powerful the energy of love is. Bad mothers believe and insist that they are the only one source of happiness and miracles for their children. They are the only one reason for their children’s happiness, no other. Bad mothers will keep reminding their children to keep worshipping their mother like a God, keep praising the sacred love of mother, always remember that mother is the most important figure in their life second to God, to sacrifice everything in life to make their mother happy and the only God they worship. That’s what fake mothers want.")]), _vm._v(" "), _c('p', [_vm._v("The worst reason, but a true story, why some mothers use social media and real life to punish and put God’s curse on their children is because of two words, money and greed. These mothers believe their children didn’t give them enough money to upgrade her lifestyle. If the children are on holiday, they also want to be on holiday, plus the children have to pay for their transport, accommodation, food and all, because mother is important. What the children get, the mother gets, too. Bad mothers believe money is equal to love. Many mothers also manipulate their children to hate their father because of a bitter divorce.")]), _vm._v(" "), _c('p', [_vm._v("Typical of these fake mothers is they have an honesty phobia, they never admit they make mistakes, they play favourites with their children and always compare the bad and the good child, they have no empathy and compassion. They would say it online, my favourite daughter is Teddina Bundy and my least favourite child is Ug Lee. What they want is give me, give me, give me. Meanwhile fake mothers play favourite child and cursed child, actually what they do is play with fire, they will get burned eventually. Be careful of what you wish for. You manipulate God, religion and children by using the word God and being a mother, you think your prayer is powerful because you are a mother, no, what is powerful is what you have in your heart. God doesn’t give you Heaven because you are a mother, but what is inside your heart. God doesn’t give you what you want, but He gives you what you are. One word for fake mothers that you should give to your children and their family: respect. Facts: most fake mothers don’t have a good relationship with their own mother. You using the words “I am a mother, you were in my womb for nine months” to punish your children is not a sign of a mother, but it is a sign of a fake and bully mother. You bully your own children.")]), _vm._v(" "), _c('p', [_vm._v("First school is your own home. It doesn’t happen overnight to be able to play a violin, it takes times, some coaching, classes, dedication and support. You guide your children in the right direction to achieve their goal. It is you who run the ship, you are the captain of your ship as a mother because you have the knowledge and the experience. How you became what you are now, is because of the experience, memory and what you’ve been taught and learned from your family, environment, the past and upbringings, that put you here, where you are now. The bad experience we had in our childhood and what we’ve endured, we will make sure our children will get a better chance, opportunity and future than us.")]), _vm._v(" "), _c('p', [_vm._v("We all have entitlements and rights as a citizen and a human being. We all deserve to be loved and to love, to respect and to be respected, to protect and to be protected as a citizen (in saying that, in a corrupt country the law is designed to protect the criminals and punish the victims). No matter who you are in the world, it is your beautiful mind and the way you conduct yourself that matters the most. We all are entitled to write our thoughts and express our opinion on social media, but it will be unfair if we only hear it from one side. Just like in the court room, all parties have an opportunity to say, to get a fair opinion. Be careful if you only read one side of the story on social media, because it is their version, not the whole truth.")]), _vm._v(" "), _c('p', [_vm._v("Be careful too where you launch your complaints, you may have the freedom to say anything you want in your country. But outside your country, you make an air hostess upset, there will be some cops waiting for you at the airport to escort you to the police station with a possibility of 2 weeks’ jail. You say one word on your social media against the authority and government in foreign countries, mouthing off at airport staff, littering, making graffiti, and many more minor childish behaviours can land you in jail in a foreign country. One word can cost your life, your reputation, your job and all of your lifetime savings to pay for lawyers in foreign country.")])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781528985536',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(103)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(105);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 105 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.b6f7794ad187ffcefe61.js